!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"));else if ("function" === typeof define && define.amd) define(["react"], t);else {
    var a = "object" === typeof exports ? t(require("react")) : t(e.react);

    for (var c in a) {
      ("object" === typeof exports ? exports : e)[c] = a[c];
    }
  }
}(window, function (e) {
  return function (e) {
    var t = {};

    function __webpack_require__(a) {
      if (t[a]) return t[a].exports;
      var c = t[a] = {
        i: a,
        l: !1,
        exports: {}
      };
      return e[a].call(c.exports, c, c.exports, __webpack_require__), c.l = !0, c.exports;
    }

    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, a) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: a
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var a = Object.create(null);
      if (__webpack_require__.r(a), Object.defineProperty(a, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var c in e) {
        __webpack_require__.d(a, c, function (t) {
          return e[t];
        }.bind(null, c));
      }
      return a;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 2);
  }([function (t, a) {
    t.exports = e;
  }, function (e, t, a) {
    var c;
    !function () {
      "use strict";

      var a = {}.hasOwnProperty;

      function classNames() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var c = arguments[t];

          if (c) {
            var l = typeof c;
            if ("string" === l || "number" === l) e.push(c);else if (Array.isArray(c) && c.length) {
              var i = classNames.apply(null, c);
              i && e.push(i);
            } else if ("object" === l) for (var h in c) {
              a.call(c, h) && c[h] && e.push(h);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (classNames.default = classNames, e.exports = classNames) : void 0 === (c = function () {
        return classNames;
      }.apply(t, [])) || (e.exports = c);
    }();
  }, function (e, t, a) {
    e.exports = a(8);
  }, function (e, t, a) {
    var c = a(4);
    "string" === typeof c && (c = [[e.i, c, ""]]);
    var l = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    a(6)(c, l);
    c.locals && (e.exports = c.locals);
  }, function (e, t, a) {
    (e.exports = a(5)(!0)).push([e.i, ".tide-icon {\n\tvertical-align: middle;\n\tdisplay: inline-block\n}\n\n.tide-icon path {\n\tfill: var(--color-p1-10);\n}\n\n.tide-icon.slack-icon rect,\n.tide-icon.slack-icon path {\n  fill: var(--main-navy)\n}\n\n/* COLORWAY */\n.colorway-icon {\n\tdisplay: block;\n}\n\n/* open new tab icon */\n.tide-icon.tide--open-new-tab path {\n\tfill: none;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC,wBAAwB;AACzB;;AAEA;;EAEE;AACF;;AAEA,aAAa;AACb;CACC,cAAc;AACf;;AAEA,sBAAsB;AACtB;CACC,UAAU;AACX",
      file: "style.css",
      sourcesContent: [".tide-icon {\n\tvertical-align: middle;\n\tdisplay: inline-block\n}\n\n.tide-icon path {\n\tfill: var(--color-p1-10);\n}\n\n.tide-icon.slack-icon rect,\n.tide-icon.slack-icon path {\n  fill: var(--main-navy)\n}\n\n/* COLORWAY */\n.colorway-icon {\n\tdisplay: block;\n}\n\n/* open new tab icon */\n.tide-icon.tide--open-new-tab path {\n\tfill: none;\n}\n"]
    }]);
  }, function (e, t, a) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function toString() {
        return this.map(function (t) {
          var a = function cssWithMappingToString(e, t) {
            var a = e[1] || "",
                c = e[3];
            if (!c) return a;

            if (t && "function" === typeof btoa) {
              var l = function toComment(e) {
                return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
              }(c),
                  i = c.sources.map(function (e) {
                return "/*# sourceURL=" + c.sourceRoot + e + " */";
              });

              return [a].concat(i).concat([l]).join("\n");
            }

            return [a].join("\n");
          }(t, e);

          return t[2] ? "@media " + t[2] + "{" + a + "}" : a;
        }).join("");
      }, t.i = function (e, a) {
        "string" === typeof e && (e = [[null, e, ""]]);

        for (var c = {}, l = 0; l < this.length; l++) {
          var i = this[l][0];
          null != i && (c[i] = !0);
        }

        for (l = 0; l < e.length; l++) {
          var h = e[l];
          null != h[0] && c[h[0]] || (a && !h[2] ? h[2] = a : a && (h[2] = "(" + h[2] + ") and (" + a + ")"), t.push(h));
        }
      }, t;
    };
  }, function (e, t, a) {
    var c = {},
        l = function (e) {
      var t;
      return function () {
        return "undefined" === typeof t && (t = e.apply(this, arguments)), t;
      };
    }(function () {
      return window && document && document.all && !window.atob;
    }),
        i = function (e) {
      var t = {};
      return function (e, a) {
        if ("function" === typeof e) return e();

        if ("undefined" === typeof t[e]) {
          var c = function (e, t) {
            return t ? t.querySelector(e) : document.querySelector(e);
          }.call(this, e, a);

          if (window.HTMLIFrameElement && c instanceof window.HTMLIFrameElement) try {
            c = c.contentDocument.head;
          } catch (l) {
            c = null;
          }
          t[e] = c;
        }

        return t[e];
      };
    }(),
        h = null,
        r = 0,
        n = [],
        s = a(7);

    function addStylesToDom(e, t) {
      for (var a = 0; a < e.length; a++) {
        var l = e[a],
            i = c[l.id];

        if (i) {
          i.refs++;

          for (var h = 0; h < i.parts.length; h++) {
            i.parts[h](l.parts[h]);
          }

          for (; h < l.parts.length; h++) {
            i.parts.push(addStyle(l.parts[h], t));
          }
        } else {
          var r = [];

          for (h = 0; h < l.parts.length; h++) {
            r.push(addStyle(l.parts[h], t));
          }

          c[l.id] = {
            id: l.id,
            refs: 1,
            parts: r
          };
        }
      }
    }

    function listToStyles(e, t) {
      for (var a = [], c = {}, l = 0; l < e.length; l++) {
        var i = e[l],
            h = t.base ? i[0] + t.base : i[0],
            r = {
          css: i[1],
          media: i[2],
          sourceMap: i[3]
        };
        c[h] ? c[h].parts.push(r) : a.push(c[h] = {
          id: h,
          parts: [r]
        });
      }

      return a;
    }

    function insertStyleElement(e, t) {
      var a = i(e.insertInto);
      if (!a) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var c = n[n.length - 1];
      if ("top" === e.insertAt) c ? c.nextSibling ? a.insertBefore(t, c.nextSibling) : a.appendChild(t) : a.insertBefore(t, a.firstChild), n.push(t);else if ("bottom" === e.insertAt) a.appendChild(t);else {
        if ("object" !== typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var l = i(e.insertAt.before, a);
        a.insertBefore(t, l);
      }
    }

    function removeStyleElement(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var t = n.indexOf(e);
      t >= 0 && n.splice(t, 1);
    }

    function createStyleElement(e) {
      var t = document.createElement("style");

      if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
        var c = function getNonce() {
          0;
          return a.nc;
        }();

        c && (e.attrs.nonce = c);
      }

      return addAttrs(t, e.attrs), insertStyleElement(e, t), t;
    }

    function addAttrs(e, t) {
      Object.keys(t).forEach(function (a) {
        e.setAttribute(a, t[a]);
      });
    }

    function addStyle(e, t) {
      var a, c, l, i;

      if (t.transform && e.css) {
        if (!(i = "function" === typeof t.transform ? t.transform(e.css) : t.transform.default(e.css))) return function () {};
        e.css = i;
      }

      if (t.singleton) {
        var n = r++;
        a = h || (h = createStyleElement(t)), c = applyToSingletonTag.bind(null, a, n, !1), l = applyToSingletonTag.bind(null, a, n, !0);
      } else e.sourceMap && "function" === typeof URL && "function" === typeof URL.createObjectURL && "function" === typeof URL.revokeObjectURL && "function" === typeof Blob && "function" === typeof btoa ? (a = function createLinkElement(e) {
        var t = document.createElement("link");
        return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", addAttrs(t, e.attrs), insertStyleElement(e, t), t;
      }(t), c = function updateLink(e, t, a) {
        var c = a.css,
            l = a.sourceMap,
            i = void 0 === t.convertToAbsoluteUrls && l;
        (t.convertToAbsoluteUrls || i) && (c = s(c));
        l && (c += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(l)))) + " */");
        var h = new Blob([c], {
          type: "text/css"
        }),
            r = e.href;
        e.href = URL.createObjectURL(h), r && URL.revokeObjectURL(r);
      }.bind(null, a, t), l = function l() {
        removeStyleElement(a), a.href && URL.revokeObjectURL(a.href);
      }) : (a = createStyleElement(t), c = function applyToTag(e, t) {
        var a = t.css,
            c = t.media;
        c && e.setAttribute("media", c);
        if (e.styleSheet) e.styleSheet.cssText = a;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(a));
        }
      }.bind(null, a), l = function l() {
        removeStyleElement(a);
      });

      return c(e), function updateStyle(t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          c(e = t);
        } else l();
      };
    }

    e.exports = function (e, t) {
      if ("undefined" !== typeof DEBUG && DEBUG && "object" !== typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (t = t || {}).attrs = "object" === typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = l()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
      var a = listToStyles(e, t);
      return addStylesToDom(a, t), function update(e) {
        for (var l = [], i = 0; i < a.length; i++) {
          var h = a[i];
          (r = c[h.id]).refs--, l.push(r);
        }

        e && addStylesToDom(listToStyles(e, t), t);

        for (i = 0; i < l.length; i++) {
          var r;

          if (0 === (r = l[i]).refs) {
            for (var n = 0; n < r.parts.length; n++) {
              r.parts[n]();
            }

            delete c[r.id];
          }
        }
      };
    };

    var o = function () {
      var e = [];
      return function (t, a) {
        return e[t] = a, e.filter(Boolean).join("\n");
      };
    }();

    function applyToSingletonTag(e, t, a, c) {
      var l = a ? "" : c.css;
      if (e.styleSheet) e.styleSheet.cssText = o(t, l);else {
        var i = document.createTextNode(l),
            h = e.childNodes;
        h[t] && e.removeChild(h[t]), h.length ? e.insertBefore(i, h[t]) : e.appendChild(i);
      }
    }
  }, function (e, t) {
    e.exports = function (e) {
      var t = "undefined" !== typeof window && window.location;
      if (!t) throw new Error("fixUrls requires window.location");
      if (!e || "string" !== typeof e) return e;
      var a = t.protocol + "//" + t.host,
          c = a + t.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
        var l,
            i = t.trim().replace(/^"(.*)"$/, function (e, t) {
          return t;
        }).replace(/^'(.*)'$/, function (e, t) {
          return t;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i) ? e : (l = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? a + i : c + i.replace(/^\.\//, ""), "url(" + JSON.stringify(l) + ")");
      });
    };
  }, function (e, t, a) {
    "use strict";

    a.r(t);
    var c = a(0),
        l = a.n(c);
    var i = a(1),
        h = a.n(i);
    var r = {
      "widget-online": function widgetOnline(_ref) {
        var e = _ref.className,
            _ref$width = _ref.width,
            t = _ref$width === void 0 ? "28" : _ref$width,
            _ref$height = _ref.height,
            a = _ref$height === void 0 ? "25" : _ref$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 28 25"
        }, l.a.createElement("g", {
          fill: "#7695A5",
          fillRule: "evenodd"
        }, l.a.createElement("path", {
          d: "M14 1.75c-6.755 0-12.25 3.925-12.25 8.75 0 3.74 3.535 6.066 5.64 7.12.298.148.485.45.485.782 0 1.557-.47 2.98-.945 4.018 1.235-.367 2.825-1.13 3.676-2.698.15-.28.444-.455.762-.458 0 0 1.703-.014 2.632-.014 6.755 0 12.25-3.925 12.25-8.75S20.755 1.75 14 1.75zM5.25 24.5c-.32 0-.618-.176-.77-.46-.16-.297-.136-.658.063-.93.014-.02 1.37-1.914 1.56-4.187C2.16 16.805 0 13.83 0 10.5 0 4.71 6.28 0 14 0s14 4.71 14 10.5S21.72 21 14 21c-.61 0-1.554.006-2.126.01-2.11 3.234-6.392 3.48-6.582 3.49H5.25z"
        }), l.a.createElement("path", {
          d: "M12.19 14.608c.372.373.982.353 1.33-.044l5.73-6.25c.33-.38.293-.956-.086-1.288-.38-.33-.954-.293-1.286.086l-5.09 5.517-2.045-2.045c-.355-.356-.933-.356-1.29 0-.354.356-.354.933 0 1.29l2.736 2.733z"
        })));
      },
      "widget-offline": function widgetOffline(_ref2) {
        var e = _ref2.className,
            _ref2$width = _ref2.width,
            t = _ref2$width === void 0 ? "28" : _ref2$width,
            _ref2$height = _ref2.height,
            a = _ref2$height === void 0 ? "25" : _ref2$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 28 25"
        }, l.a.createElement("path", {
          d: "M5.25 24.5c-.32 0-.618-.176-.77-.46-.16-.297-.136-.658.063-.93.014-.02 1.37-1.914 1.56-4.187C2.16 16.805 0 13.83 0 10.5 0 4.71 6.28 0 14 0s14 4.71 14 10.5S21.72 21 14 21c-.61 0-1.554.006-2.126.01-2.11 3.234-6.392 3.48-6.582 3.49H5.25zM14 1.75c-6.755 0-12.25 3.925-12.25 8.75 0 3.74 3.535 6.066 5.64 7.12.298.148.485.45.485.782 0 1.557-.47 2.98-.945 4.018 1.235-.367 2.825-1.13 3.676-2.698.15-.28.444-.455.762-.458 0 0 1.703-.014 2.632-.014 6.755 0 12.25-3.925 12.25-8.75S20.755 1.75 14 1.75zM10.432 7c0-.483.39-.875.87-.875h5.225c.33 0 .632.187.78.484.147.295.115.65-.083.916l-4.18 5.6h3.483c.48 0 .87.39.87.874s-.39.875-.87.875h-5.225c-.33 0-.63-.187-.778-.484-.147-.296-.116-.65.083-.915l4.18-5.6H11.3c-.48 0-.87-.392-.87-.875z",
          fill: "#7695A5",
          fillRule: "evenodd"
        }));
      },
      "window-search": function windowSearch(_ref3) {
        var e = _ref3.className,
            _ref3$width = _ref3.width,
            t = _ref3$width === void 0 ? "26" : _ref3$width,
            _ref3$height = _ref3.height,
            a = _ref3$height === void 0 ? "24" : _ref3$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M24 24h-21.818c-1.203 0-2.182-0.98-2.182-2.182v-19.636c0-1.203 0.979-2.182 2.182-2.182h21.818c1.203 0 2.182 0.979 2.182 2.182v19.636c0 1.202-0.979 2.182-2.182 2.182zM23.997 21.818l0.002-15.273h-21.817v15.273h21.815zM2.182 2.182v2.182h21.818v-2.182h-21.818zM12 8.68c2.407 0 4.364 1.957 4.364 4.364 0 0.807-0.235 1.553-0.619 2.203l2.481 2.481c0.427 0.425 0.427 1.116 0 1.543-0.213 0.214-0.492 0.32-0.771 0.32s-0.559-0.106-0.771-0.32l-2.481-2.481c-0.649 0.384-1.395 0.619-2.203 0.619-2.407 0-4.364-1.957-4.364-4.364s1.957-4.364 4.364-4.364zM12 15.226c0.425 0 0.82-0.128 1.157-0.339 0.051-0.157 0.128-0.307 0.253-0.432 0.125-0.124 0.275-0.202 0.432-0.253 0.212-0.337 0.339-0.731 0.339-1.157 0-1.202-0.979-2.182-2.182-2.182s-2.182 0.98-2.182 2.182c0 1.203 0.979 2.182 2.182 2.182z"
        }));
      },
      "window-content": function windowContent(_ref4) {
        var e = _ref4.className,
            _ref4$width = _ref4.width,
            t = _ref4$width === void 0 ? "26" : _ref4$width,
            _ref4$height = _ref4.height,
            a = _ref4$height === void 0 ? "24" : _ref4$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M24 24h-21.818c-1.203 0-2.182-0.979-2.182-2.182v-19.636c0-1.202 0.979-2.182 2.182-2.182h21.818c1.203 0 2.182 0.98 2.182 2.182v19.636c0 1.203-0.979 2.182-2.182 2.182zM2.182 21.818h21.815l0.002-15.273h-21.817v15.273zM2.182 2.182v2.182h21.818v-2.182h-21.818zM20.727 15.273h-6.545c-0.602 0-1.091-0.488-1.091-1.091s0.489-1.091 1.091-1.091h6.545c0.602 0 1.091 0.488 1.091 1.091s-0.489 1.091-1.091 1.091zM20.727 12h-6.545c-0.602 0-1.091-0.488-1.091-1.091 0-0.602 0.489-1.091 1.091-1.091h6.545c0.602 0 1.091 0.489 1.091 1.091 0 0.603-0.489 1.091-1.091 1.091zM9.818 18.545h-4.364c-0.602 0-1.091-0.489-1.091-1.091v-6.545c0-0.602 0.489-1.091 1.091-1.091h4.364c0.602 0 1.091 0.489 1.091 1.091v6.545c0 0.602-0.489 1.091-1.091 1.091zM8.727 12h-2.182v4.364h2.182v-4.364zM14.182 16.364h2.182c0.602 0 1.091 0.488 1.091 1.091 0 0.602-0.489 1.091-1.091 1.091h-2.182c-0.602 0-1.091-0.489-1.091-1.091 0-0.603 0.489-1.091 1.091-1.091z"
        }));
      },
      "window-code": function windowCode(_ref5) {
        var e = _ref5.className,
            _ref5$width = _ref5.width,
            t = _ref5$width === void 0 ? "26" : _ref5$width,
            _ref5$height = _ref5.height,
            a = _ref5$height === void 0 ? "24" : _ref5$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M24 24h-21.818c-1.203 0-2.182-0.979-2.182-2.182v-19.636c0-1.202 0.979-2.182 2.182-2.182h21.818c1.203 0 2.182 0.98 2.182 2.182v19.636c0 1.203-0.979 2.182-2.182 2.182zM2.182 21.818h21.815l0.002-15.273h-21.817v15.273zM2.182 2.182v2.182h21.818v-2.182h-21.818zM16.044 18.227c-0.213 0.213-0.492 0.32-0.771 0.32s-0.559-0.107-0.771-0.32c-0.427-0.425-0.427-1.116 0-1.543l2.501-2.501-2.501-2.501c-0.427-0.427-0.427-1.116 0-1.543 0.427-0.425 1.116-0.425 1.543 0l3.273 3.273c0.427 0.427 0.427 1.117 0 1.543l-3.273 3.273zM11.68 18.226c-0.213 0.213-0.492 0.32-0.771 0.32s-0.559-0.107-0.771-0.32l-3.273-3.273c-0.427-0.427-0.427-1.116 0-1.543l3.273-3.273c0.427-0.427 1.116-0.427 1.543 0 0.427 0.425 0.427 1.116 0 1.543l-2.501 2.501 2.501 2.501c0.427 0.427 0.427 1.117 0 1.543z"
        }));
      },
      "window-bookmark": function windowBookmark(_ref6) {
        var e = _ref6.className,
            _ref6$width = _ref6.width,
            t = _ref6$width === void 0 ? "26" : _ref6$width,
            _ref6$height = _ref6.height,
            a = _ref6$height === void 0 ? "24" : _ref6$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M24 24h-21.818c-1.203 0-2.182-0.979-2.182-2.182v-19.636c0-1.202 0.979-2.182 2.182-2.182h21.818c1.202 0 2.182 0.98 2.182 2.182v19.636c0 1.203-0.98 2.182-2.182 2.182zM2.182 21.818h21.815l0.002-15.273h-2.181v5.455c0 0.403-0.221 0.772-0.576 0.962-0.161 0.086-0.338 0.129-0.515 0.129-0.212 0-0.423-0.061-0.605-0.183l-2.666-1.778-2.668 1.778c-0.335 0.223-0.766 0.244-1.12 0.055s-0.576-0.56-0.576-0.962v-5.455h-10.909v15.273zM2.182 4.364h10.909v-2.182h-10.909v2.182zM15.273 2.182v7.78l1.577-1.052c0.367-0.244 0.844-0.244 1.211 0l1.575 1.051v-7.779h-4.364zM21.818 2.182v2.182h2.182v-2.182h-2.182z"
        }));
      },
      "link-1": function link1(_ref7) {
        var e = _ref7.className,
            _ref7$width = _ref7.width,
            t = _ref7$width === void 0 ? "24" : _ref7$width,
            _ref7$height = _ref7.height,
            a = _ref7$height === void 0 ? "24" : _ref7$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M22.421 9.243l-2.175 2.175c-1.025 1.024-2.386 1.588-3.834 1.588h-0.416c-0.553 0-1.001-0.448-1.001-1s0.449-1.001 1.001-1.001h0.416c0.913 0 1.772-0.356 2.419-1.001l2.175-2.175c0.646-0.648 1.001-1.507 1.001-2.422 0-0.913-0.355-1.772-1.001-2.42-1.335-1.333-3.505-1.333-4.839 0l-2.174 2.176c-0.646 0.646-1.002 1.507-1.002 2.421v0.408c0 0.554-0.449 1.002-1.001 1.002s-1.001-0.449-1.001-1.002v-0.408c0-1.448 0.565-2.81 1.588-3.836l2.176-2.176c2.115-2.114 5.556-2.114 7.67 0 1.025 1.024 1.589 2.386 1.589 3.835s-0.564 2.811-1.589 3.837zM7.987 17.004c-0.256 0-0.511-0.098-0.707-0.293-0.391-0.391-0.391-1.025 0-1.416l8.010-8.010c0.39-0.391 1.024-0.391 1.415 0s0.39 1.025 0 1.415l-8.010 8.011c-0.196 0.195-0.451 0.293-0.708 0.293zM7.993 12.993h-0.414c-0.913 0-1.773 0.356-2.421 1.001l-2.174 2.176c-1.333 1.334-1.334 3.507 0 4.84 1.334 1.332 3.506 1.332 4.84 0l2.174-2.175c0.646-0.648 1.002-1.507 1.002-2.422v-0.41c0-0.554 0.449-1.001 1.001-1.001s1.001 0.448 1.001 1.001v0.41c0 1.449-0.565 2.811-1.589 3.837l-2.175 2.175c-1.057 1.057-2.447 1.586-3.836 1.586s-2.778-0.528-3.835-1.586c-2.114-2.114-2.114-5.555-0.001-7.672l2.175-2.175c1.026-1.025 2.388-1.589 3.836-1.589h0.414c0.554 0 1.001 0.448 1.001 1.001s-0.448 1.001-1.001 1.001z"
        }));
      },
      "firewall-done": function firewallDone(_ref8) {
        var e = _ref8.className,
            _ref8$width = _ref8.width,
            t = _ref8$width === void 0 ? "20" : _ref8$width,
            _ref8$height = _ref8.height,
            a = _ref8$height === void 0 ? "24" : _ref8$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 20 24"
        }, l.a.createElement("path", {
          d: "M20.073 10.016c-0.001 0.104-0.222 10.491-9.687 13.916-0.007 0.002-0.014 0.001-0.020 0.003-0.103 0.035-0.212 0.057-0.323 0.057s-0.22-0.022-0.323-0.057c-0.007-0.002-0.013-0.001-0.020-0.003-9.465-3.425-9.686-13.812-9.687-13.916-0.006-0.552-0.011-1.456-0.011-2.008v-2.997c0-1.101 0.901-1.998 2.008-1.998h1.004c4.218 0 6.116-2.481 6.195-2.587 0.191-0.255 0.48-0.379 0.776-0.389 0.339-0.028 0.684 0.099 0.896 0.394 0.075 0.1 1.974 2.582 6.192 2.582h1.004c1.108 0 2.008 0.898 2.008 1.998v2.997c0 0.552-0.005 1.456-0.011 2.008zM18.075 5.010h-1.004c-3.669 0-5.935-1.564-7.029-2.575-1.095 1.011-3.36 2.575-7.029 2.575h-1.004v2.997c0 0.546 0.005 1.441 0.011 1.987 0.005 0.364 0.234 8.841 8.021 11.912 7.821-3.089 8.022-11.822 8.023-11.912 0.006-0.546 0.011-1.441 0.011-1.987v-2.997zM10.43 15.593c-0.164 0.222-0.414 0.367-0.689 0.4-0.040 0.005-0.079 0.007-0.12 0.007-0.235 0-0.463-0.082-0.645-0.233l-3.595-2.997c-0.426-0.354-0.481-0.984-0.126-1.408 0.355-0.422 0.99-0.48 1.415-0.124l2.776 2.314 3.805-5.137c0.329-0.444 0.957-0.539 1.404-0.212s0.542 0.953 0.213 1.397l-4.438 5.994z"
        }));
      },
      "code-3": function code3(_ref9) {
        var e = _ref9.className,
            _ref9$width = _ref9.width,
            t = _ref9$width === void 0 ? "26" : _ref9$width,
            _ref9$height = _ref9.height,
            a = _ref9$height === void 0 ? "24" : _ref9$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M26.016 12.775l-5.488 5.463c-0.214 0.213-0.495 0.319-0.776 0.319s-0.562-0.106-0.776-0.319c-0.429-0.427-0.429-1.118 0-1.544l4.712-4.691-4.712-4.685c-0.429-0.426-0.429-1.118 0-1.545 0.429-0.426 1.123-0.426 1.552 0l5.488 5.458c0.206 0.205 0.322 0.482 0.322 0.771s-0.115 0.568-0.322 0.773zM10.928 23.237c-0.143 0.473-0.578 0.777-1.051 0.777-0.104 0-0.21-0.014-0.315-0.045-0.581-0.173-0.91-0.784-0.736-1.36l6.584-21.84c0.173-0.577 0.782-0.908 1.366-0.732 0.581 0.173 0.91 0.781 0.736 1.359l-6.584 21.841zM7.361 18.235c-0.214 0.213-0.495 0.319-0.776 0.319s-0.562-0.106-0.776-0.319l-5.488-5.458c-0.205-0.204-0.322-0.482-0.322-0.771 0-0.289 0.116-0.567 0.322-0.773l5.488-5.462c0.429-0.427 1.123-0.427 1.552 0 0.429 0.426 0.429 1.117 0 1.544l-4.712 4.69 4.712 4.685c0.429 0.426 0.429 1.118 0 1.545z"
        }));
      },
      "flag-1": function flag1(_ref10) {
        var e = _ref10.className,
            _ref10$width = _ref10.width,
            t = _ref10$width === void 0 ? "22" : _ref10$width,
            _ref10$height = _ref10.height,
            a = _ref10$height === void 0 ? "24" : _ref10$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 22 24"
        }, l.a.createElement("path", {
          d: "M21.147 12.95c-1.89 1.525-3.831 2.042-5.742 2.042-2.004 0-3.975-0.557-5.824-1.079-2.93-0.828-5.476-1.52-7.599-0.029v9.101c0 0.552-0.44 0.999-0.985 0.999s-0.986-0.447-0.986-0.999v-20.506c0-0.029 0.014-0.054 0.016-0.083-0.009-0.298 0.097-0.596 0.34-0.801 2.982-2.512 6.419-1.54 9.744-0.601 3.518 0.992 6.838 1.93 9.979-0.731 0.138-0.118 0.301-0.173 0.466-0.202 0.056-0.015 0.102-0.045 0.166-0.045 0.027 0 0.056 0.016 0.084 0.018 0.010 0.001 0.019 0.006 0.029 0.007 0.522 0.066 1.114 0.559 1.114 1.074v10.959c0 0.412-0.381 0.737-0.801 0.876zM15.404 3.999c-2.004 0-3.975-0.557-5.824-1.079-2.93-0.828-5.476-1.52-7.599-0.029v8.709c2.575-1.15 5.388-0.387 8.129 0.389 3.468 0.978 6.745 1.896 9.845-0.629v-8.569c-1.509 0.887-3.039 1.207-4.551 1.207z"
        }));
      },
      users: function users(_ref11) {
        var e = _ref11.className,
            _ref11$width = _ref11.width,
            t = _ref11$width === void 0 ? "34" : _ref11$width,
            _ref11$height = _ref11.height,
            a = _ref11$height === void 0 ? "24" : _ref11$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 34 24"
        }, l.a.createElement("path", {
          d: "M34 19.407v0.593c0 0.552-0.448 1-1 1h-10c-0.552 0-1-0.448-1-1s0.448-1 1-1h8.985c-0.238-3.292-3.34-6-6.985-6-1.618 0-3.146 0.512-4.419 1.482-0.44 0.334-1.066 0.249-1.401-0.189-0.335-0.439-0.25-1.067 0.19-1.402 0.907-0.691 1.949-1.184 3.045-1.5-2.012-0.97-3.415-3.012-3.415-5.391 0-3.308 2.691-6 6-6s6 2.692 6 6c0 2.369-1.392 4.403-3.39 5.377 3.653 1.074 6.39 4.317 6.39 8.030zM29 6c0-2.205-1.794-4-4-4s-4 1.795-4 4c0 2.205 1.794 4 4 4s4-1.795 4-4zM12.823 13.4c4.097 1.17 7.177 4.785 7.177 8.933v0.667c0 0.552-0.448 1-1 1h-18c-0.552 0-1-0.448-1-1v-0.667c0-4.148 3.080-7.763 7.177-8.933-2.457-1.088-4.177-3.545-4.177-6.4 0-3.86 3.14-7 7-7s7 3.14 7 7c0 2.855-1.72 5.312-4.177 6.4zM2.009 22h15.982c-0.197-3.827-3.776-7-7.991-7s-7.794 3.173-7.991 7zM10 2c-2.757 0-5 2.243-5 5s2.243 5 5 5c2.757 0 5-2.243 5-5s-2.243-5-5-5z"
        }));
      },
      user: function user(_ref12) {
        var e = _ref12.className,
            _ref12$width = _ref12.width,
            t = _ref12$width === void 0 ? "20" : _ref12$width,
            _ref12$height = _ref12.height,
            a = _ref12$height === void 0 ? "24" : _ref12$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 20 24"
        }, l.a.createElement("path", {
          d: "M19 24h-18c-0.552 0-1-0.448-1-1v-0.667c0-4.148 3.080-7.763 7.177-8.933-2.457-1.088-4.177-3.545-4.177-6.4 0-3.86 3.14-7 7-7s7 3.14 7 7c0 2.855-1.72 5.312-4.177 6.4 4.097 1.17 7.177 4.785 7.177 8.933v0.667c0 0.552-0.448 1-1 1zM15 7c0-2.757-2.243-5-5-5s-5 2.243-5 5c0 2.757 2.243 5 5 5s5-2.243 5-5zM10 15c-4.215 0-7.794 3.173-7.991 7h15.982c-0.197-3.827-3.776-7-7.991-7z"
        }));
      },
      "user-target": function userTarget(_ref13) {
        var e = _ref13.className,
            _ref13$width = _ref13.width,
            t = _ref13$width === void 0 ? "24" : _ref13$width,
            _ref13$height = _ref13.height,
            a = _ref13$height === void 0 ? "24" : _ref13$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M12 24c-6.617 0-12-5.383-12-12s5.383-12 12-12c6.617 0 12 5.383 12 12s-5.383 12-12 12zM13 2.051v0.949c0 0.552-0.448 1-1 1s-1-0.448-1-1v-0.949c-4.717 0.47-8.478 4.232-8.949 8.949h0.949c0.552 0 1 0.448 1 1s-0.448 1-1 1h-0.949c0.471 4.717 4.232 8.479 8.949 8.95v-0.95c0-0.552 0.448-1 1-1s1 0.448 1 1v0.95c4.717-0.471 8.478-4.233 8.948-8.95h-0.948c-0.552 0-1-0.448-1-1s0.448-1 1-1h0.948c-0.47-4.717-4.231-8.479-8.948-8.949zM15 17h-6c-1.103 0-2-0.785-2-1.75v-0.75c0-0.045 0.020-0.083 0.026-0.126 0.009-0.070 0.017-0.137 0.041-0.204 0.021-0.060 0.052-0.112 0.084-0.167 0.033-0.056 0.064-0.11 0.107-0.159 0.046-0.051 0.098-0.090 0.153-0.131 0.036-0.027 0.061-0.064 0.102-0.087l1.81-1.009c-0.322-0.827-0.33-1.59-0.32-1.851 0-0.006-0.003-0.011-0.003-0.017l0.002-2.25c0-0.026 0.013-0.047 0.015-0.073 0.002-0.031-0.009-0.060-0.003-0.092 0.243-1.441 1.739-2.333 2.986-2.333 1.256 0.041 2.743 0.89 2.986 2.333 0.006 0.032-0.005 0.061-0.003 0.092 0.002 0.025 0.015 0.047 0.015 0.073l0.002 2.25c0 0.006-0.003 0.011-0.003 0.017 0.010 0.262 0.001 1.020-0.318 1.844l1.811 1.018c0.039 0.022 0.063 0.059 0.098 0.085 0.056 0.041 0.109 0.081 0.155 0.133 0.043 0.049 0.074 0.103 0.107 0.158 0.032 0.055 0.062 0.107 0.084 0.168 0.023 0.066 0.032 0.133 0.041 0.203 0.005 0.043 0.025 0.081 0.025 0.125v0.75c0 0.965-0.897 1.75-2 1.75zM12.843 13.872c-0.019-0.011-0.029-0.029-0.047-0.040-0.024-0.016-0.051-0.022-0.074-0.040-0.035-0.027-0.053-0.066-0.084-0.097-0.048-0.048-0.093-0.094-0.13-0.15-0.035-0.054-0.060-0.109-0.084-0.168-0.025-0.060-0.047-0.117-0.060-0.181-0.013-0.062-0.015-0.123-0.015-0.186-0.001-0.065 0-0.126 0.012-0.191s0.036-0.125 0.061-0.188c0.016-0.040 0.018-0.083 0.039-0.121 0.013-0.022 0.034-0.035 0.048-0.056s0.017-0.045 0.033-0.065c0.504-0.654 0.456-1.562 0.456-1.571-0.001-0.017 0.006-0.031 0.006-0.047 0-0.007-0.004-0.013-0.004-0.020l-0.002-2.116c-0.076-0.286-0.55-0.635-0.998-0.635s-0.921 0.35-0.998 0.635l-0.002 2.116c0 0.007-0.004 0.012-0.004 0.019 0 0.017 0.008 0.031 0.006 0.048-0.001 0.031-0.042 0.925 0.457 1.57 0.022 0.029 0.028 0.064 0.046 0.094 0.010 0.016 0.027 0.025 0.036 0.042 0.016 0.028 0.016 0.059 0.028 0.088 0.032 0.074 0.059 0.146 0.072 0.223 0.011 0.062 0.012 0.121 0.012 0.182-0.001 0.060-0.003 0.118-0.015 0.177-0.015 0.077-0.041 0.147-0.073 0.219-0.018 0.040-0.035 0.078-0.059 0.116-0.049 0.081-0.112 0.149-0.185 0.214-0.016 0.015-0.024 0.035-0.041 0.048-0.012 0.009-0.027 0.012-0.039 0.021-0.031 0.022-0.051 0.054-0.086 0.073l-1.999 1.115h5.694l-2.007-1.128z"
        }));
      },
      "user-profile-2": function userProfile2(_ref14) {
        var e = _ref14.className,
            _ref14$width = _ref14.width,
            t = _ref14$width === void 0 ? "29" : _ref14$width,
            _ref14$height = _ref14.height,
            a = _ref14$height === void 0 ? "24" : _ref14$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 29 24"
        }, l.a.createElement("path", {
          d: "M26.72 20.4h-24.641c-1.147 0-2.080-0.942-2.080-2.1v-16.2c0-1.158 0.932-2.1 2.080-2.1h24.641c1.147 0 2.080 0.942 2.080 2.1v16.2c0 1.158-0.932 2.1-2.080 2.1zM26.4 2.4h-24v15.6h24v-15.6zM3.683 13.392c0.026-0.073 0.067-0.134 0.107-0.199 0.040-0.066 0.074-0.132 0.127-0.19 0.058-0.064 0.126-0.11 0.197-0.161 0.044-0.032 0.076-0.077 0.125-0.103l2.3-1.217c-0.422-1.034-0.457-1.973-0.457-2.191 0-0.012-0.006-0.022-0.006-0.032l0.002-2.7c0-0.031 0.014-0.056 0.017-0.086 0.002-0.038-0.010-0.073-0.004-0.112 0.292-1.73 2.1-2.801 3.608-2.801 1.499 0 3.298 1.070 3.589 2.801 0.007 0.038-0.006 0.073-0.004 0.112 0.002 0.030 0.018 0.055 0.018 0.086l0.002 2.7c0 0.012-0.006 0.022-0.007 0.032-0.001 0.212-0.037 1.164-0.469 2.209l2.159 1.214c0.046 0.025 0.073 0.067 0.115 0.098 0.068 0.050 0.133 0.1 0.19 0.163 0.052 0.059 0.088 0.122 0.126 0.188 0.040 0.066 0.076 0.128 0.102 0.202 0.028 0.080 0.038 0.161 0.049 0.246 0.007 0.050 0.030 0.095 0.030 0.148v0.9c0 1.158-0.898 2.1-2 2.1h-7.999c-1.103 0-2-0.942-2-2.1v-0.9c0-0.056 0.025-0.104 0.032-0.158 0.012-0.086 0.020-0.169 0.050-0.25zM10.61 13.046c-0.023-0.013-0.036-0.036-0.058-0.049-0.029-0.019-0.061-0.026-0.088-0.048-0.042-0.031-0.064-0.078-0.1-0.114-0.058-0.058-0.113-0.114-0.157-0.181-0.042-0.065-0.072-0.132-0.102-0.203-0.029-0.071-0.055-0.139-0.071-0.215s-0.018-0.149-0.018-0.226c-0.001-0.077 0-0.151 0.014-0.228 0.014-0.078 0.042-0.149 0.072-0.222 0.019-0.049 0.022-0.102 0.048-0.149 0.016-0.028 0.042-0.043 0.060-0.070 0.016-0.024 0.019-0.053 0.037-0.076 0.635-0.823 0.65-1.955 0.65-1.967 0-0.011 0.006-0.019 0.006-0.029l-0.002-2.509c-0.092-0.343-0.662-0.762-1.204-0.762-0.551 0-1.13 0.42-1.223 0.762l-0.001 2.514c0 0.011 0.005 0.019 0.005 0.030 0 0.037 0.018 1.15 0.644 1.961 0.030 0.038 0.037 0.085 0.062 0.126 0.013 0.023 0.036 0.036 0.048 0.060 0.017 0.031 0.016 0.066 0.029 0.097 0.037 0.089 0.065 0.175 0.079 0.268 0.013 0.073 0.016 0.143 0.014 0.217-0.002 0.071-0.007 0.139-0.023 0.209-0.018 0.091-0.047 0.175-0.085 0.26-0.023 0.048-0.046 0.092-0.074 0.138-0.060 0.096-0.133 0.176-0.22 0.253-0.019 0.017-0.028 0.040-0.047 0.054-0.018 0.013-0.038 0.018-0.056 0.030-0.041 0.030-0.070 0.071-0.116 0.096l-2.503 1.325h6.785l-2.407-1.354zM16.8 7.2h4.8c0.664 0 1.2 0.538 1.2 1.2s-0.536 1.2-1.2 1.2h-4.8c-0.664 0-1.2-0.538-1.2-1.2s0.536-1.2 1.2-1.2zM15.6 4.8c0-0.662 0.536-1.2 1.2-1.2h7.2c0.664 0 1.2 0.538 1.2 1.2s-0.536 1.2-1.2 1.2h-7.2c-0.664 0-1.2-0.538-1.2-1.2zM7.2 21.6h14.4c0.664 0 1.2 0.538 1.2 1.2s-0.536 1.2-1.2 1.2h-14.4c-0.664 0-1.2-0.538-1.2-1.2s0.536-1.2 1.2-1.2z"
        }));
      },
      "user-picture-1": function userPicture1(_ref15) {
        var e = _ref15.className,
            _ref15$width = _ref15.width,
            t = _ref15$width === void 0 ? "24" : _ref15$width,
            _ref15$height = _ref15.height,
            a = _ref15$height === void 0 ? "24" : _ref15$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M22.022 24h-20.045c-1.090 0-1.977-0.887-1.977-1.977v-20.045c0-1.091 0.887-1.978 1.977-1.978h20.045c1.091 0 1.978 0.887 1.978 1.978v20.045c0 1.090-0.887 1.977-1.978 1.977zM22 22v-3h-20.003l0.003 3.023 20-0.023zM12 14c-1.858 0-3.411 1.28-3.858 3h7.716c-0.447-1.72-2-3-3.858-3zM14 9c0-1.103-0.897-2-2-2s-2 0.897-2 2c0 1.103 0.897 2 2 2s2-0.897 2-2zM1.977 2l0.017 15h4.094c0.361-2.126 1.848-3.865 3.824-4.604-1.142-0.705-1.912-1.958-1.912-3.396 0-2.206 1.794-4 4-4s4 1.794 4 4c0 1.438-0.77 2.691-1.912 3.396 1.976 0.739 3.463 2.478 3.824 4.604h4.088v-15.022l-20.023 0.022z"
        }));
      },
      "user-picture-2": function userPicture2(_ref16) {
        var e = _ref16.className,
            _ref16$width = _ref16.width,
            t = _ref16$width === void 0 ? "24" : _ref16$width,
            _ref16$height = _ref16.height,
            a = _ref16$height === void 0 ? "24" : _ref16$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M21.533 24h-19.066c-1.361 0-2.467-1.106-2.467-2.467v-19.066c0-1.36 1.106-2.467 2.467-2.467h19.066c1.361 0 2.467 1.107 2.467 2.467v19.066c0 1.361-1.106 2.467-2.467 2.467zM22 2.467c0-0.253-0.214-0.467-0.467-0.467h-19.066c-0.253 0-0.467 0.214-0.467 0.467v19.066c0 0.253 0.214 0.467 0.467 0.467h19.066c0.253 0 0.467-0.214 0.467-0.467v-19.066zM18.020 20c-0.007 0-0.014 0-0.020 0h-12c-0.552 0-1-0.448-1-1 0-2.687 1.871-4.834 4.602-5.64-1.542-0.852-2.602-2.477-2.602-4.36 0-2.757 2.243-5 5-5s5 2.243 5 5c0 1.882-1.058 3.505-2.598 4.358 2.655 0.784 4.496 2.838 4.594 5.423 0.016 0.070 0.024 0.144 0.024 0.219 0 0.552-0.448 1-1 1zM12 6c-1.654 0-3 1.346-3 3s1.346 3 3 3c1.654 0 3-1.346 3-3s-1.346-3-3-3zM12 15c-2.461 0-4.349 1.214-4.861 3h9.722c-0.512-1.786-2.4-3-4.861-3z"
        }));
      },
      "user-delete": function userDelete(_ref17) {
        var e = _ref17.className,
            _ref17$width = _ref17.width,
            t = _ref17$width === void 0 ? "28" : _ref17$width,
            _ref17$height = _ref17.height,
            a = _ref17$height === void 0 ? "24" : _ref17$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 28 24"
        }, l.a.createElement("path", {
          d: "M25.32 12l2.286 2.293c0.389 0.39 0.389 1.023 0 1.414-0.195 0.195-0.45 0.293-0.705 0.293s-0.51-0.098-0.705-0.293l-2.285-2.293-2.286 2.293c-0.195 0.195-0.45 0.293-0.705 0.293s-0.51-0.098-0.704-0.293c-0.39-0.391-0.39-1.024 0-1.414l2.285-2.293-2.285-2.293c-0.39-0.391-0.39-1.024 0-1.414 0.389-0.391 1.020-0.391 1.409 0l2.286 2.293 2.285-2.293c0.389-0.391 1.020-0.391 1.41 0 0.389 0.39 0.389 1.023 0 1.414l-2.286 2.293zM19.924 22.334v0.666c0 0.552-0.447 1-0.997 1h-17.942c-0.55 0-0.996-0.448-0.996-1v-0.666c0-4.151 3.074-7.768 7.161-8.936-2.452-1.086-4.171-3.541-4.171-6.398 0-3.86 3.13-7 6.977-7s6.977 3.14 6.977 7c0 2.857-1.719 5.312-4.171 6.398 4.087 1.168 7.162 4.785 7.162 8.936zM14.94 7c0-2.757-2.236-5-4.984-5s-4.984 2.243-4.984 5c0 2.757 2.236 5 4.984 5s4.984-2.243 4.984-5zM9.956 15c-4.201 0-7.768 3.173-7.965 7h15.93c-0.197-3.827-3.764-7-7.965-7z"
        }));
      },
      "user-circle": function userCircle(_ref18) {
        var e = _ref18.className,
            _ref18$width = _ref18.width,
            t = _ref18$width === void 0 ? "24" : _ref18$width,
            _ref18$height = _ref18.height,
            a = _ref18$height === void 0 ? "24" : _ref18$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M12 24c-6.617 0-12-5.383-12-12s5.383-12 12-12c6.617 0 12 5.383 12 12s-5.383 12-12 12zM17.3 20.464c-0.006-0.033-0.024-0.061-0.027-0.096-0.182-2.409-2.547-4.368-5.273-4.368-2.662 0-5.024 2.009-5.273 4.481 1.533 0.957 3.337 1.519 5.273 1.519 1.948 0 3.762-0.569 5.3-1.536zM15.022 10c0-1.654-1.345-3-2.999-3-1.655 0-3.001 1.346-3.001 3s1.346 3 3.001 3c1.654 0 2.999-1.345 2.999-3zM12 2c-5.514 0-10 4.486-10 10 0 2.779 1.141 5.295 2.978 7.109 0.658-2.189 2.479-3.96 4.721-4.709-1.583-0.84-2.677-2.486-2.677-4.4 0-2.757 2.244-5 5.001-5 2.756 0 4.999 2.243 4.999 5 0 1.905-1.083 3.545-2.655 4.389 2.3 0.733 4.094 2.482 4.692 4.687 1.816-1.812 2.941-4.315 2.941-7.076 0-5.514-4.486-10-10-10z"
        }));
      },
      "user-check": function userCheck(_ref19) {
        var e = _ref19.className,
            _ref19$width = _ref19.width,
            t = _ref19$width === void 0 ? "29" : _ref19$width,
            _ref19$height = _ref19.height,
            a = _ref19$height === void 0 ? "24" : _ref19$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 29 24"
        }, l.a.createElement("path", {
          d: "M28.675 8.579l-4.949 7c-0.169 0.239-0.434 0.392-0.725 0.417l-0.086 0.004c-0.261 0-0.514-0.103-0.701-0.289l-3.016-3.001c-0.391-0.388-0.394-1.021-0.007-1.414 0.386-0.392 1.017-0.396 1.408-0.006l2.183 2.17 4.27-6.039c0.319-0.45 0.94-0.555 1.388-0.237 0.448 0.32 0.554 0.945 0.235 1.395zM12.753 13.4c4.079 1.17 7.145 4.786 7.145 8.934v0.666c0 0.552-0.445 1-0.995 1h-17.922c-0.55 0-0.996-0.448-0.996-1v-0.666c0-4.148 3.067-7.764 7.146-8.934-2.446-1.088-4.159-3.545-4.159-6.4 0-3.86 3.127-7 6.97-7s6.97 3.14 6.97 7c0 2.855-1.713 5.312-4.159 6.4zM1.985 22h15.913c-0.196-3.827-3.76-7-7.956-7s-7.76 3.173-7.957 7zM9.942 2c-2.745 0-4.978 2.243-4.978 5s2.233 5 4.978 5c2.745 0 4.978-2.243 4.978-5s-2.233-5-4.978-5z"
        }));
      },
      "user-add": function userAdd(_ref20) {
        var e = _ref20.className,
            _ref20$width = _ref20.width,
            t = _ref20$width === void 0 ? "29" : _ref20$width,
            _ref20$height = _ref20.height,
            a = _ref20$height === void 0 ? "24" : _ref20$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 29 24"
        }, l.a.createElement("path", {
          d: "M28 13h-3v3c0 0.552-0.448 1-1 1s-1-0.448-1-1v-3h-3c-0.552 0-1-0.448-1-1s0.448-1 1-1h3v-3c0-0.552 0.448-1 1-1s1 0.448 1 1v3h3c0.552 0 1 0.448 1 1s-0.448 1-1 1zM12.823 13.4c4.097 1.17 7.177 4.786 7.177 8.934v0.666c0 0.552-0.448 1-1 1h-18c-0.552 0-1-0.448-1-1v-0.666c0-4.148 3.080-7.764 7.177-8.934-2.457-1.088-4.177-3.545-4.177-6.4 0-3.86 3.14-7 7-7s7 3.14 7 7c0 2.855-1.72 5.312-4.177 6.4zM2.009 22h15.982c-0.197-3.827-3.777-7-7.991-7s-7.793 3.173-7.991 7zM10 2c-2.757 0-5 2.243-5 5s2.243 5 5 5c2.757 0 5-2.243 5-5s-2.243-5-5-5z"
        }));
      },
      "team-2": function team2(_ref21) {
        var e = _ref21.className,
            _ref21$width = _ref21.width,
            t = _ref21$width === void 0 ? "24" : _ref21$width,
            _ref21$height = _ref21.height,
            a = _ref21$height === void 0 ? "24" : _ref21$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M24 23c0 0.552-0.448 1-1 1h-8c-0.552 0-1-0.448-1-1 0-2.109 1.317-3.908 3.168-4.642-0.705-0.549-1.168-1.397-1.168-2.358 0-1.654 1.346-3 3-3s3 1.346 3 3c0 0.961-0.463 1.809-1.168 2.358 1.851 0.734 3.168 2.533 3.168 4.642zM19 15c-0.551 0-1 0.449-1 1s0.449 1 1 1c0.551 0 1-0.449 1-1s-0.449-1-1-1zM19 20c-1.304 0-2.416 0.836-2.829 2h5.658c-0.413-1.164-1.525-2-2.829-2zM16.020 11c-0.007 0-0.014 0-0.020 0h-8c-0.552 0-1-0.448-1-1 0-2.109 1.317-3.908 3.168-4.641-0.705-0.55-1.168-1.397-1.168-2.359 0-1.654 1.346-3 3-3s3 1.346 3 3c0 0.96-0.461 1.806-1.164 2.355 1.784 0.708 3.070 2.41 3.159 4.422 0.016 0.072 0.025 0.146 0.025 0.223 0 0.552-0.448 1-1 1zM12 2c-0.551 0-1 0.449-1 1s0.449 1 1 1c0.551 0 1-0.449 1-1s-0.449-1-1-1zM12 7c-1.304 0-2.416 0.836-2.829 2h5.658c-0.413-1.164-1.525-2-2.829-2zM8 16c0 0.961-0.463 1.809-1.168 2.358 1.851 0.734 3.168 2.533 3.168 4.642 0 0.552-0.448 1-1 1h-8c-0.552 0-1-0.448-1-1 0-2.109 1.317-3.908 3.168-4.642-0.705-0.549-1.168-1.397-1.168-2.358 0-1.654 1.346-3 3-3s3 1.346 3 3zM2.171 22h5.658c-0.413-1.164-1.525-2-2.829-2s-2.416 0.836-2.829 2zM5 15c-0.551 0-1 0.449-1 1s0.449 1 1 1c0.551 0 1-0.449 1-1s-0.449-1-1-1zM9.106 16.448c-0.248-0.495-0.047-1.095 0.447-1.342l1.447-0.724v-1.382c0-0.552 0.448-1 1-1s1 0.448 1 1v1.382l1.447 0.724c0.494 0.247 0.695 0.847 0.448 1.342-0.176 0.35-0.529 0.552-0.896 0.552-0.15 0-0.303-0.034-0.446-0.106l-1.553-0.776-1.553 0.776c-0.143 0.072-0.296 0.106-0.446 0.106-0.367 0-0.72-0.202-0.895-0.552z"
        }));
      },
      activity: function activity(_ref22) {
        var e = _ref22.className,
            _ref22$width = _ref22.width,
            t = _ref22$width === void 0 ? "40" : _ref22$width,
            _ref22$height = _ref22.height,
            a = _ref22$height === void 0 ? "28" : _ref22$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 18 20"
        }, l.a.createElement("g", {
          id: "Integration-Types",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "Multi-Level-1",
          transform: "translate(-385.000000, -469.000000)",
          fill: "#394F5A"
        }, l.a.createElement("path", {
          d: "M400.654273,488.988333 C400.635455,488.99 400.619091,489 400.599455,489 L387.400545,489 C387.380909,489 387.364545,488.99 387.345727,488.988333 C386.043182,488.929167 385,487.84 385,486.5 L385,474.833333 C385,474.3725 385.366545,474 385.818182,474 L388.218727,474 C388.237545,474 388.253909,474.01 388.272727,474.010833 L388.272727,469.833333 C388.272727,469.3725 388.639273,469 389.090909,469 L402.181818,469 C402.633455,469 403,469.3725 403,469.833333 L403,486.5 C403,487.84 401.956818,488.929167 400.654273,488.988333 Z M388.272727,475.655833 C388.253909,475.656667 388.237545,475.666667 388.218727,475.666667 L386.636364,475.666667 L386.636364,486.5 C386.636364,486.96 387.003727,487.333333 387.454545,487.333333 C387.905364,487.333333 388.272727,486.96 388.272727,486.5 L388.272727,475.655833 Z M401.363636,470.666667 L389.909091,470.666667 L389.909091,486.5 C389.909091,486.794167 389.850182,487.071667 389.758545,487.333333 L400.545455,487.333333 C400.996273,487.333333 401.363636,486.96 401.363636,486.5 L401.363636,470.666667 Z M399.727273,483.166667 L391.545455,483.166667 C391.093818,483.166667 390.727273,482.794167 390.727273,482.333333 C390.727273,481.873333 391.093818,481.5 391.545455,481.5 L399.727273,481.5 C400.178909,481.5 400.545455,481.873333 400.545455,482.333333 C400.545455,482.794167 400.178909,483.166667 399.727273,483.166667 Z M399.727273,479.833333 L391.545455,479.833333 C391.093818,479.833333 390.727273,479.460833 390.727273,479 C390.727273,478.539167 391.093818,478.166667 391.545455,478.166667 L399.727273,478.166667 C400.178909,478.166667 400.545455,478.539167 400.545455,479 C400.545455,479.460833 400.178909,479.833333 399.727273,479.833333 Z M396.454545,475.666667 L391.545455,475.666667 C391.093818,475.666667 390.727273,475.294167 390.727273,474.833333 C390.727273,474.3725 391.093818,474 391.545455,474 L396.454545,474 C396.906182,474 397.272727,474.3725 397.272727,474.833333 C397.272727,475.294167 396.906182,475.666667 396.454545,475.666667 Z",
          id: "activity"
        }))));
      },
      rolodex: function rolodex(_ref23) {
        var e = _ref23.className,
            _ref23$width = _ref23.width,
            t = _ref23$width === void 0 ? "45" : _ref23$width,
            _ref23$height = _ref23.height,
            a = _ref23$height === void 0 ? "31" : _ref23$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 45 31"
        }, l.a.createElement("path", {
          d: "M43.594 31H1.406C.63 31 0 30.37 0 29.59V1.41C0 .63.63 0 1.406 0h42.188C44.37 0 45 .63 45 1.41v28.18c0 .78-.63 1.41-1.406 1.41zM42.187 2.818H2.813v25.364H8.44v-1.41c0-.777.63-1.408 1.407-1.408.776 0 1.406.63 1.406 1.41v1.408H33.75v-1.41c0-.777.63-1.408 1.406-1.408.778 0 1.407.63 1.407 1.41v1.408h5.624V2.818zm-5.624 14.09h-11.25c-.775 0-1.405-.63-1.405-1.408 0-.778.63-1.41 1.406-1.41h11.248c.778 0 1.407.632 1.407 1.41 0 .778-.63 1.41-1.407 1.41zm0-5.635h-11.25c-.775 0-1.405-.632-1.405-1.41 0-.777.63-1.408 1.406-1.408h11.248c.778 0 1.407.63 1.407 1.41 0 .776-.63 1.408-1.407 1.408zm-17.81 11.272H9.376c-1.292 0-2.343-1.107-2.343-2.467V19.02c0-.044.02-.08.024-.123.008-.097.028-.188.058-.28.025-.087.054-.168.095-.247.042-.077.093-.146.147-.217.06-.076.124-.142.2-.204.033-.03.052-.07.09-.093l2.67-1.836c-.448-1.03-.48-1.904-.468-2.26 0-.006-.003-.01-.003-.017V10.57c0-.037.02-.068.022-.103.002-.044-.012-.085-.005-.13.34-2.032 2.444-3.29 4.2-3.29h.007c1.748 0 3.848 1.257 4.19 3.29.008.042-.006.083-.003.127.002.037.02.068.02.106l.003 3.173-.003.015c.012.353-.02 1.225-.467 2.255l2.673 1.846c.037.024.055.062.087.09.075.06.14.13.2.206.055.07.104.138.145.216.042.08.07.16.097.248.028.09.046.18.056.277.004.043.025.08.025.123v1.058c0 1.36-1.05 2.467-2.343 2.467zm-3.58-4.934c-.03-.017-.063-.026-.09-.047-.126-.097-.216-.22-.3-.345-.01-.013-.023-.023-.03-.037-.072-.113-.11-.24-.146-.368-.014-.05-.04-.097-.05-.15-.014-.085 0-.173.003-.262.002-.098-.004-.194.02-.29.01-.046.038-.086.053-.13.04-.12.075-.24.15-.35.01-.016.03-.024.042-.04v-.003c.68-.885.648-1.693.647-1.702-.003-.03.01-.058.008-.09 0-.015-.01-.03-.01-.048l-.003-2.986c-.11-.403-.773-.896-1.403-.896s-1.297.493-1.404.896l-.002 2.987c0 .014-.007.025-.007.04 0 .026.01.05.01.077-.005.066-.025.855.642 1.722.01.01.01.025.018.038.008.01.02.015.03.027.046.07.06.147.092.22.04.087.09.168.11.258.02.092.014.184.017.277.002.087.014.173 0 .26-.014.09-.055.174-.085.26-.03.083-.05.167-.098.245-.047.08-.12.142-.184.213-.055.06-.09.13-.156.178-.01.01-.027.014-.04.023-.01.008-.013.02-.024.026l-3.086 2.117h8.34L15.17 17.61zm10.14 2.117h5.626c.775 0 1.405.632 1.405 1.41 0 .777-.63 1.408-1.406 1.408h-5.626c-.776 0-1.406-.63-1.406-1.41 0-.776.63-1.408 1.406-1.408z",
          fill: "#0176FF",
          fillRule: "evenodd"
        }));
      },
      "location-2": function location2(_ref24) {
        var e = _ref24.className,
            _ref24$width = _ref24.width,
            t = _ref24$width === void 0 ? "18" : _ref24$width,
            _ref24$height = _ref24.height,
            a = _ref24$height === void 0 ? "24" : _ref24$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 18 24"
        }, l.a.createElement("path", {
          d: "M9.651 23.759c-0.187 0.16-0.419 0.241-0.651 0.241s-0.464-0.081-0.651-0.241c-0.341-0.293-8.349-7.255-8.349-14.716 0-4.986 4.037-9.043 9-9.043s9 4.057 9 9.043c0 7.461-8.008 14.423-8.349 14.716zM9 2c-3.859 0-7 3.16-7 7.043 0 5.402 5.148 10.823 6.999 12.597 1.851-1.776 7.001-7.205 7.001-12.597 0-3.883-3.141-7.043-7-7.043zM9 13.074c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4zM9 7.074c-1.102 0-2 0.897-2 2s0.898 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2z"
        }));
      },
      infinite: function infinite(_ref25) {
        var e = _ref25.className,
            _ref25$width = _ref25.width,
            t = _ref25$width === void 0 ? "47" : _ref25$width,
            _ref25$height = _ref25.height,
            a = _ref25$height === void 0 ? "24" : _ref25$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 47 24"
        }, l.a.createElement("path", {
          d: "M43.161 20.489c-2.365 2.355-5.543 3.534-8.709 3.534-3.135 0-6.257-1.151-8.577-3.464-0.772-0.768-0.792-2.030-0.043-2.822s1.98-0.811 2.75-0.043c3.145 3.133 8.69 3.096 11.87-0.070 1.505-1.501 2.334-3.491 2.334-5.605-0.002-2.11-0.83-4.096-2.334-5.59-3.137-3.131-8.237-3.133-11.387-0.021-1.599 1.729-2.641 3.878-3.742 6.154-1.28 2.645-2.6 5.38-4.928 7.877-0.010 0.010-0.023 0.012-0.033 0.021-0.008 0.010-0.010 0.021-0.019 0.029-2.318 2.311-5.364 3.466-8.414 3.466-3.046 0-6.091-1.155-8.412-3.466-2.266-2.26-3.516-5.269-3.514-8.472 0.002-3.197 1.251-6.2 3.514-8.454 4.703-4.687 12.618-4.722 17.286-0.074 0.772 0.768 0.792 2.030 0.043 2.822-0.751 0.794-1.982 0.809-2.75 0.043-3.145-3.131-8.69-3.098-11.868 0.074-1.507 1.496-2.334 3.481-2.336 5.592 0 2.114 0.827 4.104 2.334 5.607 3.139 3.122 8.237 3.125 11.382 0.019 1.904-2.048 3.036-4.384 4.232-6.858 1.188-2.458 2.418-4.998 4.442-7.173 0.008-0.010 0.021-0.012 0.031-0.021 0.008-0.010 0.012-0.021 0.019-0.029 4.639-4.627 12.191-4.627 16.829 0 2.266 2.252 3.512 5.255 3.514 8.453 0.002 3.203-1.247 6.212-3.514 8.472z"
        }));
      },
      "calendar-check": function calendarCheck(_ref26) {
        var e = _ref26.className,
            _ref26$width = _ref26.width,
            t = _ref26$width === void 0 ? "24" : _ref26$width,
            _ref26$height = _ref26.height,
            a = _ref26$height === void 0 ? "24" : _ref26$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M22 24h-20c-1.103 0-2-0.897-2-2v-18c0-1.103 0.897-2 2-2h4v-1c0-0.552 0.447-1 1-1s1 0.448 1 1v1h8v-1c0-0.552 0.447-1 1-1s1 0.448 1 1v1h4c1.102 0 2 0.897 2 2v18c0 1.103-0.898 2-2 2zM18 4v1c0 0.552-0.447 1-1 1s-1-0.448-1-1v-1h-8v1c0 0.552-0.447 1-1 1s-1-0.448-1-1v-1h-4v18h19.997l0.003-18h-4zM11.603 17.652c-0.184 0.215-0.452 0.341-0.735 0.347-0.008 0.001-0.015 0.001-0.023 0.001-0.276 0-0.538-0.113-0.728-0.314l-2.844-3.016c-0.379-0.401-0.361-1.034 0.040-1.413 0.403-0.379 1.035-0.361 1.415 0.041l2.082 2.208 4.431-5.158c0.362-0.419 0.993-0.465 1.41-0.106 0.419 0.359 0.467 0.991 0.108 1.41l-5.156 6z"
        }));
      },
      "video-camera": function videoCamera(_ref27) {
        var e = _ref27.className,
            _ref27$width = _ref27.width,
            t = _ref27$width === void 0 ? "34" : _ref27$width,
            _ref27$height = _ref27.height,
            a = _ref27$height === void 0 ? "24" : _ref27$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 34 24"
        }, l.a.createElement("path", {
          d: "M33.196 23.813c-0.209 0.113-0.438 0.167-0.668 0.167-0.274 0-0.547-0.079-0.785-0.236l-6.286-4.179v1.595c0 1.556-1.269 2.82-2.829 2.82h-19.8c-1.56 0-2.829-1.264-2.829-2.82v-18.332c0-1.554 1.269-2.82 2.829-2.82h19.8c1.56 0 2.829 1.266 2.829 2.82v1.597l6.286-4.179c0.433-0.289 0.993-0.317 1.452-0.071s0.747 0.724 0.747 1.243v21.152c0 0.52-0.287 0.997-0.747 1.243zM31.114 4.055l-6.286 4.178c-0.037 0.024-0.079 0.027-0.117 0.048-0.085 0.047-0.173 0.081-0.269 0.109-0.091 0.027-0.177 0.045-0.269 0.054-0.045 0.004-0.085 0.027-0.13 0.027-0.048 0-0.089-0.023-0.137-0.028-0.095-0.008-0.182-0.027-0.273-0.055-0.089-0.027-0.171-0.059-0.25-0.102-0.078-0.041-0.147-0.089-0.216-0.144-0.076-0.062-0.143-0.129-0.205-0.205-0.028-0.035-0.069-0.055-0.095-0.093-0.024-0.037-0.028-0.081-0.048-0.119-0.047-0.083-0.079-0.168-0.107-0.262s-0.048-0.182-0.057-0.276c-0.004-0.044-0.025-0.082-0.025-0.126v-4.231h-19.8v18.385h19.8v-4.284c0-0.044 0.021-0.082 0.025-0.126 0.008-0.095 0.028-0.184 0.057-0.276 0.028-0.093 0.061-0.178 0.107-0.263 0.020-0.038 0.024-0.081 0.048-0.117 0.025-0.038 0.066-0.059 0.096-0.095 0.061-0.075 0.126-0.14 0.202-0.202 0.071-0.057 0.141-0.106 0.222-0.149 0.076-0.041 0.154-0.072 0.239-0.099 0.095-0.030 0.188-0.048 0.287-0.057 0.045-0.006 0.083-0.027 0.13-0.027 0.044 0 0.081 0.021 0.123 0.025 0.096 0.008 0.187 0.027 0.28 0.055s0.18 0.062 0.263 0.109c0.038 0.020 0.082 0.023 0.119 0.048l6.286 4.178v-15.881z"
        }));
      },
      photo: function photo(_ref28) {
        var e = _ref28.className,
            _ref28$width = _ref28.width,
            t = _ref28$width === void 0 ? "29" : _ref28$width,
            _ref28$height = _ref28.height,
            a = _ref28$height === void 0 ? "24" : _ref28$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 29 24"
        }, l.a.createElement("path", {
          d: "M26.177 24h-23.78c-1.312 0-2.378-1.076-2.378-2.4v-19.2c0-1.324 1.067-2.4 2.378-2.4h23.78c1.31 0 2.586 1.076 2.586 2.4v19.2c0 1.324-1.276 2.4-2.586 2.4zM26.363 2.4h-23.966v10.59l6.36-5.501c0.47-0.408 1.175-0.382 1.614 0.062l6.406 6.464 3.931-2.976c0.506-0.383 1.222-0.299 1.626 0.192l4.030 4.879v-13.711zM26.363 19.86l-5.134-6.216-3.852 2.916c-0.473 0.359-1.135 0.311-1.554-0.112l-6.355-6.414-7.072 6.118v5.448h23.966v-1.74zM19.043 7.2c0-1.324 1.067-2.4 2.38-2.4 1.31 0 2.376 1.076 2.376 2.4s-1.066 2.4-2.376 2.4c-1.313 0-2.38-1.076-2.38-2.4zM21.419 7.201l0.004 1.199 0.001-1.2c-0.001 0-0.004 0-0.005 0.001z"
        }));
      },
      camera: function camera(_ref29) {
        var e = _ref29.className,
            _ref29$width = _ref29.width,
            t = _ref29$width === void 0 ? "29" : _ref29$width,
            _ref29$height = _ref29.height,
            a = _ref29$height === void 0 ? "24" : _ref29$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 29 24"
        }, l.a.createElement("path", {
          d: "M25.2 24h-21.6c-1.985 0-3.6-1.615-3.6-3.6v-13.2c0-1.985 1.615-3.6 3.6-3.6h2.879l1.577-2.963c0.208-0.392 0.616-0.637 1.060-0.637h10.57c0.444 0 0.852 0.245 1.060 0.637l1.577 2.963h2.879c1.985 0 3.6 1.615 3.6 3.6v13.2c0 1.985-1.615 3.6-3.6 3.6zM26.4 7.2c0-0.661-0.539-1.2-1.2-1.2h-3.6c-0.202 0-0.383-0.062-0.55-0.15-0.046-0.024-0.082-0.054-0.125-0.084-0.13-0.091-0.236-0.202-0.322-0.336-0.017-0.026-0.048-0.037-0.064-0.066l-1.576-2.964h-9.13l-1.576 2.964c-0.028 0.052-0.073 0.083-0.106 0.128-0.049 0.068-0.095 0.134-0.157 0.191-0.059 0.053-0.124 0.089-0.191 0.128-0.065 0.040-0.126 0.080-0.199 0.107-0.079 0.029-0.161 0.037-0.245 0.049-0.055 0.007-0.104 0.032-0.162 0.032h-3.6c-0.661 0-1.2 0.539-1.2 1.2v13.2c0 0.661 0.539 1.2 1.2 1.2h21.6c0.661 0 1.2-0.539 1.2-1.2v-13.2zM14.4 19.2c-3.64 0-6.6-2.96-6.6-6.599 0-3.64 2.96-6.6 6.6-6.6s6.6 2.96 6.6 6.6c0 3.638-2.96 6.599-6.6 6.599zM14.4 8.401c-2.316 0-4.2 1.884-4.2 4.2 0 2.315 1.884 4.199 4.2 4.199s4.2-1.884 4.2-4.199c0-2.316-1.884-4.2-4.2-4.2z"
        }));
      },
      "target-4": function target4(_ref30) {
        var e = _ref30.className,
            _ref30$width = _ref30.width,
            t = _ref30$width === void 0 ? "24" : _ref30$width,
            _ref30$height = _ref30.height,
            a = _ref30$height === void 0 ? "24" : _ref30$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M23 13h-2.061c-0.463 4.164-3.775 7.478-7.939 7.941v2.059c0 0.552-0.447 1-1 1s-1-0.448-1-1v-2.059c-4.164-0.463-7.476-3.777-7.939-7.941h-2.061c-0.553 0-1-0.448-1-1s0.447-1 1-1h2.061c0.463-4.164 3.774-7.479 7.939-7.942v-2.058c0-0.552 0.447-1 1-1s1 0.448 1 1v2.058c4.165 0.463 7.476 3.778 7.939 7.942h2.061c0.553 0 1 0.448 1 1s-0.447 1-1 1zM13 18.899c3.054-0.443 5.464-2.848 5.907-5.899h-2.017c-0.4 1.954-1.935 3.5-3.89 3.898v2.001zM13 11h1.816c-0.304-0.843-0.97-1.514-1.816-1.816v1.816zM14.815 13h-1.815v1.815c0.846-0.302 1.511-0.973 1.815-1.815zM11 13h-1.815c0.304 0.842 0.969 1.513 1.815 1.815v-1.815zM11 18.899v-2.001c-1.955-0.398-3.49-1.944-3.89-3.898h-2.017c0.443 3.051 2.853 5.456 5.907 5.899zM11 5.1c-3.055 0.443-5.464 2.849-5.907 5.9h2.017c0.399-1.954 1.935-3.5 3.89-3.899v-2.001zM9.184 11h1.816v-1.816c-0.846 0.302-1.512 0.973-1.816 1.816zM13 5.1v2.001c1.955 0.399 3.491 1.945 3.89 3.899h2.017c-0.443-3.051-2.852-5.457-5.907-5.9z"
        }));
      },
      "target-2": function target2(_ref31) {
        var e = _ref31.className,
            _ref31$width = _ref31.width,
            t = _ref31$width === void 0 ? "24" : _ref31$width,
            _ref31$height = _ref31.height,
            a = _ref31$height === void 0 ? "24" : _ref31$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M22.893 17.042c-0.234 0.5-0.828 0.719-1.328 0.486-0.501-0.233-0.719-0.828-0.487-1.328 0.612-1.318 0.922-2.731 0.922-4.2 0-5.514-4.486-10-10-10s-10 4.486-10 10c0 5.514 4.486 10 10 10 1.483 0 2.912-0.317 4.244-0.942 0.504-0.237 1.096-0.020 1.33 0.48 0.235 0.5 0.020 1.095-0.48 1.33-1.601 0.751-3.315 1.132-5.094 1.132-6.617 0-12-5.383-12-12s5.383-12 12-12c6.617 0 12 5.383 12 12 0 1.762-0.373 3.458-1.107 5.042zM12 17.976c0.58 0 1.153-0.083 1.705-0.247 0.532-0.16 1.086 0.144 1.243 0.672 0.158 0.53-0.143 1.086-0.673 1.244-0.736 0.22-1.501 0.331-2.275 0.331-4.379 0-7.941-3.562-7.941-7.941 0-4.417 3.576-8.011 7.972-8.011 4.362 0 7.911 3.594 7.911 8.011 0 0.685-0.088 1.365-0.261 2.023-0.14 0.534-0.689 0.852-1.221 0.713-0.534-0.141-0.853-0.688-0.713-1.222 0.129-0.492 0.195-1.001 0.195-1.514 0-3.314-2.652-6.011-5.911-6.011-3.293 0-5.972 2.697-5.972 6.011 0 3.276 2.665 5.941 5.941 5.941zM12 15.998c-2.204 0-3.997-1.794-3.997-3.998s1.793-3.997 3.997-3.997c2.204 0 3.997 1.793 3.997 3.997 0 0.739-0.215 1.423-0.566 2.017l4.961 4.96h2.577c0.553 0 1 0.448 1 1s-0.447 1-1 1h-1.991v1.992c0 0.552-0.448 0.999-1 0.999-0.553 0-1-0.447-1-0.999v-2.578l-4.961-4.96c-0.594 0.351-1.278 0.567-2.017 0.567zM13.997 12c0-1.101-0.895-1.997-1.997-1.997s-1.997 0.896-1.997 1.997c0 1.101 0.895 1.997 1.997 1.997 0.177 0 0.346-0.030 0.509-0.074l-0.219-0.219c-0.391-0.39-0.391-1.024 0-1.414 0.391-0.391 1.024-0.391 1.414 0l0.219 0.219c0.044-0.163 0.074-0.332 0.074-0.509z"
        }));
      },
      "speech-buble-money": function speechBubleMoney(_ref32) {
        var e = _ref32.className,
            _ref32$width = _ref32.width,
            t = _ref32$width === void 0 ? "26" : _ref32$width,
            _ref32$height = _ref32.height,
            a = _ref32$height === void 0 ? "24" : _ref32$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M13.091 20.727h-1.783c-2.112 3.101-6.708 3.267-6.914 3.273-0.010 0-0.021 0-0.031 0-0.435 0-0.832-0.261-1.004-0.663-0.176-0.411-0.082-0.888 0.237-1.203 0.045-0.046 1.651-1.679 1.955-3.616-3.587-2.073-5.552-4.963-5.552-8.196 0-5.691 5.872-10.321 13.091-10.321s13.091 4.63 13.091 10.321c0 5.738-5.872 10.406-13.091 10.406zM13.091 2.182c-6.015 0-10.909 3.651-10.909 8.139 0 3.466 3.143 5.631 5.016 6.613 0.36 0.188 0.585 0.561 0.585 0.967 0 1.284-0.428 2.47-0.94 3.429 1.103-0.375 2.28-1.034 2.879-2.194 0.188-0.362 0.562-0.59 0.97-0.59h2.4c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139zM13.091 8.727c1.836 0 3.273 1.198 3.273 2.727 0 1.216-0.916 2.212-2.212 2.573 0.008 0.052 0.031 0.099 0.031 0.154v1.091c0 0.602-0.488 1.091-1.091 1.091s-1.091-0.489-1.091-1.091v-1.091h-1.091c-0.603 0-1.091-0.489-1.091-1.091s0.488-1.091 1.091-1.091h2.182c0.676 0 1.091-0.352 1.091-0.545 0-0.192-0.415-0.545-1.091-0.545-1.836 0-3.273-1.198-3.273-2.727 0-1.216 0.916-2.212 2.212-2.573-0.008-0.052-0.031-0.099-0.031-0.154v-1.091c0-0.602 0.488-1.091 1.091-1.091s1.091 0.489 1.091 1.091v1.091h1.091c0.603 0 1.091 0.489 1.091 1.091s-0.488 1.091-1.091 1.091h-2.182c-0.676 0-1.091 0.353-1.091 0.545s0.415 0.545 1.091 0.545z"
        }));
      },
      "money-bag": function moneyBag(_ref33) {
        var e = _ref33.className,
            _ref33$width = _ref33.width,
            t = _ref33$width === void 0 ? "21" : _ref33$width,
            _ref33$height = _ref33.height,
            a = _ref33$height === void 0 ? "24" : _ref33$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 21 24"
        }, l.a.createElement("path", {
          d: "M20.944 16.246c0 4.94-1.985 7.751-6.979 7.751h-5.985c-4.994 0-7.988-2.811-7.988-7.751 0-3.977 4.215-8.106 5.77-9.494-0.74-1.178-2.040-3.535-1.715-5.156 0.118-0.586 0.431-1.057 0.906-1.365 1.087-0.701 2.019 0.415 2.578 1.080 0.080 0.096 0.185 0.22 0.287 0.336 0.004-0.008 0.008-0.015 0.012-0.021 0.346-0.606 0.925-1.621 2.141-1.621 1.078 0 1.628 0.521 1.957 0.83 0.039 0.038 0.075 0.076 0.114 0.109 0.364-0.013 0.517-0.115 0.802-0.305 0.408-0.272 0.965-0.644 2-0.644 0.805 0 1.485 0.495 1.82 1.324 0.543 1.34 0.185 3.614-1.421 5.524 1.648 1.48 5.702 5.518 5.702 9.403zM14.77 1.958c-0.369 0.011-0.521 0.113-0.808 0.304-0.407 0.272-0.965 0.645-2 0.645-0.719 0-1.153-0.41-1.413-0.655-0.231-0.218-0.301-0.284-0.579-0.284-0.082 0.054-0.291 0.422-0.404 0.619-0.296 0.518-0.743 1.301-1.65 1.301-0.788 0-1.348-0.643-1.884-1.282 0.203 0.98 0.98 2.438 1.633 3.43h5.63c1.183-1.147 1.616-2.476 1.618-3.352 0.002-0.413-0.090-0.64-0.143-0.727zM13.568 7.999h-6.238c-1.712 1.471-5.346 5.224-5.346 8.247 0 3.843 2.117 5.756 5.996 5.756h5.985c3.879 0 4.987-1.912 4.987-5.756 0-3.023-3.661-6.778-5.384-8.247zM10.448 14.070c1.374 0 2.49 1.1 2.49 2.452 0 1.003-0.616 1.865-1.494 2.244v0.207c0 0.542-0.445 0.982-0.996 0.982s-0.996-0.44-0.996-0.982h-0.498c-0.551 0-0.997-0.439-0.997-0.981s0.446-0.981 0.997-0.981h1.493c0.274 0 0.498-0.22 0.498-0.491s-0.223-0.49-0.498-0.49c-1.373 0-2.49-1.1-2.49-2.452 0-1.004 0.616-1.865 1.494-2.244v-0.208c0-0.542 0.445-0.981 0.996-0.981s0.996 0.439 0.996 0.981h0.499c0.55 0 0.996 0.44 0.996 0.982s-0.446 0.981-0.996 0.981h-1.494c-0.274 0-0.498 0.22-0.498 0.491s0.223 0.49 0.498 0.49z"
        }));
      },
      "donut-chart-2": function donutChart2(_ref34) {
        var e = _ref34.className,
            _ref34$width = _ref34.width,
            t = _ref34$width === void 0 ? "24" : _ref34$width,
            _ref34$height = _ref34.height,
            a = _ref34$height === void 0 ? "24" : _ref34$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M23 11h-6c-0.395 0-1.065-0.159-1.225-0.521-0.653-1.476-2.108-2.43-3.707-2.43-2.225 0-4.035 1.814-4.035 4.042 0 1.602 0.951 3.059 2.426 3.713 0.361 0.16 0.541 0.8 0.541 1.196v6c0 0.297-0.079 0.579-0.307 0.769-0.181 0.151-0.407 0.231-0.639 0.231-0.060 0-0.121-0.005-0.18-0.017-5.725-1.053-9.88-6.055-9.88-11.892 0-6.667 5.416-12.091 12.074-12.091 5.829 0 10.824 4.16 11.876 9.894 0.053 0.292-0.026 0.593-0.215 0.821-0.19 0.227-0.432 0.285-0.729 0.285zM12.068 2c-5.557 0-10.077 4.527-10.077 10.091 0 4.461 2.907 8.337 7.064 9.634v-4.396c-1.853-1.078-3.020-3.069-3.020-5.238 0-3.331 2.706-6.042 6.033-6.042 2.166 0 4.153 1.168 5.231 3.025h4.39c-1.295-4.163-5.166-7.074-9.621-7.074zM13.677 15.804c0.938-0.417 1.683-1.163 2.098-2.102 0.16-0.361 0.83-0.702 1.225-0.702h6c0.297 0 0.539 0.239 0.729 0.467 0.189 0.228 0.268 0.529 0.215 0.821-0.899 4.899-4.789 8.796-9.682 9.695-0.061 0.012-0.12 0.017-0.18 0.017-0.232 0-0.459-0.080-0.639-0.232-0.228-0.19-0.36-0.471-0.36-0.768v-6.282c0-0.395 0.233-0.754 0.594-0.914zM15.080 21.724c3.134-0.985 5.937-3.585 6.92-6.724h-5c-0.534 0.923-0.998 1.794-1.92 2.329v4.395z"
        }));
      },
      "bar-chart": function barChart(_ref35) {
        var e = _ref35.className,
            _ref35$width = _ref35.width,
            t = _ref35$width === void 0 ? "23" : _ref35$width,
            _ref35$height = _ref35.height,
            a = _ref35$height === void 0 ? "24" : _ref35$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 23 24"
        }, l.a.createElement("path", {
          d: "M22 24h-5c-0.553 0-1-0.448-1-1v-22c0-0.552 0.447-1 1-1h5c0.553 0 1 0.448 1 1v22c0 0.552-0.447 1-1 1zM21 2h-3v20h3v-20zM14 24h-5c-0.553 0-1-0.448-1-1v-10c0-0.552 0.447-1 1-1h5c0.553 0 1 0.448 1 1v10c0 0.552-0.447 1-1 1zM13 14h-3v8h3v-8zM6 24h-5c-0.553 0-1-0.448-1-1v-15c0-0.552 0.447-1 1-1h5c0.553 0 1 0.448 1 1v15c0 0.552-0.447 1-1 1zM5 9h-3v13h3v-13z"
        }));
      },
      "line-chart": function lineChart(_ref36) {
        var e = _ref36.className,
            _ref36$width = _ref36.width,
            t = _ref36$width === void 0 ? "18" : _ref36$width,
            _ref36$height = _ref36.height,
            a = _ref36$height === void 0 ? "18" : _ref36$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 18 18",
          fill: "none"
        }, l.a.createElement("path", {
          d: "M3.15004 13.3349L7.12504 9.3599L9.56254 11.7974C9.87004 12.1049 10.365 12.0899 10.65 11.7674L16.0275 5.7149C16.29 5.4224 16.275 4.9724 15.9975 4.6874C15.6975 4.3874 15.195 4.3949 14.91 4.7174L10.1175 10.1024L7.65004 7.6349C7.35754 7.3424 6.88504 7.3424 6.59254 7.6349L2.02504 12.2099C1.73254 12.5024 1.73254 12.9749 2.02504 13.2674L2.09254 13.3349C2.38504 13.6274 2.86504 13.6274 3.15004 13.3349Z",
          fill: "#687882"
        }));
      },
      "download-2": function download2(_ref37) {
        var e = _ref37.className,
            _ref37$width = _ref37.width,
            t = _ref37$width === void 0 ? "24" : _ref37$width,
            _ref37$height = _ref37.height,
            a = _ref37$height === void 0 ? "24" : _ref37$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M22 24h-20c-1.103 0-2-0.897-2-1.999v-5.998c0-0.552 0.447-0.999 1-0.999s1 0.447 1 0.999v5.998h20v-5.998c0-0.552 0.447-0.999 1-0.999s1 0.447 1 0.999v5.998c0 1.102-0.898 1.999-2 1.999zM12.708 17.699c-0.092 0.093-0.203 0.166-0.326 0.217-0.122 0.051-0.252 0.077-0.382 0.077s-0.26-0.026-0.382-0.077c-0.121-0.050-0.23-0.122-0.322-0.213 0-0.001-0.001-0.001-0.002-0.002v0c-0.001-0.001-0.001-0.001-0.002-0.002l-4.998-4.987c-0.392-0.39-0.392-1.022-0.002-1.413 0.391-0.392 1.023-0.39 1.414-0.002l3.294 3.286v-13.584c0-0.552 0.447-0.999 1-0.999s1 0.447 1 0.999v13.584l3.294-3.286c0.391-0.388 1.023-0.39 1.414 0.002 0.39 0.391 0.39 1.023-0.002 1.413l-4.998 4.987z"
        }));
      },
      "upload-2": function upload2(_ref38) {
        var e = _ref38.className,
            _ref38$width = _ref38.width,
            t = _ref38$width === void 0 ? "24" : _ref38$width,
            _ref38$height = _ref38.height,
            a = _ref38$height === void 0 ? "24" : _ref38$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M22.087 23.993h-20.079c-1.106 0-2.008-0.898-2.008-2v-6c0-0.552 0.449-1 1.004-1s1.004 0.448 1.004 1v6h20.079v-6c0-0.552 0.449-1 1.004-1s1.004 0.448 1.004 1v6c0 1.102-0.901 2-2.008 2zM17.067 6.976c-0.257 0-0.513-0.098-0.709-0.292l-3.307-3.287v13.587c0 0.552-0.449 0.999-1.004 0.999s-1.004-0.447-1.004-0.999v-13.587l-3.307 3.287c-0.393 0.389-1.027 0.391-1.42-0.002-0.392-0.391-0.392-1.024 0.002-1.414l5.018-4.989c0.092-0.092 0.205-0.166 0.328-0.217 0.094-0.039 0.195-0.051 0.296-0.059 0.030-0.003 0.055-0.018 0.086-0.018s0.056 0.015 0.086 0.018c0.1 0.008 0.202 0.020 0.296 0.059 0.122 0.050 0.232 0.122 0.324 0.214 0 0 0.001 0.001 0.002 0.001v0c0.001 0.001 0.001 0.001 0.002 0.002l5.018 4.989c0.394 0.39 0.394 1.023 0.002 1.414-0.196 0.196-0.454 0.294-0.711 0.294z"
        }));
      },
      "warning-circle": function warningCircle(_ref39) {
        var e = _ref39.className,
            _ref39$width = _ref39.width,
            t = _ref39$width === void 0 ? "24" : _ref39$width,
            _ref39$height = _ref39.height,
            a = _ref39$height === void 0 ? "24" : _ref39$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M12 24c-6.617 0-12-5.383-12-12s5.383-12 12-12c6.617 0 12 5.383 12 12s-5.383 12-12 12zM12 2c-5.514 0-10 4.486-10 10s4.486 10 10 10c5.514 0 10-4.486 10-10s-4.486-10-10-10zM12 19c-0.26 0-0.52-0.11-0.71-0.29-0.181-0.19-0.29-0.45-0.29-0.71 0-0.27 0.109-0.52 0.29-0.71 0.37-0.37 1.040-0.37 1.42 0 0.18 0.19 0.29 0.44 0.29 0.71 0 0.26-0.11 0.52-0.29 0.71-0.19 0.18-0.45 0.29-0.71 0.29zM12 15c-0.553 0-1-0.448-1-1v-8c0-0.552 0.447-1 1-1s1 0.448 1 1v8c0 0.552-0.447 1-1 1z"
        }));
      },
      "warning-triangle": function warningTriangle(_ref40) {
        var e = _ref40.className,
            _ref40$width = _ref40.width,
            t = _ref40$width === void 0 ? "15" : _ref40$width,
            _ref40$height = _ref40.height,
            a = _ref40$height === void 0 ? "15" : _ref40$height;
        return l.a.createElement("svg", {
          className: e,
          height: a,
          width: t,
          viewBox: "0 0 24 22",
          fill: "none"
        }, l.a.createElement("path", {
          d: "M23.8121 20.4957L12.9159 0.564103C12.728 0.188034 12.3523 0 11.9765 0C11.6008 0 11.225 0.188034 11.0372 0.564103L0.1409 20.4957C-0.0469667 20.8718 -0.0469667 21.2479 0.1409 21.4359C0.328767 21.812 0.704501 22 1.08023 22H23.0607C23.4364 22 23.8121 21.812 24 21.4359C24 21.2479 24 20.8718 23.8121 20.4957ZM11.0372 9.02564C11.0372 8.46154 11.4129 8.08547 11.9765 8.08547C12.5401 8.08547 12.9159 8.46154 12.9159 9.02564V14.1026C12.9159 14.6667 12.5401 15.0427 11.9765 15.0427C11.4129 15.0427 11.0372 14.6667 11.0372 14.1026V9.02564ZM12.728 17.8632C12.3523 18.2393 11.6008 18.2393 11.225 17.8632C10.8493 17.2991 10.8493 16.735 11.225 16.359C11.6008 15.9829 12.3523 15.9829 12.728 16.359C13.1037 16.735 13.1037 17.2991 12.728 17.8632Z",
          fill: "#C8520E"
        }));
      },
      trash: function trash(_ref41) {
        var e = _ref41.className,
            _ref41$width = _ref41.width,
            t = _ref41$width === void 0 ? "20" : _ref41$width,
            _ref41$height = _ref41.height,
            a = _ref41$height === void 0 ? "24" : _ref41$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 20 24"
        }, l.a.createElement("path", {
          d: "M19 6h-1.090l-1.805 16.117c-0.118 1.056-1.043 1.883-2.105 1.883h-8c-1.064 0-1.987-0.828-2.104-1.885l-1.776-16.115h-1.12c-0.552 0-1-0.448-1-1s0.448-1 1-1h5v-1c0-1.654 1.346-3 3-3h2c1.654 0 3 1.346 3 3v1h5c0.552 0 1 0.448 1 1s-0.448 1-1 1zM12 3c0-0.551-0.449-1-1-1h-2c-0.551 0-1 0.449-1 1v1h4v-1zM4.132 6l1.753 15.897c0.004 0.039 0.075 0.103 0.115 0.103h8c0.040 0 0.113-0.065 0.118-0.105l1.78-15.895h-11.766z"
        }));
      },
      plus: function plus(_ref42) {
        var e = _ref42.className,
            _ref42$width = _ref42.width,
            t = _ref42$width === void 0 ? "35" : _ref42$width,
            _ref42$height = _ref42.height,
            a = _ref42$height === void 0 ? "30" : _ref42$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 11 11"
        }, l.a.createElement("g", {
          id: "Integration-Types",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "Multi-Level--3",
          transform: "translate(-422.000000, -1011.000000)",
          fill: "#394F5A",
          stroke: "#394F5A"
        }, l.a.createElement("path", {
          d: "M427.91243,1016.49996 L430.914487,1019.5023 C431.028504,1019.61618 431.028504,1019.80092 430.914487,1019.9148 C430.857773,1019.9716 430.783133,1020 430.708493,1020 C430.633852,1020 430.559212,1019.9716 430.502204,1019.9148 L427.499853,1016.91247 L424.497796,1019.9148 C424.441081,1019.9716 424.366441,1020 424.291801,1020 C424.217161,1020 424.142521,1019.9716 424.085513,1019.9148 C423.971496,1019.80092 423.971496,1019.61618 424.085513,1019.5023 L427.08757,1016.49996 L424.085513,1013.49792 C423.971496,1013.38404 423.971496,1013.1993 424.085513,1013.08541 C424.19953,1012.97153 424.384073,1012.97153 424.497796,1013.08541 L427.499853,1016.08745 L430.50191,1013.08541 C430.615927,1012.97153 430.80047,1012.97153 430.914487,1013.08541 C431.02821,1013.1993 431.02821,1013.38404 430.914487,1013.49792 L427.91243,1016.49996 Z",
          id: "plus",
          transform: "translate(427.500000, 1016.500000) rotate(45.000000) translate(-427.500000, -1016.500000) "
        }))));
      },
      minus: function minus(_ref43) {
        var e = _ref43.className,
            _ref43$height = _ref43.height,
            t = _ref43$height === void 0 ? "12" : _ref43$height,
            _ref43$width = _ref43.width,
            a = _ref43$width === void 0 ? "12" : _ref43$width;
        return l.a.createElement("svg", {
          className: e,
          width: a,
          height: t,
          viewBox: "0 0 53.06 53.06"
        }, l.a.createElement("g", {
          id: "Symbols"
        }, l.a.createElement("g", {
          id: "controls",
          transform: "translate(-113.000000, -15.000000)"
        }, l.a.createElement("g", {
          id: "Group-8-Copy",
          transform: "translate(71.000000, 0.000000)"
        }, l.a.createElement("g", {
          id: "Group-8",
          transform: "translate(31.000000, 0.000000)"
        }, l.a.createElement("path", {
          fill: "#465259",
          d: "M59.058,46.53H16.001c-2.762,0-5-2.236-5-5s2.238-5,5-5h43.057c2.762,0,5,2.236,5,5S61.82,46.53,59.058,46.53z"
        }))))));
      },
      "share-1": function share1(_ref44) {
        var e = _ref44.className,
            _ref44$width = _ref44.width,
            t = _ref44$width === void 0 ? "26" : _ref44$width,
            _ref44$height = _ref44.height,
            a = _ref44$height === void 0 ? "24" : _ref44$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M25.863 6.214l-4.366 4.364c-0.213 0.214-0.492 0.32-0.771 0.32s-0.559-0.106-0.772-0.32c-0.426-0.426-0.426-1.116 0-1.543l2.503-2.502h-5.006c-4.734 0-8.732 3.898-8.732 8.511 0 0.604-0.489 1.091-1.091 1.091-0.604 0-1.092-0.488-1.092-1.091 0-5.895 4.897-10.693 10.915-10.693h5.006l-2.503-2.501c-0.426-0.426-0.426-1.116 0-1.544 0.426-0.426 1.117-0.426 1.544 0l4.366 4.365c0.426 0.426 0.426 1.116 0 1.544zM6.535 6.533h-4.366v15.276h19.647v-7.637c0-0.603 0.489-1.091 1.091-1.091 0.604 0 1.092 0.489 1.092 1.091v7.637c0 1.204-0.981 2.182-2.184 2.182h-19.647c-1.203 0-2.182-0.978-2.182-2.182v-15.276c0-1.202 0.979-2.182 2.182-2.182h4.366c0.604 0 1.092 0.489 1.092 1.091 0 0.604-0.489 1.091-1.092 1.091z"
        }));
      },
      "settings-1": function settings1(_ref45) {
        var e = _ref45.className,
            _ref45$width = _ref45.width,
            t = _ref45$width === void 0 ? "33" : _ref45$width,
            _ref45$height = _ref45.height,
            a = _ref45$height === void 0 ? "34" : _ref45$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 33 34"
        }, l.a.createElement("path", {
          d: "M29.173 17.01c0-.753-.05-1.42-.165-2.036l-.983.185.655.754 3.075-2.667-.656-.755.554.832c.635-.423.846-1.238.55-1.93C31.574 9.458 30.448 7.52 29 5.87a1.57 1.57 0 0 0-1.85-.445l-3.785 1.307.955.167a12.855 12.855 0 0 0-3.452-2.007l.62.74-.777-4C20.62.986 20.05.418 19.353.318a16.15 16.15 0 0 0-6.415.01c-.64.09-1.21.658-1.31 1.357l-.77 3.95.622-.74C10.2 5.387 9 6.08 8.01 6.91l.97-.18L5.13 5.4c-.606-.264-1.335-.068-1.8.49C1.9 7.52.773 9.457.113 11.477c-.265.608-.054 1.423.58 1.846l.555-.832-.655.755 3.074 2.667.655-.755-.98-.186c-.117.617-.167 1.283-.167 2.037s.05 1.42.166 2.037l.98-.185-.654-.755-3.074 2.667.655.755-.554-.833c-.635.423-.846 1.238-.55 1.93.63 1.936 1.755 3.874 3.205 5.525a1.57 1.57 0 0 0 1.85.444L8.98 27.29l-.97-.18c.99.83 2.187 1.523 3.467 2.018l-.622-.74.778 4c.092.648.66 1.216 1.36 1.316 1.076.2 2.126.307 3.177.307 1.05 0 2.102-.105 3.22-.312.658-.094 1.226-.662 1.326-1.36l.768-3.95-.62.74a12.936 12.936 0 0 0 3.452-2.006l-.955.167 3.852 1.332c.606.263 1.335.067 1.8-.49 1.43-1.63 2.558-3.57 3.218-5.588.265-.61.054-1.424-.58-1.847l-.556.832.655-.756-3.075-2.667-.655.755.983.185c.116-.617.165-1.283.165-2.036zm-2.236 2.232l.433.376 3.074 2.666.1.077a.434.434 0 0 1-.18-.52 14.434 14.434 0 0 1-2.868 4.992c.072-.087.28-.143.442-.074l-3.92-1.36-.523-.18-.43.348c-.893.72-1.88 1.294-2.92 1.697l-.514.2-.105.542-.778 4c.018-.13.14-.255.322-.28a15.787 15.787 0 0 1-2.897.286c-.922 0-1.852-.093-2.855-.28.14.02.264.144.29.324l-.786-4.05-.106-.54-.515-.2c-1.08-.42-2.086-1-2.902-1.686l-.434-.365-.536.186-3.852 1.332c.094-.043.303.013.39.12-1.29-1.47-2.28-3.174-2.853-4.93.04.086-.018.31-.21.44l.1-.078 3.074-2.666.433-.376-.106-.564a9.106 9.106 0 0 1-.13-1.667c0-.64.04-1.186.13-1.667l.106-.564-.433-.377-3.074-2.666-.1-.077c.192.13.25.353.178.522a14.463 14.463 0 0 1 2.87-4.993c-.07.086-.28.142-.44.073l3.918 1.36.536.185.434-.365c.816-.685 1.823-1.267 2.903-1.685l.516-.2.106-.542.777-4c-.018.13-.142.255-.322.28 1.926-.39 3.864-.39 5.733-.01-.122-.015-.245-.14-.27-.32l.785 4.05.106.543.516.198c1.04.403 2.026.977 2.918 1.697l.43.35.525-.183 3.85-1.333c-.093.042-.302-.014-.39-.12 1.29 1.47 2.28 3.173 2.854 4.93-.04-.087.017-.31.21-.44l-.1.077-3.074 2.666-.433.376.105.563c.09.48.13 1.028.13 1.668 0 .64-.04 1.187-.13 1.668l-.105.564zm-15.764-2.23c0-2.76 2.233-5 5-5 2.744 0 5 2.255 5 5a5 5 0 0 1-5 5c-2.78 0-5-2.22-5-5zm12 0c0-3.85-3.15-7-7-7-3.873 0-7 3.138-7 7 0 3.884 3.115 7 7 7a7 7 0 0 0 7-7z",
          fill: "#B5D2E1",
          fillRule: "evenodd"
        }));
      },
      question: function question(_ref46) {
        var e = _ref46.className,
            _ref46$width = _ref46.width,
            t = _ref46$width === void 0 ? "24" : _ref46$width,
            _ref46$height = _ref46.height,
            a = _ref46$height === void 0 ? "24" : _ref46$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24",
          fill: "none"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 24C5.383 24 0 18.617 0 12C0 5.383 5.383 0 12 0C18.617 0 24 5.383 24 12C24 18.617 18.617 24 12 24ZM14.389 12.344C12.94 13.517 12.994 14.816 12.997 14.87C13.028 15.415 12.616 15.892 12.072 15.932C12.046 15.934 12.022 15.935 11.997 15.935C11.484 15.935 11.05 15.551 11.004 15.032C10.996 14.936 10.821 12.659 13.13 10.789C13.772 10.27 14 9.814 14 9.051C14 7.889 13.103 6.943 12 6.943C10.86 6.943 10 7.803 10 8.943C10 9.496 9.552 9.943 9 9.943C8.448 9.943 8 9.496 8 8.943C8 6.701 9.757 4.944 12 4.944C14.206 4.944 16 6.786 16 9.051C16 10.426 15.503 11.442 14.389 12.344ZM12.985 18.114C13.079 17.569 12.709 17.08 12.165 16.986C11.618 16.891 11.099 17.286 11.005 17.83C10.911 18.374 11.276 18.891 11.82 18.985C11.878 18.995 11.935 19 11.991 19C12.469 19 12.892 18.656 12.976 18.17L12.985 18.114Z",
          fill: "#353F45"
        }));
      },
      "refresh-2": function refresh2(_ref47) {
        var e = _ref47.className,
            _ref47$width = _ref47.width,
            t = _ref47$width === void 0 ? "28" : _ref47$width,
            _ref47$height = _ref47.height,
            a = _ref47$height === void 0 ? "24" : _ref47$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 28 24"
        }, l.a.createElement("path", {
          d: "M27.82 19.074c-0.17 0.085-0.353 0.126-0.53 0.126-0.436 0-0.854-0.244-1.063-0.664l-0.994-2.010c-1.762 4.469-5.996 7.474-11.002 7.474-5.438 0-10.298-3.548-11.82-8.628-0.19-0.635 0.164-1.304 0.792-1.496 0.624-0.193 1.29 0.166 1.48 0.8 1.222 4.076 5.148 6.924 9.548 6.924 4.128 0 7.481-2.436 8.838-6.126l-2.372 1.199c-0.588 0.298-1.3 0.056-1.592-0.536s-0.055-1.313 0.53-1.609l4.748-2.401c0.589-0.296 1.301-0.055 1.594 0.538l2.374 4.8c0.294 0.593 0.055 1.314-0.53 1.61zM25.259 10.126c-0.626 0.191-1.291-0.167-1.481-0.802-1.223-4.076-5.148-6.924-9.547-6.924-4.132 0-7.486 2.437-8.842 6.127l2.375-1.201c0.588-0.296 1.301-0.055 1.592 0.538 0.294 0.593 0.056 1.314-0.53 1.61l-4.748 2.399c-0.17 0.086-0.352 0.127-0.529 0.127-0.437 0-0.856-0.242-1.063-0.662l-2.375-4.801c-0.293-0.593-0.055-1.314 0.532-1.61 0.589-0.296 1.3-0.055 1.592 0.538l0.994 2.008c1.759-4.468 5.994-7.471 11.003-7.471 5.436 0 10.296 3.548 11.819 8.628 0.191 0.635-0.164 1.304-0.791 1.498z"
        }));
      },
      "paper-clip": function paperClip(_ref48) {
        var e = _ref48.className,
            _ref48$width = _ref48.width,
            t = _ref48$width === void 0 ? "27" : _ref48$width,
            _ref48$height = _ref48.height,
            a = _ref48$height === void 0 ? "24" : _ref48$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 27 24"
        }, l.a.createElement("path", {
          d: "M12.483 24c-0.287 0-0.573-0.112-0.793-0.334-0.439-0.446-0.439-1.168 0-1.614l11.638-11.833c0.868-0.882 1.346-2.056 1.346-3.303s-0.478-2.42-1.346-3.3c-1.791-1.822-4.706-1.821-6.496 0l-13.501 13.726c-0.761 0.775-1.127 1.52-1.086 2.217 0.039 0.679 0.461 1.203 0.71 1.454 0.418 0.426 0.871 0.604 1.38 0.538 0.639-0.081 1.373-0.527 2.125-1.292l10.594-10.771c0.437-0.445 1.148-0.445 1.586 0 0.439 0.445 0.439 1.168 0 1.613l-10.593 10.773c-1.124 1.142-2.279 1.796-3.434 1.942-1.21 0.153-2.331-0.259-3.244-1.187-0.816-0.83-1.301-1.871-1.363-2.932-0.081-1.376 0.505-2.711 1.74-3.966l13.501-13.727c2.666-2.71 7.004-2.71 9.669 0 1.291 1.311 2.003 3.057 2.003 4.914s-0.712 3.603-2.003 4.916l-11.638 11.833c-0.219 0.222-0.506 0.334-0.794 0.334z"
        }));
      },
      "notification-paused": function notificationPaused(_ref49) {
        var e = _ref49.className,
            _ref49$width = _ref49.width,
            t = _ref49$width === void 0 ? "20" : _ref49$width,
            _ref49$height = _ref49.height,
            a = _ref49$height === void 0 ? "24" : _ref49$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 20 24"
        }, l.a.createElement("path", {
          d: "M19.63 19.263c-0.287 0.468-0.803 0.737-1.416 0.737h-4.323c0 2.205-1.783 4-3.975 4-2.19 0-3.973-1.795-3.973-4h-4.321c-0.612 0-1.128-0.269-1.415-0.737-0.288-0.468-0.296-1.054-0.022-1.605l2.78-4.923v-5.735c0-3.86 3.119-7 6.951-7 3.835 0 6.954 3.14 6.954 7v5.735l2.756 4.876c0.299 0.598 0.291 1.183 0.004 1.652zM9.916 22c1.096 0 1.988-0.897 1.988-2h-3.974c0 1.103 0.891 2 1.986 2zM15.014 13.494c-0.010-0.017-0.009-0.036-0.018-0.054-0.029-0.059-0.044-0.123-0.062-0.189-0.017-0.066-0.035-0.128-0.039-0.195-0.001-0.020-0.011-0.036-0.011-0.056v-6c0-2.757-2.229-5-4.968-5-2.737 0-4.964 2.243-4.964 5v6c0 0.020-0.010 0.037-0.012 0.056-0.003 0.066-0.021 0.129-0.038 0.194-0.018 0.066-0.033 0.13-0.063 0.19-0.008 0.018-0.008 0.037-0.017 0.054l-2.546 4.506h15.285l-2.547-4.506zM6.938 8c0-0.552 0.445-1 0.993-1h3.973c0.382 0 0.73 0.221 0.895 0.567 0.166 0.346 0.119 0.757-0.119 1.058l-2.682 3.375h1.906c0.549 0 0.993 0.448 0.993 1s-0.444 1-0.993 1h-3.973c-0.381 0-0.73-0.221-0.895-0.567s-0.119-0.757 0.12-1.058l2.682-3.375h-1.907c-0.548 0-0.993-0.448-0.993-1z"
        }));
      },
      notification: function notification(_ref50) {
        var e = _ref50.className,
            _ref50$width = _ref50.width,
            t = _ref50$width === void 0 ? "20" : _ref50$width,
            _ref50$height = _ref50.height,
            a = _ref50$height === void 0 ? "24" : _ref50$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 20 24"
        }, l.a.createElement("path", {
          d: "M19.633 19.263c-0.287 0.468-0.804 0.737-1.416 0.737h-4.323c0 2.205-1.783 4-3.974 4s-3.973-1.795-3.973-4h-4.321c-0.612 0-1.129-0.269-1.416-0.737s-0.295-1.054-0.022-1.605l2.781-4.923v-5.735c0-3.86 3.118-7 6.951-7 3.834 0 6.954 3.14 6.954 7v5.735l2.756 4.876c0.298 0.598 0.291 1.184 0.003 1.652zM9.92 22c1.096 0 1.988-0.897 1.988-2h-3.975c0 1.103 0.891 2 1.987 2zM15.018 13.494c-0.142-0.25-0.159-0.534-0.080-0.789v-5.454c-0.022-0.082-0.050-0.162-0.050-0.251 0-2.757-2.229-5-4.968-5-2.737 0-4.964 2.243-4.964 5v6c0 0.020-0.011 0.036-0.012 0.056-0.003 0.067-0.022 0.129-0.039 0.195s-0.032 0.13-0.062 0.189c-0.008 0.018-0.008 0.037-0.017 0.054l-2.547 4.506h15.286l-2.547-4.506z"
        }));
      },
      "magnifier-1": function magnifier1(_ref51) {
        var e = _ref51.className,
            _ref51$width = _ref51.width,
            t = _ref51$width === void 0 ? "24" : _ref51$width,
            _ref51$height = _ref51.height,
            a = _ref51$height === void 0 ? "24" : _ref51$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M23.608 23.707c-0.195 0.195-0.45 0.293-0.705 0.293s-0.51-0.098-0.704-0.293l-7.653-7.682c-1.535 1.233-3.477 1.975-5.59 1.975-4.944 0-8.967-4.037-8.967-8.999 0-4.963 4.023-9.001 8.967-9.001s8.966 4.038 8.966 9.001c0 2.121-0.739 4.070-1.967 5.61l7.653 7.682c0.389 0.39 0.389 1.024 0 1.414zM8.956 2c-3.846 0-6.974 3.141-6.974 7.001s3.128 6.999 6.974 6.999c3.845 0 6.974-3.14 6.974-6.999s-3.129-7.001-6.974-7.001z"
        }));
      },
      home: function home(_ref52) {
        var e = _ref52.className,
            _ref52$width = _ref52.width,
            t = _ref52$width === void 0 ? "24" : _ref52$width,
            _ref52$height = _ref52.height,
            a = _ref52$height === void 0 ? "24" : _ref52$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M23.588 13.723c-0.192 0.177-0.433 0.263-0.673 0.263-0.27 0-0.538-0.108-0.735-0.324l-0.261-0.286v8.614c0 1.102-0.893 2.001-1.99 2.001h-3.982c-0.549 0-0.995-0.449-0.995-1.001 0-0.127 0.029-0.248 0.072-0.36v-6.66l-6.045 0.018v7.002c0 0.552-0.446 1.001-0.995 1.001h-3.982c-1.097 0-1.99-0.898-1.99-2.001v-8.614l-0.261 0.286c-0.371 0.408-1.002 0.435-1.406 0.061-0.406-0.372-0.433-1.006-0.061-1.413l10.948-12.004c0.377-0.413 1.090-0.413 1.467 0l10.948 12.004c0.372 0.408 0.344 1.041-0.060 1.413zM20.044 11.319l-8.077-8.856-7.963 8.73v10.797h2.986v-6.003c0-1.103 0.893-2.002 1.99-2.002h5.972c1.097 0 1.99 0.898 1.99 2.002v6.003l3.101 0.002v-10.673z"
        }));
      },
      "flash-2": function flash2(_ref53) {
        var e = _ref53.className,
            _ref53$width = _ref53.width,
            t = _ref53$width === void 0 ? "16" : _ref53$width,
            _ref53$height = _ref53.height,
            a = _ref53$height === void 0 ? "24" : _ref53$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 24"
        }, l.a.createElement("path", {
          d: "M15.217 11.119l-8.204 12.176c-0.137 0.407-0.513 0.695-0.955 0.695-0.042 0-0.084-0.002-0.127-0.008-0.474-0.056-0.814-0.427-0.87-0.869-0.006-0.027-0.003-0.055-0.007-0.082-0.002-0.054-0.019-0.105-0.012-0.16l0.009-0.079c0.005-0.037 0.006-0.073 0.014-0.111l0.965-7.673-4.708-0.001c-0.742 0-1.068-0.398-1.197-0.635-0.363-0.668 0.085-1.315 0.232-1.528l9.966-12.476c0.349-0.435 0.992-0.512 1.435-0.173 0.249 0.19 0.37 0.469 0.38 0.755 0.016 0.12 0.016 0.244-0.016 0.369l-1.928 7.698h4.087c0.738 0 1.058 0.383 1.184 0.611 0.342 0.625-0.043 1.188-0.249 1.491zM9.749 11.012c-0.459 0-0.883-0.197-1.194-0.557-0.361-0.417-0.527-1.016-0.431-1.562l0.92-3.677-6.227 7.793h3.68c0.574 0 1.018 0.175 1.319 0.521 0.16 0.184 0.412 0.584 0.31 1.203l-0.507 4.031 5.223-7.752h-3.092z"
        }));
      },
      "edit-1": function edit1(_ref54) {
        var e = _ref54.className,
            _ref54$width = _ref54.width,
            t = _ref54$width === void 0 ? "24" : _ref54$width,
            _ref54$height = _ref54.height,
            a = _ref54$height === void 0 ? "24" : _ref54$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M23.918 4.155c-0.006 0.044-0.029 0.081-0.041 0.122-0.015 0.055-0.029 0.108-0.053 0.16-0.035 0.073-0.081 0.134-0.13 0.195-0.022 0.028-0.032 0.062-0.057 0.087l-9.998 9.992c-0.017 0.016-0.039 0.022-0.057 0.037-0.049 0.044-0.106 0.077-0.164 0.11-0.060 0.033-0.118 0.066-0.183 0.087-0.021 0.007-0.037 0.023-0.060 0.028l-4 1.001c-0.080 0.020-0.161 0.030-0.242 0.030-0.262 0-0.518-0.104-0.707-0.293-0.248-0.249-0.348-0.609-0.263-0.949l1-3.998c0.006-0.023 0.022-0.039 0.030-0.062 0.020-0.065 0.052-0.121 0.086-0.181 0.033-0.059 0.066-0.114 0.109-0.163 0.015-0.018 0.021-0.041 0.038-0.059l9.998-9.992c0.029-0.029 0.068-0.041 0.1-0.066 0.052-0.041 0.104-0.080 0.164-0.11 0.064-0.031 0.127-0.051 0.194-0.069 0.037-0.010 0.069-0.032 0.107-0.037 0.212-0.030 2.098-0.26 3.249 0.974 1.126 1.199 0.91 2.958 0.882 3.155zM21.576 2.366c-0.282-0.304-0.833-0.374-1.208-0.375l-9.534 9.527-0.529 2.114 2.114-0.529 9.534-9.527c-0.004-0.36-0.077-0.89-0.377-1.21zM12.106 3.914h-10.088v18.159h18.159v-10.088c0-0.552 0.2-0.977 0.753-0.977s1 0.447 1 0.999v10.991c0 0.553-0.448 1-1 1h-19.997c-0.552 0-0.932-0.364-0.932-0.916v-20.177c0-0.552 0.38-0.89 0.932-0.89h10.998c0.552 0 1 0.447 1 1 0 0.552-0.272 0.899-0.824 0.899z"
        }));
      },
      "config-1": function config1(_ref55) {
        var e = _ref55.className,
            _ref55$width = _ref55.width,
            t = _ref55$width === void 0 ? "24" : _ref55$width,
            _ref55$height = _ref55.height,
            a = _ref55$height === void 0 ? "24" : _ref55$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M22 9.815v13.185c0 0.552-0.448 1-1 1s-1-0.448-1-1v-13.185c-1.162-0.414-2-1.513-2-2.815s0.838-2.401 2-2.816v-3.184c0-0.552 0.448-1 1-1s1 0.448 1 1v3.184c1.161 0.415 2 1.514 2 2.816s-0.839 2.401-2 2.815zM21 6c-0.551 0-1 0.448-1 1 0 0.551 0.449 1 1 1s1-0.449 1-1c0-0.552-0.449-1-1-1zM13 19.816v3.184c0 0.552-0.448 1-1 1s-1-0.448-1-1v-3.184c-1.161-0.415-2-1.514-2-2.816s0.839-2.401 2-2.816v-13.184c0-0.552 0.448-1 1-1s1 0.448 1 1v13.184c1.162 0.415 2 1.514 2 2.816s-0.838 2.401-2 2.816zM12 16c-0.551 0-1 0.448-1 1s0.449 1 1 1c0.551 0 1-0.448 1-1s-0.449-1-1-1zM4 14.816v8.184c0 0.552-0.448 1-1 1s-1-0.448-1-1v-8.184c-1.162-0.414-2-1.514-2-2.816s0.838-2.402 2-2.816v-8.184c0-0.552 0.448-1 1-1s1 0.448 1 1v8.184c1.161 0.414 2 1.514 2 2.816s-0.839 2.402-2 2.816zM3 11c-0.551 0-1 0.449-1 1s0.449 1 1 1c0.551 0 1-0.449 1-1s-0.449-1-1-1z"
        }));
      },
      check: function check(_ref56) {
        var e = _ref56.className,
            _ref56$width = _ref56.width,
            t = _ref56$width === void 0 ? "32" : _ref56$width,
            _ref56$height = _ref56.height,
            a = _ref56$height === void 0 ? "24" : _ref56$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 32 24"
        }, l.a.createElement("path", {
          d: "M12.043 23.981c-0.35 0-0.686-0.139-0.936-0.386l-10.723-10.661c-0.521-0.519-0.525-1.362-0.008-1.885 0.516-0.523 1.358-0.525 1.88-0.008l9.716 9.66 17.591-20.248c0.48-0.555 1.32-0.614 1.875-0.13 0.554 0.484 0.611 1.326 0.129 1.88l-18.522 21.319c-0.241 0.279-0.586 0.444-0.953 0.457-0.016 0.001-0.032 0.001-0.050 0.001z"
        }));
      },
      close: function close(_ref57) {
        var e = _ref57.className,
            _ref57$width = _ref57.width,
            t = _ref57$width === void 0 ? "24" : _ref57$width,
            _ref57$height = _ref57.height,
            a = _ref57$height === void 0 ? "24" : _ref57$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M13.357 11.993l10.256 10.295c0.39 0.391 0.39 1.024 0 1.415-0.194 0.195-0.449 0.292-0.704 0.292s-0.51-0.097-0.705-0.292l-10.257-10.295-10.256 10.295c-0.194 0.195-0.449 0.292-0.704 0.292s-0.51-0.097-0.705-0.292c-0.39-0.391-0.39-1.024 0-1.415l10.256-10.295-10.256-10.294c-0.39-0.391-0.39-1.024 0-1.415s1.020-0.391 1.409 0l10.256 10.294 10.256-10.294c0.39-0.391 1.020-0.391 1.41 0 0.389 0.391 0.389 1.024 0 1.415l-10.256 10.294z"
        }));
      },
      "cancel-square": function cancelSquare(_ref58) {
        var e = _ref58.className,
            _ref58$width = _ref58.width,
            t = _ref58$width === void 0 ? "24" : _ref58$width,
            _ref58$height = _ref58.height,
            a = _ref58$height === void 0 ? "24" : _ref58$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M23 24h-22c-0.552 0-1-0.448-1-1v-22c0-0.552 0.448-1 1-1h22c0.552 0 1 0.448 1 1v22c0 0.552-0.448 1-1 1zM22 2h-20v20h20v-20zM7.293 7.293c0.391-0.391 1.023-0.391 1.414 0l3.293 3.293 3.293-3.293c0.391-0.391 1.023-0.391 1.414 0 0.391 0.39 0.391 1.024 0 1.414l-3.293 3.293 3.293 3.293c0.391 0.39 0.391 1.024 0 1.414-0.195 0.195-0.451 0.293-0.707 0.293s-0.512-0.098-0.707-0.293l-3.293-3.293-3.293 3.293c-0.195 0.195-0.451 0.293-0.707 0.293s-0.512-0.098-0.707-0.293c-0.391-0.39-0.391-1.024 0-1.414l3.293-3.293-3.293-3.293c-0.391-0.39-0.391-1.024 0-1.414z"
        }));
      },
      "cancel-circle": function cancelCircle(_ref59) {
        var e = _ref59.className,
            _ref59$height = _ref59.height,
            t = _ref59$height === void 0 ? "30" : _ref59$height,
            _ref59$width = _ref59.width,
            a = _ref59$width === void 0 ? "30" : _ref59$width;
        return l.a.createElement("svg", {
          className: e,
          height: t,
          width: a,
          viewBox: "0 0 30 30"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15 30C6.72937 30 0 23.2716 0 15C0 6.72937 6.72937 0 15 0C23.2706 0 30 6.72937 30 15C30 23.2716 23.2706 30 15 30ZM15 1.875C7.7625 1.875 1.875 7.7625 1.875 15C1.875 22.2366 7.7625 28.125 15 28.125C22.2375 28.125 28.125 22.2366 28.125 15C28.125 7.7625 22.2375 1.875 15 1.875ZM20.3503 20.3503C20.1675 20.5331 19.9275 20.625 19.6875 20.625C19.4475 20.625 19.2075 20.5331 19.0247 20.3503L15 16.3256L10.9753 20.3503C10.7925 20.5331 10.5525 20.625 10.3125 20.625C10.0725 20.625 9.8325 20.5331 9.64969 20.3503C9.28312 19.9847 9.28312 19.3903 9.64969 19.0247L13.6744 15L9.64969 10.9753C9.28312 10.6097 9.28312 10.0163 9.64969 9.65063C10.0162 9.28312 10.6087 9.28312 10.9753 9.65063L15 13.6744L19.0247 9.65063C19.3912 9.28312 19.9837 9.28312 20.3503 9.65063C20.7169 10.0163 20.7169 10.6097 20.3503 10.9753L16.3256 15L20.3503 19.0247C20.7169 19.3903 20.7169 19.9847 20.3503 20.3503Z",
          fill: "#4E5C65"
        }));
      },
      "check-square": function checkSquare(_ref60) {
        var e = _ref60.className,
            _ref60$width = _ref60.width,
            t = _ref60$width === void 0 ? "24" : _ref60$width,
            _ref60$height = _ref60.height,
            a = _ref60$height === void 0 ? "24" : _ref60$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M23 24h-22c-0.552 0-1-0.448-1-1v-22c0-0.552 0.448-1 1-1h22c0.552 0 1 0.448 1 1v22c0 0.552-0.448 1-1 1zM22 2h-20v20h20v-20zM6.624 11.219l4.253 3.402 6.371-7.279c0.363-0.416 0.995-0.458 1.411-0.095 0.415 0.364 0.457 0.996 0.093 1.412l-7 7.999c-0.197 0.226-0.474 0.342-0.752 0.342-0.22 0-0.44-0.072-0.624-0.219l-5.001-4c-0.431-0.345-0.501-0.975-0.156-1.406 0.344-0.431 0.975-0.501 1.405-0.156z"
        }));
      },
      write: function write(_ref61) {
        var e = _ref61.className,
            _ref61$width = _ref61.width,
            t = _ref61$width === void 0 ? "24" : _ref61$width,
            _ref61$height = _ref61.height,
            a = _ref61$height === void 0 ? "24" : _ref61$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M23.552 4.819l-16.565 16.676c-0.001 0-0.001 0.001-0.002 0.001l-0.005 0.005c-0.069 0.070-0.155 0.116-0.241 0.162-0.029 0.016-0.049 0.042-0.080 0.055l-5.281 2.206c-0.123 0.051-0.252 0.076-0.381 0.076-0.258 0-0.512-0.102-0.702-0.293-0.284-0.286-0.369-0.716-0.215-1.090l2.191-5.318c0.034-0.083 0.092-0.147 0.144-0.215 0.027-0.035 0.040-0.076 0.071-0.108l0.003-0.003c0.002-0.002 0.003-0.003 0.004-0.004l13.638-13.73c0-0.001 0.001-0.002 0.001-0.002 0.001-0.001 0.002-0.001 0.003-0.002l2.922-2.942c0.186-0.188 0.439-0.293 0.702-0.293s0.516 0.105 0.702 0.293l3.091 3.112c0.388 0.391 0.388 1.024 0 1.414zM3.537 19.448l-0.701 1.701 1.69-0.706-0.989-0.995zM4.593 17.683l1.685 1.697 12.243-12.324-1.686-1.698-12.242 12.325zM19.759 2.414l-1.52 1.53 1.686 1.698 1.52-1.529-1.686-1.699zM8.944 22h11.919c0.548 0 0.993 0.448 0.993 1s-0.445 1-0.993 1h-11.919c-0.549 0-0.994-0.448-0.994-1s0.445-1 0.994-1z"
        }));
      },
      underline: function underline(_ref62) {
        var e = _ref62.className,
            _ref62$width = _ref62.width,
            t = _ref62$width === void 0 ? "18" : _ref62$width,
            _ref62$height = _ref62.height,
            a = _ref62$height === void 0 ? "24" : _ref62$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 18 24"
        }, l.a.createElement("path", {
          d: "M17 24h-16c-0.552 0-1-0.448-1-1s0.448-1 1-1h16c0.552 0 1 0.448 1 1s-0.448 1-1 1zM9 20c-4.187 0-7-2.813-7-7v-12c0-0.552 0.448-1 1-1s1 0.448 1 1v12c0 3.084 1.916 5 5 5s5-1.916 5-5v-12c0-0.552 0.448-1 1-1s1 0.448 1 1v12c0 4.187-2.813 7-7 7z"
        }));
      },
      "text-italic": function textItalic(_ref63) {
        var e = _ref63.className,
            _ref63$width = _ref63.width,
            t = _ref63$width === void 0 ? "14" : _ref63$width,
            _ref63$height = _ref63.height,
            a = _ref63$height === void 0 ? "24" : _ref63$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 14 24"
        }, l.a.createElement("path", {
          d: "M13.049 1.994h-2.244l-5.476 19.991h1.697c0.554 0 1.004 0.447 1.004 1 0 0.551-0.45 0.999-1.004 0.999h-6.023c-0.554 0-1.004-0.448-1.004-0.999 0-0.553 0.45-1 1.004-1h2.244l5.476-19.991h-1.697c-0.554 0-1.004-0.448-1.004-1s0.45-1 1.004-1h6.023c0.554 0 1.004 0.448 1.004 1s-0.45 1-1.004 1z"
        }));
      },
      bold: function bold(_ref64) {
        var e = _ref64.className,
            _ref64$width = _ref64.width,
            t = _ref64$width === void 0 ? "16" : _ref64$width,
            _ref64$height = _ref64.height,
            a = _ref64$height === void 0 ? "24" : _ref64$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 24"
        }, l.a.createElement("path", {
          d: "M12.489 10.896c2.129 1.165 3.511 3.408 3.511 6.104 0 4.056-2.916 7-6.934 7h-8.066c-0.552 0-1-0.448-1-1v-22c0-0.552 0.448-1 1-1h8.066c3.383 0 5.934 2.579 5.934 6 0 2.049-0.986 3.818-2.511 4.896zM14 17c0-2.469-1.707-4.969-4.969-4.969-0.054 0-0.101-0.023-0.154-0.031h-6.877v10h7.066c3.39 0 4.934-2.592 4.934-5zM9.066 2h-7.066v8h7c2.28 0 4-1.72 4-4 0-2.318-1.654-4-3.934-4z"
        }));
      },
      "paragraph-down": function paragraphDown(_ref65) {
        var e = _ref65.className,
            _ref65$width = _ref65.width,
            t = _ref65$width === void 0 ? "24" : _ref65$width,
            _ref65$height = _ref65.height,
            a = _ref65$height === void 0 ? "24" : _ref65$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M22.962 18.994h-10.98c-0.551 0-0.999-0.448-0.999-0.999s0.401-0.952 0.952-0.952h11.028c0.551 0 0.996 0.401 0.996 0.952s-0.447 0.999-0.998 0.999zM22.962 13.999h-10.98c-0.551 0-0.999-0.447-0.999-0.999 0-0.551 0.447-0.999 0.999-0.999h10.98c0.55 0 0.998 0.447 0.998 0.999s-0.447 0.999-0.998 0.999zM22.962 9.004h-5.99c-0.551 0-0.998-0.447-0.998-0.999s0.446-0.999 0.997-0.999h5.99c0.55 0 0.998 0.447 0.998 0.999 0 0.551-0.447 0.999-0.998 0.999zM22.962 4.008h-7.986c-0.551 0-0.999-0.447-0.999-0.999 0-0.551 0.447-0.999 0.999-0.999h7.986c0.55 0 0.998 0.447 0.998 0.999s-0.447 0.999-0.998 0.999zM12.981 8.604c-0.272 0-0.542-0.11-0.739-0.327l-4.317-4.751v19.532c0 0.552-0.384 0.931-0.935 0.931s-1.070-0.379-1.070-0.931v-19.384l-4.181 4.603c-0.37 0.408-1.001 0.439-1.411 0.067-0.407-0.372-0.437-1.003-0.066-1.412l5.796-6.381c0.186-0.318 0.545-0.539 0.931-0.539 0.147 0 0.28 0.035 0.4 0.092 0.126 0.052 0.244 0.13 0.338 0.235l5.991 6.593c0.371 0.408 0.341 1.040-0.067 1.412-0.191 0.173-0.432 0.26-0.671 0.26zM11.936 22.055h11.028c0.551 0 0.996 0.384 0.996 0.935s-0.447 0.999-0.998 0.999h-10.98c-0.551 0-0.999-0.447-0.999-0.999s0.401-0.935 0.952-0.935z"
        }));
      },
      "paragraph-up": function paragraphUp(_ref66) {
        var e = _ref66.className,
            _ref66$width = _ref66.width,
            t = _ref66$width === void 0 ? "24" : _ref66$width,
            _ref66$height = _ref66.height,
            a = _ref66$height === void 0 ? "24" : _ref66$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M22.933 17h-5.974c-0.55 0-0.996-0.448-0.996-1s0.446-1 0.996-1h5.974c0.55 0 0.996 0.448 0.996 1s-0.446 1-0.996 1zM22.933 12h-10.953c-0.55 0-0.996-0.448-0.996-1s0.446-1 0.996-1h10.953c0.55 0 0.996 0.448 0.996 1s-0.446 1-0.996 1zM22.933 7h-10.953c-0.55 0-0.996-0.448-0.996-1s0.446-1 0.996-1h10.953c0.55 0 0.996 0.448 0.996 1s-0.446 1-0.996 1zM22.933 2h-10.953c-0.55 0-0.996-0.448-0.996-1s0.446-1 0.996-1h10.953c0.55 0 0.996 0.448 0.996 1s-0.446 1-0.996 1zM13.646 15.661c0.407 0.371 0.437 1.003 0.067 1.412l-5.975 6.6c-0.099 0.11-0.222 0.19-0.355 0.246-0.115 0.052-0.243 0.081-0.382 0.081-0.141 0-0.274-0.031-0.395-0.084-0.029-0.012-0.051-0.038-0.079-0.053-0.089-0.050-0.175-0.103-0.244-0.177-0.005-0.006-0.013-0.008-0.018-0.013l-5.975-6.6c-0.37-0.409-0.34-1.041 0.067-1.412 0.408-0.372 1.037-0.342 1.406 0.066l4.242 4.687v-19.414c0-0.552 0.446-1 0.996-1s0.937 0.448 0.937 1v19.479l4.302-4.752c0.37-0.407 0.999-0.437 1.406-0.066zM14.967 20h7.966c0.55 0 0.996 0.448 0.996 1s-0.446 1-0.996 1h-7.966c-0.55 0-0.996-0.448-0.996-1s0.446-1 0.996-1z"
        }));
      },
      "list-bullets": function listBullets(_ref67) {
        var e = _ref67.className,
            _ref67$width = _ref67.width,
            t = _ref67$width === void 0 ? "26" : _ref67$width,
            _ref67$height = _ref67.height,
            a = _ref67$height === void 0 ? "24" : _ref67$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M25.091 13.091h-15.273c-0.602 0-1.091-0.489-1.091-1.091s0.489-1.091 1.091-1.091h15.273c0.602 0 1.091 0.489 1.091 1.091s-0.489 1.091-1.091 1.091zM25.091 4.364h-15.273c-0.602 0-1.091-0.489-1.091-1.091s0.489-1.091 1.091-1.091h15.273c0.602 0 1.091 0.489 1.091 1.091s-0.489 1.091-1.091 1.091zM3.273 24c-1.804 0-3.273-1.468-3.273-3.273s1.468-3.273 3.273-3.273c1.804 0 3.273 1.468 3.273 3.273s-1.468 3.273-3.273 3.273zM3.273 19.636c-0.601 0-1.091 0.49-1.091 1.091s0.49 1.091 1.091 1.091c0.601 0 1.091-0.49 1.091-1.091s-0.49-1.091-1.091-1.091zM3.273 15.273c-1.804 0-3.273-1.468-3.273-3.273s1.468-3.273 3.273-3.273c1.804 0 3.273 1.468 3.273 3.273s-1.468 3.273-3.273 3.273zM3.273 10.909c-0.601 0-1.091 0.49-1.091 1.091s0.49 1.091 1.091 1.091c0.601 0 1.091-0.49 1.091-1.091s-0.49-1.091-1.091-1.091zM3.273 6.545c-1.804 0-3.273-1.467-3.273-3.273 0-1.804 1.468-3.273 3.273-3.273s3.273 1.468 3.273 3.273c0 1.805-1.468 3.273-3.273 3.273zM3.273 2.182c-0.601 0-1.091 0.49-1.091 1.091s0.49 1.091 1.091 1.091c0.601 0 1.091-0.49 1.091-1.091s-0.49-1.091-1.091-1.091zM9.818 19.636h15.273c0.602 0 1.091 0.489 1.091 1.091s-0.489 1.091-1.091 1.091h-15.273c-0.602 0-1.091-0.489-1.091-1.091s0.489-1.091 1.091-1.091z"
        }));
      },
      "list-numbers": function listNumbers(_ref68) {
        var e = _ref68.className,
            _ref68$width = _ref68.width,
            t = _ref68$width === void 0 ? "25" : _ref68$width,
            _ref68$height = _ref68.height,
            a = _ref68$height === void 0 ? "24" : _ref68$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 25 24"
        }, l.a.createElement("path", {
          d: "M23.996 13.087h-15.266c-0.602 0-1.091-0.488-1.091-1.090s0.443-0.993 1.045-0.993h15.314c0.602 0 1.088 0.392 1.088 0.993s-0.488 1.090-1.091 1.090zM23.996 4.374h-15.266c-0.602 0-1.091-0.488-1.091-1.088 0-0.603 0.443-1.033 1.045-1.033h15.314c0.602 0 1.088 0.43 1.088 1.033 0 0.601-0.488 1.088-1.091 1.088zM3.683 23.348c-0.628 0.55-1.523 0.657-2.127 0.657-0.288 0-0.509-0.025-0.604-0.037-0.597-0.080-1.016-0.627-0.937-1.224 0.080-0.594 0.624-1.015 1.22-0.936 0.188 0.023 0.41 0.022 0.603 0.003-0.042-0.004-0.082-0.009-0.119-0.010-0.057 0.002-0.104 0.001-0.133 0.001-0.589-0.012-1.062-0.489-1.068-1.077-0.007-0.59 0.457-1.075 1.046-1.099 0.030-0.001 0.079 0.001 0.13-0.002 0.025-0.001 0.050-0.003 0.075-0.005-0.179-0.018-0.381-0.021-0.559-0.002-0.59 0.060-1.133-0.374-1.196-0.969-0.062-0.597 0.366-1.132 0.964-1.197 0.295-0.034 1.814-0.152 2.727 0.667 0.434 0.387 0.663 0.909 0.663 1.507 0 0.399-0.106 0.767-0.311 1.083 0.205 0.318 0.311 0.69 0.311 1.095 0 0.619-0.237 1.154-0.685 1.546zM4.368 14.179c0 0.602-0.489 1.090-1.091 1.090h-2.181c-0.441 0-0.838-0.266-1.006-0.673-0.17-0.407-0.077-0.875 0.235-1.186 0.908-0.909 1.781-2.081 1.86-2.494-0.196-0.009-0.462-0.008-0.692-0.005l-0.396 0.001c-0.602 0-1.091-0.488-1.091-1.088 0-0.602 0.489-1.090 1.091-1.090l0.382-0.001c0.981-0.004 1.759-0.011 2.338 0.563 0.496 0.491 0.552 1.157 0.552 1.616 0 0.675-0.411 1.467-0.921 2.192 0.522 0.081 0.921 0.532 0.921 1.075zM2.187 6.552c-0.602 0-1.091-0.488-1.091-1.090v-2.178c-0.258-0.010-0.513-0.11-0.714-0.304-0.434-0.417-0.447-1.106-0.030-1.54l1.049-1.088c0.308-0.321 0.78-0.422 1.192-0.256 0.413 0.166 0.684 0.567 0.684 1.011v4.356c0 0.602-0.488 1.090-1.091 1.090zM8.683 19.756h15.314c0.602 0 1.088 0.353 1.088 0.955 0 0.601-0.487 1.233-1.088 1.233h-15.314c-0.602 0-1.045-0.632-1.045-1.233 0-0.602 0.443-0.955 1.045-0.955z"
        }));
      },
      "book-4": function book4(_ref69) {
        var e = _ref69.className,
            _ref69$width = _ref69.width,
            t = _ref69$width === void 0 ? "18" : _ref69$width,
            _ref69$height = _ref69.height,
            a = _ref69$height === void 0 ? "18" : _ref69$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 18 18"
        }, l.a.createElement("g", {
          id: "Final"
        }, l.a.createElement("g", {
          id: "Upgrade---Short-Screen"
        }, l.a.createElement("g", {
          id: "Group-13"
        }, l.a.createElement("g", {
          id: "Side-Nav"
        }, l.a.createElement("path", {
          id: "Shape",
          d: "M16.75,17.16,9.21,18.67H8.92L1.38,17.16A1.72,1.72,0,0,1,0,15.51V2.06A1.38,1.38,0,0,1,.53,1,1.37,1.37,0,0,1,1.67.72L8.92,2.17l.14,0,.14,0L16.46.72a1.35,1.35,0,0,1,1.64,1.35V15.51A1.72,1.72,0,0,1,16.75,17.16ZM8.31,3.59,1.54,2.23V15.51a.22.22,0,0,0,.13.16L8.31,17Zm6-.91-2.26.45V6l.55-.66a.75.75,0,0,1,1-.11l.66.53Zm2.26-.45-.75.15v5a.75.75,0,0,1-1.22.59l-1.3-1L11.9,8.59a.75.75,0,0,1-.58.27.74.74,0,0,1-.26,0,.76.76,0,0,1-.5-.71V3.44l-.75.15V17l6.64-1.33a.22.22,0,0,0,.13-.16Z",
          transform: "translate(-0.03 -0.69)"
        }))))));
      },
      "knowledgebase-book": function knowledgebaseBook(_ref70) {
        var e = _ref70.className,
            _ref70$width = _ref70.width,
            t = _ref70$width === void 0 ? "18" : _ref70$width,
            _ref70$height = _ref70.height,
            a = _ref70$height === void 0 ? "18" : _ref70$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 20 20"
        }, l.a.createElement("defs", null), l.a.createElement("g", {
          id: "general",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "Artboard-3",
          fill: "#394F5A"
        }, l.a.createElement("path", {
          d: "M19.375,17.5 L12.5,17.5 C11.46625,17.5 10.625,18.34125 10.625,19.375 C10.625,19.720625 10.345,20 10,20 C9.655,20 9.375,19.720625 9.375,19.375 C9.375,18.34125 8.53375,17.5 7.5,17.5 L0.625,17.5 C0.28,17.5 0,17.22 0,16.875 L0,0.625 C0,0.279375 0.28,0 0.625,0 L7.5,0 C8.525625,0 9.43,0.50375 10,1.269375 C10.57,0.50375 11.474375,0 12.5,0 L19.375,0 C19.72,0 20,0.279375 20,0.625 L20,16.875 C20,17.22 19.72,17.5 19.375,17.5 Z M7.5,1.25 L1.25,1.25 L1.25,16.25 L7.5,16.25 C8.20625,16.25 8.85125,16.494375 9.375,16.89125 L9.375,3.125 C9.375,2.09125 8.53375,1.25 7.5,1.25 Z M18.75,1.25 L12.5,1.25 C11.46625,1.25 10.625,2.09125 10.625,3.125 L10.625,16.89125 C11.14875,16.494375 11.79375,16.25 12.5,16.25 L18.75,16.25 L18.75,1.25 Z M11.875,12.5 C11.875,12.155 12.155,11.875 12.5,11.875 L16.875,11.875 C17.22,11.875 17.5,12.155 17.5,12.5 C17.5,12.845 17.22,13.125 16.875,13.125 L12.5,13.125 C12.155,13.125 11.875,12.845 11.875,12.5 Z M16.875,9.375 L12.5,9.375 C12.155,9.375 11.875,9.095 11.875,8.75 C11.875,8.405 12.155,8.125 12.5,8.125 L16.875,8.125 C17.22,8.125 17.5,8.405 17.5,8.75 C17.5,9.095 17.22,9.375 16.875,9.375 Z M16.875,5.625 L12.5,5.625 C12.155,5.625 11.875,5.345625 11.875,5 C11.875,4.655 12.155,4.375 12.5,4.375 L16.875,4.375 C17.22,4.375 17.5,4.655 17.5,5 C17.5,5.345625 17.22,5.625 16.875,5.625 Z M7.5,13.125 L3.125,13.125 C2.78,13.125 2.5,12.845 2.5,12.5 C2.5,12.155 2.78,11.875 3.125,11.875 L7.5,11.875 C7.845,11.875 8.125,12.155 8.125,12.5 C8.125,12.845 7.845,13.125 7.5,13.125 Z M7.5,9.375 L3.125,9.375 C2.78,9.375 2.5,9.095 2.5,8.75 C2.5,8.405 2.78,8.125 3.125,8.125 L7.5,8.125 C7.845,8.125 8.125,8.405 8.125,8.75 C8.125,9.095 7.845,9.375 7.5,9.375 Z M7.5,5.625 L3.125,5.625 C2.78,5.625 2.5,5.345625 2.5,5 C2.5,4.655 2.78,4.375 3.125,4.375 L7.5,4.375 C7.845,4.375 8.125,4.655 8.125,5 C8.125,5.345625 7.845,5.625 7.5,5.625 Z",
          id: "book---6"
        }))));
      },
      article: function article(_ref71) {
        var e = _ref71.className,
            _ref71$width = _ref71.width,
            t = _ref71$width === void 0 ? "14" : _ref71$width,
            _ref71$height = _ref71.height,
            a = _ref71$height === void 0 ? "16" : _ref71$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 14 16"
        }, l.a.createElement("defs", null), l.a.createElement("g", {
          id: "create",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "add-menu",
          transform: "translate(-941.000000, -179.000000)",
          fill: "#394F5A"
        }, l.a.createElement("g", {
          id: "art-new",
          transform: "translate(941.000000, 179.000000)"
        }, l.a.createElement("path", {
          d: "M13.3,13.9666667 L11.9007,13.9666667 L11.9007,15.296 C11.9007,15.6626667 11.5871,15.9606667 11.2007,15.9606667 C10.8143,15.9606667 10.5007,15.6626667 10.5007,15.296 L10.5007,13.9666667 L9.1,13.9666667 C8.7136,13.9666667 8.4,13.6693333 8.4,13.302 C8.4,12.9346667 8.7136,12.6373333 9.1,12.6373333 L10.5007,12.6373333 L10.5007,11.3073333 C10.5007,10.94 10.8143,10.6426667 11.2007,10.6426667 C11.5871,10.6426667 11.9007,10.94 11.9007,11.3073333 L11.9007,12.6373333 L13.3,12.6373333 C13.6864,12.6373333 14,12.9346667 14,13.302 C14,13.6693333 13.6864,13.9666667 13.3,13.9666667 Z M12.6,7.98466667 C12.6,8.352 12.2864,8.64933333 11.9,8.64933333 C11.5136,8.64933333 11.2,8.352 11.2,7.98466667 L11.2,5.99066667 L7,5.99066667 C6.6136,5.99066667 6.3,5.69333333 6.3,5.326 L6.3,1.31333333 L1.4,1.31333333 L1.4,14.6313333 L6.3,14.6313333 C6.6864,14.6313333 7,14.9286667 7,15.296 C7,15.6626667 6.6864,15.9606667 6.3,15.9606667 L1.4,15.9606667 C0.6279,15.9606667 0,15.364 0,14.6313333 L0,1.338 C0,0.605333333 0.6279,0.00866666667 1.4,0.00866666667 L7,0.00866666667 C7.0147,0.00866666667 7.0273,0.016 7.0427,0.0173333333 C7.1064,0.0206666667 7.168,0.0326666667 7.2282,0.0526666667 C7.2506,0.06 7.273,0.0653333333 7.294,0.0746666667 C7.3647,0.106 7.4312,0.146 7.4893,0.2 C7.4914,0.202 7.4935,0.202666667 7.4956,0.204666667 L12.3186,4.784 C12.341,4.79866667 12.3515,4.824 12.3718,4.84133333 C12.3921,4.85933333 12.4082,4.88 12.4264,4.90066667 C12.5342,5.01733333 12.614,5.15866667 12.614,5.326 C12.614,5.34933333 12.6021,5.36933333 12.6,5.392 L12.6,7.98466667 Z M7.7,2.278 L7.7,4.66133333 L10.2102,4.66133333 L7.7,2.278 Z",
          id: "Shape"
        })))));
      },
      "article-create-1": function articleCreate1(_ref72) {
        var e = _ref72.width,
            t = _ref72.height,
            a = _ref72.className;
        return l.a.createElement("svg", {
          className: a,
          width: e,
          height: t
        }, l.a.createElement("path", {
          d: "M10.154 14H.846C.38 14 0 13.607 0 13.125V.875C0 .393.38 0 .846 0h9.308c.466 0 .846.393.846.875v12.25c0 .482-.38.875-.846.875zM1 1v12.25h9.306L10.308 1H1zm7.192 8.875H1.423A.43.43 0 0 1 1 9.437.43.43 0 0 1 1.423 9h6.77a.43.43 0 0 1 .422.438.43.43 0 0 1-.423.437zm0-2H1.423A.43.43 0 0 1 1 7.437.43.43 0 0 1 1.423 7h6.77a.43.43 0 0 1 .422.438.43.43 0 0 1-.423.437zm.77-2H6.423A.43.43 0 0 1 6 5.437.43.43 0 0 1 6.423 5h2.539a.43.43 0 0 1 .423.438.43.43 0 0 1-.423.437zm0-2H6.423A.43.43 0 0 1 6 3.437.43.43 0 0 1 6.423 3h2.539a.43.43 0 0 1 .423.438.43.43 0 0 1-.423.437zm-5 2.625H1.423A.43.43 0 0 1 1 6.062V3.438A.43.43 0 0 1 1.423 3h2.539a.43.43 0 0 1 .423.438v2.624a.43.43 0 0 1-.423.438zM3.692 3H2v1.75h1.692V3zm-2.269 7h4.23a.43.43 0 0 1 .424.438.43.43 0 0 1-.423.437h-4.23A.43.43 0 0 1 1 10.438.43.43 0 0 1 1.423 10z",
          fill: "#394F5A",
          fillRule: "evenodd"
        }));
      },
      "article-create-2": function articleCreate2(_ref73) {
        var _ref73$width = _ref73.width,
            e = _ref73$width === void 0 ? "13" : _ref73$width,
            _ref73$height = _ref73.height,
            t = _ref73$height === void 0 ? "15" : _ref73$height,
            a = _ref73.className;
        return l.a.createElement("svg", {
          className: a,
          width: e,
          height: t
        }, l.a.createElement("path", {
          d: "M11.406 15H1.094A1.09 1.09 0 0 1 0 13.917V1.083C0 .486.49 0 1.094 0h10.312A1.09 1.09 0 0 1 12.5 1.083v12.834A1.09 1.09 0 0 1 11.406 15zM11.25 1.25h-10v12.5h10V1.25zM2.5 7.5H10a.625.625 0 0 1 0 1.25H2.5a.625.625 0 0 1 0-1.25zm0 1.875H10a.625.625 0 0 1 0 1.25H2.5a.625.625 0 0 1 0-1.25zm0 1.875h4.375a.625.625 0 0 1 0 1.25H2.5a.625.625 0 0 1 0-1.25zm7.5-5H7.5A.625.625 0 0 1 7.5 5H10a.625.625 0 0 1 0 1.25zm0-1.875H7.5a.625.625 0 0 1 0-1.25H10a.625.625 0 0 1 0 1.25zM5.625 6.25h-2.5a.625.625 0 0 1-.625-.625v-2.5c0-.345.28-.625.625-.625h2.5c.345 0 .625.28.625.625v2.5c0 .345-.28.625-.625.625zM5 3.75H3.75V5H5V3.75z",
          fill: "#394F5A",
          fillRule: "evenodd"
        }));
      },
      "article-download": function articleDownload(_ref74) {
        var e = _ref74.className,
            _ref74$width = _ref74.width,
            t = _ref74$width === void 0 ? "14" : _ref74$width,
            _ref74$height = _ref74.height,
            a = _ref74$height === void 0 ? "16" : _ref74$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 12 16"
        }, l.a.createElement("g", {
          id: "personal->-Team-upgrade-flow",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "pro-copy-13",
          transform: "translate(-908.000000, -926.000000)",
          fill: "#394F5A"
        }, l.a.createElement("g", {
          id: "download-copy",
          transform: "translate(908.000000, 924.000000)"
        }, l.a.createElement("g", {
          id: "file-download",
          transform: "translate(0.500000, 2.500000)"
        }, l.a.createElement("path", {
          d: "M11.0954667,4.77813333 C11.1072889,4.80551111 11.1091556,4.83662222 11.1172444,4.86586667 C11.1359111,4.9256 11.1620444,4.98284444 11.1620444,5.0488 C11.1620444,5.07057778 11.1514667,5.08862222 11.1496,5.10977778 L11.1496,7.52026667 C11.1496,7.86373333 10.8720889,8.14124444 10.5304889,8.14124444 C10.1882667,8.14124444 9.97484444,7.85751111 9.97484444,7.51466667 L9.97484444,5.648 L6.24151111,5.648 C5.89928889,5.648 5.61928889,5.36862222 5.61928889,5.02577778 L5.61928889,1.30302222 L1.24257778,1.30302222 L1.24257778,13.7176 L4.95786667,13.7176 C5.29946667,13.7176 5.57697778,13.9957333 5.57697778,14.3385778 C5.57697778,14.6808 5.29946667,14.9589333 4.95786667,14.9589333 L1.24257778,14.9589333 C0.559377778,14.9589333 0.00435555556,14.4020444 0.00435555556,13.7176 L0.00435555556,1.30302222 C0.00435555556,0.618577778 0.559377778,0.0616888889 1.24257778,0.0616888889 L6.19608889,0.0616888889 C6.39457778,0.0616888889 6.5632,0.161244444 6.67644444,0.306844444 L10.9007111,4.54231111 C10.9654222,4.59333333 11.0158222,4.6512 11.0562667,4.71964444 C11.0693333,4.74017778 11.0848889,4.75635556 11.0954667,4.77813333 Z M6.8152,2.20151111 L6.8152,4.42782222 L9.03528889,4.42782222 L6.8152,2.20151111 Z M7.25324444,12.0475556 L8.10817778,12.9049778 L8.10817778,9.38133333 C8.10817778,9.03848889 8.33093333,8.76222222 8.67253333,8.76222222 C9.01475556,8.76222222 9.29226667,9.04035556 9.29226667,9.38257778 L9.29226667,12.8502222 L10.0924444,12.0475556 C10.3344889,11.8048889 10.7264889,11.8048889 10.9679111,12.0475556 C11.2099556,12.2902222 11.2099556,12.6828444 10.9679111,12.9248889 L9.1112,14.7865778 C9.05395556,14.8444444 8.98551111,14.8898667 8.90897778,14.9216 C8.83368889,14.9527111 8.75342222,14.9695111 8.67253333,14.9695111 C8.51448889,14.9695111 8.35582222,14.9085333 8.23511111,14.7872 L6.37715556,12.9248889 C6.13573333,12.6828444 6.13573333,12.2902222 6.37715556,12.0475556 C6.6192,11.8048889 7.0112,11.8048889 7.25324444,12.0475556 Z",
          id: "Shape"
        }))))));
      },
      section: function section(_ref75) {
        var e = _ref75.className,
            _ref75$width = _ref75.width,
            t = _ref75$width === void 0 ? "15" : _ref75$width,
            _ref75$height = _ref75.height,
            a = _ref75$height === void 0 ? "14" : _ref75$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 15 14",
          version: "1.1"
        }, l.a.createElement("defs", null), l.a.createElement("g", {
          id: "create",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "add-menu",
          transform: "translate(-942.000000, -219.000000)",
          fill: "#394F5A"
        }, l.a.createElement("g", {
          id: "sect-new",
          transform: "translate(942.000000, 219.000000)"
        }, l.a.createElement("path", {
          d: "M14.375,8.22818182 C14.029375,8.22818182 13.75,7.945 13.75,7.59563636 L13.75,2.534 L7.5,2.534 C7.5,2.534 7.5,2.534 7.499375,2.534 C7.499375,2.534 7.499375,2.534 7.499375,2.534 C7.42625,2.534 7.354375,2.51681818 7.28375,2.49009091 C7.26125,2.48181818 7.241875,2.471 7.220625,2.46018182 C7.198125,2.44872727 7.174375,2.44236364 7.153125,2.42772727 L5.435625,1.26890909 L1.25,1.26890909 L1.25,11.4545455 L8.125,11.4545455 C8.470625,11.4545455 8.75,11.6747273 8.75,12.0247273 C8.75,12.3740909 8.470625,12.7272727 8.125,12.7272727 L1.25,12.7272727 C0.560625,12.7272727 0,12.0896364 0,11.3915455 L0,1.26890909 C0,0.570818182 0.560625,0.00381818182 1.25,0.00381818182 L5.625,0.00381818182 C5.64375,0.00381818182 5.66,0.0127272727 5.678125,0.0146363636 C5.721875,0.0184545455 5.7625,0.0273636364 5.804375,0.0400909091 C5.845,0.0528181818 5.881875,0.0674545455 5.91875,0.0878181818 C5.935625,0.0967272727 5.955,0.0986363636 5.971875,0.109454545 L7.689375,1.26890909 L13.75,1.26890909 C14.43875,1.26890909 15,1.83654545 15,2.534 L15,7.59563636 C15,7.945 14.720625,8.22818182 14.375,8.22818182 Z M10.625,10.759 L11.875,10.759 L11.875,9.49327273 C11.875,9.14390909 12.154375,8.86072727 12.5,8.86072727 C12.845625,8.86072727 13.125,9.14390909 13.125,9.49327273 L13.125,10.759 L14.375,10.759 C14.720625,10.759 15,11.0421818 15,11.3915455 C15,11.7409091 14.720625,12.0247273 14.375,12.0247273 L13.125,12.0247273 L13.125,13.2898182 C13.125,13.6391818 12.845625,13.9223636 12.5,13.9223636 C12.154375,13.9223636 11.875,13.6391818 11.875,13.2898182 L11.875,12.0247273 L10.625,12.0247273 C10.279375,12.0247273 10,11.7409091 10,11.3915455 C10,11.0421818 10.279375,10.759 10.625,10.759 Z",
          id: "Shape"
        })))));
      },
      category: function category(_ref76) {
        var e = _ref76.className,
            _ref76$width = _ref76.width,
            t = _ref76$width === void 0 ? "17" : _ref76$width,
            _ref76$height = _ref76.height,
            a = _ref76$height === void 0 ? "15" : _ref76$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 17 15"
        }, l.a.createElement("defs", null), l.a.createElement("g", {
          id: "create",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "add-menu",
          transform: "translate(-941.000000, -254.000000)",
          fill: "#394F5A"
        }, l.a.createElement("path", {
          d: "M953.875,268.2391 C953.875,268.6234 953.557667,268.9356 953.166667,268.9356 L942.416667,268.9356 C941.635375,268.9356 941,268.3105 941,267.5419 L941,257.7874 C941,257.4024 941.317333,257.0902 941.708333,257.0902 C942.099333,257.0902 942.416667,257.4024 942.416667,257.7874 L942.416667,267.5916 L953.166667,267.5916 C953.557667,267.5916 953.875,267.8541 953.875,268.2391 Z M957.375,262.228182 C957.029375,262.228182 956.75,261.945 956.75,261.595636 L956.75,256.534 L950.5,256.534 C950.42625,256.534 950.354375,256.516818 950.28375,256.490091 C950.26125,256.481818 950.241875,256.471 950.220625,256.460182 C950.198125,256.448727 950.174375,256.442364 950.153125,256.427727 L948.435625,255.268909 L944.25,255.268909 L944.25,265.454545 L951.125,265.454545 C951.470625,265.454545 951.75,265.674727 951.75,266.024727 C951.75,266.374091 951.470625,266.727273 951.125,266.727273 L944.25,266.727273 C943.560625,266.727273 943,266.089636 943,265.391545 L943,255.268909 C943,254.570818 943.560625,254.003818 944.25,254.003818 L948.625,254.003818 C948.64375,254.003818 948.66,254.012727 948.678125,254.014636 C948.721875,254.018455 948.7625,254.027364 948.804375,254.040091 C948.845,254.052818 948.881875,254.067455 948.91875,254.087818 C948.935625,254.096727 948.955,254.098636 948.971875,254.109455 L950.689375,255.268909 L956.75,255.268909 C957.43875,255.268909 958,255.836545 958,256.534 L958,261.595636 C958,261.945 957.720625,262.228182 957.375,262.228182 Z M953.625,264.759 L954.875,264.759 L954.875,263.493273 C954.875,263.143909 955.154375,262.860727 955.5,262.860727 C955.845625,262.860727 956.125,263.143909 956.125,263.493273 L956.125,264.759 L957.375,264.759 C957.720625,264.759 958,265.042182 958,265.391545 C958,265.740909 957.720625,266.024727 957.375,266.024727 L956.125,266.024727 L956.125,267.289818 C956.125,267.639182 955.845625,267.922364 955.5,267.922364 C955.154375,267.922364 954.875,267.639182 954.875,267.289818 L954.875,266.024727 L953.625,266.024727 C953.279375,266.024727 953,265.740909 953,265.391545 C953,265.042182 953.279375,264.759 953.625,264.759 Z",
          id: "cat---new"
        }))));
      },
      "shopping-tag": function shoppingTag(_ref77) {
        var e = _ref77.className,
            _ref77$width = _ref77.width,
            t = _ref77$width === void 0 ? "24" : _ref77$width,
            _ref77$height = _ref77.height,
            a = _ref77$height === void 0 ? "24" : _ref77$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M22.999 12.414l-10.571 10.988c-0.391 0.39-0.893 0.598-1.428 0.598s-1.038-0.208-1.414-0.585l-9.001-9.001c-0.377-0.376-0.585-0.878-0.585-1.414s0.208-1.038 0.586-1.415l11.013-10.598c0.565-0.567 1.581-0.987 2.401-0.987h8c1.103 0 2 0.897 2 2v8c0 0.819-0.421 1.834-1.001 2.414zM22 2h-8c-0.285 0-0.799 0.213-1.001 0.414l-11.014 10.6 9.015 8.986c0.002 0 0.002 0 0.003-0.001l10.568-10.985c0.216-0.216 0.429-0.73 0.429-1.014v-8zM17.999 9c-1.653 0-2.999-1.345-2.999-3s1.346-3 2.999-3c1.654 0 3.001 1.346 3.001 3s-1.347 3-3.001 3zM17.999 5c-0.55 0-0.999 0.448-0.999 1 0 0.551 0.449 1 0.999 1 0.552 0 1.001-0.449 1.001-1s-0.449-1-1.001-1z"
        }));
      },
      "laptop-1": function laptop1(_ref78) {
        var e = _ref78.className,
            _ref78$width = _ref78.width,
            t = _ref78$width === void 0 ? "26" : _ref78$width,
            _ref78$height = _ref78.height,
            a = _ref78$height === void 0 ? "24" : _ref78$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M25.843 23.637c-0.206 0.231-0.502 0.363-0.812 0.363h-23.953c-0.31 0-0.605-0.132-0.812-0.363s-0.304-0.54-0.271-0.848l1.082-9.758v-11.94c0-0.603 0.488-1.091 1.089-1.091h21.776c0.601 0 1.089 0.488 1.089 1.091v11.941l1.082 9.757c0.035 0.308-0.064 0.616-0.271 0.848zM22.853 2.182h-19.598v9.818h19.598v-9.818zM22.968 14.182h-19.827l-0.847 7.636h21.52l-0.847-7.636zM6.521 20.727h-2.177v-2.182h2.177v2.182zM5.433 15.273h2.177v2.182h-2.177v-2.182zM18.499 20.727h-10.888v-2.182h10.888v2.182zM21.765 20.727h-2.177v-2.182h2.177v2.182zM18.499 15.273h2.177v2.182h-2.177v-2.182zM15.232 15.273h2.177v2.182h-2.177v-2.182zM11.965 15.273h2.179v2.182h-2.179v-2.182zM8.699 15.273h2.177v2.182h-2.177v-2.182z"
        }));
      },
      "phone-message-1": function phoneMessage1(_ref79) {
        var e = _ref79.className,
            _ref79$width = _ref79.width,
            t = _ref79$width === void 0 ? "23" : _ref79$width,
            _ref79$height = _ref79.height,
            a = _ref79$height === void 0 ? "24" : _ref79$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 23 24"
        }, l.a.createElement("path", {
          d: "M16 16.992c-0.205 0-0.494 0.002-0.736 0.004-0.896 0.885-2.167 1.024-2.874 1.024-0.296 0-0.493-0.025-0.521-0.028-0.386-0.051-0.707-0.321-0.823-0.692-0.116-0.372-0.007-0.777 0.28-1.039 0 0 0.218-0.227 0.357-0.56-1.733-1.081-2.683-2.552-2.683-4.205 0-3.031 3.141-5.496 7-5.496s7 2.465 7 5.496c0 3.031-3.141 5.496-7 5.496zM16 8c-2.71 0-5 1.601-5 3.496 0 1.436 1.412 2.372 2.254 2.802 0.044 0.022 0.072 0.061 0.111 0.088 0.059 0.042 0.118 0.079 0.166 0.132 0.043 0.048 0.072 0.102 0.105 0.156 0.034 0.055 0.070 0.107 0.093 0.169 0.025 0.066 0.031 0.134 0.041 0.204 0.007 0.048 0.029 0.091 0.029 0.141 0 0.021-0.004 0.039-0.004 0.059-0.001 0.009-0.002 0.018-0.002 0.027-0.004 0.13-0.010 0.259-0.027 0.38 0.080-0.063 0.152-0.138 0.212-0.224 0.192-0.276 0.499-0.409 0.812-0.412v-0.018c0 0 0.782-0.008 1.21-0.008 2.71 0 5-1.601 5-3.496s-2.29-3.496-5-3.496zM8 21h-2v-2.002h2v2.002zM5 4c0-0.552 0.447-1 1-1h2c0.553 0 1 0.448 1 1s-0.447 1-1 1h-2c-0.553 0-1-0.448-1-1zM13 5c-0.553 0-1-0.448-1-1v-1.533c0-0.253-0.214-0.467-0.467-0.467h-9.066c-0.253 0-0.467 0.214-0.467 0.467v19.066c0 0.253 0.214 0.467 0.467 0.467h9.066c0.253 0 0.467-0.214 0.467-0.467v-1.533c0-0.552 0.447-1 1-1s1 0.448 1 1v1.533c0 1.361-1.106 2.467-2.467 2.467h-9.066c-1.361 0-2.467-1.106-2.467-2.467v-19.066c0-1.36 1.106-2.467 2.467-2.467h9.066c1.361 0 2.467 1.107 2.467 2.467v1.533c0 0.552-0.447 1-1 1z"
        }));
      },
      "message-1": function message1(_ref80) {
        var e = _ref80.className,
            _ref80$width = _ref80.width,
            t = _ref80$width === void 0 ? "26" : _ref80$width,
            _ref80$height = _ref80.height,
            a = _ref80$height === void 0 ? "24" : _ref80$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M4.364 24c-0.412 0-0.791-0.233-0.975-0.604-0.19-0.38-0.141-0.835 0.122-1.166 0.017-0.023 1.568-1.995 1.875-4.059-2.717-1.36-5.386-4.234-5.386-7.849 0-5.691 5.872-10.321 13.091-10.321s13.091 4.63 13.091 10.321c0 5.738-5.872 10.406-13.091 10.406h-1.565c-2.135 3.104-6.919 3.267-7.133 3.273-0.009 0-0.019 0-0.028 0zM13.091 2.182c-6.015 0-10.909 3.651-10.909 8.139 0 2.797 2.39 5.212 4.751 6.154 0.415 0.166 0.686 0.567 0.686 1.013 0 1.448-0.515 2.864-1.069 3.967 1.26-0.346 2.719-1.018 3.389-2.319 0.188-0.362 0.562-0.59 0.97-0.59h2.182c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139z"
        }));
      },
      "message-1-write": function message1Write(_ref81) {
        var e = _ref81.className,
            _ref81$width = _ref81.width,
            t = _ref81$width === void 0 ? "26" : _ref81$width,
            _ref81$height = _ref81.height,
            a = _ref81$height === void 0 ? "24" : _ref81$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M13.091 20.727h-1.565c-2.135 3.104-6.919 3.267-7.133 3.273-0.009 0-0.019 0-0.028 0-0.412 0-0.791-0.233-0.975-0.604-0.19-0.38-0.141-0.835 0.122-1.167 0.017-0.022 1.568-1.993 1.874-4.058-2.716-1.359-5.385-4.234-5.385-7.849 0-5.691 5.872-10.321 13.091-10.321s13.091 4.63 13.091 10.321c0 5.738-5.872 10.406-13.091 10.406zM13.091 2.182c-6.015 0-10.909 3.651-10.909 8.139 0 2.797 2.39 5.213 4.751 6.155 0.415 0.165 0.686 0.567 0.686 1.013 0 1.448-0.515 2.863-1.069 3.965 1.261-0.346 2.719-1.018 3.389-2.319 0.188-0.362 0.562-0.59 0.97-0.59h2.182c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139zM16.364 9.818h2.182v2.182h-2.182v-2.182zM12 9.818h2.182v2.182h-2.182v-2.182zM7.636 9.818h2.182v2.182h-2.182v-2.182z"
        }));
      },
      "message-1-heart": function message1Heart(_ref82) {
        var e = _ref82.className,
            _ref82$width = _ref82.width,
            t = _ref82$width === void 0 ? "26" : _ref82$width,
            _ref82$height = _ref82.height,
            a = _ref82$height === void 0 ? "24" : _ref82$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M13.091 20.727h-1.567c-2.134 3.104-6.917 3.267-7.132 3.273-0.009 0-0.019 0-0.028 0-0.412 0-0.791-0.233-0.976-0.604-0.189-0.38-0.14-0.835 0.123-1.167 0.017-0.022 1.568-1.993 1.875-4.058-2.717-1.359-5.386-4.234-5.386-7.849 0-5.691 5.872-10.321 13.091-10.321s13.091 4.63 13.091 10.321c0 5.738-5.872 10.406-13.091 10.406zM13.091 2.182c-6.015 0-10.909 3.651-10.909 8.139 0 2.797 2.39 5.213 4.751 6.155 0.415 0.165 0.686 0.567 0.686 1.013 0 1.448-0.515 2.863-1.069 3.965 1.261-0.346 2.719-1.018 3.389-2.319 0.188-0.362 0.562-0.59 0.97-0.59h2.182c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139zM18.416 12c-0.007 0.007-0.010 0.015-0.016 0.022l-4.584 4.067c-0.059 0.052-0.129 0.080-0.194 0.117-0.041 0.023-0.076 0.055-0.12 0.072-0.132 0.055-0.269 0.086-0.409 0.086-0.001 0-0.001 0-0.001 0s0 0 0 0c-0.141 0-0.278-0.032-0.41-0.086-0.044-0.017-0.079-0.049-0.12-0.072-0.065-0.037-0.135-0.064-0.194-0.117l-4.584-4.067c-0.007-0.007-0.010-0.015-0.016-0.022-0.008-0.008-0.019-0.010-0.026-0.017-0.747-0.74-1.195-1.765-1.195-2.746 0-2.086 1.713-3.782 3.818-3.782 1.058 0 2.021 0.428 2.727 1.115 0.706-0.687 1.669-1.115 2.727-1.115 2.105 0 3.818 1.696 3.818 3.782 0 0.981-0.447 2.006-1.195 2.746-0.008 0.008-0.019 0.010-0.026 0.017zM15.818 7.636c-0.802 0-1.513 0.557-1.656 1.298-0.001 0.003-0.003 0.005-0.004 0.009-0.019 0.093-0.063 0.173-0.105 0.257-0.085 0.173-0.199 0.327-0.355 0.432-0.008 0.005-0.019 0.007-0.026 0.012-0.111 0.070-0.235 0.123-0.367 0.149-0.003 0.001-0.005 0.003-0.009 0.004-0.070 0.013-0.135-0.002-0.204-0.002-0.070 0-0.137 0.015-0.208 0.002-0.003-0.001-0.007-0.003-0.009-0.004-0.123-0.024-0.236-0.076-0.341-0.14-0.016-0.010-0.037-0.012-0.052-0.022-0.107-0.072-0.197-0.167-0.274-0.274-0.005-0.008-0.015-0.012-0.021-0.021-0.027-0.040-0.036-0.092-0.058-0.136-0.041-0.084-0.087-0.166-0.106-0.259-0.001-0.003-0.003-0.005-0.004-0.009-0.143-0.741-0.854-1.298-1.656-1.298-0.902 0-1.636 0.718-1.636 1.6 0 0.396 0.214 0.862 0.543 1.188l3.82 3.389 3.82-3.389c0.329-0.326 0.543-0.792 0.543-1.188 0-0.883-0.734-1.6-1.636-1.6z"
        }));
      },
      "message-1-ask": function message1Ask(_ref83) {
        var e = _ref83.className,
            _ref83$width = _ref83.width,
            t = _ref83$width === void 0 ? "26" : _ref83$width,
            _ref83$height = _ref83.height,
            a = _ref83$height === void 0 ? "24" : _ref83$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M13.091 20.727h-1.565c-2.135 3.104-6.919 3.267-7.133 3.273-0.009 0-0.019 0-0.028 0-0.412 0-0.791-0.233-0.975-0.604-0.19-0.38-0.141-0.835 0.122-1.167 0.017-0.022 1.568-1.994 1.874-4.058-2.716-1.36-5.385-4.234-5.385-7.849 0-5.691 5.872-10.321 13.091-10.321s13.091 4.63 13.091 10.321c0 5.738-5.872 10.406-13.091 10.406zM13.091 2.182c-6.015 0-10.909 3.651-10.909 8.139 0 2.797 2.39 5.212 4.751 6.154 0.415 0.166 0.686 0.567 0.686 1.013 0 1.448-0.515 2.864-1.069 3.967 1.261-0.346 2.719-1.018 3.389-2.319 0.188-0.362 0.562-0.59 0.97-0.59h2.182c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139zM14.182 11.799v0.201c0 0.122-0.028 0.235-0.070 0.341-0.053 0.159-0.131 0.311-0.247 0.433-0.053 0.050-0.123 0.080-0.185 0.12v0c-0.081 0.051-0.159 0.097-0.25 0.128-0.106 0.041-0.218 0.069-0.339 0.069s-0.233-0.027-0.339-0.069c-0.16-0.053-0.312-0.131-0.435-0.248-0.116-0.122-0.193-0.274-0.248-0.434-0.040-0.106-0.069-0.218-0.069-0.34v-1.091c0-0.602 0.489-1.091 1.091-1.091 0.601 0 1.091-0.49 1.091-1.091s-0.49-1.091-1.091-1.091c-0.601 0-1.091 0.49-1.091 1.091 0 0.602-0.489 1.091-1.091 1.091s-1.091-0.489-1.091-1.091c0-1.804 1.468-3.273 3.273-3.273s3.273 1.468 3.273 3.273c0 1.42-0.915 2.62-2.182 3.072zM13.865 14.498c0.196 0.207 0.316 0.491 0.316 0.775s-0.12 0.567-0.316 0.775c-0.207 0.196-0.491 0.316-0.775 0.316s-0.567-0.12-0.775-0.316c-0.196-0.207-0.316-0.491-0.316-0.775s0.12-0.567 0.316-0.775c0.415-0.404 1.145-0.404 1.549 0z"
        }));
      },
      "message-1-alert": function message1Alert(_ref84) {
        var e = _ref84.className,
            _ref84$width = _ref84.width,
            t = _ref84$width === void 0 ? "26" : _ref84$width,
            _ref84$height = _ref84.height,
            a = _ref84$height === void 0 ? "24" : _ref84$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M13.091 20.727h-1.567c-2.134 3.104-6.917 3.267-7.132 3.273-0.009 0-0.019 0-0.028 0-0.412 0-0.791-0.233-0.976-0.604-0.189-0.38-0.14-0.835 0.123-1.167 0.017-0.022 1.568-1.993 1.875-4.058-2.717-1.359-5.386-4.234-5.386-7.849 0-5.691 5.872-10.321 13.091-10.321s13.091 4.63 13.091 10.321c0 5.738-5.872 10.406-13.091 10.406zM13.091 2.182c-6.015 0-10.909 3.651-10.909 8.139 0 2.797 2.39 5.213 4.751 6.155 0.415 0.165 0.686 0.567 0.686 1.013 0 1.448-0.515 2.863-1.069 3.965 1.261-0.346 2.719-1.018 3.389-2.319 0.188-0.362 0.562-0.59 0.97-0.59h2.182c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139zM13.091 15.273c-0.284 0-0.567-0.12-0.775-0.316-0.196-0.207-0.316-0.491-0.316-0.775s0.12-0.567 0.316-0.775c0.404-0.404 1.135-0.404 1.549 0 0.196 0.207 0.316 0.491 0.316 0.775s-0.12 0.567-0.316 0.775c-0.207 0.196-0.491 0.316-0.775 0.316zM13.091 12c-0.602 0-1.091-0.489-1.091-1.091v-4.364c0-0.602 0.489-1.091 1.091-1.091s1.091 0.489 1.091 1.091v4.364c0 0.602-0.489 1.091-1.091 1.091z"
        }));
      },
      "comment-1": function comment1(_ref85) {
        var e = _ref85.className,
            _ref85$width = _ref85.width,
            t = _ref85$width === void 0 ? "26" : _ref85$width,
            _ref85$height = _ref85.height,
            a = _ref85$height === void 0 ? "24" : _ref85$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M13.091 20.727h-1.567c-2.134 3.103-6.917 3.266-7.132 3.272-0.009 0.001-0.019 0.001-0.028 0.001-0.412 0-0.791-0.233-0.975-0.604-0.19-0.38-0.141-0.835 0.122-1.166 0.017-0.022 1.568-1.995 1.874-4.059-2.716-1.36-5.385-4.235-5.385-7.849 0-5.691 5.872-10.321 13.091-10.321s13.091 4.63 13.091 10.321c0 5.738-5.872 10.406-13.091 10.406zM13.091 2.182c-6.015 0-10.909 3.651-10.909 8.139 0 2.796 2.39 5.212 4.751 6.155 0.415 0.165 0.686 0.566 0.686 1.012 0 1.448-0.515 2.864-1.069 3.968 1.26-0.347 2.719-1.019 3.389-2.32 0.188-0.363 0.562-0.59 0.97-0.59h2.182c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139zM18.545 9.818h-10.909c-0.602 0-1.091-0.489-1.091-1.091s0.489-1.091 1.091-1.091h10.909c0.602 0 1.091 0.489 1.091 1.091s-0.489 1.091-1.091 1.091zM7.636 10.909h7.636c0.602 0 1.091 0.489 1.091 1.091s-0.489 1.091-1.091 1.091h-7.636c-0.602 0-1.091-0.489-1.091-1.091s0.489-1.091 1.091-1.091z"
        }));
      },
      "comments-1": function comments1(_ref86) {
        var e = _ref86.className,
            _ref86$width = _ref86.width,
            t = _ref86$width === void 0 ? "26" : _ref86$width,
            _ref86$height = _ref86.height,
            a = _ref86$height === void 0 ? "24" : _ref86$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M22.365 19.653c0.274 1.62 1.152 2.324 1.193 2.355 0.35 0.268 0.513 0.728 0.397 1.154-0.115 0.425-0.469 0.746-0.908 0.802-0.037 0.005-0.276 0.034-0.648 0.034-1.121 0-3.452-0.278-5.21-2.205h-1.373c-1.975 0-3.842-0.418-5.401-1.208-0.537-0.272-0.752-0.928-0.479-1.465 0.272-0.536 0.929-0.751 1.467-0.479 1.253 0.636 2.781 0.972 4.415 0.972h1.853c0.025 0 0.047 0.013 0.071 0.015 0.075 0.004 0.145 0.023 0.217 0.044 0.067 0.019 0.131 0.034 0.192 0.064 0.060 0.029 0.11 0.071 0.165 0.111 0.061 0.046 0.119 0.091 0.169 0.148 0.016 0.017 0.038 0.026 0.053 0.047 0.616 0.805 1.39 1.252 2.105 1.496-0.255-0.609-0.448-1.357-0.515-2.24-0.002-0.014-0.004-0.026-0.005-0.040-0.002-0.024-0.009-0.043-0.011-0.068-0.002-0.052 0.017-0.098 0.021-0.148 0.007-0.079 0.010-0.155 0.033-0.229 0.020-0.068 0.053-0.124 0.086-0.185 0.032-0.063 0.061-0.124 0.106-0.18 0.048-0.060 0.108-0.106 0.168-0.154 0.040-0.033 0.067-0.076 0.112-0.104 1.255-0.757 3.361-2.427 3.361-5.116 0-1.317-0.721-2.774-1.714-3.465-0.494-0.345-0.616-1.023-0.273-1.517s1.023-0.616 1.519-0.272c1.585 1.102 2.65 3.214 2.65 5.254 0 2.54-1.391 4.898-3.817 6.578zM10.364 17.434h-1.371c-1.76 1.925-4.089 2.205-5.21 2.205-0.372 0-0.611-0.028-0.648-0.034-0.445-0.057-0.809-0.38-0.92-0.814-0.109-0.434 0.058-0.891 0.422-1.152 0.029-0.023 0.907-0.725 1.178-2.345-2.425-1.68-3.815-4.039-3.815-6.578 0-4.808 4.649-8.72 10.364-8.72s10.364 3.912 10.364 8.72c0 4.808-4.649 8.719-10.364 8.719zM10.364 2.175c-4.512 0-8.182 2.933-8.182 6.54 0 2.689 2.104 4.359 3.359 5.116 0.045 0.027 0.071 0.070 0.11 0.101 0.061 0.049 0.121 0.095 0.17 0.156 0.045 0.055 0.073 0.116 0.106 0.178 0.032 0.062 0.067 0.119 0.086 0.187 0.023 0.075 0.026 0.151 0.033 0.229 0.003 0.050 0.023 0.096 0.020 0.147-0.001 0.025-0.008 0.044-0.010 0.069-0.001 0.014-0.003 0.027-0.005 0.043-0.065 0.881-0.26 1.631-0.514 2.239 0.716-0.243 1.489-0.689 2.107-1.497 0.015-0.020 0.037-0.028 0.053-0.046 0.050-0.059 0.109-0.104 0.17-0.149 0.055-0.040 0.105-0.082 0.165-0.11 0.060-0.031 0.124-0.046 0.191-0.064 0.073-0.021 0.143-0.039 0.218-0.045 0.024-0.001 0.045-0.014 0.070-0.014h1.856c4.51 0 8.18-2.933 8.18-6.539 0-3.607-3.67-6.54-8.182-6.54zM14.042 8.727h-6.545c-0.602 0-1.091-0.489-1.091-1.090 0-0.602 0.489-1.090 1.091-1.090h6.545c0.602 0 1.091 0.488 1.091 1.090 0 0.601-0.489 1.090-1.091 1.090zM7.497 9.817h4.364c0.602 0 1.091 0.489 1.091 1.090 0 0.602-0.489 1.090-1.091 1.090h-4.364c-0.602 0-1.091-0.488-1.091-1.090 0-0.601 0.489-1.090 1.091-1.090z"
        }));
      },
      "chat-1": function chat1(_ref87) {
        var e = _ref87.className,
            _ref87$width = _ref87.width,
            t = _ref87$width === void 0 ? "26" : _ref87$width,
            _ref87$height = _ref87.height,
            a = _ref87$height === void 0 ? "24" : _ref87$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 26 24"
        }, l.a.createElement("path", {
          d: "M22.365 19.653c0.274 1.62 1.152 2.324 1.193 2.354 0.351 0.269 0.512 0.729 0.397 1.155-0.116 0.425-0.469 0.746-0.908 0.802-0.037 0.005-0.275 0.034-0.648 0.034-1.121 0-3.452-0.278-5.21-2.205h-1.373c-1.975 0-3.842-0.418-5.401-1.208-0.537-0.272-0.752-0.928-0.479-1.465 0.273-0.536 0.929-0.751 1.467-0.479 1.253 0.636 2.78 0.972 4.415 0.972h1.853c0.025 0 0.046 0.013 0.071 0.014 0.075 0.005 0.145 0.024 0.219 0.045 0.065 0.019 0.129 0.034 0.189 0.063 0.060 0.031 0.112 0.072 0.167 0.112 0.060 0.046 0.118 0.091 0.168 0.147 0.016 0.019 0.038 0.027 0.053 0.048 0.616 0.805 1.389 1.252 2.105 1.495-0.255-0.608-0.448-1.356-0.515-2.237-0.002-0.014-0.004-0.028-0.005-0.043-0.002-0.024-0.009-0.043-0.010-0.068-0.003-0.051 0.016-0.098 0.020-0.148 0.007-0.077 0.010-0.154 0.033-0.228 0.020-0.068 0.053-0.125 0.086-0.188 0.033-0.061 0.061-0.122 0.106-0.178 0.048-0.061 0.109-0.107 0.17-0.156 0.039-0.032 0.065-0.074 0.11-0.101 1.255-0.757 3.361-2.427 3.361-5.116 0-1.317-0.721-2.774-1.714-3.465-0.494-0.345-0.616-1.023-0.273-1.517s1.024-0.615 1.519-0.272c1.585 1.102 2.65 3.214 2.65 5.254 0 2.54-1.391 4.898-3.817 6.578zM10.364 17.434h-1.372c-1.759 1.925-4.088 2.205-5.209 2.205-0.373 0-0.611-0.028-0.648-0.034-0.445-0.057-0.809-0.38-0.92-0.814-0.109-0.434 0.058-0.891 0.422-1.152 0.029-0.024 0.907-0.725 1.179-2.347-2.426-1.679-3.816-4.037-3.816-6.577 0-4.808 4.649-8.72 10.364-8.72s10.364 3.912 10.364 8.72c0 4.808-4.649 8.719-10.364 8.719zM10.364 2.175c-4.512 0-8.182 2.933-8.182 6.54 0 2.689 2.104 4.359 3.359 5.116 0.045 0.027 0.071 0.070 0.11 0.101 0.061 0.049 0.121 0.095 0.17 0.156 0.045 0.055 0.073 0.116 0.106 0.178 0.032 0.062 0.067 0.119 0.086 0.187 0.023 0.075 0.026 0.151 0.033 0.229 0.003 0.050 0.023 0.096 0.021 0.147-0.002 0.025-0.009 0.044-0.011 0.069-0.001 0.014-0.003 0.027-0.005 0.041-0.065 0.883-0.26 1.632-0.514 2.24 0.716-0.243 1.489-0.689 2.107-1.497 0.015-0.020 0.037-0.028 0.053-0.046 0.050-0.058 0.108-0.104 0.17-0.149 0.053-0.040 0.105-0.082 0.165-0.111s0.123-0.045 0.19-0.063c0.073-0.021 0.143-0.039 0.219-0.045 0.024-0.001 0.045-0.014 0.070-0.014h1.856c4.51 0 8.18-2.933 8.18-6.539 0-3.607-3.67-6.54-8.182-6.54z"
        }));
      },
      "megaphone-2": function megaphone2(_ref88) {
        var e = _ref88.className,
            _ref88$width = _ref88.width,
            t = _ref88$width === void 0 ? "29" : _ref88$width,
            _ref88$height = _ref88.height,
            a = _ref88$height === void 0 ? "24" : _ref88$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 29 24"
        }, l.a.createElement("path", {
          d: "M28.887 10.776c0 2.649-2.159 4.804-4.814 4.804v4.806c0 0.427-0.229 0.823-0.599 1.038-0.187 0.11-0.396 0.162-0.604 0.162-0.206 0-0.412-0.053-0.597-0.158l-8.147-4.646h-6.903v6.005c0 0.664-0.539 1.201-1.204 1.201s-1.204-0.537-1.204-1.201v-6.005h-2.407c-1.328 0-2.407-1.077-2.407-2.402v-7.207c0-1.324 1.080-2.402 2.407-2.402h11.717l8.147-4.646c0.371-0.213 0.828-0.212 1.201 0.004 0.371 0.215 0.599 0.611 0.599 1.039v4.805c2.655 0.001 4.814 2.156 4.814 4.805zM4.814 7.172h-2.407v7.207h2.407v-7.207zM21.665 3.237l-6.625 3.777c-0.202 0.117-0.422 0.146-0.639 0.137-0.037 0.004-0.069 0.022-0.106 0.022-0.001 0-0.001 0-0.002 0h-7.071v7.207h7.222c0.024 0 0.045 0.012 0.069 0.013 0.081 0.005 0.156 0.026 0.235 0.048 0.079 0.020 0.156 0.040 0.227 0.075 0.022 0.011 0.046 0.010 0.066 0.022l6.625 3.778v-15.079zM24.072 8.374v4.805c1.328-0.001 2.407-1.078 2.407-2.402 0-1.325-1.080-2.401-2.407-2.402z"
        }));
      },
      email: function email(_ref89) {
        var e = _ref89.className,
            _ref89$width = _ref89.width,
            t = _ref89$width === void 0 ? "32" : _ref89$width,
            _ref89$height = _ref89.height,
            a = _ref89$height === void 0 ? "24" : _ref89$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 32 24"
        }, l.a.createElement("path", {
          d: "M28 24h-24c-2.205 0-4-1.795-4-4v-16c0-2.205 1.795-4 4-4h24c2.205 0 4 1.795 4 4v16c0 2.205-1.795 4-4 4zM4 21.333h24c0.735 0 1.333-0.599 1.333-1.333v-15.729l-12.496 10.1c-0.244 0.197-0.54 0.296-0.837 0.296s-0.593-0.099-0.837-0.296l-12.496-10.1v15.729c0 0.735 0.599 1.333 1.333 1.333zM27.076 2.667h-22.152l11.076 8.953 11.076-8.953z"
        }));
      },
      "inbox-empty": function inboxEmpty(_ref90) {
        var e = _ref90.className,
            _ref90$width = _ref90.width,
            t = _ref90$width === void 0 ? "29" : _ref90$width,
            _ref90$height = _ref90.height,
            a = _ref90$height === void 0 ? "24" : _ref90$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 29 24"
        }, l.a.createElement("path", {
          d: "M26.222 24h-23.824c-1.314 0-2.382-1.076-2.382-2.4v-9.6c0-0.046 0.020-0.085 0.025-0.13s-0.007-0.086 0.002-0.131l2.383-10.8c0.12-0.548 0.604-0.94 1.163-0.94h21.44c0.559 0 1.042 0.391 1.163 0.94l2.383 10.8c0.010 0.044-0.002 0.086 0.002 0.131s0.025 0.084 0.025 0.13v9.6c0 1.324-1.068 2.4-2.382 2.4zM24.076 2.4h-19.53l-1.853 8.4h6.853c0.658 0 1.19 0.538 1.19 1.2 0 1.985 1.603 3.6 3.574 3.6 1.972 0 3.574-1.615 3.574-3.6 0-0.662 0.534-1.2 1.192-1.2h6.853l-1.853-8.4zM26.363 13.2h-6.217c-0.553 2.735-2.959 4.8-5.836 4.8-2.875 0-5.281-2.065-5.834-4.8h-6.113v8.4h24v-8.4z"
        }));
      },
      "inbox-full": function inboxFull(_ref91) {
        var e = _ref91.className,
            _ref91$width = _ref91.width,
            t = _ref91$width === void 0 ? "24" : _ref91$width,
            _ref91$height = _ref91.height,
            a = _ref91$height === void 0 ? "24" : _ref91$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M21.799 24h-19.81c-1.093 0-1.981-0.897-1.981-2v-8c0-0.096 0.029-0.182 0.054-0.27-0.052-0.187-0.068-0.387-0.001-0.585l2.178-6.467c0.117-0.347 0.409-0.571 0.741-0.641v-2.037c0-0.552 0.443-1 0.99-1h15.848c0.547 0 0.991 0.448 0.991 1v2.038c0.33 0.070 0.621 0.293 0.738 0.64l2.181 6.467c0.041 0.121 0.052 0.245 0.047 0.366 0.111 0.147 0.194 0.308 0.194 0.489v8c0 1.103-1.077 2-2.17 2zM2.98 10.691l-0.778 2.309h0.778v-2.309zM18.828 5h-13.867v8h2.971c0.547 0 0.991 0.448 0.991 1 0 1.655 1.332 3 2.969 3 1.64 0 2.974-1.345 2.974-3 0-0.552 0.443-1 0.99-1h2.972v-8zM20.809 10.695v2.305h0.777l-0.777-2.305zM21.969 15h-5.222c-0.461 2.279-2.462 4-4.855 4-2.39 0-4.39-1.721-4.85-4h-5.053v7h19.98v-7zM17.837 2h-11.886c-0.547 0-0.99-0.448-0.99-1s0.443-1 0.99-1h11.886c0.547 0 0.991 0.448 0.991 1s-0.444 1-0.991 1z"
        }));
      },
      "email-send": function emailSend(_ref92) {
        var e = _ref92.className,
            _ref92$width = _ref92.width,
            t = _ref92$width === void 0 ? "36" : _ref92$width,
            _ref92$height = _ref92.height,
            a = _ref92$height === void 0 ? "24" : _ref92$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 36 24"
        }, l.a.createElement("path", {
          d: "M36.029 4.008l-2.007 16.342c-0.217 2.025-1.971 3.629-3.991 3.629h-19.521c-0.83 0-1.503-0.67-1.503-1.495 0-0.827 0.703-1.36 1.533-1.36h19.573c0.471 0 0.869-0.602 0.923-1.114l1.822-14.819-12.336 10.928c-0.276 0.245-0.631 0.379-0.998 0.379-0.030 0-0.059-0.002-0.089-0.005-0.398-0.023-0.769-0.202-1.034-0.498l-12.021-13.465c-0.051-0.057-0.071-0.129-0.111-0.193-0.059-0.089-0.122-0.172-0.16-0.274-0.039-0.102-0.048-0.206-0.065-0.313-0.011-0.074-0.044-0.139-0.044-0.215 0-0.015 0.009-0.027 0.009-0.042 0.003-0.111 0.038-0.214 0.065-0.321 0.023-0.084 0.029-0.17 0.065-0.247 0.035-0.077 0.095-0.14 0.143-0.212 0.062-0.090 0.116-0.185 0.196-0.26 0.012-0.011 0.017-0.026 0.027-0.035 0.057-0.051 0.129-0.071 0.191-0.111 0.090-0.059 0.175-0.122 0.277-0.16 0.102-0.039 0.208-0.048 0.316-0.065 0.072-0.011 0.139-0.042 0.214-0.042h24.78c1.083 0 2.121 0.464 2.852 1.272 0.684 0.756 1.001 1.713 0.894 2.695zM10.85 3.032l8.798 9.857 11.125-9.857h-19.923zM10.509 9.017c0 0.827-0.673 1.497-1.503 1.497h-4.506c-0.83 0-1.503-0.67-1.503-1.497s0.673-1.497 1.503-1.497h4.506c0.83 0 1.503 0.67 1.503 1.497zM12.012 13.506c0 0.827-0.673 1.497-1.503 1.497h-9.014c-0.83 0-1.503-0.67-1.503-1.497s0.673-1.497 1.503-1.497h9.014c0.83 0 1.503 0.67 1.503 1.497zM6.002 16.499h7.513c0.83 0 1.501 0.669 1.501 1.495s-0.672 1.497-1.501 1.497h-7.513c-0.83 0-1.501-0.67-1.501-1.497s0.672-1.495 1.501-1.495z"
        }));
      },
      "email-2-at": function email2At(_ref93) {
        var e = _ref93.className,
            _ref93$width = _ref93.width,
            t = _ref93$width === void 0 ? "24" : _ref93$width,
            _ref93$height = _ref93.height,
            a = _ref93$height === void 0 ? "24" : _ref93$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M20.806 24h-17.828c-1.639 0-2.972-1.345-2.972-3v-10c0-0.008 0.004-0.015 0.005-0.023 0.002-0.077 0.026-0.149 0.045-0.223 0.005-0.028 0.007-0.056 0.016-0.083 0.002-0.005 0.005-0.008 0.007-0.013 0.023-0.063 0.055-0.12 0.091-0.178 0.020-0.036 0.030-0.075 0.056-0.108 0.011-0.014 0.028-0.020 0.040-0.033 0.005-0.006 0.013-0.010 0.018-0.016 0.019-0.019 0.026-0.045 0.046-0.063l3.245-2.978c0.405-0.372 1.031-0.342 1.399 0.067 0.368 0.408 0.338 1.041-0.067 1.412l-2.389 2.193 5.675 4.622 2.685-2.22c0.582-0.472 1.447-0.471 2.020-0.008l2.693 2.228 5.674-4.621-2.368-2.174c-0.405-0.371-0.435-1.004-0.068-1.412 0.369-0.409 0.995-0.439 1.399-0.068l3.225 2.959c0.020 0.018 0.028 0.043 0.045 0.062 0.007 0.006 0.014 0.010 0.020 0.017 0.012 0.013 0.029 0.019 0.040 0.033 0.027 0.034 0.036 0.073 0.057 0.109 0.035 0.058 0.067 0.114 0.090 0.176 0.002 0.005 0.005 0.009 0.007 0.014 0.010 0.029 0.012 0.058 0.018 0.088 0.018 0.072 0.041 0.143 0.043 0.217 0.001 0.008 0.005 0.016 0.005 0.024v10c0 1.655-1.333 3-2.972 3zM1.938 13.051v7.697l4.69-3.878-4.69-3.819zM11.892 15.102l-8.342 6.898h16.684l-8.342-6.898zM21.938 12.977l-4.781 3.893 4.781 3.954v-7.847zM14.171 9.975c-0.586-0.235-0.994-0.664-1.177-1.194-0.341 0.138-0.712 0.219-1.102 0.219-1.638 0-2.971-1.346-2.971-3s1.333-3 2.971-3c0.9 0 1.697 0.414 2.243 1.053 0.417 0.118 0.728 0.488 0.728 0.947v3.144c0.071 0.031 0.442 0.043 0.548-0.047 0.467-0.501 0.451-1.194 0.438-1.805l-0.005-0.292c0-2.206-1.775-4-3.956-4-2.182 0-3.958 1.794-3.958 4 0 2.205 1.776 4 3.958 4 0.547 0 0.991 0.448 0.991 1s-0.444 1-0.991 1c-3.274 0-5.939-2.691-5.939-6 0-3.308 2.665-6 5.939-6s5.937 2.692 5.937 6l0.004 0.247c0.018 0.794 0.048 2.123-0.979 3.224-0.621 0.665-1.747 0.876-2.679 0.504zM11.892 5c-0.546 0-0.99 0.449-0.99 1s0.444 1 0.99 1c0.546 0 0.991-0.449 0.991-1s-0.445-1-0.991-1z"
        }));
      },
      answer: function answer(_ref94) {
        var e = _ref94.className,
            _ref94$width = _ref94.width,
            t = _ref94$width === void 0 ? "24" : _ref94$width,
            _ref94$height = _ref94.height,
            a = _ref94$height === void 0 ? "24" : _ref94$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 24"
        }, l.a.createElement("path", {
          d: "M18.688 24c-2.537 0-7.166-2.973-11.518-7.398-2.515-2.554-4.599-5.249-5.868-7.587-1.495-2.753-1.709-4.701-0.638-5.789l3.273-2.961c0.197-0.177 0.456-0.266 0.717-0.25 0.263 0.018 0.508 0.141 0.68 0.343l4.263 4.997c0.261 0.305 0.315 0.74 0.137 1.101l-1.65 3.354 5.883 5.976 3.301-1.676c0.355-0.18 0.781-0.127 1.082 0.137l4.918 4.308c0.199 0.174 0.321 0.421 0.339 0.688 0.019 0.266-0.069 0.528-0.242 0.729l-2.851 3.295c-0.363 0.371-0.911 0.733-1.826 0.733zM2.084 4.612c-0.163 0.234-0.28 1.189 0.941 3.438 1.182 2.178 3.148 4.714 5.537 7.14 4.351 4.424 8.465 6.811 10.126 6.811 0.216 0 0.336-0.043 0.372-0.080l2.172-2.511-3.67-3.214-3.349 1.701c-0.38 0.192-0.837 0.116-1.136-0.188l-6.885-6.996c-0.3-0.303-0.374-0.768-0.185-1.153l1.673-3.4-3.181-3.728-2.415 2.18z"
        }));
      },
      "next-4": function next4(_ref95) {
        var e = _ref95.className,
            _ref95$width = _ref95.width,
            t = _ref95$width === void 0 ? "36" : _ref95$width,
            _ref95$height = _ref95.height,
            a = _ref95$height === void 0 ? "24" : _ref95$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 36 24"
        }, l.a.createElement("path", {
          d: "M35.77 17.073c-0.075 0.184-0.184 0.349-0.322 0.487l-5.977 6c-0.291 0.293-0.674 0.439-1.056 0.439s-0.765-0.147-1.056-0.439c-0.583-0.585-0.583-1.536 0-2.121l3.426-3.439h-21.797c-4.944 0-8.967-4.038-8.967-9v-7.5c0-0.828 0.669-1.5 1.495-1.5 0.825 0 1.494 0.672 1.494 1.5v7.5c0 3.309 2.681 6 5.978 6h21.797l-3.426-3.44c-0.583-0.585-0.583-1.536 0-2.121 0.584-0.587 1.529-0.587 2.112 0l5.977 6c0.138 0.138 0.248 0.303 0.322 0.487 0.151 0.366 0.151 0.78 0 1.146z"
        }));
      },
      "arrow-2-left": function arrow2Left(_ref96) {
        var e = _ref96.className,
            _ref96$width = _ref96.width,
            t = _ref96$width === void 0 ? "41" : _ref96$width,
            _ref96$height = _ref96.height,
            a = _ref96$height === void 0 ? "24" : _ref96$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 41 24"
        }, l.a.createElement("path", {
          d: "M39.513 13.703h-33.667l7.379 7.362c0.673 0.669 0.673 1.756 0 2.426-0.335 0.335-0.775 0.502-1.215 0.502s-0.88-0.167-1.215-0.502l-10.314-10.29c0 0 0-0.002-0.002-0.002-0.157-0.157-0.283-0.345-0.369-0.554-0.174-0.421-0.174-0.894 0-1.313 0.086-0.209 0.212-0.397 0.369-0.554 0.002-0.002 0.002-0.002 0.002-0.002l10.314-10.29c0.671-0.669 1.758-0.669 2.429 0 0.673 0.669 0.673 1.756 0 2.426l-7.379 7.362h33.667c0.949 0 1.718 0.766 1.718 1.713s-0.77 1.715-1.718 1.715z"
        }));
      },
      "arrow-2-right": function arrow2Right(_ref97) {
        var e = _ref97.className,
            _ref97$width = _ref97.width,
            t = _ref97$width === void 0 ? "41" : _ref97$width,
            _ref97$height = _ref97.height,
            a = _ref97$height === void 0 ? "24" : _ref97$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 41 24"
        }, l.a.createElement("path", {
          d: "M41.145 11.332c0.174 0.419 0.174 0.892 0 1.313-0.086 0.209-0.21 0.397-0.369 0.554 0 0 0 0.002 0 0.002l-10.314 10.29c-0.336 0.335-0.775 0.502-1.215 0.502s-0.88-0.167-1.216-0.502c-0.671-0.669-0.671-1.756 0-2.426l7.379-7.362h-33.666c-0.951 0-1.72-0.768-1.72-1.715s0.77-1.713 1.72-1.713h33.666l-7.379-7.362c-0.671-0.669-0.671-1.756 0-2.426s1.76-0.669 2.431 0l10.314 10.29c0 0 0 0 0 0.002 0.159 0.157 0.283 0.345 0.369 0.554z"
        }));
      },
      "arrow-1-left": function arrow1Left(_ref98) {
        var e = _ref98.className,
            _ref98$width = _ref98.width,
            t = _ref98$width === void 0 ? "10" : _ref98$width,
            _ref98$height = _ref98.height,
            a = _ref98$height === void 0 ? "18" : _ref98$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 10 18"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.44194 0.808058C9.68602 1.05214 9.68602 1.44786 9.44194 1.69194L1.88388 9.25L9.44194 16.8081C9.68602 17.0521 9.68602 17.4479 9.44194 17.6919C9.19786 17.936 8.80214 17.936 8.55806 17.6919L0.558057 9.69194C0.440848 9.57473 0.375 9.41576 0.375 9.25C0.375 9.08424 0.440848 8.92527 0.558057 8.80806L8.55806 0.808058C8.80214 0.563981 9.19786 0.563981 9.44194 0.808058Z",
          fill: "#353F45"
        }));
      },
      "arrow-1-right": function arrow1Right(_ref99) {
        var e = _ref99.className,
            _ref99$width = _ref99.width,
            t = _ref99$width === void 0 ? "10" : _ref99$width,
            _ref99$height = _ref99.height,
            a = _ref99$height === void 0 ? "18" : _ref99$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 10 18"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.558058 17.6919C0.313981 17.4479 0.313981 17.0521 0.558058 16.8081L8.11612 9.25L0.558058 1.69194C0.31398 1.44786 0.31398 1.05214 0.558058 0.808058C0.802135 0.56398 1.19786 0.56398 1.44194 0.808058L9.44194 8.80806C9.55915 8.92527 9.625 9.08424 9.625 9.25C9.625 9.41576 9.55915 9.57473 9.44194 9.69194L1.44194 17.6919C1.19786 17.936 0.802136 17.936 0.558058 17.6919Z",
          fill: "#353F45"
        }));
      },
      "chevron-down": function chevronDown(_ref100) {
        var e = _ref100.className,
            _ref100$width = _ref100.width,
            t = _ref100$width === void 0 ? "18" : _ref100$width,
            _ref100$height = _ref100.height,
            a = _ref100$height === void 0 ? "10" : _ref100$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 18 10"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.558058 0.558058C0.802136 0.313981 1.19786 0.313981 1.44194 0.558058L9 8.11612L16.5581 0.558058C16.8021 0.313981 17.1979 0.313981 17.4419 0.558058C17.686 0.802136 17.686 1.19786 17.4419 1.44194L9.44194 9.44194C9.32473 9.55915 9.16576 9.625 9 9.625C8.83424 9.625 8.67527 9.55915 8.55806 9.44194L0.558058 1.44194C0.313981 1.19786 0.313981 0.802136 0.558058 0.558058Z",
          fill: "#353F45"
        }));
      },
      "chevron-up": function chevronUp(_ref101) {
        var e = _ref101.className,
            _ref101$height = _ref101.height,
            t = _ref101$height === void 0 ? "10" : _ref101$height,
            _ref101$width = _ref101.width,
            a = _ref101$width === void 0 ? "18" : _ref101$width;
        return l.a.createElement("svg", {
          className: e,
          width: a,
          height: t,
          viewBox: "0 0 18 10",
          fill: "none"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.4419 9.44194C17.1979 9.68602 16.8021 9.68602 16.5581 9.44194L9 1.88388L1.44194 9.44194C1.19786 9.68602 0.802135 9.68602 0.558058 9.44194C0.31398 9.19786 0.31398 8.80213 0.558058 8.55806L8.55806 0.558057C8.67527 0.440848 8.83424 0.374999 9 0.374999C9.16576 0.374999 9.32473 0.440848 9.44194 0.558057L17.4419 8.55806C17.686 8.80214 17.686 9.19786 17.4419 9.44194Z",
          fill: "#353F45"
        }));
      },
      "drift-logo-round": function driftLogoRound(_ref102) {
        var e = _ref102.className,
            _ref102$width = _ref102.width,
            t = _ref102$width === void 0 ? "25" : _ref102$width,
            _ref102$height = _ref102.height,
            a = _ref102$height === void 0 ? "25" : _ref102$height;
        return l.a.createElement("svg", {
          className: e,
          xmlns: "http://www.w3.org/2000/svg",
          width: t,
          height: a,
          viewBox: "0 0 338.6 402.31"
        }, l.a.createElement("path", {
          d: "M175.6.1a169.34,169.34,0,0,0-32,336.6,4,4,0,0,1,3.1,5.7l-25.2,51.9s-.6,1.3-1.1,2.3a4.1,4.1,0,0,0,5,5.5c52.7-16.3,213.2-99.8,213.2-234.9C338.6,77.6,265.1,3.3,175.6.1Zm66.1,84.1a10.59,10.59,0,0,1-1,1.2l-47.3,53.8a11,11,0,0,0-1.2,1.4c-1.7,2.4,0,5.4,3.3,5.5h19.3c3.2.3,4.8,3.2,3.1,5.6l-1.3,1.6-34.9,39.3c-.4.5-.8.9-1.2,1.5-1.5,2.4.2,5.1,3.4,5.3h12.6a4.36,4.36,0,0,1,4.1,2.3,3.25,3.25,0,0,1-1,4,11,11,0,0,1-1,.8l-80.7,60.9a15,15,0,0,1-1.5,1.2,2.44,2.44,0,0,1-2.6,0,1.76,1.76,0,0,1-.8-2c.2-.5.7-1.5.7-1.5l22.2-45.8.6-1.3c1.5-3,0-5.6-3.3-6H116.4a12.1,12.1,0,0,1-1.9-.1c-2.7-.4-4.2-2.7-3.2-5a15.48,15.48,0,0,1,.8-1.5l27.6-46.3s.3-.5.5-.8c1.5-2.7-.3-5.4-3.8-5.5H118.3c-2.3,0-4-1.2-4.4-3.1a4.23,4.23,0,0,1,.7-2.7l8.4-14.8,27.6-48.6.7-1.1a7.49,7.49,0,0,1,7-3.8h78.6a16.35,16.35,0,0,1,2.2.2C241.9,79.5,243.1,82.1,241.7,84.2Z"
        }));
      },
      "drift-logo-full": function driftLogoFull(_ref103) {
        var e = _ref103.className,
            _ref103$width = _ref103.width,
            t = _ref103$width === void 0 ? 69 : _ref103$width,
            _ref103$height = _ref103.height,
            a = _ref103$height === void 0 ? 16 : _ref103$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 720 168"
        }, l.a.createElement("path", {
          d: "M263.62,166.43,242,115.67H223.44v50.76H174.26V0h86.68c38,0,58.44,26,58.44,57.14,0,28.7-16.31,43.92-29.22,50.41l29.47,58.88Zm5.84-106.16c0-11.32-7.79-16.35-16.07-16.35H223.44v33h29.95C261.67,76.94,269.46,71.91,269.46,60.27Z"
        }), l.a.createElement("path", {
          d: "M447.17,166.43V0H570.84V43.92h-74.3V66.21h72.59v43.92H496.54v56.3Z"
        }), l.a.createElement("path", {
          d: "M0,166.43V0H73c51.47,0,89.7,29.94,89.7,83.09s-38.23,83.34-89.45,83.34ZM112.49,83.09c0-22.46-12.75-39.17-39.21-39.17H49.5v78.6H73C97.78,122.52,112.49,104.05,112.49,83.09Z"
        }), l.a.createElement("path", {
          d: "M627.08,166.43V43.92H583.31V0H720V43.92H676.47V166.43Z"
        }), l.a.createElement("path", {
          d: "M436.28.48a13.44,13.44,0,0,1,1.94.16c2.44.57,3.49,2.79,2.25,4.67a13.55,13.55,0,0,1-.88,1.06L398,53.64s-.77.82-1.08,1.26c-1.52,2.13,0,4.71,2.94,4.87.45,0,1.36,0,1.36,0H415.5s.91,0,1.36,0c2.79.29,4.23,2.85,2.76,4.9-.34.48-1.17,1.37-1.17,1.37l-30.66,34.56a12.74,12.74,0,0,0-1.05,1.28c-1.34,2.07.21,4.51,3,4.67.75,0,1.52,0,2.27,0a3.77,3.77,0,0,1,3.57,2,2.82,2.82,0,0,1-.88,3.49c-.27.25-.85.74-.85.74l-62.09,53.47s-.84.76-1.31,1.08a2.06,2.06,0,0,1-2.25,0,1.42,1.42,0,0,1-.67-1.74c.16-.45.61-1.33.61-1.33l19.54-40.27.57-1.17c1.31-2.63,0-4.88-2.91-5.24-.35,0-1.12,0-1.12,0l-13.64,0a14.29,14.29,0,0,1-1.66-.09c-2.41-.39-3.68-2.41-2.77-4.37.21-.44.73-1.29.73-1.29l24.25-40.65s.28-.46.41-.7c1.32-2.4-.28-4.7-3.34-4.79-1.26,0-3.79,0-3.79,0s-6.54,0-10.8,0h-1.33c-2.05,0-3.51-1.09-3.83-2.74a3.46,3.46,0,0,1,.64-2.37l7.38-13L360.7,4.85l.6-1c1.24-2.24,3.33-3.32,6.17-3.32h68.81Z"
        }));
      },
      contacts: function contacts(_ref104) {
        var e = _ref104.className,
            _ref104$width = _ref104.width,
            t = _ref104$width === void 0 ? "16" : _ref104$width,
            _ref104$height = _ref104.height,
            a = _ref104$height === void 0 ? "12" : _ref104$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 12"
        }, l.a.createElement("g", {
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("path", {
          stroke: "#B5D2E1",
          strokeWidth: ".15",
          d: "M14.97 8.866c-.154-1.48-1.566-2.673-3.205-2.673-.746 0-1.45.235-2.034.682-.24.182-.58.136-.764-.103-.183-.24-.136-.583.104-.765.375-.286.808-.51 1.282-.664-.906-.51-1.486-1.462-1.486-2.52 0-1.598 1.3-2.898 2.9-2.898 1.597 0 2.897 1.3 2.897 2.9 0 1.052-.575 2.002-1.476 2.512 1.693.572 2.888 2.103 2.888 3.796v.28c0 .3-.244.544-.546.544h-4.706c-.302 0-.546-.244-.546-.545 0-.3.244-.546.546-.546h4.146zm-1.398-6.042c0 .996-.81 1.807-1.807 1.807-.997 0-1.808-.81-1.808-1.806 0-.997.81-1.808 1.808-1.808.996 0 1.807.81 1.807 1.808zM6.24 6.29c1.9.624 3.247 2.33 3.247 4.22v.314c0 .3-.245.545-.546.545H.47c-.3 0-.545-.245-.545-.546v-.314c0-1.89 1.346-3.596 3.246-4.22-1.11-.57-1.833-1.718-1.833-2.996 0-1.858 1.51-3.37 3.37-3.37 1.857 0 3.368 1.512 3.368 3.37 0 1.278-.722 2.426-1.835 2.997zm2.146 3.988l.005.08.076-.08h-.08zm-7.36 0h-.08l.074.08.005-.08zm0 0c.135-1.73 1.77-3.144 3.68-3.144 1.91 0 3.545 1.413 3.68 3.144h-7.36zm3.68-9.262c-1.256 0-2.278 1.022-2.278 2.278S3.45 5.572 4.706 5.572 6.984 4.55 6.984 3.294 5.962 1.016 4.706 1.016z"
        })));
      },
      conversations: function conversations(_ref105) {
        var e = _ref105.className,
            _ref105$width = _ref105.width,
            t = _ref105$width === void 0 ? "16" : _ref105$width,
            _ref105$height = _ref105.height,
            a = _ref105$height === void 0 ? "16" : _ref105$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 16"
        }, l.a.createElement("path", {
          d: "M2.07 15.597c-.115-.253-.085-.556.075-.777.01-.016.958-1.33 1.146-2.707C1.63 11.207 0 9.29 0 6.88 0 3.088 3.59 0 8 0s8 3.087 8 6.88c0 3.826-3.59 6.938-8 6.938h-.957C5.74 15.888 2.815 15.996 2.683 16c-.268 0-.5-.156-.612-.403zM1.334 6.88c0 1.865 1.46 3.476 2.904 4.103.253.11.42.378.42.676 0 .964-.316 1.908-.654 2.643.77-.23 1.66-.678 2.07-1.546.116-.24.344-.393.594-.393H8c3.676 0 6.667-2.46 6.667-5.483 0-2.99-2.99-5.425-6.667-5.425-3.676 0-6.667 2.434-6.667 5.426z",
          fill: "#B5D2E1",
          fillRule: "evenodd"
        }));
      },
      dashboard: function dashboard(_ref106) {
        var e = _ref106.className,
            _ref106$width = _ref106.width,
            t = _ref106$width === void 0 ? "16" : _ref106$width,
            _ref106$height = _ref106.height,
            a = _ref106$height === void 0 ? "17" : _ref106$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 17"
        }, l.a.createElement("path", {
          d: "M15.334 9.912c-.18 0-.36-.077-.493-.23l-.173-.203v6.103c0 .78-.6 1.417-1.334 1.417h-2.667c-.367 0-.666-.318-.666-.71 0-.09.02-.175.048-.254v-4.72L6 11.33v4.96c0 .392-.3.71-.667.71H2.666c-.735 0-1.333-.636-1.333-1.417V9.48l-.175.202c-.25.29-.67.308-.942.043-.27-.263-.29-.712-.04-1L7.507.218c.253-.293.73-.293.983 0l7.334 8.504c.25.29.23.738-.04 1-.128.127-.29.188-.45.188zM8 1.748L2.666 7.933v7.65h2V11.33c0-.782.6-1.418 1.334-1.418h4c.735 0 1.333.636 1.333 1.418v4.253h2.077v-7.56L8 1.747z",
          fill: "#B5D2E1",
          fillRule: "evenodd"
        }));
      },
      liveView: function liveView(_ref107) {
        var e = _ref107.className,
            _ref107$width = _ref107.width,
            t = _ref107$width === void 0 ? "40" : _ref107$width,
            _ref107$height = _ref107.height,
            a = _ref107$height === void 0 ? "40" : _ref107$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("circle", {
          cx: "20",
          cy: "20",
          r: "14",
          fill: "white"
        }), l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M32.7533 27.3707C33.42 27.6813 34.212 27.3893 34.524 26.7227C35.5027 24.6107 36 22.3493 36 20C36 11.1773 28.8227 4 20 4C11.1773 4 4 11.1773 4 20C4 28.8227 11.1773 36 20 36C22.372 36 24.6573 35.492 26.792 34.4907C27.4587 34.1773 27.7453 33.384 27.432 32.7173C27.12 32.0507 26.3307 31.7613 25.6587 32.0773C23.8827 32.9107 21.9773 33.3333 20 33.3333C12.648 33.3333 6.66667 27.352 6.66667 20C6.66667 12.648 12.648 6.66667 20 6.66667C27.352 6.66667 33.3333 12.648 33.3333 20C33.3333 21.9587 32.92 23.8427 32.104 25.6C31.7947 26.2667 32.0853 27.06 32.7533 27.3707ZM22.2733 27.6387C21.5373 27.8573 20.7733 27.968 20 27.968C15.632 27.968 12.0787 24.4147 12.0787 20.0467C12.0787 15.628 15.6507 12.032 20.0413 12.032C24.3867 12.032 27.9227 15.628 27.9227 20.0467C27.9227 20.7307 27.8347 21.4093 27.6627 22.0653C27.476 22.7773 27.9013 23.5067 28.6133 23.6947C29.3227 23.88 30.0547 23.456 30.2413 22.744C30.472 21.8667 30.5893 20.96 30.5893 20.0467C30.5893 14.1573 25.8573 9.36533 20.0413 9.36533C14.18 9.36533 9.412 14.1573 9.412 20.0467C9.412 25.8853 14.1613 30.6347 20 30.6347C21.032 30.6347 22.052 30.4867 23.0333 30.1933C23.74 29.9827 24.1413 29.2413 23.9307 28.5347C23.7213 27.8307 22.9827 27.4253 22.2733 27.6387ZM20 25.3307C17.0613 25.3307 14.6707 22.9387 14.6707 20C14.6707 17.0613 17.0613 14.6707 20 14.6707C22.9387 14.6707 25.3293 17.0613 25.3293 20C25.3293 20.9853 25.0427 21.8973 24.5747 22.6893L31.1893 29.3027H34.6253C35.3627 29.3027 35.9587 29.9 35.9587 30.636C35.9587 31.372 35.3627 31.9693 34.6253 31.9693H31.9707V34.6253C31.9707 35.3613 31.3733 35.9573 30.6373 35.9573C29.9 35.9573 29.304 35.3613 29.304 34.6253V31.188L22.6893 24.5747C21.8973 25.0427 20.9853 25.3307 20 25.3307ZM20 17.3373C21.4693 17.3373 22.6627 18.532 22.6627 20C22.6627 20.236 22.6227 20.4613 22.564 20.6787L22.272 20.3867C21.752 19.8653 20.908 19.8653 20.3867 20.3867C19.8653 20.9067 19.8653 21.752 20.3867 22.272L20.6787 22.564C20.4613 22.6227 20.236 22.6627 20 22.6627C18.5307 22.6627 17.3373 21.468 17.3373 20C17.3373 18.532 18.5307 17.3373 20 17.3373Z",
          fill: "#353F45"
        }));
      },
      overview: function overview(_ref108) {
        var e = _ref108.className,
            _ref108$width = _ref108.width,
            t = _ref108$width === void 0 ? "16" : _ref108$width,
            _ref108$height = _ref108.height,
            a = _ref108$height === void 0 ? "15" : _ref108$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 15"
        }, l.a.createElement("path", {
          d: "M15.334 8.182H6c-.368 0-.667-.305-.667-.682 0-.376.3-.682.667-.682h9.334c.367 0 .666.306.666.682 0 .377-.3.682-.666.682zm.006-5.5H5.962c-.368 0-.63-.26-.63-.636 0-.377.3-.683.668-.683h9.334c.367 0 .666.306.666.683 0 .376-.292.637-.66.637zM2 15c-1.102 0-2-.918-2-2.045 0-1.13.898-2.046 2-2.046 1.103 0 2 .916 2 2.045C4 14.082 3.103 15 2 15zm0-2.727c-.368 0-.666.305-.666.682 0 .376.298.68.666.68.368 0 .667-.304.667-.68 0-.377-.3-.682-.667-.682zm0-2.728c-1.102 0-2-.917-2-2.045s.898-2.046 2-2.046c1.103 0 2 .918 2 2.046 0 1.128-.897 2.045-2 2.045zm0-2.727c-.368 0-.666.306-.666.682 0 .376.298.682.666.682.368 0 .667-.306.667-.682 0-.376-.3-.682-.667-.682zm.398-3.686c-.11.15-.273.248-.455.272-.027.004-.055.005-.082.005-.153 0-.302-.055-.422-.156L.244 2.252c-.285-.24-.326-.67-.093-.96.236-.29.655-.333.94-.094l.65.546L2.798.277c.218-.302.636-.368.932-.144.295.223.36.65.14.953L2.398 3.132zM6 12.272h9.334c.367 0 .666.306.666.683 0 .376-.3.68-.666.68H6c-.368 0-.667-.304-.667-.68 0-.377.3-.682.667-.682z",
          fill: "#B5D2E1",
          fillRule: "evenodd"
        }));
      },
      sync: function sync(_ref109) {
        var e = _ref109.className,
            _ref109$width = _ref109.width,
            t = _ref109$width === void 0 ? "16" : _ref109$width,
            _ref109$height = _ref109.height,
            a = _ref109$height === void 0 ? "14" : _ref109$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 14"
        }, ">", l.a.createElement("defs", null), l.a.createElement("g", {
          id: "admin",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "salesforce-sync",
          fill: "#394F5A"
        }, l.a.createElement("path", {
          d: "M12.064,11.961 C11.788,11.9885 11.54,11.801 11.506,11.5265 C11.4715,11.253 11.666,11.003 11.9395,10.969 C13.6845,10.75 15,9.259 15,7.5 C15,5.5705 13.43,4 11.5,4 C11.434,4 11.368,4.004 11.3025,4.011 C11.072,4.044 10.851,3.9005 10.773,3.6805 C10.211,2.077 8.695,1 7,1 C4.7945,1 3,2.7945 3,5 C3,5.184 3.016,5.372 3.049,5.5745 C3.089,5.8175 2.946,6.053 2.7125,6.13 C1.688,6.468 1,7.42 1,8.5 C1,9.8785 2.1215,11 3.5,11 L4.002,11 C4.278,11 4.502,11.2235 4.502,11.5 C4.502,11.7765 4.278,12 4.002,12 L3.5,12 C1.57,12 0,10.4295 0,8.5 C0,7.128 0.794,5.9025 2.013,5.3335 C2.0045,5.2215 2,5.1105 2,5 C2,2.243 4.243,0 7,0 C8.9935,0 10.7895,1.1915 11.58,3.0005 C14.0245,3.0435 16,5.0455 16,7.5 C16,9.762 14.308,11.68 12.064,11.961 Z M5.85358232,11.1465 L7.000025,12.293 L7.000025,7.5 C7.000025,7.2235 7.2240138,7 7.5,7 C7.7759862,7 7.999975,7.2235 7.999975,7.5 L7.999975,12.293 L9.14641768,11.1465 C9.3419079,10.951 9.65789211,10.951 9.85338233,11.1465 C10.0488726,11.342 10.0488726,11.658 9.85338233,11.8535 L7.85348233,13.8535 C7.8519824,13.855 7.8499825,13.8555 7.84848258,13.857 C7.80348483,13.901 7.75048748,13.937 7.69099045,13.9615 C7.6299935,13.9865 7.56499675,14 7.5,14 C7.43500325,14 7.3700065,13.9865 7.30900955,13.9615 C7.24901255,13.9365 7.19501525,13.9005 7.14951752,13.8555 C7.14851757,13.8545 7.14751762,13.8545 7.14651767,13.8535 L5.14661767,11.8535 C4.95112744,11.658 4.95112744,11.342 5.14661767,11.1465 C5.34210789,10.951 5.6580921,10.951 5.85358232,11.1465 Z",
          id: "Shape"
        }))));
      },
      "notification-active": function notificationActive(_ref110) {
        var e = _ref110.className,
            _ref110$width = _ref110.width,
            t = _ref110$width === void 0 ? "16" : _ref110$width,
            _ref110$height = _ref110.height,
            a = _ref110$height === void 0 ? "16" : _ref110$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 16"
        }, l.a.createElement("g", {
          id: "flow",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "admin-copy-2",
          transform: "translate(-983.000000, -638.000000)",
          fill: "#0075FF"
        }, l.a.createElement("g", {
          id: "Group-Copy-4",
          transform: "translate(782.000000, 618.000000)"
        }, l.a.createElement("g", {
          id: "notification-copy-7",
          transform: "translate(201.000000, 20.000000)"
        }, l.a.createElement("path", {
          d: "M12.3160361,11.23675 C12.1472125,11.50975 11.8430949,11.6666667 11.4830949,11.6666667 L8.94015373,11.6666667 C8.94015373,12.9529167 7.8913302,14 6.60250667,14 C5.31368314,14 4.26544784,12.9529167 4.26544784,11.6666667 L1.72368314,11.6666667 C1.36368314,11.6666667 1.05956549,11.50975 0.890741961,11.23675 C0.721918432,10.96375 0.717212549,10.6219167 0.877800785,10.3005 L2.51368314,7.42875 L2.51368314,4.08333333 C2.51368314,1.83166667 4.34780078,0 6.60250667,0 C8.85780078,0 10.6930949,1.83166667 10.6930949,4.08333333 L10.6930949,7.42875 L12.3142714,10.2730833 C12.4895655,10.6219167 12.4854478,10.96375 12.3160361,11.23675 Z M6.60250667,12.8333333 C7.24721255,12.8333333 7.77191843,12.3100833 7.77191843,11.6666667 L5.43368314,11.6666667 C5.43368314,12.3100833 5.95780078,12.8333333 6.60250667,12.8333333 Z M9.6013302,7.8715 C9.51780078,7.72566667 9.50780078,7.56 9.55427137,7.41125 L9.55427137,4.22975 C9.5413302,4.18191667 9.52485961,4.13525 9.52485961,4.08333333 C9.52485961,2.47508333 8.21368314,1.16666667 6.60250667,1.16666667 C4.99250667,1.16666667 3.68250667,2.47508333 3.68250667,4.08333333 L3.68250667,7.58333333 C3.68250667,7.595 3.67603608,7.60433333 3.67544784,7.616 C3.67368314,7.65508333 3.66250667,7.69125 3.65250667,7.72975 C3.64250667,7.76825 3.63368314,7.80558333 3.61603608,7.84 C3.6113302,7.8505 3.6113302,7.86158333 3.60603608,7.8715 L2.10780078,10.5 L11.0995655,10.5 L9.6013302,7.8715 Z",
          id: "Shape"
        }))))));
      },
      "notification-snooze": function notificationSnooze(_ref111) {
        var e = _ref111.className,
            _ref111$width = _ref111.width,
            t = _ref111$width === void 0 ? "16" : _ref111$width,
            _ref111$height = _ref111.height,
            a = _ref111$height === void 0 ? "16" : _ref111$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 16"
        }, l.a.createElement("g", {
          id: "flow",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "admin-copy-2",
          transform: "translate(-1396.000000, -637.000000)",
          fill: "#0075FF"
        }, l.a.createElement("g", {
          id: "notificatio-off-copy-3",
          transform: "translate(1396.000000, 637.000000)"
        }, l.a.createElement("path", {
          d: "M15.696,1.7216 L1.72096,15.74848 C1.59744,15.87264 1.43488,15.93536 1.27232,15.93536 C1.10976,15.93536 0.9472,15.87264 0.82304,15.74848 C0.57472,15.49952 0.57472,15.09568 0.82304,14.84672 L2.41088,13.25312 C2.2624,13.17312 2.1376,13.05984 2.04864,12.9152 C1.86432,12.61632 1.8592,12.24384 2.03456,11.89184 L3.81312,8.75328 L3.81312,5.09568 C3.81312,2.63488 5.80736,0.63296 8.25856,0.63296 C10.04224,0.63296 11.62752,1.70176 12.32768,3.2992 L14.79808,0.81984 C15.04576,0.57024 15.44832,0.57024 15.696,0.81984 C15.94432,1.0688 15.94432,1.472 15.696,1.7216 Z M11.3312,4.28224 L11.3312,4.2816 C10.96512,2.88448 9.70112,1.90848 8.25856,1.90848 C6.50752,1.90848 5.08352,3.33824 5.08352,5.09568 L5.08352,8.9216 C5.08352,8.9344 5.07712,8.94528 5.07648,8.95744 C5.07392,8.99968 5.0624,9.04 5.05152,9.0816 C5.04,9.12384 5.0304,9.16416 5.01184,9.20256 C5.00608,9.21344 5.00672,9.22624 5.00032,9.23712 L3.3568,12.13568 C3.39776,12.14784 3.43296,12.17024 3.47008,12.19008 L11.3344,4.29632 C11.33312,4.2912 11.33248,4.28672 11.3312,4.28224 Z M6.50496,12.33408 C6.62592,12.19136 6.80256,12.10944 6.9888,12.10944 L13.14816,12.10944 L11.51872,9.23712 C11.51296,9.22624 11.51296,9.21344 11.50784,9.20256 C11.48864,9.16416 11.47904,9.12384 11.46816,9.0816 C11.45728,9.04 11.44512,8.99968 11.4432,8.95744 C11.44192,8.94528 11.43552,8.9344 11.43552,8.9216 L11.43552,7.64608 C11.43552,7.29472 11.72032,7.00864 12.07104,7.00864 C12.42176,7.00864 12.70592,7.29472 12.70592,7.64608 L12.70592,8.75328 L14.46848,11.86176 C14.65984,12.24384 14.65472,12.61632 14.4704,12.9152 C14.28736,13.21344 13.95712,13.38496 13.56544,13.38496 L10.80064,13.38496 C10.80064,14.79104 9.66016,15.93536 8.25856,15.93536 C6.912,15.93536 5.7984,14.87936 5.7216,13.53088 C5.712,13.36768 5.7664,13.2064 5.872,13.0816 L6.50496,12.33408 Z M8.25856,14.65984 C8.96,14.65984 9.53024,14.08768 9.53024,13.38496 L7.28256,13.38496 L7.02464,13.69024 C7.16096,14.24896 7.66464,14.65984 8.25856,14.65984 Z",
          id: "Shape"
        })))));
      },
      info: function info(_ref112) {
        var e = _ref112.className,
            _ref112$width = _ref112.width,
            t = _ref112$width === void 0 ? "22" : _ref112$width,
            _ref112$height = _ref112.height,
            a = _ref112$height === void 0 ? "22" : _ref112$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 22 22"
        }, l.a.createElement("g", {
          fill: "#CCC",
          fillRule: "evenodd"
        }, l.a.createElement("path", {
          d: "M10.92 21.065c-5.597 0-10.15-4.553-10.15-10.15S5.322.765 10.92.765s10.15 4.553 10.15 10.15-4.553 10.15-10.15 10.15zm0-19c-4.88 0-8.85 3.97-8.85 8.85 0 4.88 3.97 8.85 8.85 8.85 4.88 0 8.85-3.97 8.85-8.85 0-4.88-3.97-8.85-8.85-8.85z"
        }), l.a.createElement("path", {
          d: "M12.497 15.205a1.884 1.884 0 0 1-.19.218c-.1.102-.277.226-.532.373-.254.146-.517.23-.786.254-.69.058-1.19-.226-1.498-.854-.274-.59-.293-1.283-.058-2.082l.387-1.617c.137-.468.12-.768-.05-.9-.037-.037-.106-.052-.21-.043a1.01 1.01 0 0 0-.228.05c-.08.028-.15.055-.203.08l-.07.037c-.114.063-.215.025-.302-.113a.34.34 0 0 1 .007-.406c.035-.054.1-.13.19-.225.092-.096.265-.22.52-.372a1.84 1.84 0 0 1 .785-.26c.705-.06 1.208.223 1.51.85.273.59.292 1.284.057 2.083l-.387 1.617c-.135.48-.117.784.054.914.026.03.095.04.206.03.07-.007.147-.024.23-.05.08-.03.148-.055.202-.08l.068-.038c.115-.062.216-.022.304.12.088.144.086.282-.007.415M11.67 8.722a1.475 1.475 0 1 1 0-2.95 1.475 1.475 0 0 1 0 2.95"
        })));
      },
      "check-circle": function checkCircle(_ref113) {
        var e = _ref113.className,
            _ref113$width = _ref113.width,
            t = _ref113$width === void 0 ? "32" : _ref113$width,
            _ref113$height = _ref113.height,
            a = _ref113$height === void 0 ? "32" : _ref113$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 32 32"
        }, l.a.createElement("path", {
          d: "M16 31.999c-8.822 0-16-7.177-16-15.999s7.178-16 16-16 16 7.177 16 16c0 8.822-7.178 15.999-16 15.999zM16 1.333c-8.087 0-14.667 6.579-14.667 14.667s6.579 14.666 14.667 14.666 14.667-6.579 14.667-14.666c0-8.088-6.579-14.667-14.667-14.667zM14.574 21.787c-0.123 0.133-0.293 0.209-0.473 0.213-0.005 0-0.010 0-0.015 0-0.175 0-0.343-0.069-0.468-0.192l-6.086-6.001c-0.262-0.258-0.265-0.68-0.007-0.943s0.681-0.265 0.943-0.006l5.597 5.518 9.447-10.164c0.25-0.271 0.673-0.285 0.942-0.035s0.285 0.673 0.034 0.943l-9.914 10.666z"
        }));
      },
      slack: function slack(_ref114) {
        var e = _ref114.className,
            _ref114$width = _ref114.width,
            t = _ref114$width === void 0 ? "22" : _ref114$width,
            _ref114$height = _ref114.height,
            a = _ref114$height === void 0 ? "22" : _ref114$height;
        return l.a.createElement("svg", {
          className: "slack-icon ".concat(e),
          width: t,
          height: a,
          viewBox: "0 0 22 22"
        }, l.a.createElement("rect", {
          id: "Rectangle-path",
          x: "9.52",
          y: "9.48",
          width: "3.07",
          height: "2.97",
          transform: "translate(-3.04 4.05) rotate(-18.52)",
          fill: "rgb(181,210,225)"
        }), l.a.createElement("path", {
          id: "Shape",
          d: "M21.06,7.94C18.8.44,15.56-1.31,8,.94S-1.2,6.44,1,14s5.5,9.25,13,7S23.31,15.45,21.06,7.94Zm-3.79,4.87-1.41.47.49,1.47a1.13,1.13,0,0,1-.72,1.43,1,1,0,0,1-.38.05,1.17,1.17,0,0,1-1-.77L13.71,14l-2.92,1,.49,1.47a1.13,1.13,0,0,1-.72,1.43,1,1,0,0,1-.38.05,1.17,1.17,0,0,1-1-.77L8.64,15.7l-1.41.47a1,1,0,0,1-.38.05,1.17,1.17,0,0,1-1-.77A1.13,1.13,0,0,1,6.51,14l1.41-.47L7,10.74l-1.41.47a1,1,0,0,1-.38.05,1.17,1.17,0,0,1-1-.77,1.13,1.13,0,0,1,.72-1.43l1.41-.47L5.78,7.12a1.13,1.13,0,1,1,2.15-.72l.49,1.47,2.92-1-.49-1.47A1.13,1.13,0,1,1,13,4.71l.49,1.47,1.41-.47a1.13,1.13,0,1,1,.72,2.15l-1.41.47.94,2.81,1.41-.47a1.13,1.13,0,1,1,.72,2.15Z",
          transform: "translate(-0.13 -0.03)",
          fill: "rgb(181,210,225)"
        }));
      },
      "clone-1": function clone1(_ref115) {
        var e = _ref115.className,
            _ref115$width = _ref115.width,
            t = _ref115$width === void 0 ? "20" : _ref115$width,
            _ref115$height = _ref115.height,
            a = _ref115$height === void 0 ? "20" : _ref115$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 30 30"
        }, l.a.createElement("path", {
          d: "M24.4,4H11.7c-1.5,0-2.6,1.2-2.6,2.6v2.4H6.6C5.2,9.1,4,10.2,4,11.7v12.7C4,25.8,5.2,27,6.6,27 h12.7c1.5,0,2.6-1.2,2.6-2.6v-2.4h2.4c1.5,0,2.6-1.2,2.6-2.6V6.6C27,5.2,25.8,4,24.4,4z M20.4,24.3c0,0.6-0.5,1.1-1.1,1.1H6.7 c-0.6,0-1.1-0.5-1.1-1.1V11.7c0-0.6,0.5-1.1,1.1-1.1h12.7c0.6,0,1.1,0.5,1.1,1.1L20.4,24.3L20.4,24.3z M25.5,19.3 c0,0.6-0.5,1.1-1.1,1.1h-2.4v-8.8c0-1.5-1.2-2.6-2.6-2.6h-8.8V6.6c0-0.6,0.5-1.1,1.1-1.1h12.7c0.6,0,1.1,0.5,1.1,1.1V19.3z"
        }));
      },
      lightbulb: function lightbulb(_ref116) {
        var e = _ref116.className,
            _ref116$height = _ref116.height,
            t = _ref116$height === void 0 ? "24" : _ref116$height,
            _ref116$width = _ref116.width,
            a = _ref116$width === void 0 ? "24" : _ref116$width;
        return l.a.createElement("svg", {
          className: e,
          width: a,
          height: t,
          viewBox: "0 0 24 24"
        }, l.a.createElement("g", {
          id: "Group"
        }, l.a.createElement("path", {
          className: "st0",
          d: "M12,6.2c-1.1,0-2.1,0.5-2.8,1.2C8.9,7.9,8.6,8.3,8.4,8.8C8.3,9.2,8.2,9.6,8.2,10c0,0.8,0.2,1.5,0.7,2.1 c0.3,0.5,0.7,0.8,1.2,1.1l0.2,1.7h3.3l0.2-1.7c0.5-0.3,0.9-0.7,1.2-1.1c0.4-0.6,0.7-1.3,0.7-2.1c0-0.4-0.1-0.8-0.2-1.2 c-0.2-0.5-0.4-0.9-0.8-1.3C14.1,6.7,13.1,6.2,12,6.2z M12,12c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S13.1,12,12,12z"
        }), l.a.createElement("path", {
          className: "st0",
          d: "M10.8,17.5h0.6c0,0.3,0.3,0.6,0.6,0.6s0.6-0.3,0.6-0.6h0.6v-1.2h-2.5V17.5z"
        }), l.a.createElement("path", {
          className: "st0",
          d: "M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M14.8,14.1l-0.3,2.1v1.5c0,0.6-0.4,1-1,1h-0.4 c-0.2,0.4-0.6,0.6-1.1,0.6s-0.9-0.3-1.1-0.6h-0.4c-0.6,0-1-0.4-1-1v-1.5l-0.3-2.1C7.9,13.2,7,11.7,7,10c0-2.8,2.2-5,5-5s5,2.2,5,5 C17,11.7,16.1,13.2,14.8,14.1z"
        })));
      },
      briefcase: function briefcase(_ref117) {
        var e = _ref117.className,
            _ref117$width = _ref117.width,
            t = _ref117$width === void 0 ? "11" : _ref117$width,
            _ref117$height = _ref117.height,
            a = _ref117$height === void 0 ? "10" : _ref117$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 11 10",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("path", {
          d: "M9.927 9.356H1.593c-.46 0-.833-.351-.833-.783v-5.87c0-.43.374-.782.833-.782h2.084V1.53c0-.647.56-1.174 1.25-1.174h1.666c.69 0 1.25.527 1.25 1.174v.391h2.084c.459 0 .833.351.833.783v5.87c0 .431-.374.782-.833.782zm-8.334-.783h8.332l.001-3.13H7.01c0 .647-.56 1.174-1.25 1.174-.33 0-.643-.123-.881-.344a1.131 1.131 0 0 1-.369-.83H1.593v3.13zm3.75-3.13c0 .102.044.2.124.275a.435.435 0 0 0 .293.116c.23 0 .417-.175.417-.391V4.66c0-.102-.045-.2-.124-.275a.437.437 0 0 0-.293-.116c-.23 0-.417.176-.417.391v.783zM7.01 1.53c0-.216-.187-.391-.417-.391H4.927c-.23 0-.417.175-.417.39v.392h2.5V1.53zM1.593 2.704V4.66H4.51c0-.647.56-1.174 1.25-1.174.33 0 .643.123.881.345.239.224.369.518.369.83h2.916V2.703H1.594z",
          fill: "#000",
          fillRule: "evenodd"
        }));
      },
      ban: function ban(_ref118) {
        var e = _ref118.className,
            _ref118$width = _ref118.width,
            t = _ref118$width === void 0 ? "24" : _ref118$width,
            _ref118$height = _ref118.height,
            a = _ref118$height === void 0 ? "24" : _ref118$height;
        return l.a.createElement("svg", {
          width: t,
          height: a,
          viewBox: "0 0 14 14",
          className: e
        }, l.a.createElement("g", {
          id: "Layer_1"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#394F5A",
          d: "M7,1.167c-1.398,0-2.683,0.495-3.689,1.318l8.203,8.204\r c0.824-1.007,1.32-2.291,1.32-3.689C12.834,3.783,10.217,1.167,7,1.167z M1.166,7c0,3.217,2.617,5.833,5.834,5.833\r c1.398,0,2.684-0.495,3.689-1.319L2.486,3.311C1.662,4.316,1.166,5.602,1.166,7z M7,14c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7\r S10.859,14,7,14z"
        })));
      },
      pencil: function pencil(_ref119) {
        var e = _ref119.className,
            _ref119$width = _ref119.width,
            t = _ref119$width === void 0 ? "24" : _ref119$width,
            _ref119$height = _ref119.height,
            a = _ref119$height === void 0 ? "24" : _ref119$height;
        return l.a.createElement("svg", {
          width: t,
          height: a,
          className: e,
          viewBox: "0 0 47.986 47.985"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.558,47.293c1.088,1.091,2.839,0.565,2.839,0.565l14.162-4.746 c0.354-0.121,0.676-0.318,0.938-0.583l23.966-24.006l0.003-0.003l0.004-0.003l2.45-2.46c1.841-1.837,2.892-3.936,3.046-6.062 c0.127-1.713-0.281-4.311-2.932-6.962c-2.675-2.685-5.275-3.13-7-3.016c-2.152,0.127-4.261,1.168-6.102,3.016h-0.007L5.502,29.509 c-0.265,0.265-0.462,0.589-0.583,0.94L0.046,45.117C0.046,45.117-0.229,46.503,0.558,47.293z M35.32,6.439 c0-0.003,0-0.003,0.007-0.007c0.689-0.696,1.78-1.546,2.999-1.62c1.07-0.061,2.179,0.482,3.313,1.62 c1.091,1.098,1.613,2.176,1.54,3.21c-0.087,1.215-0.948,2.306-1.654,3.009v0.006l-0.756,0.76l-6.206-6.219L35.32,6.439z M9.298,32.511L31.168,10.6l6.206,6.219L15.503,38.73l-9.312,3.106L9.298,32.511z"
        }));
      },
      bot: function bot(_ref120) {
        var e = _ref120.className,
            _ref120$width = _ref120.width,
            t = _ref120$width === void 0 ? "18" : _ref120$width,
            _ref120$height = _ref120.height,
            a = _ref120$height === void 0 ? "16" : _ref120$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 18 16"
        }, l.a.createElement("g", {
          id: "Layer_3",
          "data-name": "Layer 3"
        }, l.a.createElement("g", {
          id: "mask-2"
        }, l.a.createElement("path", {
          id: "path-1",
          d: "M18,12a.57.57,0,0,1-.57-.58V7.92a.57.57,0,1,1,1.13,0V11.4A.57.57,0,0,1,18,12Zm-2.78,4.63H3.78a1.67,1.67,0,0,1-1.65-1.68V5.55A1.67,1.67,0,0,1,3.78,3.87H5V2.71a.57.57,0,0,1,0-.15,1.13,1.13,0,1,1,1.08,0,.57.57,0,0,1,0,.15V3.87h6.8V2.71a.57.57,0,0,1,0-.15,1.13,1.13,0,1,1,1.08,0,.57.57,0,0,1,0,.15V3.87h1.18a1.67,1.67,0,0,1,1.65,1.68v9.37A1.67,1.67,0,0,1,15.22,16.61Zm.52-11.06A.52.52,0,0,0,15.22,5H3.78a.52.52,0,0,0-.52.53v9.37a.52.52,0,0,0,.52.53H15.22a.52.52,0,0,0,.52-.53ZM5.54,12a.57.57,0,1,1,1.13,0h5.66a.57.57,0,1,1,1.13,0v1.16H5.54ZM12,10.24a1.45,1.45,0,1,1,1.42-1.45A1.43,1.43,0,0,1,12,10.24ZM12,8.5a.29.29,0,1,0,.28.29A.29.29,0,0,0,12,8.5ZM7,10.24A1.45,1.45,0,1,1,8.37,8.79,1.43,1.43,0,0,1,7,10.24ZM7,8.5a.29.29,0,1,0,.28.29A.29.29,0,0,0,7,8.5ZM1,12a.57.57,0,0,1-.57-.58V7.92A.57.57,0,0,1,1,7.34a.57.57,0,0,1,.57.58V11.4A.57.57,0,0,1,1,12Z",
          transform: "translate(-0.44 -0.39)",
          fill: "#fff"
        }))));
      },
      "bot-2": function Bot2Svg(_ref121) {
        var _ref121$className = _ref121.className,
            e = _ref121$className === void 0 ? "" : _ref121$className,
            _ref121$height = _ref121.height,
            t = _ref121$height === void 0 ? 22 : _ref121$height,
            _ref121$width = _ref121.width,
            a = _ref121$width === void 0 ? 22 : _ref121$width;
        return l.a.createElement("svg", {
          className: e,
          width: a,
          height: t,
          viewBox: "0 0 22 22",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.75 2C12.75 2.83934 12.233 3.55793 11.5 3.85462V7H13.75V8.25H18.75C20.2688 8.25 21.5 9.48122 21.5 11V19C21.5 20.5188 20.2688 21.75 18.75 21.75H2.75C1.23122 21.75 0 20.5188 0 19V11C0 9.48122 1.23122 8.25 2.75 8.25H7.75V7H10V3.85462C9.26704 3.55793 8.75 2.83934 8.75 2C8.75 0.89543 9.64543 0 10.75 0C11.8546 0 12.75 0.89543 12.75 2ZM1.5 11C1.5 10.3096 2.05964 9.75 2.75 9.75H18.75C19.4404 9.75 20 10.3096 20 11V19C20 19.6904 19.4404 20.25 18.75 20.25H2.75C2.05964 20.25 1.5 19.6904 1.5 19V11ZM7.75 14.5C7.75 15.3284 7.07843 16 6.25 16C5.42157 16 4.75 15.3284 4.75 14.5C4.75 13.6716 5.42157 13 6.25 13C7.07843 13 7.75 13.6716 7.75 14.5ZM15.25 16C16.0784 16 16.75 15.3284 16.75 14.5C16.75 13.6716 16.0784 13 15.25 13C14.4216 13 13.75 13.6716 13.75 14.5C13.75 15.3284 14.4216 16 15.25 16Z",
          fill: "white"
        }));
      },
      "pb-attribute": function pbAttribute(_ref122) {
        var e = _ref122.className,
            t = _ref122.width,
            a = _ref122.height;
        return l.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, l.a.createElement("g", null, l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#3A4F5A",
          d: "M45.443,16.937c-1.331,0-2.412-1.08-2.412-2.412c0-1.333,1.077-2.414,2.412-2.414\r c1.331,0,2.411,1.081,2.411,2.414C47.856,15.856,46.774,16.937,45.443,16.937z M45.443,8.56c-3.29,0-5.967,2.675-5.967,5.967\r c0,3.291,2.673,5.965,5.967,5.965c3.292,0,5.965-2.672,5.965-5.965C51.408,11.234,48.735,8.56,45.443,8.56z"
        })), l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#3A4F5A",
          d: "M38.763,25.514c-0.979,0-1.772,0.793-1.772,1.773v27.355c0,0.98,0.793,1.773,1.772,1.773\r c0.979,0,1.771-0.793,1.771-1.773V27.285C40.531,26.307,39.741,25.514,38.763,25.514z"
        })), l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#3A4F5A",
          d: "M52.113,25.514c-0.979,0-1.772,0.793-1.772,1.773v27.355c0,0.98,0.793,1.773,1.772,1.773\r c0.979,0,1.771-0.793,1.771-1.773V27.285C53.896,26.307,53.092,25.514,52.113,25.514z"
        })), l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#3A4F5A",
          d: "M60.866,59.074c0,0.979-0.794,1.769-1.774,1.769H31.793c-0.979,0-1.771-0.79-1.771-1.769V22.699\r c0-1.937,0.602-3.793,1.758-5.348l7.46-10.096c1.442-1.959,3.768-3.126,6.207-3.126s4.76,1.167,6.204,3.126l7.465,10.096\r c1.151,1.555,1.757,3.404,1.757,5.348v36.375H60.866z M26.48,34.872v11.619c-0.69,0.264-1.42,0.4-2.163,0.4\r c-3.426,0-6.203-2.791-6.203-6.206c0-3.431,2.789-6.204,6.203-6.204C25.061,34.472,25.791,34.605,26.48,34.872z M21.256,60.843\r v-3.04c0-0.79-0.526-1.494-1.294-1.705c-1.228-0.353-2.4-0.831-3.478-1.435c-0.691-0.39-1.556-0.264-2.123,0.289l-2.148,2.135\r l-4.318-4.318l2.136-2.147c0.565-0.566,0.677-1.435,0.288-2.124c-0.602-1.079-1.094-2.246-1.431-3.478\r c-0.213-0.768-0.917-1.294-1.706-1.294H4.153v-6.117h3.039c0.792,0,1.496-0.526,1.708-1.296c0.351-1.229,0.83-2.398,1.431-3.48\r c0.389-0.688,0.264-1.555-0.289-2.12l-2.135-2.136l4.32-4.318l2.147,2.136c0.565,0.567,1.431,0.676,2.122,0.286\r c1.081-0.602,2.248-1.092,3.479-1.431c0.768-0.214,1.295-0.915,1.295-1.707v-3.041l5.414-0.016\r c-0.123,0.72-0.199,1.46-0.199,2.199v8.464c-0.705-0.163-1.431-0.237-2.161-0.237c-5.375,0-9.76,4.371-9.76,9.747\r c0,5.375,4.372,9.76,9.76,9.76c0.729,0,1.458-0.089,2.161-0.241v8.879c0,0.631,0.116,1.231,0.315,1.798L21.256,60.843z\r M61.96,15.255L54.497,5.158c-2.11-2.864-5.498-4.571-9.058-4.571c-3.552,0-6.942,1.707-9.056,4.571l-7.461,10.097\r c-0.4,0.552-0.765,1.117-1.066,1.72h-8.378c-0.98,0-1.771,0.792-1.771,1.774v3.518c-0.602,0.213-1.192,0.452-1.758,0.729\r l-2.487-2.489c-0.69-0.689-1.809-0.689-2.513,0l-6.83,6.834c-0.692,0.752-0.692,1.82,0,2.511l2.487,2.486\r c-0.266,0.567-0.515,1.159-0.729,1.764h-3.52C1.392,34.073,0.6,34.878,0.6,35.858v9.658c0,0.982,0.792,1.772,1.773,1.772H5.89\r c0.212,0.601,0.45,1.193,0.727,1.757L4.13,51.533c-0.69,0.69-0.69,1.81,0,2.511l6.832,6.834c0.691,0.691,1.81,0.691,2.512,0\r l2.487-2.485c0.577,0.265,1.154,0.513,1.759,0.727v3.52c0,0.981,0.79,1.774,1.77,1.774h39.597c2.93,0,5.313-2.388,5.313-5.312\r V22.699C64.406,20,63.554,17.426,61.96,15.255z"
        }))));
      },
      "pb-branch": function pbBranch(_ref123) {
        var e = _ref123.className,
            t = _ref123.width,
            a = _ref123.height;
        return l.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M48.176,50.67c-1.683-0.005-3.199,1.012-3.843,2.566c-0.643,1.552-0.284,3.339,0.914,4.526\r c1.195,1.186,2.985,1.531,4.537,0.871c1.554-0.656,2.548-2.182,2.533-3.864C52.292,52.496,50.449,50.67,48.176,50.67z\r M36.64,10.228c0.017-1.677-0.983-3.198-2.529-3.853c-1.547-0.653-3.334-0.309-4.526,0.873c-1.193,1.183-1.554,2.967-0.912,4.513\r c0.637,1.553,2.149,2.564,3.825,2.564C34.769,14.323,36.618,12.495,36.64,10.228z M12.688,54.77c0,2.285,1.854,4.137,4.139,4.137\r c2.287,0,4.137-1.852,4.137-4.137s-1.854-4.136-4.137-4.136C14.544,50.63,12.688,52.484,12.688,54.77z M57.88,54.77\r c0.012,5.002-3.777,9.188-8.754,9.679c-4.975,0.489-9.508-2.88-10.475-7.781c-0.966-4.906,1.95-9.739,6.737-11.174V39.67\r l-12.888-9.782l-12.887,9.806v5.8c4.617,1.377,7.516,5.937,6.816,10.705c-0.696,4.771-4.783,8.304-9.604,8.304\r c-4.816,0-8.903-3.533-9.604-8.304c-0.698-4.762,2.208-9.32,6.82-10.705v-8.585l15.674-11.895v-5.504\r c-4.614-1.38-7.516-5.939-6.82-10.707c0.7-4.768,4.787-8.305,9.604-8.305c4.819,0,8.907,3.532,9.606,8.305\r c0.696,4.763-2.208,9.321-6.818,10.707v5.501l15.674,11.916v8.568C55.057,46.727,57.867,50.494,57.88,54.77z"
        })));
      },
      "pb-button": function pbButton(_ref124) {
        var e = _ref124.className,
            t = _ref124.width,
            a = _ref124.height;
        return l.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M61.612,29.395c0,1.459-1.184,2.647-2.648,2.647h-15.5L29.852,20.13v11.912H6.034\r c-1.462,0-2.65-1.188-2.65-2.647V10.867c0-1.457,1.188-2.646,2.65-2.646h52.93c1.465,0,2.648,1.189,2.648,2.646V29.395z\r M49.991,41.271l-6.131,3.104l4.275,9.327l-4.81,2.213l-4.174-9.108l-6.654,3.21v-24.05L49.991,41.271z M58.964,5.576H6.034\r c-2.913,0-5.296,2.38-5.296,5.293v18.53c0,2.909,2.382,5.296,5.296,5.296h23.818v19.612l7.997-3.999l4.172,9.115l9.627-4.408\r l-4.327-9.443l7.389-3.692l-8.222-7.188h12.479c2.909,0,5.296-2.38,5.296-5.292V10.871C64.259,7.956,61.875,5.576,58.964,5.576z"
        })));
      },
      "pb-calendar": function pbCalendar(_ref125) {
        var e = _ref125.className,
            t = _ref125.width,
            a = _ref125.height;
        return l.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M16.26,16.262c1.494,0,2.706-1.214,2.706-2.707V2.727c0-1.494-1.212-2.707-2.706-2.707\r s-2.706,1.213-2.706,2.707v10.828C13.554,15.051,14.766,16.262,16.26,16.262z M13.554,29.798h5.412\r c1.494,0,2.707-1.215,2.707-2.709c0-1.493-1.213-2.708-2.707-2.708h-5.412c-1.494,0-2.709,1.215-2.709,2.708\r C10.845,28.583,12.06,29.798,13.554,29.798z M35.203,46.034h-5.412c-1.493,0-2.706,1.215-2.706,2.709\r c0,1.499,1.213,2.703,2.706,2.703h5.412c1.495,0,2.709-1.209,2.709-2.703C37.912,47.244,36.703,46.034,35.203,46.034z\r M27.085,5.437h-5.412v5.413h5.414L27.085,5.437L27.085,5.437z M18.966,35.204h-5.417c-1.494,0-2.707,1.22-2.707,2.708\r c0,1.495,1.213,2.709,2.707,2.709h5.417c1.494,0,2.704-1.214,2.704-2.709C21.675,36.414,20.46,35.204,18.966,35.204z M59.568,5.437\r h-5.419v5.413h5.419v48.719H5.433V10.847h5.414v-5.41H5.433c-2.99,0-5.413,2.423-5.413,5.413v48.719\r c0,2.987,2.426,5.412,5.413,5.412h54.13c2.993,0,5.418-2.425,5.418-5.412V10.847C64.98,7.859,62.556,5.437,59.568,5.437z\r M18.966,46.034h-5.417c-1.494,0-2.707,1.215-2.707,2.709c0,1.499,1.213,2.703,2.707,2.703h5.417c1.494,0,2.704-1.209,2.704-2.703\r C21.675,47.244,20.46,46.034,18.966,46.034z M29.796,29.798h5.413c1.494,0,2.706-1.215,2.706-2.709\r c0-1.493-1.212-2.708-2.706-2.708h-5.413c-1.493,0-2.709,1.215-2.709,2.708C27.085,28.583,28.298,29.798,29.796,29.798z\r M46.034,29.798h5.412c1.494,0,2.708-1.215,2.708-2.709c0-1.493-1.214-2.708-2.708-2.708h-5.412c-1.494,0-2.706,1.215-2.706,2.708\r C43.328,28.583,44.54,29.798,46.034,29.798z M48.737,16.262c1.494,0,2.709-1.214,2.709-2.707V2.727\r c0-1.494-1.215-2.707-2.709-2.707s-2.708,1.213-2.708,2.707v10.828C46.034,15.051,47.243,16.262,48.737,16.262z M51.446,35.204\r h-5.417c-1.494,0-2.704,1.22-2.704,2.708c0,1.495,1.21,2.709,2.704,2.709h5.417c1.494,0,2.706-1.214,2.706-2.709\r C54.149,36.414,52.94,35.204,51.446,35.204z M51.446,46.034h-5.417c-1.494,0-2.704,1.215-2.704,2.709\r c0,1.499,1.21,2.703,2.704,2.703h5.417c1.494,0,2.706-1.209,2.706-2.703C54.149,47.244,52.94,46.034,51.446,46.034z M32.5,16.262\r c1.494,0,2.703-1.214,2.703-2.707V2.727c0-1.494-1.209-2.707-2.703-2.707s-2.704,1.213-2.704,2.707v10.828\r C29.796,15.051,31.006,16.262,32.5,16.262z M35.203,35.204h-5.412c-1.493,0-2.706,1.22-2.706,2.708\r c0,1.495,1.213,2.709,2.706,2.709h5.412c1.495,0,2.709-1.214,2.709-2.709C37.912,36.414,36.703,35.204,35.203,35.204z\r M43.325,5.437h-5.418v5.413h5.418V5.437z"
        })));
      },
      "pb-close": function pbClose(_ref126) {
        var e = _ref126.className,
            t = _ref126.width,
            a = _ref126.height;
        return l.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, l.a.createElement("g", null, l.a.createElement("polygon", {
          fill: "#394F5A",
          points: "64.268,10.581 54.415,0.732 32.497,22.651 10.581,0.732 0.732,10.578 22.651,32.497 0.732,54.418 \r 10.578,64.268 32.497,42.35 54.415,64.268 64.268,54.418 42.35,32.497   "
        })));
      },
      "pb-domain-exclusion": function pbDomainExclusion(_ref127) {
        var e = _ref127.className,
            t = _ref127.width,
            a = _ref127.height;
        return l.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, l.a.createElement("g", null, l.a.createElement("g", null, l.a.createElement("path", {
          fill: "none",
          d: "M46.371,27.723h6.958c-0.274-2.842-1.037-5.526-2.192-7.98h-5.849C45.864,22.261,46.233,24.939,46.371,27.723\r z"
        }), l.a.createElement("path", {
          fill: "none",
          d: "M48.163,14.956c-1.994-2.492-4.465-4.579-7.264-6.11c1.159,1.788,2.146,3.849,2.979,6.11H48.163z"
        }), l.a.createElement("path", {
          fill: "none",
          d: "M31.928,7.772v7.183h7.283C37.327,11.293,34.784,8.712,31.928,7.772z"
        }), l.a.createElement("path", {
          fill: "none",
          d: "M41.102,19.743h-9.174v7.98h10.535C42.295,24.855,41.818,22.173,41.102,19.743z"
        }), l.a.createElement("path", {
          fill: "none",
          d: "M18.112,8.846c-2.799,1.531-5.269,3.618-7.261,6.11h4.285C15.966,12.695,16.954,10.634,18.112,8.846z"
        }), l.a.createElement("path", {
          fill: "none",
          d: "M19.801,14.956h7.285V7.772C24.23,8.712,21.687,11.293,19.801,14.956z"
        }), l.a.createElement("path", {
          fill: "none",
          d: "M16.549,27.723h10.537v-7.98H17.91C17.196,22.173,16.719,24.855,16.549,27.723z"
        }), l.a.createElement("path", {
          fill: "none",
          d: "M17.91,40.492h9.176v-7.98H16.549C16.719,35.381,17.196,38.063,17.91,40.492z"
        }), l.a.createElement("path", {
          fill: "none",
          d: "M12.642,32.512H5.684c0.275,2.844,1.037,5.526,2.193,7.98h5.849C13.152,37.981,12.778,35.287,12.642,32.512z"
        }), l.a.createElement("path", {
          fill: "none",
          d: "M10.852,45.28c1.995,2.498,4.456,4.577,7.261,6.11c-1.158-1.788-2.146-3.849-2.976-6.11H10.852z"
        }), l.a.createElement("path", {
          fill: "none",
          d: "M27.086,52.462V45.28h-7.285C21.687,48.942,24.23,51.524,27.086,52.462z"
        }), l.a.createElement("path", {
          fill: "none",
          d: "M13.726,19.743H7.877c-1.156,2.454-1.918,5.138-2.193,7.98h6.958C12.778,24.939,13.149,22.261,13.726,19.743z\r "
        }), l.a.createElement("path", {
          fill: "#394F5A",
          d: "M35.039,50.704c0-0.002,0-0.004,0-0.008c-0.979,0.807-2.021,1.407-3.111,1.766V45.28h4.038\r c0.606-1.748,1.491-3.36,2.608-4.788h-6.646v-7.98h10.535c-0.099,1.676-0.312,3.279-0.606,4.813\r c1.293-0.945,2.73-1.704,4.278-2.246c0.088-0.852,0.194-1.696,0.236-2.567h6.958c-0.057,0.574-0.145,1.136-0.24,1.694\r c1.743,0.151,3.401,0.561,4.945,1.203c0.324-1.72,0.515-3.485,0.515-5.292c0-15.703-12.856-28.729-29.042-28.729\r c-16.187,0-29.042,13.025-29.042,28.729S13.32,58.847,29.507,58.847c2.493,0,4.893-0.344,7.195-0.923\r c-0.122-0.25-0.271-0.48-0.378-0.738C35.485,55.217,35.039,53.013,35.039,50.704z M51.137,19.743\r c1.155,2.454,1.918,5.138,2.192,7.98h-6.958c-0.138-2.783-0.507-5.462-1.083-7.98H51.137z M48.163,14.956h-4.285\r c-0.832-2.261-1.819-4.322-2.979-6.11C43.698,10.376,46.169,12.464,48.163,14.956z M31.928,7.772\r c2.856,0.94,5.399,3.521,7.283,7.183h-7.283V7.772z M31.928,19.743h9.174c0.717,2.431,1.193,5.113,1.361,7.98H31.928V19.743z\r M18.112,8.846c-1.158,1.788-2.146,3.849-2.976,6.11h-4.285C12.844,12.464,15.313,10.376,18.112,8.846z M7.877,19.743h5.849\r c-0.576,2.518-0.947,5.197-1.084,7.98H5.684C5.959,24.88,6.721,22.196,7.877,19.743z M7.877,40.492\r c-1.156-2.454-1.918-5.137-2.193-7.98h6.958c0.137,2.775,0.511,5.47,1.084,7.98H7.877z M10.852,45.28h4.285\r c0.829,2.262,1.817,4.322,2.976,6.11C15.308,49.857,12.847,47.778,10.852,45.28z M27.086,52.462\r c-2.855-0.938-5.399-3.52-7.285-7.182h7.285V52.462z M27.086,40.492H17.91c-0.714-2.429-1.191-5.111-1.361-7.98h10.537V40.492z\r M27.086,27.723H16.549c0.17-2.867,0.647-5.549,1.361-7.98h9.176V27.723z M27.086,14.956h-7.285\r c1.886-3.662,4.43-6.243,7.285-7.183V14.956z"
        })), l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M63.518,45.67c-1.271-2.984-3.596-5.323-6.44-6.651c-0.435-0.202-0.885-0.372-1.342-0.524\r c-0.248-0.082-0.5-0.152-0.751-0.22c-0.218-0.059-0.442-0.108-0.664-0.154c-0.857-0.183-1.734-0.314-2.634-0.318\r c-2.807-0.01-5.388,0.877-7.508,2.374c-0.11,0.078-0.217,0.163-0.328,0.245c-0.324,0.244-0.633,0.502-0.93,0.774\r c-0.096,0.084-0.191,0.164-0.278,0.252c-0.366,0.354-0.713,0.726-1.037,1.122c-0.054,0.069-0.104,0.142-0.16,0.212\r c-0.26,0.336-0.508,0.687-0.736,1.047c-0.08,0.128-0.156,0.255-0.232,0.385c-0.214,0.366-0.412,0.742-0.587,1.129\r c-0.042,0.088-0.088,0.17-0.126,0.259c-0.206,0.471-0.378,0.957-0.526,1.455c-0.034,0.126-0.064,0.255-0.099,0.383\r c-0.104,0.393-0.188,0.791-0.252,1.197c-0.023,0.15-0.05,0.302-0.068,0.452c-0.069,0.531-0.115,1.067-0.115,1.616\r c0,1.8,0.37,3.491,1.022,5.037c1.986,4.722,6.646,7.856,11.827,7.869c5.25,0.026,9.933-3.096,11.965-7.869\r c0.651-1.546,1.018-3.239,1.018-5.037C64.535,48.948,64.169,47.229,63.518,45.67z M61.035,51.917\r c-0.336,0.28-0.797,0.467-1.312,0.467c-6.783,0-7.442,0-8.106,0c-0.633,0-1.296,0-8.091,0c-0.499,0-0.979-0.187-1.322-0.467\r c-0.316-0.334-0.526-0.732-0.526-1.203c0-0.448,0.21-0.858,0.526-1.165c0.343-0.295,0.819-0.482,1.322-0.482\r c6.799,0,7.458,0,8.091,0c0.664,0,1.323,0,8.106,0c0.519,0,0.976,0.188,1.312,0.482c0.343,0.307,0.553,0.719,0.553,1.165\r C61.588,51.185,61.374,51.587,61.035,51.917z"
        }))));
      },
      "pb-email": function pbEmail(_ref128) {
        var e = _ref128.className,
            t = _ref128.width,
            a = _ref128.height;
        return l.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M36.746,0.753C26.257-0.585,16.164,3.036,9.031,10.72c-7.13,7.684-10.002,18.089-7.856,28.531\r c2.488,12.104,11.845,21.682,23.851,24.41c2.51,0.58,5.021,0.858,7.504,0.858c4.917,0,9.713-1.115,14.17-3.308\r c1.586-0.788,2.233-2.712,1.455-4.292c-0.783-1.597-2.726-2.236-4.292-1.455c-5.359,2.652-11.393,3.332-17.413,1.959\r C17.037,55.28,9.407,47.462,7.452,37.971c-1.729-8.396,0.557-16.745,6.275-22.898c5.704-6.148,13.781-9.051,22.195-7.966\r c12.652,1.635,22.196,13.122,22.196,26.728v1.863c0,3.534-2.871,6.402-6.407,6.402c-3.531,0-6.401-2.868-6.401-6.402V22.892\r c0-1.768-1.434-3.203-3.201-3.203c-1.31,0-2.43,0.795-2.93,1.925c-1.906-1.21-4.146-1.928-6.681-1.928\r c-7.541,0-12.806,5.927-12.806,14.409c0,8.488,5.262,14.409,12.806,14.409c3.98,0,7.292-1.678,9.567-4.48\r c2.348,2.721,5.776,4.48,9.646,4.48c7.069,0,12.81-5.741,12.81-12.803v-1.865C64.521,17.02,52.582,2.798,36.746,0.753z\r M32.498,42.104c-3.95,0-6.404-3.066-6.404-8.003c0-4.942,2.455-8.01,6.404-8.01c3.952,0,6.405,3.067,6.405,8.01\r C38.902,39.037,36.449,42.104,32.498,42.104z"
        }));
      },
      "pb-filter": function pbFilter(_ref129) {
        var e = _ref129.className,
            _ref129$width = _ref129.width,
            t = _ref129$width === void 0 ? "16" : _ref129$width,
            _ref129$height = _ref129.height,
            a = _ref129$height === void 0 ? "14" : _ref129$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 16"
        }, l.a.createElement("path", {
          d: "M1 4, L15 4",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), l.a.createElement("path", {
          d: "M3 8, L13 8",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), l.a.createElement("path", {
          d: "M5 12, L11 12",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }));
      },
      "pb-greeting": function pbGreeting(_ref130) {
        var e = _ref130.className,
            t = _ref130.width,
            a = _ref130.height;
        return l.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, l.a.createElement("g", null, l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M46.433,39.434L31.282,54.705l-1.157,1.159c-2.981,2.989-6.955,4.563-10.93,4.563\r c-3.972,0-7.947-1.495-10.926-4.563C4.042,51.63,2.638,45.492,4.541,39.846l7.698-18.59c0.251-0.58,0.665-0.995,1.159-1.16\r c0.251-0.083,0.581-0.166,0.83-0.166c0.248,0,0.578,0.083,0.829,0.166c0.248,0.082,0.497,0.249,0.744,0.496\r c0.663,0.664,0.829,1.578,0.497,2.407c0,0-3.974,9.876-4.389,10.868c-0.248,0.664,0,1.245,0.496,1.245\r c0.25,0,0.499-0.166,0.829-0.498c0.995-0.993,4.553-4.561,4.553-4.561l2.814-2.821l11.507-11.536\r c0.416-0.415,0.993-0.664,1.573-0.664c0.578,0,1.159,0.249,1.574,0.664c0.827,0.83,0.827,2.24,0,3.152L21.76,32.38l-0.495,0.495\r c-0.58,0.58-0.58,1.576,0,2.158c0.332,0.332,0.663,0.415,1.076,0.415c0.248,0,0.578-0.083,0.829-0.253\r c0.083-0.083,0.167-0.166,0.248-0.249l16.475-16.349c0.413-0.415,0.996-0.665,1.574-0.665c0.494,0,0.994,0.167,1.409,0.498\r c0.41,0.333,0.576,0.748,0.744,1.079c0.249,0.745,0,1.577-0.578,2.157L26.568,38.182c-0.334,0.332-0.499,0.83-0.416,1.245\r c0,0.332,0.168,0.664,0.416,0.913c0.33,0.332,0.659,0.415,1.074,0.415c0.083,0,0.083,0,0.166,0c0.332,0,0.661-0.169,0.995-0.415\r l13.909-13.941c0.412-0.414,0.995-0.664,1.574-0.664c0.578,0,1.159,0.25,1.572,0.664c0.829,0.83,0.829,2.242,0,3.153\r L32.614,42.745l-0.497,0.498l-2.152,2.158c-0.58,0.578-0.58,1.578,0,2.159c0.333,0.332,0.663,0.412,1.074,0.412\r c0.413,0,0.827-0.166,1.074-0.412l0,0l10.594-10.625l0.661-0.664c0.414-0.412,0.996-0.661,1.576-0.661\r c0.576,0,1.157,0.249,1.574,0.661c0.33,0.332,0.495,0.747,0.578,1.162C47.177,38.188,47.011,38.936,46.433,39.434z M50.157,37.025\r c-0.164-1.072-0.66-2.072-1.489-2.819c-0.579-0.581-1.157-0.916-1.904-1.244l1.24-1.246c2.07-2.074,2.07-5.477,0-7.553\r c-0.576-0.581-1.24-0.995-2.069-1.244c0.746-1.244,0.912-2.739,0.498-4.149v-0.083v-0.084c-0.167-0.333-0.581-1.495-1.658-2.405\r c-0.912-0.748-2.069-1.162-3.312-1.162c-0.995,0-1.901,0.25-2.729,0.747c-0.253-0.747-0.664-1.495-1.242-2.073\r c-0.993-0.998-2.318-1.579-3.723-1.579c-1.408,0-2.732,0.581-3.726,1.579l-10.93,10.704c0-0.083,0.083-0.167,0.083-0.25\r c0.829-1.991,0.416-4.232-1.159-5.808c-0.495-0.499-1.076-0.915-1.737-1.163c-0.665-0.248-1.323-0.412-2.069-0.412\r c-0.665,0-1.408,0.166-1.99,0.412c-1.321,0.581-2.318,1.579-2.896,2.907l-7.7,18.59v0.083v0.083\r c-2.32,6.806-0.662,14.106,4.389,19.171c3.474,3.484,8.192,5.474,13.159,5.474c4.968,0,9.604-1.906,13.166-5.477l1.157-1.163\r l15.235-15.268C49.827,40.43,50.405,38.687,50.157,37.025z"
        })), l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M63.469,31.615c-0.552,0-0.918,0.336-0.918,0.845c0,7.167-3.021,13.918-8.521,18.979\r c-0.367,0.335-0.367,0.848,0,1.18c0.187,0.169,0.462,0.252,0.644,0.252c0.183,0,0.458-0.083,0.638-0.252\r c5.866-5.401,9.072-12.573,9.072-20.159C64.386,31.951,63.928,31.615,63.469,31.615z"
        })), l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M58.178,31.615c-0.538,0-0.895,0.329-0.895,0.82c0,5.821-2.415,11.315-6.801,15.499\r c-0.357,0.328-0.357,0.819,0,1.148c0.179,0.166,0.356,0.246,0.626,0.246c0.272,0,0.45-0.08,0.629-0.246\r c4.741-4.512,7.336-10.417,7.336-16.647C59.071,31.944,58.625,31.615,58.178,31.615z"
        })), l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M15.629,10.358c0.254,0,0.422-0.076,0.592-0.229c5.058-4.582,11.808-7.102,18.976-7.102l0,0\r c0.509,0,0.846-0.307,0.846-0.765S35.623,1.5,35.197,1.5c-7.588,0-14.759,2.673-20.159,7.561c-0.336,0.304-0.336,0.764,0,1.069\r C15.209,10.282,15.463,10.358,15.629,10.358z"
        })), l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M35.197,6.826C28.934,7,23.006,9.662,18.581,14.213c-0.334,0.344-0.334,0.858,0,1.203\r c0.168,0.17,0.417,0.257,0.585,0.257c0.169,0,0.417-0.087,0.584-0.259c4.093-4.209,9.604-6.697,15.447-6.871\r c0.502,0,0.837-0.429,0.837-0.857C36.116,7.17,35.699,6.741,35.197,6.826z"
        }))));
      },
      "pb-keywordmatching": function pbKeywordmatching(_ref131) {
        var e = _ref131.className,
            t = _ref131.width,
            a = _ref131.height;
        return l.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M11.019,23.391h12.37c0.736,0,1.303-0.572,1.303-1.314c0-0.743-0.563-1.314-1.303-1.314h-12.37\r c-0.738,0-1.301,0.571-1.301,1.314C9.716,22.818,10.324,23.391,11.019,23.391z"
        }), l.a.createElement("path", {
          fill: "#394F5A",
          d: "M63.342,46.193l-8.95-6.816c-1.379-1.052-3.328-0.805-4.428,0.518l-2.827-2.081\r c2.308-4.299,1.234-9.78-2.744-12.819c-0.591-0.452-1.216-0.819-1.861-1.119v-8.542c-0.042-2.408-1.996-4.38-4.384-4.38H4.724\r c-2.387,0-4.342,1.973-4.342,4.38v20.144c0,2.407,1.955,4.381,4.342,4.381h11.2l10.891,8.8c0.218,0.174,0.521,0.31,0.824,0.31\r c0.172,0,0.391-0.039,0.563-0.131c0.437-0.221,0.739-0.703,0.739-1.182v-7.797h2.094c0.394,0.43,0.817,0.837,1.296,1.201\r c4.015,3.071,9.601,2.593,13.069-0.901l2.813,2.071c-0.907,1.416-0.6,3.315,0.752,4.345l8.947,6.813\r c1.42,1.081,3.449,0.799,4.528-0.629l1.517-2.013C65.04,49.317,64.76,47.275,63.342,46.193z M30.401,26.94\r c-0.094,0.127-0.172,0.259-0.262,0.386h-19.12c-0.738,0-1.301,0.571-1.301,1.315c0,0.743,0.563,1.313,1.301,1.313H28.86\r c-0.759,2.405-0.58,5.002,0.448,7.271H27.6c-0.738,0-1.303,0.57-1.303,1.316v6.349l-9.116-7.354\r c-0.215-0.175-0.52-0.312-0.824-0.312H4.725c-0.956,0-1.736-0.789-1.736-1.752V15.33c0-0.964,0.78-1.753,1.736-1.753h33.419\r c0.954,0,1.736,0.789,1.736,1.753v7.735C36.373,22.528,32.687,23.892,30.401,26.94z M43.945,37.293\r c-1.763,2.345-4.7,3.263-7.359,2.562c-0.432-0.11-0.858-0.267-1.269-0.466c-0.41-0.198-0.81-0.442-1.188-0.729\r c-0.273-0.208-0.515-0.449-0.746-0.684c-0.221-0.237-0.422-0.488-0.614-0.749h-0.01c-1.537-2.091-1.843-4.898-0.71-7.27\r c0.199-0.417,0.44-0.817,0.727-1.202c0.154-0.205,0.338-0.37,0.511-0.554c1.741-1.863,4.305-2.584,6.683-2.032\r c0.381,0.091,0.759,0.22,1.132,0.378c0.06,0.026,0.122,0.041,0.184,0.071c0.43,0.194,0.847,0.437,1.241,0.729v-0.001\r c0.022,0.016,0.042,0.026,0.063,0.041C45.668,29.743,46.28,34.186,43.945,37.293z M61.622,48.962l-1.517,2.013\r c-0.099,0.131-0.279,0.156-0.41,0.059l-8.95-6.816c-0.125-0.104-0.156-0.283-0.054-0.414l1.517-2.016\r c0.1-0.127,0.28-0.153,0.41-0.056l8.946,6.817C61.693,48.646,61.718,48.828,61.622,48.962z"
        })));
      },
      "pb-list": function pbList(_ref132) {
        var e = _ref132.className,
            t = _ref132.width,
            a = _ref132.height;
        return l.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, l.a.createElement("g", null, l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M6.398,4.391c-1.107,0-2.008,0.9-2.008,2.008v52.203c0,1.107,0.901,2.008,2.008,2.008h52.203\r c1.107,0,2.008-0.9,2.008-2.008V6.398c0-1.108-0.9-2.008-2.008-2.008H6.398z M58.602,64.625H6.398\r c-3.328,0-6.023-2.695-6.023-6.023V6.398c0-3.328,2.696-6.023,6.023-6.023h52.203c3.325,0,6.023,2.696,6.023,6.023v52.203\r C64.625,61.93,61.927,64.625,58.602,64.625z"
        })), l.a.createElement("g", null, l.a.createElement("circle", {
          fill: "#394F5A",
          cx: "14.143",
          cy: "32.5",
          r: "4.589"
        })), l.a.createElement("g", null, l.a.createElement("circle", {
          fill: "#394F5A",
          cx: "14.143",
          cy: "18.732",
          r: "4.589"
        })), l.a.createElement("g", null, l.a.createElement("circle", {
          fill: "#394F5A",
          cx: "14.143",
          cy: "46.268",
          r: "4.589"
        })), l.a.createElement("g", null, l.a.createElement("rect", {
          x: "23.321",
          y: "16.438",
          fill: "#394F5A",
          width: "32.125",
          height: "4.589"
        })), l.a.createElement("g", null, l.a.createElement("rect", {
          x: "23.321",
          y: "30.206",
          fill: "#394F5A",
          width: "32.125",
          height: "4.589"
        })), l.a.createElement("g", null, l.a.createElement("rect", {
          x: "23.321",
          y: "43.974",
          fill: "#394F5A",
          width: "32.125",
          height: "4.589"
        }))));
      },
      "pb-message": function pbMessage(_ref133) {
        var e = _ref133.className,
            t = _ref133.width,
            a = _ref133.height;
        return l.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, l.a.createElement("g", null, l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M32.5,56.105c-5.755,0-11.314-1.393-16.077-4.026l-0.854-0.477l-7.457,4.454\r c-0.207,0.129-0.386,0.033-0.487-0.142c-0.058-0.104-0.052-0.194,0.021-0.317l4.063-6.74l-0.98-0.927\r c-4.528-4.291-7.022-9.769-7.022-15.435c0-13.021,12.918-23.612,28.795-23.612s28.797,10.593,28.797,23.612\r C61.297,45.514,48.377,56.105,32.5,56.105z M32.5,5.508c-17.745,0-32.184,12.107-32.184,26.986c0,6.174,2.512,12.132,7.107,16.914\r l-2.683,4.454c-0.701,1.166-0.726,2.554-0.065,3.717c0.671,1.181,1.918,1.914,3.254,1.914c0.663,0,1.333-0.187,1.922-0.541\r l5.793-3.462c5.066,2.614,10.87,3.99,16.854,3.99c17.746,0,32.184-12.106,32.184-26.986C64.684,17.615,50.246,5.508,32.5,5.508z"
        })), l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M33.538,35.062c-1.415,0-2.563-1.151-2.563-2.562s1.148-2.563,2.563-2.563\r c1.416,0,2.563,1.152,2.563,2.563S34.954,35.062,33.538,35.062z M33.538,26.271c-3.436,0-6.229,2.794-6.229,6.229\r c0,3.436,2.794,6.229,6.229,6.229c3.435,0,6.229-2.794,6.229-6.229C39.767,29.065,36.973,26.271,33.538,26.271z"
        })), l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M19.004,35.062c-1.416,0-2.563-1.151-2.563-2.562s1.147-2.563,2.563-2.563\r c1.415,0,2.562,1.152,2.562,2.563S20.419,35.062,19.004,35.062z M19.004,26.271c-3.436,0-6.229,2.794-6.229,6.229\r c0,3.436,2.793,6.229,6.229,6.229c3.434,0,6.229-2.794,6.229-6.229C25.233,29.065,22.438,26.271,19.004,26.271z"
        })), l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M48.073,35.062c-1.416,0-2.563-1.151-2.563-2.562s1.147-2.563,2.563-2.563\r c1.414,0,2.562,1.152,2.562,2.563C50.636,33.915,49.487,35.062,48.073,35.062z M48.073,26.271c-3.436,0-6.229,2.794-6.229,6.229\r c0,3.436,2.794,6.229,6.229,6.229c3.434,0,6.228-2.794,6.228-6.229C54.301,29.065,51.507,26.271,48.073,26.271z"
        }))));
      },
      "pb-spam": function pbSpam(_ref134) {
        var e = _ref134.className,
            t = _ref134.width,
            a = _ref134.height;
        return l.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M10.566,10.092v29.112c0,8.198,7.176,15.047,21.934,20.922c14.758-5.881,21.934-12.724,21.934-20.922\r V10.092c-2.69,0.263-5.779,0.175-8.885-0.259C40.242,9.091,35.47,7.425,32.504,5.332c-2.974,2.091-7.746,3.76-13.047,4.5\r C16.346,10.268,13.258,10.355,10.566,10.092z M32.498,64.625c-0.283,0-0.563-0.054-0.831-0.165\r c-0.015-0.006-0.03-0.014-0.045-0.016C14.528,57.776,6.216,49.521,6.216,39.204V7.584c0-0.65,0.293-1.265,0.8-1.679\r c0.506-0.411,1.173-0.574,1.812-0.444c2.727,0.557,6.377,0.59,10.02,0.082c6.065-0.849,10.414-2.865,12.062-4.501\r c0.635-0.652,1.441-0.825,2.426-0.523c0.308,0.125,0.574,0.317,0.787,0.554c1.677,1.631,6.006,3.628,12.027,4.47\r c3.644,0.511,7.298,0.477,10.021-0.082c0.635-0.13,1.306,0.033,1.812,0.444c0.508,0.414,0.801,1.028,0.801,1.679v31.62\r c0,10.32-8.32,18.576-25.425,25.246c-0.008,0.002-0.016,0.006-0.019,0.008c-0.168,0.07-0.345,0.117-0.518,0.141\r C32.713,64.615,32.606,64.625,32.498,64.625C32.219,64.625,32.606,64.625,32.498,64.625C32.219,64.625,32.606,64.625,32.498,64.625\r z"
        })), l.a.createElement("g", null, l.a.createElement("polygon", {
          fill: "#394F5A",
          points: "45.155,23.77 41.231,19.844 32.5,28.576 23.769,19.844 19.845,23.768 28.576,32.5 19.845,41.23 \r 23.769,45.155 32.5,36.424 41.231,45.155 45.155,41.23 36.425,32.5  "
        })));
      },
      "pb-sync": function pbSync(_ref135) {
        var e = _ref135.className,
            t = _ref135.width,
            a = _ref135.height;
        return l.a.createElement("svg", {
          x: "0px",
          y: "0px",
          width: t,
          height: a,
          className: e,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M55.53,55.007c-6.031,6.193-14.124,9.58-22.714,9.745c-0.165,0-0.248,0-0.411,0\r c-8.26,0-16.105-3.138-22.134-8.754v2.724c0,0.828-0.659,1.569-1.569,1.569l0,0c-0.826,0-1.569-0.658-1.569-1.569l-0.083-6.44\r c0-0.828,0.66-1.567,1.568-1.567l6.443-0.084c0.826,0,1.569,0.662,1.569,1.569c0,0.909-0.661,1.567-1.569,1.567h-2.644\r c5.451,5.117,12.47,7.845,19.902,7.845c0.083,0,0.246,0,0.33,0c7.764-0.084,15.114-3.222,20.563-8.755\r c7.846-8.095,10.406-19.655,6.61-30.226c-0.248-0.827,0.165-1.652,0.908-1.98c0.829-0.249,1.648,0.164,1.981,0.909\r C67.09,33.288,64.284,46.088,55.53,55.007z M5.068,42.373c0.25,0.827-0.165,1.65-0.908,1.981c-0.166,0.082-0.331,0.082-0.494,0.082\r c-0.661,0-1.24-0.413-1.488-0.991c-4.212-11.729-1.403-24.527,7.269-33.45l0,0c6.028-6.193,14.122-9.58,22.711-9.746\r C40.58,0.167,48.511,3.308,54.62,9.004V6.28c0-0.826,0.662-1.569,1.567-1.569c0.828,0,1.567,0.662,1.567,1.569l0.081,6.441\r c0,0.826-0.659,1.567-1.564,1.567l-6.446,0.083c-0.824,0-1.564-0.66-1.564-1.567c0-0.825,0.66-1.569,1.564-1.569h2.644\r C46.937,6.117,39.834,3.31,32.236,3.391c-7.763,0.083-15.113,3.22-20.563,8.754l0,0C3.748,20.158,1.187,31.719,5.068,42.373z\r M32.734,33.122C32.734,33.122,32.651,33.122,32.734,33.122c-1.569,0-2.726-0.497-3.55-1.486c-2.229-2.559-1.735-7.515-1.735-7.515\r v-0.083c0.247-5.119,3.965-5.531,5.039-5.531c0.081,0,0.081,0,0.164,0h0.083c0.828,0,5.04,0.081,5.285,5.531v0.083\r c0,0.083,0.494,5.039-1.73,7.515C35.378,32.625,34.221,33.04,32.734,33.122z M47.434,46.584h0.083c0.827,0,1.487-0.662,1.57-1.404\r c0.246-3.8-1.156-6.358-3.883-7.019c-4.789-1.237-6.774-2.725-7.43-3.633c0.329-0.248,0.659-0.496,0.905-0.829\r c3.057-3.468,2.561-9.25,2.561-9.909c-0.331-6.856-5.45-8.588-8.424-8.425c-2.972-0.083-8.092,1.569-8.422,8.425\r c-0.083,0.661-0.497,6.442,2.561,9.909c0.329,0.333,0.661,0.664,1.074,0.994c-0.743,0.909-2.806,2.309-7.35,3.468\r c-2.726,0.662-4.212,3.221-3.881,7.019c0.081,0.825,0.743,1.404,1.569,1.404h0.081c0.827-0.083,1.487-0.828,1.404-1.652\r c-0.083-1.239,0-3.387,1.569-3.798c6.11-1.487,8.505-3.635,9.498-5.205c0.577,0.166,1.157,0.166,1.817,0.248h0.082H32.9\r c0,0,0,0,0.082,0h0.084c0.744,0,1.403-0.082,2.064-0.248c0.909,1.57,3.383,3.718,9.498,5.205c1.568,0.411,1.65,2.559,1.568,3.798\r C45.948,45.756,46.527,46.501,47.434,46.584z"
        })));
      },
      "pb-webhook": function pbWebhook(_ref136) {
        var e = _ref136.className,
            t = _ref136.width,
            a = _ref136.height;
        return l.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, l.a.createElement("g", null, l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M50.533,48.523H18.784v3.349c-0.616,3.436-3.674,6.044-7.352,6.044c-4.121,0-7.464-3.277-7.464-7.323\r c0-2.495,1.272-4.697,3.214-6.021l-2.141-2.997c-2.905,1.982-4.808,5.285-4.808,9.018c0,6.066,5.012,10.986,11.196,10.986\r c5.546,0,10.15-3.955,11.04-9.148h27.908c0.644,1.091,1.848,1.823,3.228,1.823c2.058,0,3.729-1.637,3.729-3.661\r c0-2.021-1.672-3.659-3.729-3.659C52.332,46.934,51.203,47.562,50.533,48.523z"
        })), l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M8.094,49.072c0.065-0.159,0.141-0.311,0.229-0.467c0.687-1.173,1.928-1.827,3.207-1.831l13.997-23.886\r c-4.124-3.354-5.309-9.248-2.544-13.967c3.08-5.259,9.902-7.061,15.235-4.029c3.275,1.863,5.224,5.116,5.534,8.567l-3.706,0.317\r c-0.206-2.3-1.504-4.47-3.688-5.711c-3.556-2.022-8.105-0.822-10.16,2.683c-2.013,3.434-0.885,7.803,2.5,9.88l2.045,1.165\r L14.89,48.848c0.449,0.926,0.498,2.028,0.07,3.022c-0.524,1.398-1.888,2.395-3.491,2.395c-2.054,0-3.72-1.639-3.72-3.659\r C7.753,50.055,7.875,49.536,8.094,49.072z"
        })), l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M32.311,18.039l15.693,26.784l1.87-1.064l0.031,0.054c0.016-0.008,0.032-0.021,0.049-0.029\r c3.557-2.024,8.088-0.85,10.123,2.621c2.034,3.469,0.797,7.927-2.759,9.945c-2.193,1.248-4.761,1.278-6.879,0.306l-1.582,3.302\r c3.179,1.449,7.015,1.398,10.301-0.471c5.335-3.035,7.188-9.717,4.139-14.922c-2.756-4.701-8.562-6.594-13.593-4.682\r L35.776,16.122c0.601-1.077,0.636-2.421-0.028-3.555c-1.018-1.734-3.286-2.32-5.064-1.309c-1.778,1.011-2.398,3.237-1.38,4.972\r C29.953,17.34,31.103,17.98,32.311,18.039z"
        }))));
      },
      "pb-phone": function pbPhone(_ref137) {
        var e = _ref137.className,
            t = _ref137.width,
            a = _ref137.height;
        return l.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, l.a.createElement("g", null, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M22.44,36.38c-2.295-2.155-4.105-4.921-4.418-8.082c-0.312-3.169,1.055-6.603,4.495-9.583 c0.837-0.726,1.295-1.229,1.421-1.595c0.126-0.358,0.162-0.884-0.549-2.181l-7.623-9.636c-0.983-0.95-1.376-0.922-2.124-0.696 c-0.748,0.228-1.774,0.971-2.731,1.87c-6.143,5.936-8.074,10.962-7.13,16.233c0.944,5.269,5.055,11.077,11.985,17.771 c2.844,2.749,5.97,5.77,8.494,8.209c6.93,6.694,12.938,10.666,18.394,11.581c5.451,0.912,10.654-0.954,16.797-6.888 c0.933-0.925,1.703-1.919,1.936-2.643c0.231-0.719,0.262-1.099-0.721-2.051l-9.973-7.365c-1.345-0.685-1.884-0.652-2.259-0.532 c-0.382,0.127-0.897,0.566-1.647,1.376c-3.083,3.323-6.639,4.646-9.919,4.34c-3.269-0.301-6.131-2.049-8.36-4.269 M30.935,39.896 c1.87,1.896,4.127,3.065,6.255,3.299c2.187,0.203,4.486-0.495,7.036-3.241c0.789-0.853,1.652-1.836,3.108-2.307 c1.458-0.471,3.207-0.179,5.064,0.786c3.549,2.604,7.208,5.238,10.693,7.915c1.665,1.607,2.095,3.727,1.554,5.387 c-0.533,1.664-1.687,2.921-2.748,3.975c-5.923,5.968-12.943,8.852-19.831,7.842c-6.656-1.111-13.094-5.615-20.231-12.512 c-3.069-2.965-5.458-5.275-8.497-8.209C6.202,35.934,1.54,29.711,0.387,23.28C-0.98,15.33,3.391,8.856,8.504,4.118 c1.09-1.029,2.396-2.138,4.113-2.656c1.722-0.518,3.913-0.105,5.576,1.502c2.77,3.372,5.499,6.906,8.189,10.333 c1,1.799,1.304,3.486,0.817,4.893c-0.488,1.407-1.508,2.241-2.392,3.005c-2.842,2.462-3.563,4.69-3.354,6.795 c0.244,2.062,1.454,4.24,3.414,6.047"
        })));
      },
      "targeting-came-from-playbooks": function targetingCameFromPlaybooks(_ref138) {
        var e = _ref138.className,
            _ref138$width = _ref138.width,
            t = _ref138$width === void 0 ? "21" : _ref138$width,
            _ref138$height = _ref138.height,
            a = _ref138$height === void 0 ? "21" : _ref138$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 21 21"
        }, l.a.createElement("path", {
          d: "M18.219 20H2.782C1.799 20 1 19.2 1 18.219V9.313c0-.008.004-.014.004-.021.002-.043.015-.082.025-.124.01-.035.013-.07.028-.101.014-.031.037-.056.056-.084.025-.036.047-.073.08-.103l.012-.016L3.816 6.6c.046-.04.1-.063.153-.086V3.97c0-.328.266-.594.594-.594h2.976l2.572-2.23a.594.594 0 0 1 .778 0l2.57 2.228.001.002h2.977c.329 0 .594.266.594.594v2.517c.02.013.04.017.059.033l2.705 2.345c.005.005.008.011.012.016.033.03.055.067.08.103.02.028.042.053.057.084.014.031.018.066.027.1.01.042.024.082.025.125 0 .007.004.013.004.02v8.907C20 19.2 19.201 20 18.219 20zM2.429 9.374c.026.011.054.016.08.033l1.46.938V8.04l-1.54 1.334zM10.5 2.379l-1.148.996h2.297L10.5 2.379zM15.9 4.533H7.877c-.035.007-.069.019-.104.019-.03 0-.057-.014-.087-.019H5.138v6.547c0 .005-.003.01-.003.014l5.365 3.45 5.399-3.47v-6.54zM17.03 8.04v2.305l1.46-.938c.026-.017.054-.021.08-.033l-1.54-1.334zm1.857 2.524l-8.067 5.185a.59.59 0 0 1-.642 0l-8.03-5.162v7.635c0 .328.305.59.633.59h15.437c.327 0 .669-.262.669-.59v-7.658z"
        }));
      },
      "targeting-drift-behavior": function targetingDriftBehavior(_ref139) {
        var e = _ref139.className,
            _ref139$width = _ref139.width,
            t = _ref139$width === void 0 ? "24" : _ref139$width,
            _ref139$height = _ref139.height,
            a = _ref139$height === void 0 ? "21" : _ref139$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 21"
        }, l.a.createElement("path", {
          d: "M22.633 14.623a.363.363 0 0 1-.366-.36v-4.66c0-.197.164-.358.366-.358.203 0 .367.16.367.358v4.66a.363.363 0 0 1-.367.36zM20.048 20H3.952c-.617 0-1.119-.49-1.119-1.09V6.391c0-.6.502-1.09 1.119-1.09H6.5V3.817c-.631-.16-1.1-.717-1.1-1.383C5.4 1.643 6.058 1 6.867 1s1.466.643 1.466 1.434c0 .666-.469 1.223-1.1 1.383v1.485h9.9V3.817c-.63-.16-1.1-.717-1.1-1.383 0-.791.658-1.434 1.467-1.434s1.467.643 1.467 1.434c0 .666-.47 1.222-1.1 1.383v1.485h2.181c.617 0 1.119.49 1.119 1.09V18.91c0 .602-.502 1.09-1.119 1.09zM7.6 2.434a.726.726 0 0 0-.733-.717.726.726 0 0 0-.734.717c0 .395.33.717.734.717a.726.726 0 0 0 .733-.717zm10.633 0a.726.726 0 0 0-.733-.717.726.726 0 0 0-.733.717c0 .395.329.717.733.717a.726.726 0 0 0 .733-.717zm2.2 3.958a.38.38 0 0 0-.385-.373H3.952a.38.38 0 0 0-.385.373V18.91a.38.38 0 0 0 .385.374h16.096a.38.38 0 0 0 .385-.374V6.392zm-4.583 6.08c-.91 0-1.65-.724-1.65-1.614 0-.89.74-1.613 1.65-1.613.91 0 1.65.724 1.65 1.613 0 .89-.74 1.614-1.65 1.614zm0-2.51a.908.908 0 0 0-.917.896c0 .494.411.896.917.896a.907.907 0 0 0 .917-.896.908.908 0 0 0-.917-.896zm-7.333 2.51c-.91 0-1.65-.724-1.65-1.614 0-.89.74-1.613 1.65-1.613.91 0 1.65.724 1.65 1.613 0 .89-.74 1.614-1.65 1.614zm0-2.51a.908.908 0 0 0-.917.896c0 .494.411.896.917.896a.907.907 0 0 0 .916-.896.908.908 0 0 0-.916-.896zM7.6 14.264c.203 0 .367.16.367.359v.716H16.4v-.716c0-.199.164-.36.367-.36.202 0 .366.161.366.36v1.075a.362.362 0 0 1-.366.358H7.6a.362.362 0 0 1-.367-.358v-1.075c0-.199.164-.36.367-.36zm-6.233.359a.363.363 0 0 1-.367-.36v-4.66c0-.197.164-.358.367-.358.202 0 .366.16.366.358v4.66a.363.363 0 0 1-.366.36z"
        }));
      },
      "targeting-firmographics": function targetingFirmographics(_ref140) {
        var e = _ref140.className,
            _ref140$width = _ref140.width,
            t = _ref140$width === void 0 ? "24" : _ref140$width,
            _ref140$height = _ref140.height,
            a = _ref140$height === void 0 ? "21" : _ref140$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 24 21"
        }, l.a.createElement("path", {
          d: "M22.542 9.143h-2.758v7.238h1.344c.254 0 .458.202.458.452s-.204.452-.458.452H2.863a.455.455 0 0 1-.458-.452c0-.25.205-.452.458-.452h1.344V9.143H1.458a.458.458 0 0 1-.437-.317.449.449 0 0 1 .176-.507l10.537-7.238a.462.462 0 0 1 .523 0l10.487 7.203a.452.452 0 0 1-.202.859zM16.12 16.38h2.749V9.143h-2.75v7.238zm-3.665 0h2.749V9.143h-2.75v7.238zm-.917 0V9.143H8.79v7.238h2.748zm-6.414 0h2.75V9.143h-2.75v7.238zm6.873-14.378L2.919 8.238h18.153l-9.076-6.235zM1.458 19.095h21.075c.254 0 .458.202.458.452s-.204.453-.458.453H1.458A.455.455 0 0 1 1 19.547c0-.25.205-.452.458-.452z"
        }));
      },
      "targeting-geolocation": function targetingGeolocation(_ref141) {
        var e = _ref141.className,
            _ref141$width = _ref141.width,
            t = _ref141$width === void 0 ? "20" : _ref141$width,
            _ref141$height = _ref141.height,
            a = _ref141$height === void 0 ? "19" : _ref141$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 20 19"
        }, l.a.createElement("path", {
          d: "M19.892 18.722a.622.622 0 0 1-.517.278H.625a.623.623 0 0 1-.518-.278.643.643 0 0 1-.062-.59l2.5-6.334a.626.626 0 0 1 .58-.398H5a.63.63 0 0 1 .625.633.63.63 0 0 1-.625.634H3.548l-2 5.066h16.904l-2-5.066H15a.63.63 0 0 1-.625-.634c0-.35.28-.633.625-.633h1.875c.256 0 .485.158.58.398l2.5 6.333a.645.645 0 0 1-.063.591zm-9.485-3.675a.622.622 0 0 1-.814 0c-.213-.185-5.218-4.594-5.218-9.32C4.375 2.57 6.898 0 10 0s5.625 2.57 5.625 5.727c0 4.726-5.005 9.135-5.218 9.32zM10 1.267c-2.412 0-4.375 2.001-4.375 4.46 0 3.421 3.218 6.855 4.374 7.978 1.157-1.124 4.376-4.563 4.376-7.978 0-2.459-1.963-4.46-4.375-4.46zm-2.5 4.48C7.5 4.35 8.62 3.214 10 3.214c1.38 0 2.5 1.136 2.5 2.533 0 1.398-1.12 2.534-2.5 2.534-1.379 0-2.5-1.136-2.5-2.534zM10 7.014a1.26 1.26 0 0 0 1.25-1.267A1.26 1.26 0 0 0 10 4.481a1.26 1.26 0 0 0-1.25 1.266A1.26 1.26 0 0 0 10 7.014z"
        }));
      },
      "targeting-target-account": function targetingTargetAccount(_ref142) {
        var e = _ref142.className,
            _ref142$width = _ref142.width,
            t = _ref142$width === void 0 ? "22" : _ref142$width,
            _ref142$height = _ref142.height,
            a = _ref142$height === void 0 ? "22" : _ref142$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 22 22"
        }, l.a.createElement("path", {
          d: "M11 21C5.486 21 1 16.514 1 11S5.486 1 11 1s10 4.486 10 10-4.486 10-10 10zm.333-19.317V3a.333.333 0 1 1-.666 0V1.683c-4.88.174-8.81 4.104-8.984 8.983H3a.333.333 0 1 1 0 .667H1.683c.174 4.88 4.104 8.81 8.984 8.983V19a.333.333 0 1 1 .666 0v1.316c4.88-.173 8.81-4.103 8.984-8.983H19a.334.334 0 0 1 0-.667h1.317c-.174-4.879-4.104-8.809-8.984-8.983zm3 13.338H7.667A.667.667 0 0 1 7 14.355v-.833c0-.017.007-.031.01-.048.003-.025.005-.05.014-.073.009-.021.022-.038.034-.057.012-.017.02-.036.035-.05.018-.02.04-.032.062-.046.013-.009.023-.022.038-.029l2.208-1.026a3.44 3.44 0 0 1-.398-1.724c0-.004-.003-.007-.003-.011l.001-1.875c0-.009.004-.016.005-.025 0-.01-.003-.02-.001-.03.152-.904 1.133-1.513 1.966-1.527L11 7c.84 0 1.842.613 1.995 1.528.002.01-.002.02-.001.03 0 .009.005.016.005.025v1.875l-.002.011c.008.153.025.959-.398 1.724l2.208 1.026c.016.008.026.02.04.03.021.014.043.026.06.044.015.016.024.034.035.052.012.018.025.035.033.056.01.023.012.049.015.074.003.016.01.03.01.047v.833a.667.667 0 0 1-.667.666zm0-1.286l-2.363-1.1c-.009-.004-.014-.011-.023-.016-.013-.008-.027-.012-.04-.022-.008-.006-.012-.015-.02-.022a.337.337 0 0 1-.076-.104.335.335 0 0 1-.019-.06.332.332 0 0 1-.01-.062.342.342 0 0 1 .02-.127c.003-.01.002-.02.007-.03.005-.011.015-.018.022-.03.006-.01.008-.022.016-.032.542-.703.485-1.639.484-1.648 0-.007.003-.014.003-.02l-.001-.004V8.621c-.104-.54-.766-.944-1.31-.954H11c-.549 0-1.228.407-1.332.954l-.001 1.837v.003c0 .008.003.014.002.022-.002.024-.054.95.484 1.647.008.01.01.022.017.033.007.011.016.018.022.03.004.009.003.019.007.028a.3.3 0 0 1 .015.066.298.298 0 0 1-.005.124.352.352 0 0 1-.02.06.325.325 0 0 1-.032.053.31.31 0 0 1-.045.051c-.007.007-.01.016-.019.022-.012.01-.026.014-.04.021-.008.005-.014.013-.023.018l-2.363 1.099v.62h6.666v-.62z"
        }));
      },
      "targeting-url": function targetingUrl(_ref143) {
        var e = _ref143.className,
            _ref143$width = _ref143.width,
            t = _ref143$width === void 0 ? "16" : _ref143$width,
            _ref143$height = _ref143.height,
            a = _ref143$height === void 0 ? "17" : _ref143$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 17"
        }, l.a.createElement("path", {
          d: "M14.938 6.543l-2.34 2.475a.643.643 0 0 1-.945 0 .737.737 0 0 1 0-1.001l2.339-2.474c.432-.457.67-1.065.67-1.71 0-.646-.238-1.253-.67-1.71-.865-.913-2.37-.914-3.233 0l-3.424 3.62c-.891.943-.891 2.477 0 3.42.117.124.247.234.388.33.31.21.402.648.202.977a.658.658 0 0 1-.564.326.635.635 0 0 1-.36-.112 3.667 3.667 0 0 1-.613-.522c-1.412-1.493-1.412-3.924 0-5.42l3.425-3.62A3.504 3.504 0 0 1 12.375 0c.969 0 1.878.399 2.563 1.123A3.918 3.918 0 0 1 16 3.833a3.919 3.919 0 0 1-1.062 2.71zM5.24 14.879l3.424-3.621c.432-.457.67-1.064.67-1.71 0-.646-.238-1.253-.67-1.71a2.362 2.362 0 0 0-.37-.317.733.733 0 0 1-.194-.98.649.649 0 0 1 .925-.205c.209.144.405.313.584.502a3.92 3.92 0 0 1 1.063 2.71 3.918 3.918 0 0 1-1.063 2.71L6.185 15.88A3.518 3.518 0 0 1 3.623 17a3.514 3.514 0 0 1-2.563-1.12c-1.413-1.495-1.413-3.928 0-5.422l2.332-2.466a.643.643 0 0 1 .945 0 .737.737 0 0 1 0 1.001l-2.33 2.465a2.473 2.473 0 0 0-.67 1.71c0 .647.237 1.254.67 1.71a2.202 2.202 0 0 0 3.233 0z"
        }));
      },
      "targeting-website-behavior": function targetingWebsiteBehavior(_ref144) {
        var e = _ref144.className,
            _ref144$width = _ref144.width,
            t = _ref144$width === void 0 ? "22" : _ref144$width,
            _ref144$height = _ref144.height,
            a = _ref144$height === void 0 ? "20" : _ref144$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 22 20"
        }, l.a.createElement("path", {
          d: "M19.75 19H2.25C1.56 19 1 18.395 1 17.65V2.35C1 1.606 1.56 1 2.25 1h17.5c.69 0 1.25.606 1.25 1.35v15.3c0 .745-.56 1.35-1.25 1.35zm.417-16.65c0-.248-.187-.45-.417-.45H2.25c-.23 0-.417.202-.417.45V4.6h18.334V2.35zm0 3.15H1.833v12.15c0 .248.187.45.417.45h17.5c.23 0 .417-.202.417-.45V5.5zM13.17 16.168a.4.4 0 0 1-.295.132.4.4 0 0 1-.295-.132l-2.977-3.215-1.209 1.395c-.013.015-.03.021-.043.034-.023.02-.044.039-.07.054a.364.364 0 0 1-.08.03c-.018.006-.033.017-.052.02-.014.003-.028.003-.041.004H8.1l-.012.001a.374.374 0 0 1-.126-.025c-.006-.002-.012-.001-.018-.004a.412.412 0 0 1-.133-.088l-.007-.005c-.01-.01-.015-.025-.025-.037a.439.439 0 0 1-.06-.093c-.01-.022-.016-.046-.022-.07-.007-.021-.018-.04-.02-.064l-.84-6.29a.472.472 0 0 1 .117-.383.394.394 0 0 1 .354-.128l5.83.902c.018.003.034.015.052.02.027.009.053.016.079.03.025.015.047.034.07.054.014.013.03.02.043.034.006.006.007.014.012.02.02.025.032.052.046.08.012.025.025.048.032.073.008.026.01.053.012.08.004.032.008.063.005.095 0 .008.003.015.002.023-.003.02-.013.035-.018.054-.008.03-.015.06-.029.088a.439.439 0 0 1-.052.078c-.01.015-.016.032-.029.045l-1.296 1.312 2.977 3.215a.475.475 0 0 1 0 .636l-1.875 2.025zM11.173 10.6a.472.472 0 0 1 .01-.646l.978-.988-4.42-.684.637 4.768L9.29 12a.394.394 0 0 1 .614.006l2.972 3.209 1.286-1.389-2.988-3.226zM3.092 2.8h.004c.23 0 .416.202.416.45 0 .249-.186.45-.416.45-.23 0-.419-.201-.419-.45 0-.248.185-.45.415-.45zm1.25 0h.004c.23 0 .416.202.416.45 0 .249-.186.45-.416.45-.23 0-.419-.201-.419-.45 0-.248.185-.45.415-.45zm1.25 0h.004c.23 0 .416.202.416.45 0 .249-.186.45-.416.45-.23 0-.419-.201-.419-.45 0-.248.185-.45.415-.45z"
        }));
      },
      redo: function redo(_ref145) {
        var e = _ref145.className,
            _ref145$width = _ref145.width,
            t = _ref145$width === void 0 ? "9" : _ref145$width,
            _ref145$height = _ref145.height,
            a = _ref145$height === void 0 ? "11" : _ref145$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0.405 -0.009 8.58 10.968"
        }, l.a.createElement("g", null, l.a.createElement("g", {
          transform: "translate(-1444.000000, -116.000000)"
        }, l.a.createElement("g", {
          transform: "translate(1391.000000, 103.000000)"
        }, l.a.createElement("g", {
          transform: "translate(56.517678, 18.492678) scale(-1, 1) rotate(45.000000) translate(-56.517678, -18.492678) translate(51.017678, 15.992678)"
        }, l.a.createElement("path", {
          fill: "#394F5A",
          d: "M10.976,4.428C10.124,2.03,7.922,0.418,5.5,0.418c-1.916,0-3.689,1.01-4.771,2.617l0-2.649 c0-0.213-0.163-0.386-0.364-0.386C0.163,0,0,0.173,0,0.386L0,4.564c0,0.002,0,0.004,0,0.007 c0.001,0.015,0.002,0.029,0.005,0.043c0.001,0.012,0.002,0.022,0.003,0.034c0.003,0.011,0.007,0.023,0.01,0.035 C0.023,4.696,0.027,4.708,0.031,4.72c0.004,0.011,0.01,0.02,0.015,0.03c0.006,0.011,0.012,0.023,0.019,0.034 c0.006,0.01,0.015,0.019,0.022,0.029C0.095,4.822,0.102,4.832,0.11,4.841c0.008,0.008,0.018,0.015,0.028,0.022 c0.009,0.009,0.017,0.017,0.028,0.023c0.008,0.007,0.018,0.011,0.029,0.016C0.205,4.91,0.217,4.916,0.23,4.922 c0.002,0.001,0.005,0.002,0.006,0.003C0.244,4.929,0.253,4.93,0.262,4.932C0.274,4.936,0.287,4.94,0.3,4.943 c0.012,0.003,0.026,0.003,0.038,0.005C0.347,4.948,0.356,4.95,0.365,4.95l3.95,0c0.202,0,0.365-0.172,0.365-0.385 C4.68,4.351,4.516,4.179,4.315,4.179H0.926C1.786,2.371,3.56,1.189,5.5,1.189c2.121,0,4.048,1.411,4.794,3.511 c0.055,0.154,0.194,0.25,0.341,0.25c0.042,0,0.086-0.007,0.128-0.025C10.952,4.85,11.048,4.628,10.976,4.428"
        }))))));
      },
      undo: function undo(_ref146) {
        var e = _ref146.className,
            _ref146$width = _ref146.width,
            t = _ref146$width === void 0 ? "9" : _ref146$width,
            _ref146$height = _ref146.height,
            a = _ref146$height === void 0 ? "11" : _ref146$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0.404 -0.009 8.58 10.968"
        }, l.a.createElement("g", null, l.a.createElement("g", {
          transform: "translate(-1444.000000, -116.000000)"
        }, l.a.createElement("g", {
          transform: "translate(1391.000000, 103.000000)"
        }, l.a.createElement("g", {
          id: "Page-1",
          transform: "translate(56.517678, 18.492678) scale(-1, 1) rotate(45.000000) translate(-56.517678, -18.492678) translate(51.017678, 15.992678)"
        }, l.a.createElement("path", {
          id: "Fill-1",
          fill: "#394F5A",
          d: "M5.764,9.64c0.2,0.071,0.422-0.024,0.497-0.213c0.017-0.042,0.025-0.086,0.025-0.128 C6.286,9.152,6.19,9.013,6.036,8.958c-2.1-0.746-3.511-2.674-3.511-4.794c0-1.94,1.182-3.714,2.99-4.574v3.389 c0,0.201,0.172,0.365,0.385,0.365C6.114,3.344,6.286,3.18,6.286,2.979v-3.95c0-0.009-0.001-0.018-0.002-0.027 C6.282-1.01,6.281-1.024,6.279-1.036c-0.002-0.013-0.006-0.026-0.01-0.038C6.266-1.083,6.264-1.092,6.262-1.1 C6.26-1.102,6.259-1.104,6.258-1.106C6.252-1.119,6.246-1.131,6.239-1.142c-0.005-0.01-0.009-0.02-0.016-0.029 C6.216-1.181,6.208-1.19,6.199-1.198c-0.007-0.01-0.014-0.02-0.022-0.028C6.168-1.234,6.158-1.241,6.149-1.249 C6.139-1.256,6.13-1.264,6.12-1.271C6.109-1.278,6.097-1.284,6.086-1.289c-0.01-0.005-0.02-0.011-0.03-0.015 C6.044-1.309,6.032-1.313,6.02-1.317C6.008-1.32,5.996-1.324,5.984-1.327C5.973-1.329,5.962-1.33,5.951-1.331 C5.937-1.334,5.922-1.335,5.907-1.335c-0.003,0-0.005-0.001-0.007,0L1.722-1.336c-0.213,0-0.386,0.164-0.386,0.365 c0,0.201,0.173,0.364,0.386,0.364l2.649,0C2.764,0.475,1.754,2.248,1.754,4.164C1.754,6.587,3.366,8.788,5.764,9.64"
        }))))));
      },
      rocket: function rocket(_ref147) {
        var e = _ref147.className,
            _ref147$width = _ref147.width,
            t = _ref147$width === void 0 ? 24 : _ref147$width,
            _ref147$height = _ref147.height,
            a = _ref147$height === void 0 ? 24 : _ref147$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a
        }, l.a.createElement("g", {
          fill: "#B5D2E1"
        }, l.a.createElement("path", {
          d: "M15.56.88a.98.98 0 0 0-.18-.26h-.04l-.2-.14C13.88-.32 9.44.36 6.4 3.4c-.385.386-.739.8-1.06 1.24l-2.12.52a3.92 3.92 0 0 0-1.98 1.18l-.82.9a1 1 0 0 0 1.1 1.6l.56-.22a1.14 1.14 0 0 1 1.1.16l.46.34 3.16 3.22.36.48c.24.314.301.73.16 1.1l-.22.56a.98.98 0 0 0 .38 1.18.98.98 0 0 0 1.24-.08l.9-.82a3.92 3.92 0 0 0 1.2-1.96l.54-2.14c.44-.321.854-.676 1.24-1.06a11.52 11.52 0 0 0 2.86-4.98c.46-1.58.48-3.04.1-3.74zm-13.7 6.6l.28-.32a2.72 2.72 0 0 1 1.36-.82l.92-.24a12.14 12.14 0 0 0-.7 1.64 2.34 2.34 0 0 0-1.86-.28v.02zm7.8 5.04a2.72 2.72 0 0 1-.82 1.36l-.32.28a2.34 2.34 0 0 0-.26-1.88c.564-.2 1.112-.44 1.64-.72l-.24.96zm2.08-3.78a10.38 10.38 0 0 1-4.3 2.54L4.72 8.54a10.38 10.38 0 0 1 2.52-4.3c2.8-2.8 6.64-3.12 7.26-2.76.36.66.02 4.48-2.76 7.26z"
        }), l.a.createElement("path", {
          d: "M1.46 14.56l.12.1c.294.16.626.236.96.22a3.64 3.64 0 0 0 2.5-1c.261-.265.49-.56.68-.88a.6.6 0 0 0-.1-.7l-1.88-1.92a.6.6 0 0 0-.72-.12 4.64 4.64 0 0 0-.92.7c-1.06 1.06-1.2 2.76-.8 3.42l.12.16.04.02zm1.52-2.76l.28-.24 1.18 1.2-.24.26a2.42 2.42 0 0 1-1.86.64 2.42 2.42 0 0 1 .64-1.86zM10.3 3.14a1.81 1.81 0 1 0 2.56 2.56 1.81 1.81 0 0 0-2.56-2.56zm1.7 1.7a.6.6 0 1 1-.837-.86.6.6 0 0 1 .837.86z"
        })));
      },
      eye: function eye(_ref148) {
        var e = _ref148.className,
            _ref148$width = _ref148.width,
            t = _ref148$width === void 0 ? "24" : _ref148$width,
            _ref148$height = _ref148.height,
            a = _ref148$height === void 0 ? "24" : _ref148$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a
        }, l.a.createElement("path", {
          d: "M8 12c-5.197 0-8-4.259-8-6 0-1.741 2.803-6 8-6s8 4.259 8 6c0 1.741-2.803 6-8 6zM8 1.333C3.477 1.333 1.333 5.077 1.333 6c0 .923 2.144 4.667 6.667 4.667S14.667 6.923 14.667 6c0-.923-2.144-4.667-6.667-4.667zm0 8A3.337 3.337 0 0 1 4.667 6 3.337 3.337 0 0 1 8 2.667 3.337 3.337 0 0 1 11.333 6 3.337 3.337 0 0 1 8 9.333zM8 4c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z",
          fill: "#7695A5",
          fillRule: "evenodd"
        }));
      },
      "eye-off": function eyeOff(_ref149) {
        var e = _ref149.className,
            _ref149$width = _ref149.width,
            t = _ref149$width === void 0 ? "24" : _ref149$width,
            _ref149$height = _ref149.height,
            a = _ref149$height === void 0 ? "24" : _ref149$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a
        }, l.a.createElement("path", {
          fill: "#94C8FF",
          fillRule: "evenodd",
          d: "M12.09 3.623l-.002.001-9.861 9.839a.47.47 0 0 1-.665-.664l1.944-1.939C1.606 9.576.64 8.05.512 7.223a.466.466 0 0 1-.042-.19c0-1.497 2.636-5.16 7.523-5.16 1.821 0 2.85.465 3.674.845l2.12-2.115a.469.469 0 1 1 .665.664l-2.363 2.356zM6.39 7.983L8.96 5.42a1.864 1.864 0 0 0-.951-.264 1.88 1.88 0 0 0-1.881 1.876c0 .34.094.663.264.95zM7.993 2.81c-4.404 0-6.52 3.289-6.577 4.181.001.015.008.026.008.04 0 .307.712 1.82 2.76 3.15L5.713 8.66a2.783 2.783 0 0 1-.526-1.628 2.82 2.82 0 0 1 2.822-2.814 2.8 2.8 0 0 1 1.63.524l1.319-1.315c-.71-.314-1.562-.616-2.964-.616zm-.456 6.567c0-.259.21-.469.47-.469a1.88 1.88 0 0 0 1.88-1.876.47.47 0 0 1 .941 0 2.821 2.821 0 0 1-2.82 2.815.47.47 0 0 1-.471-.47zm-1.302 1.683a7.91 7.91 0 0 0 1.772.193c4.465 0 6.583-3.386 6.583-4.221 0-.399-.546-1.456-1.717-2.458a.469.469 0 1 1 .612-.712c1.204 1.03 2.045 2.334 2.045 3.17 0 1.497-2.636 5.16-7.523 5.16a8.85 8.85 0 0 1-1.98-.217.47.47 0 1 1 .208-.915z"
        }));
      },
      "categories-1": function categories1(_ref150) {
        var e = _ref150.className,
            _ref150$width = _ref150.width,
            t = _ref150$width === void 0 ? "14" : _ref150$width,
            _ref150$height = _ref150.height,
            a = _ref150$height === void 0 ? "12" : _ref150$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a
        }, l.a.createElement("path", {
          d: "M13.887 11.555a.447.447 0 0 1-.3.144l-3.906.28a.429.429 0 0 1-.47-.378l-.458-5.287v5.254a.426.426 0 0 1-.438.413H.437A.426.426 0 0 1 0 11.568V.826C0 .598.196.413.438.413H8.315c.193 0 .351.119.41.281l3.889-.28c.24-.02.45.152.47.378l.906 10.461a.398.398 0 0 1-.103.302zM3.94 1.24H.875v1.653H3.94V1.239zm0 2.479H.875v7.437H3.94V3.718zm3.939-2.48H4.814v1.654h3.064V1.239zm0 2.48H4.814v7.437h3.064V3.718zm4.368-2.449l-3.034.219.143 1.64 3.034-.219-.143-1.64zm.214 2.463l-3.034.22.623 7.173 3.033-.219-.622-7.174zm-1.134 5.772l.45-.039a.43.43 0 0 1 .476.374.421.421 0 0 1-.396.45l-.45.038a.429.429 0 0 1-.476-.374.42.42 0 0 1 .396-.45zm-5.199-.002h.438c.242 0 .437.185.437.413a.425.425 0 0 1-.437.413h-.438c-.242 0-.438-.184-.438-.413 0-.228.196-.413.438-.413zm-3.939 0h.438c.242 0 .438.185.438.413 0 .229-.196.413-.438.413h-.438c-.241 0-.437-.184-.437-.413 0-.228.196-.413.437-.413z",
          fill: "#7695A5",
          fillRule: "evenodd"
        }));
      },
      "categories-2": function categories2(_ref151) {
        var _ref151$width = _ref151.width,
            e = _ref151$width === void 0 ? "18" : _ref151$width,
            _ref151$height = _ref151.height,
            t = _ref151$height === void 0 ? "16" : _ref151$height,
            a = _ref151.className;
        return l.a.createElement("svg", {
          className: a,
          width: e,
          height: t
        }, l.a.createElement("path", {
          d: "M17.855 14.857a.567.567 0 0 1-.385.192l-5.023.374a.558.558 0 0 1-.604-.504l-.59-7.05v7.005a.557.557 0 0 1-.562.551H.563A.557.557 0 0 1 0 14.874V.552C0 .247.252 0 .563 0h10.128c.247 0 .451.158.526.375l5.001-.374a.557.557 0 0 1 .604.504l1.166 13.949a.543.543 0 0 1-.133.402zM4.939 1H1v2.204h3.939V1zm0 3H1v9.916h3.939V4zm5-3H6v2.204h3.939V1zm0 3H6v9.916h3.939V4zM15.9 1L12 1.292l.183 2.186 3.901-.292L15.901 1zm0 3L12 4.292l.8 9.565 3.9-.292L15.9 4zm-1.39 8.054l.58-.051c.31-.03.583.194.611.498a.555.555 0 0 1-.509.599l-.58.051a.558.558 0 0 1-.611-.499.555.555 0 0 1 .51-.598zM7.563 12h.563c.31 0 .562.246.562.55 0 .305-.251.551-.562.551h-.563a.557.557 0 0 1-.563-.55c0-.305.252-.551.563-.551zm-5 0h.562c.311 0 .563.246.563.55 0 .305-.252.551-.563.551h-.563a.556.556 0 0 1-.562-.55c0-.305.252-.551.563-.551z",
          fill: "#394F5A",
          fillRule: "evenodd"
        }));
      },
      "section-1": function section1(_ref152) {
        var e = _ref152.className,
            _ref152$width = _ref152.width,
            t = _ref152$width === void 0 ? "9" : _ref152$width,
            _ref152$height = _ref152.height,
            a = _ref152$height === void 0 ? "12" : _ref152$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a
        }, l.a.createElement("path", {
          d: "M8.625 2.25c.207 0 .375.168.375.375v9a.375.375 0 0 1-.375.375H1.5C.673 12 0 11.327 0 10.5v-9C0 .672.673 0 1.5 0h7.125a.375.375 0 1 1 0 .75.75.75 0 0 0 0 1.5zM1.5.75a.75.75 0 0 0 0 1.5h5.83a1.476 1.476 0 0 1-.205-.75c0-.274.08-.528.208-.75H1.5zM1.5 3c-.274 0-.528-.08-.75-.209V10.5c0 .413.336.75.75.75h6.75V3H1.5z",
          fill: "#394F5A",
          fillRule: "evenodd"
        }));
      },
      "section-2": function section2(_ref153) {
        var e = _ref153.className,
            _ref153$width = _ref153.width,
            t = _ref153$width === void 0 ? "11" : _ref153$width,
            _ref153$height = _ref153.height,
            a = _ref153$height === void 0 ? "14 " : _ref153$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a
        }, l.a.createElement("path", {
          d: "M10.542 2.625c.253 0 .458.196.458.438v10.5a.448.448 0 0 1-.458.437H1.833C.823 14 0 13.215 0 12.25V1.75C0 .784.822 0 1.833 0h8.709c.253 0 .458.196.458.438a.448.448 0 0 1-.458.437c-.506 0-.917.392-.917.875 0 .482.411.875.917.875zM1.917 1C1.41 1 1 1.392 1 1.875c0 .482.411.875.917.875h7.126a1.663 1.663 0 0 1-.251-.875c0-.32.097-.616.255-.875h-7.13zm0 2.243A1.88 1.88 0 0 1 1 3v8.993c0 .482.411.875.917.875h8.25V3.243h-8.25z",
          fill: "#394F5A",
          fillRule: "evenodd"
        }));
      },
      hamburger: function hamburger(_ref154) {
        var _ref154$width = _ref154.width,
            e = _ref154$width === void 0 ? "14" : _ref154$width,
            _ref154$height = _ref154.height,
            t = _ref154$height === void 0 ? "10" : _ref154$height;
        return l.a.createElement("svg", {
          width: e,
          height: t
        }, l.a.createElement("g", {
          stroke: "#7695A5",
          fill: "none",
          fillRule: "evenodd",
          strokeLinecap: "square"
        }, l.a.createElement("path", {
          d: "M1.441.5h12M1.441 5h12M1.441 9.5h12"
        })));
      },
      meatballs: function meatballs(_ref155) {
        var e = _ref155.className,
            _ref155$width = _ref155.width,
            t = _ref155$width === void 0 ? "24" : _ref155$width,
            _ref155$height = _ref155.height,
            a = _ref155$height === void 0 ? "24" : _ref155$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 30 30",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.5 18C7.88071 18 9 16.8807 9 15.5C9 14.1193 7.88071 13 6.5 13C5.11929 13 4 14.1193 4 15.5C4 16.8807 5.11929 18 6.5 18ZM14.5 18C15.8807 18 17 16.8807 17 15.5C17 14.1193 15.8807 13 14.5 13C13.1193 13 12 14.1193 12 15.5C12 16.8807 13.1193 18 14.5 18ZM25 15.5C25 16.8807 23.8807 18 22.5 18C21.1193 18 20 16.8807 20 15.5C20 14.1193 21.1193 13 22.5 13C23.8807 13 25 14.1193 25 15.5Z",
          fill: "#353F45"
        }));
      },
      "circle-line": function circleLine(_ref156) {
        var e = _ref156.className,
            _ref156$width = _ref156.width,
            t = _ref156$width === void 0 ? "14" : _ref156$width,
            _ref156$height = _ref156.height,
            a = _ref156$height === void 0 ? "14" : _ref156$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 12 12"
        }, l.a.createElement("g", {
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          transform: "translate(-398.000000, -326.000000)",
          stroke: "#7695A5"
        }, l.a.createElement("g", {
          transform: "translate(399.000000, 284.000000)"
        }, l.a.createElement("g", {
          transform: "translate(0.000000, 43.000000)"
        }, l.a.createElement("g", null, l.a.createElement("circle", {
          strokeWidth: "0.5",
          cx: "5",
          cy: "5",
          r: "5"
        }), l.a.createElement("path", {
          d: "M2.85874548,5.07565111 L7.28264633,5.07565111",
          fill: "#D8D8D8",
          strokeLinecap: "round"
        })))))));
      },
      "circle-check-2": function circleCheck2(_ref157) {
        var e = _ref157.className,
            _ref157$width = _ref157.width,
            t = _ref157$width === void 0 ? "14" : _ref157$width,
            _ref157$height = _ref157.height,
            a = _ref157$height === void 0 ? "14" : _ref157$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 12 12"
        }, l.a.createElement("g", {
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          transform: "translate(-398.000000, -408.000000)",
          stroke: "#7695A5"
        }, l.a.createElement("g", {
          transform: "translate(399.000000, 284.000000)"
        }, l.a.createElement("g", {
          transform: "translate(0.000000, 125.000000)"
        }, l.a.createElement("g", null, l.a.createElement("circle", {
          strokeWidth: "0.5",
          cx: "5",
          cy: "5",
          r: "5"
        }), l.a.createElement("polyline", {
          strokeLinecap: "round",
          points: "2.85874548 5.07565111 4.30973174 6.54263831 7.11187993 3.4083043"
        })))))));
      },
      "circle-empty": function circleEmpty(_ref158) {
        var e = _ref158.className,
            _ref158$width = _ref158.width,
            t = _ref158$width === void 0 ? "14" : _ref158$width,
            _ref158$height = _ref158.height,
            a = _ref158$height === void 0 ? "14" : _ref158$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 12 12"
        }, l.a.createElement("g", {
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          transform: "translate(-398.000000, -283.000000)",
          stroke: "#7695A5",
          strokeWidth: "0.5"
        }, l.a.createElement("g", {
          transform: "translate(399.000000, 284.000000)"
        }, l.a.createElement("g", null, l.a.createElement("circle", {
          cx: "5",
          cy: "5",
          r: "5"
        }))))));
      },
      ticket: function ticket(_ref159) {
        var e = _ref159.className,
            _ref159$width = _ref159.width,
            t = _ref159$width === void 0 ? "32" : _ref159$width,
            _ref159$height = _ref159.height,
            a = _ref159$height === void 0 ? "22" : _ref159$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 32 22"
        }, l.a.createElement("path", {
          d: "M29 22H3c-1.654 0-3-1.345-3-2.999V3c0-1.654 1.346-3 3-3h26c1.654 0 3 1.346 3 3v16.001A3.003 3.003 0 0 1 29 22zm1-19c0-.551-.449-1-1-1H3c-.551 0-1 .449-1 1v16.001c0 .55.449.999 1 .999h26c.551 0 1-.449 1-.999V3zm-3 9h-6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zm-1-6h-4v4h4V6zM16 17H6a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2zm0-4H6a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2zm-6-5H6a1 1 0 0 1 0-2h4a1 1 0 1 1 0 2z",
          fillRule: "evenodd"
        }));
      },
      "support-bot": function supportBot(_ref160) {
        var e = _ref160.className,
            _ref160$width = _ref160.width,
            t = _ref160$width === void 0 ? "30" : _ref160$width,
            _ref160$height = _ref160.height,
            a = _ref160$height === void 0 ? "30" : _ref160$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 30 30"
        }, l.a.createElement("defs", null, l.a.createElement("path", {
          d: "M17.564 21.764H2.558A2.19 2.19 0 0 1 .393 19.56V7.23a2.19 2.19 0 0 1 2.165-2.204h1.6V3.505a.748.748 0 0 1 0-.197 1.482 1.482 0 1 1 1.417 0 .748.748 0 0 1 0 .197v1.521h8.92V3.505a.748.748 0 0 1 0-.197 1.482 1.482 0 1 1 1.416 0 .748.748 0 0 1 0 .197v1.521h1.548a2.19 2.19 0 0 1 2.164 2.204v12.29a2.19 2.19 0 0 1-2.06 2.217v.027zm.682-14.508a.682.682 0 0 0-.682-.747H2.558a.682.682 0 0 0-.682.695v12.29a.682.682 0 0 0 .682.696h15.006a.682.682 0 0 0 .682-.696V7.256zM4.866 15.69a.748.748 0 1 1 1.483 0h7.424a.748.748 0 1 1 1.482 0v1.522H4.866V15.69zm8.474-2.308a1.902 1.902 0 1 1 1.863-1.902 1.876 1.876 0 0 1-1.863 1.902zm0-2.283a.38.38 0 1 0-.026.76.38.38 0 0 0 .026-.76zm-6.558 2.283a1.902 1.902 0 1 1 1.797-1.902 1.876 1.876 0 0 1-1.797 1.902zm0-2.283a.38.38 0 1 0-.027.76.38.38 0 0 0 .027-.76z",
          id: "a"
        })), l.a.createElement("g", {
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          transform: "translate(5 6)"
        }, l.a.createElement("mask", {
          id: "b",
          fill: "#fff"
        }, l.a.createElement("use", {
          xlinkHref: "#a"
        })), l.a.createElement("use", {
          fill: "#000",
          fillRule: "nonzero",
          xlinkHref: "#a"
        }), l.a.createElement("g", {
          mask: "url(#b)",
          fill: "#394F5A"
        }, l.a.createElement("path", {
          d: "M-5-5h30v30H-5z"
        }))), l.a.createElement("path", {
          d: "M18.3 24.5c1.958-.444 3.4-.84 4.326-1.19.926-.35 2.134-.953 3.624-1.81",
          stroke: "#394F5A",
          strokeWidth: "1.5",
          strokeLinecap: "square"
        }), l.a.createElement("g", {
          fill: "#394F5A",
          fillRule: "nonzero"
        }, l.a.createElement("path", {
          d: "M26.938 15.375h-1.375a.689.689 0 0 0-.688.688v5.5c0 .378.309.687.688.687h1.375a.689.689 0 0 0 .687-.688v-5.5a.689.689 0 0 0-.688-.687zM2.375 21.563c0 .378.309.687.688.687h1.374a.689.689 0 0 0 .688-.688v-5.5a.689.689 0 0 0-.688-.687H3.063a.689.689 0 0 0-.687.688v5.5zM25.5 14.382v-.13c0-5.429-4.71-9.845-10.5-9.845S4.5 8.823 4.5 14.253v.13c.015-.006.031.314.048.958L3 15.358v-1.105C3 8.048 8.383 3 15 3c6.616 0 12 5.048 12 11.253v1.1l-1.518.015c-.001-.662.005-.99.018-.986z"
        })), l.a.createElement("circle", {
          fill: "#394F5A",
          fillRule: "nonzero",
          cx: "18",
          cy: "24.5",
          r: "1"
        })));
      },
      outreach: function outreach(_ref161) {
        var e = _ref161.className,
            t = _ref161.width,
            a = _ref161.height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 27 25",
          version: "1.1"
        }, l.a.createElement("g", {
          id: "enroll-in-outreach",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "Artboard-Copy-2",
          transform: "translate(-125.000000, -141.000000)",
          fill: "#FFFFFF"
        }, l.a.createElement("g", {
          id: "Group-7",
          transform: "translate(125.000000, 141.000000)"
        }, l.a.createElement("path", {
          d: "M11.7399564,0 C15.7828962,0 21.8918356,1.25115191 24.7355609,4.12029489 C25.4559714,4.84777061 26.3985892,6.27259517 26.3985892,8.35932516 C26.3985892,12.0693627 23.4358241,17.7615723 20.1644377,21.0631247 C18.4731927,22.7697243 15.7828962,25 12.1640904,25 C8.62640783,25 5.92464829,22.5756717 5.14251359,21.78617 C2.1462411,18.7628482 2.55795385e-13,14.1738144 2.55795385e-13,9.89491033 C2.55795385e-13,7.19500957 0.762735641,4.83359325 2.70881375,2.87091515 C4.51116247,1.05266889 7.61677511,1.57400301e-15 11.7399564,0 Z M16.7440313,14.795846 C18.1090195,13.417984 18.4767198,11.7211314 18.4767198,10.7871978 C18.4767198,10.110229 18.3003647,9.11692777 17.4609146,8.27071667 C16.1735227,6.97171617 14.747692,6.60487701 13.1966493,6.60487701 C11.2320539,6.60487701 9.91203623,7.23133905 9.03290625,8.11919614 C8.34335796,8.81477281 7.74727785,9.88427731 7.74727785,11.403913 C7.74727785,12.9226625 8.54969338,14.3900191 9.42441449,15.2716736 C10.2321207,16.0868718 11.5018771,16.6902956 12.7804513,16.6902956 C14.0590255,16.6902956 15.3790431,16.1737081 16.7440313,14.795846 Z",
          id: "Combined-Shape"
        })))));
      },
      "emoji-face": function emojiFace(_ref162) {
        var e = _ref162.className,
            _ref162$width = _ref162.width,
            t = _ref162$width === void 0 ? "24" : _ref162$width,
            _ref162$height = _ref162.height,
            a = _ref162$height === void 0 ? "24" : _ref162$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 15"
        }, l.a.createElement("path", {
          d: "M8 15c-4.411 0-8-3.364-8-7.5S3.589 0 8 0s8 3.364 8 7.5S12.411 15 8 15zM8 1.25c-3.676 0-6.667 2.804-6.667 6.25S4.324 13.75 8 13.75c3.676 0 6.667-2.804 6.667-6.25S11.676 1.25 8 1.25zM8 12.5c-1.942 0-3.705-1.094-4.601-2.856-.16-.312-.018-.685.314-.833.33-.15.73-.017.888.295C5.275 10.428 6.577 11.25 8 11.25c1.431 0 2.733-.82 3.397-2.142.156-.312.554-.447.888-.299.332.148.475.52.318.833C11.717 11.404 9.953 12.5 8 12.5zm2.667-5c-.735 0-1.334-.56-1.334-1.25S9.932 5 10.667 5C11.402 5 12 5.56 12 6.25s-.598 1.25-1.333 1.25zm-5.334 0C4.6 7.5 4 6.94 4 6.25S4.599 5 5.333 5c.736 0 1.334.56 1.334 1.25S6.069 7.5 5.333 7.5z"
        }));
      },
      expand: function expand(_ref163) {
        var e = _ref163.className,
            _ref163$width = _ref163.width,
            t = _ref163$width === void 0 ? "24" : _ref163$width,
            _ref163$height = _ref163.height,
            a = _ref163$height === void 0 ? "24" : _ref163$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a
        }, l.a.createElement("g", {
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          transform: "translate(-681.000000, -475.000000)",
          fill: "#FFFFFF"
        }, l.a.createElement("g", {
          transform: "translate(681.000000, 475.000000)"
        }, l.a.createElement("path", {
          d: "M14.343,14 L5.9742,14 C5.6442,14 5.3766,13.7386667 5.3766,13.4166667 C5.3766,13.0946667 5.6442,12.8333333 5.9742,12.8333333 L13.7454,12.8333333 L13.7454,1.16666667 L1.7436,1.16666667 L1.7436,8.75 C1.7436,9.072 1.5228,9.33333333 1.1922,9.33333333 C0.8622,9.33333333 0.5946,9.072 0.5946,8.75 L0.5946,0.583333333 C0.5946,0.261333333 0.8622,0 1.1922,0 L14.343,0 C14.673,0 14.9406,0.261333333 14.9406,0.583333333 L14.9406,13.4166667 C14.9406,13.7386667 14.673,14 14.343,14 Z M8.7162,5.25 L5.376,5.25 C5.046,5.25 4.7784,4.98866667 4.7784,4.66666667 C4.7784,4.34466667 5.046,4.08333333 5.376,4.08333333 L10.1592,4.08333333 C10.4892,4.08333333 10.7568,4.34466667 10.7568,4.66666667 L10.7568,9.33333333 C10.7568,9.65533333 10.4892,9.91666667 10.1592,9.91666667 C9.8292,9.91666667 9.5616,9.65533333 9.5616,9.33333333 L9.5616,6.07483333 L1.6152,13.8290833 C1.4982,13.9428333 1.3452,14 1.1922,14 C1.0392,14 0.8868,13.9428333 0.7698,13.8290833 C0.5364,13.6015833 0.5364,13.2323333 0.7698,13.00425 L8.7162,5.25 Z",
          id: "Shape"
        })))));
      },
      utm: function utm(_ref164) {
        var e = _ref164.className,
            _ref164$height = _ref164.height,
            t = _ref164$height === void 0 ? "8" : _ref164$height,
            _ref164$width = _ref164.width,
            a = _ref164$width === void 0 ? "15" : _ref164$width;
        return l.a.createElement("svg", {
          className: e,
          width: a,
          height: t,
          viewBox: "0 0 15 8",
          fill: "none"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.0417 0.360044H0.720058C0.521211 0.360044 0.360014 0.521242 0.360014 0.720089V6.84084C0.360014 7.03969 0.521211 7.20089 0.720059 7.20089H14.0417C14.2405 7.20089 14.4017 7.03969 14.4017 6.84084V0.720089C14.4017 0.521242 14.2405 0.360044 14.0417 0.360044ZM0.720058 0C0.322364 0 -3.05176e-05 0.322395 -3.05176e-05 0.720089V6.84084C-3.05176e-05 7.23854 0.322364 7.56093 0.720059 7.56093H14.0417C14.4394 7.56093 14.7618 7.23854 14.7618 6.84084V0.720089C14.7618 0.322395 14.4394 0 14.0417 0H0.720058Z",
          fill: "#5D6A74"
        }), l.a.createElement("path", {
          d: "M3.97691 5.58298C4.95479 5.58298 5.43365 5.02347 5.43365 4.19177V2.1604H4.83382V4.17665C4.83382 4.71096 4.53642 5.05876 3.97691 5.05876C3.4174 5.05876 3.12001 4.71096 3.12001 4.17665V2.1604H2.52017V4.19177C2.52017 5.02347 3.00407 5.58298 3.97691 5.58298Z",
          fill: "#5D6A74"
        }), l.a.createElement("path", {
          d: "M7.48165 5.5225V2.67958H8.49985V2.1604H5.87369V2.67958H6.89189V5.5225H7.48165Z",
          fill: "#5D6A74"
        }), l.a.createElement("path", {
          d: "M12.4352 5.5225V2.1604H11.6035L10.6911 4.46901L9.77372 2.1604H8.94202V5.5225H9.53177V2.92658L10.5651 5.5225H10.8171L11.8454 2.92658V5.5225H12.4352Z",
          fill: "#5D6A74"
        }));
      },
      "drift-bolt": function driftBolt(_ref165) {
        var e = _ref165.className,
            _ref165$width = _ref165.width,
            t = _ref165$width === void 0 ? "15" : _ref165$width,
            _ref165$height = _ref165.height,
            a = _ref165$height === void 0 ? "24" : _ref165$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 15 24",
          fill: "none"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.363947 8.7126L4.40694 0.427245C4.53511 0.166152 4.79937 0 5.09053 0H13.7699C14.0215 0 14.2272 0.20413 14.2272 0.457311C14.2272 0.557001 14.194 0.653525 14.1338 0.732644L8.80121 7.77425C8.6493 7.97521 8.68886 8.26162 8.88983 8.41353C8.96895 8.47366 9.06547 8.50689 9.16516 8.50689H11.2049C11.4565 8.50689 11.6622 8.71102 11.6622 8.9642C11.6622 9.06389 11.6289 9.16199 11.5688 9.24111L7.55588 14.493C7.40239 14.694 7.44036 14.9804 7.64133 15.1339C7.72045 15.194 7.81855 15.2273 7.91824 15.2273H8.19041C8.44201 15.2273 8.64772 15.4314 8.64772 15.6846C8.64772 15.8064 8.60025 15.9219 8.51322 16.0074L0.587064 23.9335C0.49845 24.0222 0.352871 24.0222 0.264258 23.9335C0.19938 23.8687 0.178809 23.769 0.215204 23.6835L2.81348 17.4442C2.91 17.2116 2.80082 16.9442 2.56821 16.8476C2.51282 16.8239 2.45269 16.8128 2.39256 16.8128H0.457309C0.20571 16.8128 0 16.6087 0 16.3555C0 16.2827 0.0174062 16.2115 0.0506362 16.1466L3.19008 10.0355C3.3056 9.81078 3.21698 9.53544 2.99229 9.41992C2.92741 9.38669 2.8562 9.36929 2.78341 9.36929H0.776949C0.525351 9.36929 0.319641 9.16516 0.319641 8.91198C0.316476 8.84394 0.3323 8.77589 0.363947 8.7126Z",
          fill: "black"
        }));
      },
      "lightning-bolt": function lightningBolt(_ref166) {
        var e = _ref166.className,
            _ref166$width = _ref166.width,
            t = _ref166$width === void 0 ? "14" : _ref166$width,
            _ref166$height = _ref166.height,
            a = _ref166$height === void 0 ? "24" : _ref166$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 14 24"
        }, l.a.createElement("path", {
          fill: "#394F5A",
          fillRule: "nonzero",
          d: "M8.61 2L2 12.148h4.848L3.91 20.623l7.492-10.482h-5.29L8.61 2zm2.792 6.14c1.627 0 2.573 1.84 1.627 3.164L5.537 21.786c-1.343 1.879-4.273.364-3.517-1.818l2.018-5.82H2c-1.588 0-2.542-1.761-1.676-3.092L6.934.908C8.2-1.034 11.204.371 10.524 2.587L8.817 8.141h2.585z"
        }));
      },
      "lightning-bolt-filled": function lightningBoltFilled(_ref167) {
        var e = _ref167.className,
            _ref167$width = _ref167.width,
            t = _ref167$width === void 0 ? "11" : _ref167$width,
            _ref167$height = _ref167.height,
            a = _ref167$height === void 0 ? "17" : _ref167$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 11 17"
        }, l.a.createElement("path", {
          fill: "#7A8A94",
          fillRule: "evenodd",
          d: "M.132 10.16l5.278-.67-3.424 7.213 8.749-10.181-5.475.695L7.502.797z"
        }));
      },
      "support-ticket": function supportTicket(_ref168) {
        var e = _ref168.className,
            _ref168$width = _ref168.width,
            t = _ref168$width === void 0 ? "28" : _ref168$width,
            _ref168$height = _ref168.height,
            a = _ref168$height === void 0 ? "28" : _ref168$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 28 28"
        }, l.a.createElement("g", {
          fill: "#394F5A",
          fillRule: "nonzero"
        }, l.a.createElement("path", {
          d: "M23.307 23.307c-5.14 5.14-13.474 5.14-18.614 0-5.14-5.14-5.14-13.474 0-18.614 5.14-5.14 13.474-5.14 18.614 0 5.14 5.14 5.14 13.474 0 18.614zm-1.414-1.414c4.359-4.36 4.359-11.427 0-15.786-4.36-4.359-11.427-4.359-15.786 0-4.359 4.36-4.359 11.427 0 15.786 4.36 4.359 11.427 4.359 15.786 0z"
        }), l.a.createElement("path", {
          d: "M17.803 17.803a5.378 5.378 0 1 1-7.606-7.606 5.378 5.378 0 0 1 7.606 7.606zM16.39 16.39a3.378 3.378 0 1 0-4.778-4.778 3.378 3.378 0 0 0 4.778 4.778z"
        }), l.a.createElement("path", {
          d: "M3.317 7.483L4.731 6.07l5.504 5.504-1.414 1.414zM15.013 19.18l1.414-1.415 5.504 5.504-1.414 1.414zM6.069 4.731l1.414-1.414 5.504 5.504-1.414 1.414zM17.765 16.427l1.414-1.414 5.504 5.504-1.414 1.414zM8.82 15.013l1.415 1.414-5.504 5.504-1.414-1.414zM20.173 3.661l1.414 1.414-5.504 5.504-1.414-1.414zM11.573 17.765l1.414 1.414-5.504 5.504-1.414-1.414zM22.925 6.413l1.414 1.414-5.504 5.504-1.414-1.414z"
        }), l.a.createElement("path", {
          d: "M6.717 2.55a4 4 0 0 0-4.342 4.243c.237 3.656.356 6.042.356 7.21 0 1.168-.119 3.555-.356 7.212a4 4 0 0 0 4.338 4.244c3.593-.312 6.004-.468 7.287-.468 1.272 0 3.651.153 7.191.46a4 4 0 0 0 4.333-4.297c-.339-4.337-.508-7.16-.508-8.53 0-1.167.121-3.059.362-5.713a4 4 0 0 0-4.33-4.346c-3.499.304-5.845.456-7.095.456-1.27 0-3.664-.158-7.236-.472zm7.236-1.53c1.173 0 3.48-.149 6.922-.448a6 6 0 0 1 6.495 6.52c-.236 2.598-.354 4.442-.354 5.532 0 1.3.168 4.09.502 8.374a6 6 0 0 1-6.5 6.445c-3.483-.301-5.822-.452-7.018-.452-1.207 0-3.578.153-7.114.46a6 6 0 0 1-6.507-6.365c.234-3.613.352-5.974.352-7.084 0-1.109-.117-3.469-.351-7.08A6 6 0 0 1 6.893.557c3.514.309 5.867.464 7.06.464z"
        })));
      },
      "question-bubble": function questionBubble(_ref169) {
        var e = _ref169.className,
            _ref169$width = _ref169.width,
            t = _ref169$width === void 0 ? "27" : _ref169$width,
            _ref169$height = _ref169.height,
            a = _ref169$height === void 0 ? "24" : _ref169$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 27 24"
        }, l.a.createElement("defs", null, l.a.createElement("path", {
          id: "a",
          d: "M13.091 20.727h-1.565C9.391 23.831 4.607 23.994 4.393 24h-.028a1.093 1.093 0 0 1-.853-1.771c.017-.022 1.568-1.994 1.874-4.058C2.67 16.811.001 13.937.001 10.322.001 4.631 5.873.001 13.092.001c7.219 0 13.091 4.63 13.091 10.321 0 5.738-5.872 10.406-13.091 10.406l-.001-.001zm0-18.545c-6.015 0-10.909 3.651-10.909 8.139 0 2.797 2.39 5.212 4.751 6.154.415.166.686.567.686 1.013 0 1.448-.515 2.864-1.069 3.967 1.261-.346 2.719-1.018 3.389-2.319.188-.362.562-.59.97-.59h2.182c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139v-.001zm1.091 9.617V12a.919.919 0 0 1-.07.341 1.148 1.148 0 0 1-.247.433c-.053.05-.123.08-.185.12a1.18 1.18 0 0 1-.589.197.912.912 0 0 1-.339-.069 1.144 1.144 0 0 1-.435-.248 1.173 1.173 0 0 1-.248-.434A.954.954 0 0 1 12 12v-1.091c0-.602.489-1.091 1.091-1.091.601 0 1.091-.49 1.091-1.091s-.49-1.091-1.091-1.091S12 8.126 12 8.727a1.092 1.092 0 0 1-2.182 0 3.277 3.277 0 0 1 3.273-3.273 3.276 3.276 0 0 1 3.273 3.273c0 1.42-.915 2.62-2.182 3.072zm-.317 2.699c.196.207.316.491.316.775 0 .284-.12.567-.316.775a1.148 1.148 0 0 1-.775.316 1.15 1.15 0 0 1-.775-.316 1.148 1.148 0 0 1-.316-.775c0-.284.12-.567.316-.775.415-.404 1.145-.404 1.549 0h.001z"
        })), l.a.createElement("g", {
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("mask", {
          id: "b",
          fill: "#fff"
        }, l.a.createElement("use", {
          xlinkHref: "#a"
        })), l.a.createElement("use", {
          fill: "#000",
          fillRule: "nonzero",
          xlinkHref: "#a"
        }), l.a.createElement("g", {
          fill: "#394F5A",
          mask: "url(#b)"
        }, l.a.createElement("path", {
          d: "M-2-3h30v30H-2z"
        }))));
      },
      linkedin: function linkedin(_ref170) {
        var e = _ref170.className,
            _ref170$width = _ref170.width,
            t = _ref170$width === void 0 ? "30" : _ref170$width,
            _ref170$height = _ref170.height,
            a = _ref170$height === void 0 ? "30" : _ref170$height;
        return l.a.createElement("svg", {
          width: t,
          height: a,
          viewBox: "0 0 30 30",
          className: e
        }, l.a.createElement("defs", null, l.a.createElement("path", {
          d: "M0.740055504,6.12765957 L4.56984274,6.12765957 L4.56984274,18 L0.740055504,18 L0.740055504,6.12765957 Z M10.6975023,11.106383 L10.6975023,18 L6.86771508,18 L6.86771508,8.80851064 C6.86771508,8.80851064 6.80388529,6.53191489 6.80388529,6.12765957 L10.5698427,6.12765957 L10.6975023,7.76595745 C11.4634598,6.61702128 12.6123959,5.74468085 14.1443108,5.74468085 C16.8251619,5.74468085 18.7400555,7.65957447 18.7400555,11.106383 L18.7400555,18 L14.9102683,18 L14.9102683,11.4893617 C14.9102683,9.57446809 13.9740981,8.80851064 12.8251619,8.80851064 C11.6762257,8.80851064 10.6975023,9.57446809 10.6975023,11.106383 Z M2.63367253,4.21276596 L2.61239593,4.21276596 C1.2506938,4.21276596 0.357076781,3.27659574 0.357076781,2.10638298 C0.357076781,0.914893617 1.2719704,0 2.67622572,0 C4.05920444,0 4.93154487,0.914893617 4.95282146,2.10638298 C4.95282146,3.27659574 4.05920444,4.21276596 2.63367253,4.21276596 Z",
          id: "path-linkedin"
        })), l.a.createElement("g", {
          id: "icon/linkedin",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "color/navy-extra-dark",
          transform: "translate(6.000000, 6.000000)"
        }, l.a.createElement("mask", {
          id: "mask-2",
          fill: "white"
        }, l.a.createElement("use", {
          xlinkHref: "#path-linkedin"
        })), l.a.createElement("use", {
          id: "Mask",
          fill: "#394F5A",
          xlinkHref: "#path-linkedin"
        }))));
      },
      twitter: function twitter(_ref171) {
        var e = _ref171.className,
            _ref171$width = _ref171.width,
            t = _ref171$width === void 0 ? "30" : _ref171$width,
            _ref171$height = _ref171.height,
            a = _ref171$height === void 0 ? "30" : _ref171$height;
        return l.a.createElement("svg", {
          width: t,
          height: a,
          viewBox: "0 0 30 30",
          className: e
        }, l.a.createElement("defs", null, l.a.createElement("path", {
          d: "M18.6667153,1.79321455 C18.1481954,2.57099435 17.5000456,3.24074918 16.7654758,3.78087405 C16.7654758,3.95371401 16.7654758,4.10494897 16.7654758,4.27778892 C16.7654758,9.33335765 12.9197867,15.1667062 5.87655852,15.1667062 C3.71605907,15.1667062 1.68518958,14.6913963 0,13.6111466 C0.302469924,13.6543566 0.604939848,13.6759616 0.907409772,13.6759616 C2.70062432,13.6759616 4.3642089,12.8981818 5.66050858,11.861142 C3.99692399,11.839537 2.57099435,10.7160773 2.09568447,9.20372768 C2.33333941,9.24693767 2.57099435,9.26854267 2.80864929,9.26854267 C3.15432921,9.26854267 3.50000912,9.22533268 3.82408404,9.1389127 C2.07407948,8.79323279 0.75617481,7.23767318 0.75617481,5.37964365 C0.75617481,5.35803865 0.75617481,5.35803865 0.75617481,5.33643366 C1.27469468,5.61729859 1.85802953,5.79013854 2.48457437,5.81174354 C1.44753464,5.12038371 0.777779804,3.95371401 0.777779804,2.63580934 C0.777779804,1.92284452 0.972224755,1.33950966 1.29629967,0.777779804 C3.1975392,3.08951422 6.00618849,4.53704886 9.18212269,4.70988882 C9.11730771,4.42902389 9.09570271,4.12655396 9.09570271,3.82408404 C9.09570271,1.70679457 10.8024973,0 12.9197867,0 C14.0216415,0 15.0154712,0.47530988 15.728436,1.2098797 C16.5926358,1.03703974 17.4136256,0.712964821 18.1481954,0.280864929 C17.8673305,1.16666971 17.2623907,1.92284452 16.4630059,2.3981544 C17.2407857,2.31173442 17.9753555,2.09568447 18.6667153,1.79321455 Z",
          id: "path-twitter"
        })), l.a.createElement("g", {
          id: "icon/twitter",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "color/navy-extra-dark",
          transform: "translate(6.000000, 9.000000)"
        }, l.a.createElement("mask", {
          id: "mask-2",
          fill: "white"
        }, l.a.createElement("use", {
          xlinkHref: "#path-twitter"
        })), l.a.createElement("use", {
          id: "Mask",
          fill: "#394F5A",
          xlinkHref: "#path-twitter"
        }))));
      },
      facebook: function facebook(_ref172) {
        var e = _ref172.className,
            _ref172$width = _ref172.width,
            t = _ref172$width === void 0 ? "30" : _ref172$width,
            _ref172$height = _ref172.height,
            a = _ref172$height === void 0 ? "30" : _ref172$height;
        return l.a.createElement("svg", {
          width: t,
          height: a,
          viewBox: "0 0 30 30",
          className: e
        }, l.a.createElement("defs", null, l.a.createElement("path", {
          d: "M2.33333941,18.6667153 L2.33333941,10.1111375 L0,10.1111375 L0,7.00001824 L2.33333941,7.00001824 L2.33333941,4.27778892 C2.33333941,2.07407948 3.71605907,0 7.00001824,0 C8.31792291,0 9.33335765,0.172839957 9.33335765,0.172839957 L9.20372768,3.11111922 L7.19446319,3.11111922 C6.00618849,3.11111922 5.83334853,3.75926905 5.83334853,4.66667883 L5.83334853,7.00001824 L9.33335765,7.00001824 L9.09570271,10.1111375 L5.83334853,10.1111375 L5.83334853,18.6667153 L2.33333941,18.6667153 Z",
          id: "path-facebook"
        })), l.a.createElement("g", {
          id: "icon/facebook",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "color/navy-extra-dark",
          transform: "translate(10.000000, 6.000000)"
        }, l.a.createElement("mask", {
          id: "mask-2",
          fill: "white"
        }, l.a.createElement("use", {
          xlinkHref: "#path-facebook"
        })), l.a.createElement("use", {
          id: "Mask",
          fill: "#394F5A",
          xlinkHref: "#path-facebook"
        }))));
      },
      marketo: function marketo(_ref173) {
        var e = _ref173.className,
            _ref173$width = _ref173.width,
            t = _ref173$width === void 0 ? "16" : _ref173$width,
            _ref173$height = _ref173.height,
            a = _ref173$height === void 0 ? "16" : _ref173$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.55038 0V15.9876L13.631 12.7256V2.22016L9.55038 0Z",
          fill: "#563E94"
        }), l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.65272 12.49L4.34109 13.9287V1.36438L7.65272 2.34422V12.49Z",
          fill: "#563E94"
        }), l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 12.1799L2.50543 11.5225V3.49773L0 3.10083V12.1799Z",
          fill: "#563E94"
        }));
      },
      pardot: function pardot(_ref174) {
        var e = _ref174.className,
            _ref174$width = _ref174.width,
            t = _ref174$width === void 0 ? "16" : _ref174$width,
            _ref174$height = _ref174.height,
            a = _ref174$height === void 0 ? "16" : _ref174$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("mask", {
          id: "mask0",
          "mask-type": "alpha",
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "2",
          width: "16",
          height: "12"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 2.03308H15.997V13.7334H0",
          fill: "white"
        })), l.a.createElement("g", {
          mask: "url(#mask0)"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.65686 3.30909C7.1727 2.7475 7.89094 2.3991 8.68538 2.3991C9.74149 2.3991 10.6626 3.0143 11.1533 3.9277C11.5798 3.72872 12.0517 3.61791 12.5482 3.61791C14.4528 3.61791 15.997 5.2455 15.997 7.25314C15.997 9.26108 14.4528 10.8887 12.5482 10.8887C12.3157 10.8887 12.0886 10.8641 11.8687 10.8179C11.4368 11.623 10.6135 12.1672 9.66838 12.1672C9.27293 12.1672 8.89887 12.0718 8.56549 11.9018C8.12771 12.9784 7.10709 13.7333 5.91792 13.7333C4.67935 13.7333 3.62371 12.9145 3.21862 11.766C3.04158 11.805 2.85797 11.8257 2.66988 11.8257C1.1953 11.8257 0 10.5636 0 9.00677C0 7.96318 0.536753 7.05221 1.33492 6.56477C1.17062 6.16947 1.07939 5.73365 1.07939 5.27523C1.07939 3.48475 2.47053 2.03308 4.18633 2.03308C5.19379 2.03308 6.08908 2.53349 6.65686 3.30909Z",
          fill: "#129CD8"
        })));
      },
      sixsense: function sixsense(_ref175) {
        var e = _ref175.className,
            _ref175$width = _ref175.width,
            t = _ref175$width === void 0 ? "16" : _ref175$width,
            _ref175$height = _ref175.height,
            a = _ref175$height === void 0 ? "16" : _ref175$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 32 32",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("path", {
          d: "M7.62048 28.3461L11.373 23.997C10.6033 22.7269 10.3723 21.1104 10.9689 19.6094C11.7579 17.5696 13.74 16.3765 15.9145 16.5112C16.4726 16.5496 17.0114 16.6844 17.5118 16.896L21.2836 12.5277C20.1867 11.8349 18.9551 11.3346 17.7042 11.0844C19.0513 9.44869 23.9007 3.84875 23.9007 3.84875L19.6093 0C19.6093 0 13.1434 7.67827 10.9689 10.3532C9.67956 11.9504 8.37098 13.5476 7.08165 15.1449C5.42669 17.1847 4.75315 20.1675 5.0803 22.7846C5.36895 24.9207 6.29266 26.8258 7.62048 28.3461Z",
          fill: "#00B3B0"
        }), l.a.createElement("path", {
          d: "M25.2285 17.0885C24.7859 16.0108 24.1123 15.0101 23.2849 14.1634L19.5516 18.4933C20.3021 19.4939 20.6869 20.7833 20.4945 22.0919C20.1289 24.6898 17.5502 26.8258 14.8753 26.3255C14.2788 26.2485 13.7399 26.0561 13.2396 25.7867L9.5448 30.0588C11.9503 31.733 15.01 32.445 18.0505 31.7137C24.3817 30.1742 27.9034 23.054 25.2285 17.0885Z",
          fill: "#0C070B"
        }));
      },
      demandbase: function demandbase(_ref176) {
        var e = _ref176.className,
            _ref176$width = _ref176.width,
            t = _ref176$width === void 0 ? "16" : _ref176$width,
            _ref176$height = _ref176.height,
            a = _ref176$height === void 0 ? "16" : _ref176$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 23 32",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.130889 22.8982V13.736L2.98329 12.069C4.41567 11.1676 5.97152 10.402 6.08265 10.3773C6.34196 10.3773 6.49014 12.1554 6.49014 18.4406V26.5286L9.97723 26.4051C12.7062 26.2693 13.8792 26.1705 14.5337 25.8124C16.0895 24.9727 16.2254 24.1824 16.2254 16.0698C16.2254 12.0196 16.2254 8.38927 16.0895 7.94474C15.9537 7.50021 15.4351 6.87046 14.9288 6.47532C14.0274 5.80853 13.7681 5.80853 6.99518 5.68505L0 5.56157V0L7.6311 0.129655C14.9288 0.260544 15.5833 0.286475 17.1268 0.917461C18.2875 1.3447 19.4729 2.08559 20.2385 2.9623C22.4488 5.09358 22.5723 5.9209 22.5723 16.034C22.5723 25.6654 22.4488 26.6286 20.6213 28.7154C18.4233 31.4073 15.8302 32 6.60004 32H0L0.130889 22.8501V22.8982Z",
          fill: "#00548F"
        }));
      },
      lock: function lock(_ref177) {
        var e = _ref177.className,
            _ref177$width = _ref177.width,
            t = _ref177$width === void 0 ? "30" : _ref177$width,
            _ref177$height = _ref177.height,
            a = _ref177$height === void 0 ? "30" : _ref177$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 16"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.4074 13.7777H4.66667C3.8703 13.7777 3.22223 13.1301 3.22223 12.3333V7.51846C3.22223 6.72209 3.8703 6.07402 4.66667 6.07402H5.14815V5.11106C5.14815 3.51832 6.44382 2.22217 8.03704 2.22217C9.63027 2.22217 10.9259 3.51832 10.9259 5.11106V6.07402H11.4074C12.2038 6.07402 12.8519 6.72209 12.8519 7.51846V12.3333C12.8519 13.1301 12.2038 13.7777 11.4074 13.7777ZM8.03704 3.18513C6.9749 3.18513 6.11112 4.04891 6.11112 5.11106V6.07402H9.96297V5.11106C9.96297 4.04891 9.09919 3.18513 8.03704 3.18513ZM11.8889 7.51846C11.8889 7.25269 11.6727 7.03698 11.4074 7.03698H4.66667C4.40138 7.03698 4.18519 7.25269 4.18519 7.51846V12.3333C4.18519 12.5986 4.40138 12.8148 4.66667 12.8148H11.4074C11.6727 12.8148 11.8889 12.5986 11.8889 12.3333V7.51846Z"
        }), l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.03704 2.44444C6.56657 2.44444 5.37037 3.64108 5.37037 5.11111V6.2963H4.66667C3.99303 6.2963 3.44444 6.84488 3.44444 7.51852V12.3333C3.44444 13.0074 3.99298 13.5556 4.66667 13.5556H11.4074C12.0811 13.5556 12.6296 13.0074 12.6296 12.3333V7.51852C12.6296 6.84488 12.081 6.2963 11.4074 6.2963H10.7037V5.11111C10.7037 3.64108 9.50751 2.44444 8.03704 2.44444ZM4.92593 5.11111C4.92593 3.39566 6.32106 2 8.03704 2C9.75301 2 11.1481 3.39566 11.1481 5.11111V5.85185H11.4074C12.3265 5.85185 13.0741 6.59942 13.0741 7.51852V12.3333C13.0741 13.253 12.3265 14 11.4074 14H4.66667C3.74761 14 3 13.253 3 12.3333V7.51852C3 6.59942 3.74757 5.85185 4.66667 5.85185H4.92593V5.11111ZM5.88889 5.11111C5.88889 3.92623 6.85216 2.96296 8.03704 2.96296C9.22192 2.96296 10.1852 3.92623 10.1852 5.11111V6.2963H5.88889V5.11111ZM8.03704 3.40741C7.09762 3.40741 6.33333 4.17169 6.33333 5.11111V5.85185H9.74074V5.11111C9.74074 4.17169 8.97646 3.40741 8.03704 3.40741ZM3.96296 7.51852C3.96296 7.12987 4.27879 6.81481 4.66667 6.81481H11.4074C11.7953 6.81481 12.1111 7.12987 12.1111 7.51852V12.3333C12.1111 12.7214 11.7954 13.037 11.4074 13.037H4.66667C4.27864 13.037 3.96296 12.7214 3.96296 12.3333V7.51852ZM4.66667 7.25926C4.52396 7.25926 4.40741 7.37562 4.40741 7.51852V12.3333C4.40741 12.4759 4.5241 12.5926 4.66667 12.5926H11.4074C11.55 12.5926 11.6667 12.4759 11.6667 12.3333V7.51852C11.6667 7.37562 11.5501 7.25926 11.4074 7.25926H4.66667Z"
        }));
      },
      "fork-arrows": function forkArrows(_ref178) {
        var e = _ref178.width,
            t = _ref178.height,
            a = _ref178.className;
        return l.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: e,
          height: t,
          className: a,
          viewBox: "0 0 25 24"
        }, l.a.createElement("path", {
          fill: "#394F5A",
          fillRule: "evenodd",
          d: "M24.808 1v4.981c0 .55-.444.997-.992.997a.996.996 0 0 1-.993-.997V3.404l-5.836 5.858a10.572 10.572 0 0 0-3.097 7.507v6.148c0 .55-.444.997-.993.997-.548 0-.959-.424-.959-.974v-5.701c-.01-.056-.033-.107-.033-.165v-.305c0-.084.011-.167.012-.251-.106-2.693-1.211-5.35-3.109-7.256L2.973 3.405v2.576c0 .55-.445.997-.993.997a.996.996 0 0 1-.993-.997V1.002a1 1 0 0 1 .282-.693c.004-.004.005-.01.009-.013a.982.982 0 0 1 .323-.215.983.983 0 0 1 .373-.076L1.98.004h4.963c.548 0 .992.445.992.996 0 .55-.444.996-.992.996H4.375l5.836 5.858a12.573 12.573 0 0 1 2.686 3.997 12.592 12.592 0 0 1 2.687-3.997l5.836-5.858h-2.567A.994.994 0 0 1 17.861 1c0-.551.444-.996.992-.996h4.963c.012 0 .021.006.033.006a.997.997 0 0 1 .345.07.996.996 0 0 1 .538.54c.042.102.057.21.064.318.001.021.012.04.012.062z"
        }));
      },
      "chat-solid-1": function chatSolid1(_ref179) {
        var e = _ref179.className,
            _ref179$width = _ref179.width,
            t = _ref179$width === void 0 ? "20" : _ref179$width,
            _ref179$height = _ref179.height,
            a = _ref179$height === void 0 ? "20" : _ref179$height;
        return l.a.createElement("svg", {
          width: t,
          height: a,
          viewBox: "0 0 25 23",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("path", {
          d: "M4.583 14.894l-3.256 3.78c-.7.813-1.26.598-1.25-.46a10689.413 10689.413 0 0 1 .035-4.775V4.816a3.89 3.89 0 0 1 3.88-3.89h12.064a3.885 3.885 0 0 1 3.882 3.89v6.185a3.89 3.89 0 0 1-3.882 3.89H4.583z",
          fill: "#7695a5",
          fillRule: "evenodd"
        }));
      },
      "chat-solid-2": function chatSolid2(_ref180) {
        var e = _ref180.className,
            _ref180$width = _ref180.width,
            t = _ref180$width === void 0 ? "20" : _ref180$width,
            _ref180$height = _ref180.height,
            a = _ref180$height === void 0 ? "20" : _ref180$height;
        return l.a.createElement("svg", {
          width: t,
          height: a,
          viewBox: "0 0 25 23",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("path", {
          d: "M24.516 9.953C24.516 4.453 19.04 0 12.258 0 5.476 0 0 4.452 0 9.953c0 3.318 1.986 6.24 5.05 8.053-.34 2.552-1.815 4.055-1.844 4.084-.14.14-.17.368-.113.567a.524.524 0 0 0 .482.312c2.95 0 5.335-1.93 6.612-3.206.652.086 1.362.142 2.07.142 6.783 0 12.26-4.452 12.26-9.953z",
          fill: "#7695a5",
          fillRule: "evenodd"
        }));
      },
      "chat-outline-1": function chatOutline1(_ref181) {
        var e = _ref181.className,
            _ref181$width = _ref181.width,
            t = _ref181$width === void 0 ? "20" : _ref181$width,
            _ref181$height = _ref181.height,
            a = _ref181$height === void 0 ? "20" : _ref181$height;
        return l.a.createElement("svg", {
          width: t,
          height: a,
          viewBox: "0 0 25 23",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("path", {
          d: "M22.814 12.25h-1.362v3.063a1.02 1.02 0 0 1-1.744.72L15.92 12.25H11.92c-.94 0-1.703-.785-1.703-1.75V1.75c0-.965.764-1.75 1.703-1.75h10.896c.938 0 1.702.785 1.702 1.75v8.75c0 .965-.764 1.75-1.702 1.75zm-.34-10.208H12.257v8.166h4.086a1.032 1.032 0 0 1 .723.3l2.342 2.34v-1.62c0-.562.456-1.02 1.02-1.02h2.043V2.042zM8.17 10.208h-6.13v8.167h2.044c.564 0 1.022.457 1.022 1.02v1.62l2.34-2.34a1.022 1.022 0 0 1 .724-.3h4.086V14.29a1.02 1.02 0 0 1 2.043 0v4.377c0 .965-.763 1.75-1.702 1.75H8.595L4.808 24.2a1.022 1.022 0 0 1-1.743-.72v-3.063H1.702c-.938 0-1.702-.785-1.702-1.75v-8.75c0-.965.764-1.75 1.702-1.75h6.47a1.022 1.022 0 0 1 0 2.04z",
          fill: "#7695a5",
          fillRule: "evenodd"
        }));
      },
      "chat-outline-2": function chatOutline2(_ref182) {
        var e = _ref182.className,
            _ref182$width = _ref182.width,
            t = _ref182$width === void 0 ? "20" : _ref182$width,
            _ref182$height = _ref182.height,
            a = _ref182$height === void 0 ? "20" : _ref182$height;
        return l.a.createElement("svg", {
          width: t,
          height: a,
          viewBox: "0 0 25 23",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("path", {
          d: "M23.295 24.412a.987.987 0 0 1-1.123-.43L19.9 20.358H9.527c-1.392 0-2.523-1.153-2.523-2.57V16.3c0-.563.448-1.02 1-1.02.553 0 1 .457 1 1.02v1.485c0 .295.235.533.523.533h10.92c.036 0 .067.018.103.022a.96.96 0 0 1 .527.224.984.984 0 0 1 .14.15c.023.026.054.043.073.075l.725 1.154V9.7a.528.528 0 0 0-.523-.532h-1.48c-.55 0-1-.457-1-1.02 0-.56.45-1.018 1-1.018h1.48c1.392 0 2.524 1.152 2.524 2.57V23.433c0 .452-.293.85-.72.978zM14.49 13.226H4.116L1.844 16.85a.997.997 0 0 1-1.124.43 1.017 1.017 0 0 1-.72-.978V2.57C0 1.152 1.132 0 2.523 0H14.49c1.39 0 2.52 1.152 2.52 2.57v8.085c0 1.418-1.13 2.57-2.52 2.57zm.52-10.656a.528.528 0 0 0-.52-.532H2.522c-.288 0-.522.24-.522.532v10.242l.726-1.153c.02-.032.05-.05.07-.076a.897.897 0 0 1 .296-.256.92.92 0 0 1 .372-.118c.037-.004.068-.022.104-.022h10.92c.288 0 .522-.238.522-.533V2.57z",
          fill: "#7695a5",
          fillRule: "evenodd"
        }));
      },
      "available-blue": function availableBlue(_ref183) {
        var e = _ref183.className,
            _ref183$width = _ref183.width,
            t = _ref183$width === void 0 ? "14" : _ref183$width,
            _ref183$height = _ref183.height,
            a = _ref183$height === void 0 ? "16" : _ref183$height;
        return l.a.createElement("svg", {
          className: e,
          xmlns: "http://www.w3.org/2000/svg",
          width: t,
          height: t,
          viewBox: "0 0 8 8"
        }, l.a.createElement("g", {
          fill: "none"
        }, l.a.createElement("circle", {
          cx: "4",
          cy: "4",
          r: "4",
          fill: "#0071EB"
        }), l.a.createElement("path", {
          fill: "#FFFFFF",
          d: "M2.49 4l-.53.68 1.753 1.4 2.403-2.988-.673-.543-1.869 2.338z"
        })));
      },
      "available-white": function availableWhite(_ref184) {
        var e = _ref184.className,
            _ref184$width = _ref184.width,
            t = _ref184$width === void 0 ? "14" : _ref184$width,
            _ref184$height = _ref184.height,
            a = _ref184$height === void 0 ? "16" : _ref184$height;
        return l.a.createElement("svg", {
          className: e,
          xmlns: "http://www.w3.org/2000/svg",
          width: t,
          height: a,
          viewBox: "0 0 12 12"
        }, l.a.createElement("g", {
          fill: "none"
        }, l.a.createElement("circle", {
          cx: "6",
          cy: "6",
          r: "6",
          fill: "#F4F9FF"
        }), l.a.createElement("path", {
          fill: "#0071EB",
          d: "M3.735 6L2.94 7.02l2.63 2.101 3.603-4.484-1.01-.813L5.362 7.33z"
        })));
      },
      "away-grey": function awayGrey(_ref185) {
        var e = _ref185.className,
            _ref185$width = _ref185.width,
            t = _ref185$width === void 0 ? "14" : _ref185$width,
            _ref185$height = _ref185.height,
            a = _ref185$height === void 0 ? "16" : _ref185$height;
        return l.a.createElement("svg", {
          className: e,
          xmlns: "http://www.w3.org/2000/svg",
          width: t,
          height: a,
          viewBox: "0 0 12 12"
        }, l.a.createElement("g", {
          fill: "none"
        }, l.a.createElement("circle", {
          cx: "6",
          cy: "6",
          r: "6",
          fill: "#687882"
        }), l.a.createElement("path", {
          stroke: "#D6DDE1",
          d: "M3 6h6"
        })));
      },
      "away-white": function awayWhite(_ref186) {
        var e = _ref186.className,
            _ref186$width = _ref186.width,
            t = _ref186$width === void 0 ? "14" : _ref186$width,
            _ref186$height = _ref186.height,
            a = _ref186$height === void 0 ? "16" : _ref186$height;
        return l.a.createElement("svg", {
          className: e,
          xmlns: "http://www.w3.org/2000/svg",
          width: t,
          height: a,
          viewBox: "0 0 8 8"
        }, l.a.createElement("g", {
          fill: "none"
        }, l.a.createElement("circle", {
          cx: "4",
          cy: "4",
          r: "4",
          fill: "#687882"
        }), l.a.createElement("path", {
          stroke: "#FFF",
          d: "M2 4h4"
        })));
      },
      "chat-limit-white": function chatLimitWhite(_ref187) {
        var e = _ref187.className,
            _ref187$width = _ref187.width,
            t = _ref187$width === void 0 ? "14" : _ref187$width,
            _ref187$height = _ref187.height,
            a = _ref187$height === void 0 ? "16" : _ref187$height;
        return l.a.createElement("svg", {
          className: e,
          xmlns: "http://www.w3.org/2000/svg",
          width: t,
          height: a,
          viewBox: "0 0 12 12"
        }, l.a.createElement("g", {
          fill: "none",
          transform: "translate(-.617 -.559)"
        }, l.a.createElement("circle", {
          cx: "6.617",
          cy: "6.559",
          r: "6",
          fill: "#FFFBF0"
        }), l.a.createElement("path", {
          fill: "#F4B806",
          d: "M7.179 7.717H5.9l-.224-4.05h1.717l-.214 4.05zm-.635 2.278a.889.889 0 0 1-.877-.878c0-.466.401-.868.877-.868s.868.402.868.868a.88.88 0 0 1-.868.878z"
        })));
      },
      "chat-limit-yellow": function chatLimitYellow(_ref188) {
        var e = _ref188.className,
            _ref188$width = _ref188.width,
            t = _ref188$width === void 0 ? "14" : _ref188$width,
            _ref188$height = _ref188.height,
            a = _ref188$height === void 0 ? "16" : _ref188$height;
        return l.a.createElement("svg", {
          className: e,
          xmlns: "http://www.w3.org/2000/svg",
          width: t,
          height: a,
          viewBox: "0 0 8 8"
        }, l.a.createElement("g", {
          fill: "none"
        }, l.a.createElement("circle", {
          cx: "4",
          cy: "4",
          r: "4",
          fill: "#F4B806"
        }), l.a.createElement("path", {
          fill: "#FFFFFF",
          d: "M4.374 4.772h-.852l-.15-2.7h1.145l-.143 2.7zm-.423 1.519a.592.592 0 0 1-.585-.585c0-.311.268-.579.585-.579.317 0 .579.268.579.579a.587.587 0 0 1-.579.585z"
        })));
      },
      move: function move(_ref189) {
        var e = _ref189.className,
            _ref189$width = _ref189.width,
            t = _ref189$width === void 0 ? "20" : _ref189$width,
            _ref189$height = _ref189.height,
            a = _ref189$height === void 0 ? "20" : _ref189$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 30 30"
        }, l.a.createElement("path", {
          d: "M23.578,11.579c-0.489-0.49-1.327-0.143-1.327,0.55v1.976h-6.355V7.749h1.976 c0.693,0,1.04-0.838,0.551-1.328L15,3l-3.421,3.421c-0.49,0.49-0.143,1.328,0.55,1.328h1.976v6.355H7.749v-1.976 c0-0.693-0.838-1.04-1.328-0.55L3,15l3.421,3.422c0.49,0.489,1.328,0.143,1.328-0.551v-1.976h6.355v6.355h-1.976 c-0.693,0-1.04,0.838-0.55,1.327L15,27l3.422-3.422c0.489-0.489,0.143-1.327-0.551-1.327h-1.976v-6.355h6.355v1.976 c0,0.693,0.838,1.04,1.327,0.551L27,15L23.578,11.579z"
        }));
      },
      "video-play": function videoPlay(_ref190) {
        var e = _ref190.className,
            _ref190$width = _ref190.width,
            t = _ref190$width === void 0 ? "17" : _ref190$width,
            _ref190$height = _ref190.height,
            a = _ref190$height === void 0 ? "17" : _ref190$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 17 17"
        }, l.a.createElement("g", {
          id: "Symbols",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("path", {
          d: "M8.5,16.625 C4.01268641,16.625 0.375,12.9873136 0.375,8.5 C0.375,4.01268641 4.01268641,0.375 8.5,0.375 C12.9873136,0.375 16.625,4.01268641 16.625,8.5 C16.625,12.9873136 12.9873136,16.625 8.5,16.625 Z M8.5,15.375 C12.2969577,15.375 15.375,12.2969577 15.375,8.5 C15.375,4.70304235 12.2969577,1.625 8.5,1.625 C4.70304235,1.625 1.625,4.70304235 1.625,8.5 C1.625,12.2969577 4.70304235,15.375 8.5,15.375 Z M6.375,6.87780195 C6.375,6.67587414 6.42934923,6.47766852 6.53234483,6.30398276 C6.84925642,5.76956156 7.539398,5.59323519 8.07381919,5.91014678 L11.3136913,7.83138983 C11.4759053,7.92758273 11.6113343,8.06301172 11.7075272,8.22522581 C12.0244388,8.759647 11.8481125,9.44978858 11.3136913,9.76670017 L8.07381919,11.6879432 C7.90013343,11.7909388 7.70192781,11.8452881 7.5,11.8452881 C6.87867966,11.8452881 6.375,11.3416084 6.375,10.7202881 L6.375,6.87780195 Z M7.625,10.5008376 L10.4948036,8.799045 L7.625,7.09725244 L7.625,10.5008376 Z",
          id: "Combined-Shape",
          fill: "#353F45",
          fillRule: "nonzero"
        })));
      },
      "warning-triangle-filled": function warningTriangleFilled(_ref191) {
        var e = _ref191.className,
            _ref191$width = _ref191.width,
            t = _ref191$width === void 0 ? "16" : _ref191$width,
            _ref191$height = _ref191.height,
            a = _ref191$height === void 0 ? "16" : _ref191$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 16 16"
        }, l.a.createElement("g", {
          id: "Symbols",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "Modal/Icons/Warning",
          fill: "#353F45"
        }, l.a.createElement("path", {
          d: "M15.8184672,13.5925926 C16.0777998,14.1111111 16.059276,14.7222222 15.762896,15.2037037 C15.4479922,15.7037037 14.9108034,16 14.3365671,16 L1.66632076,16 C1.09208445,16 0.554895646,15.7037037 0.239991863,15.2037037 C-0.0563881676,14.7222222 -0.0749119195,14.1111111 0.165896856,13.5925926 L6.50102001,0.925925926 C6.79740004,0.351851852 7.37163635,0 8.00144392,0 C8.63125148,0 9.20548779,0.351851852 9.48334407,0.925925926 L15.8184672,13.5925926 Z M7.00116132,4.33333333 L7.00116132,10 L9.00172652,10 L9.00172652,4.33333333 L7.00116132,4.33333333 Z M8.00144392,14.3333333 C8.742394,14.3333333 9.33515406,13.7407407 9.33515406,13 C9.33515406,12.2592593 8.742394,11.6666667 8.00144392,11.6666667 C7.26049384,11.6666667 6.66773378,12.2592593 6.66773378,13 C6.66773378,13.7407407 7.26049384,14.3333333 8.00144392,14.3333333 Z",
          id: "Icon"
        }))));
      },
      "app-switch": function appSwitch(_ref192) {
        var e = _ref192.className,
            _ref192$width = _ref192.width,
            t = _ref192$width === void 0 ? "18" : _ref192$width,
            _ref192$height = _ref192.height,
            a = _ref192$height === void 0 ? "18" : _ref192$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 18 18"
        }, l.a.createElement("g", {
          fill: "#C1CCD2",
          fillRule: "evenodd"
        }, l.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          rx: 1
        }), l.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          x: 7,
          rx: 1
        }), l.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          x: 14,
          rx: 1
        }), l.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          y: 7,
          rx: 1
        }), l.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          x: 7,
          y: 7,
          rx: 1
        }), l.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          x: 14,
          y: 7,
          rx: 1
        }), l.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          y: 14,
          rx: 1
        }), l.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          x: 7,
          y: 14,
          rx: 1
        }), l.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          x: 14,
          y: 14,
          rx: 1
        })));
      },
      "graduation-cap": function graduationCap(_ref193) {
        var e = _ref193.className,
            _ref193$width = _ref193.width,
            t = _ref193$width === void 0 ? "18" : _ref193$width,
            _ref193$height = _ref193.height,
            a = _ref193$height === void 0 ? "16" : _ref193$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 18 16"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          d: "M16.839 13.32c-.64 0-1.162-.52-1.162-1.159 0-.427.236-.797.581-.999v-4.38l-2.334 1.332c.002.02.011.036.011.055V13.9c0 .022-.01.041-.012.063a.603.603 0 0 1-.024.115.57.57 0 0 1-.192.27c-.017.014-.027.033-.046.044-.082.052-2.046 1.247-4.951 1.247s-4.87-1.195-4.951-1.247c-.02-.011-.03-.03-.047-.043a.546.546 0 0 1-.215-.386c-.003-.021-.013-.04-.013-.063V8.17c0-.02.01-.037.01-.056l-3.2-1.827a.578.578 0 0 1 0-1.007L8.422.642a.582.582 0 0 1 .576 0l8.129 4.638a.578.578 0 0 1 .292.504c0 .01-.007.018-.007.028 0 .014.007.025.007.039v5.311c.346.202.581.572.581.999 0 .639-.52 1.16-1.161 1.16zm-4.065.235V8.77l-3.776 2.155a.578.578 0 0 1-.576 0L4.645 8.77v4.783c.583.291 2.078.927 4.065.927 1.998 0 3.484-.634 4.064-.925zM8.71 1.813l-6.96 3.97 6.959 3.97 6.958-3.97-6.958-3.97z"
        }));
      },
      library: function library(_ref194) {
        var e = _ref194.className,
            _ref194$width = _ref194.width,
            t = _ref194$width === void 0 ? "18" : _ref194$width,
            _ref194$height = _ref194.height,
            a = _ref194$height === void 0 ? "16" : _ref194$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 18 16"
        }, l.a.createElement("path", {
          d: "M.75 2.941h16.5c.414 0 .75.33.75.735v10.295a.743.743 0 0 1-.75.735H.75A.743.743 0 0 1 0 13.97V3.676c0-.406.336-.735.75-.735zm0 .735v10.295h16.5V3.676H.75zm6 2.665a.427.427 0 0 1 .64-.371l4.353 2.482a.427.427 0 0 1 0 .743l-4.354 2.483a.427.427 0 0 1-.639-.372V6.341zM1.125 2.47c-.207 0-.375-.224-.375-.5 0-.277.168-.5.375-.5h15.738c.207 0 .375.223.375.5 0 .276-.168.5-.375.5H1.125zM2.625 1C2.418 1 2.25.776 2.25.5s.168-.5.375-.5h13.5c.207 0 .375.224.375.5s-.168.5-.375.5h-13.5z"
        }));
      },
      siftrock: function siftrock(_ref195) {
        var e = _ref195.className,
            _ref195$width = _ref195.width,
            t = _ref195$width === void 0 ? "18" : _ref195$width,
            _ref195$height = _ref195.height,
            a = _ref195$height === void 0 ? "18" : _ref195$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 18 18"
        }, l.a.createElement("g", {
          fill: "#644A9E",
          fillRule: "evenodd"
        }, l.a.createElement("circle", {
          cx: 8.9,
          cy: 15.9,
          r: 1.9
        }), l.a.createElement("circle", {
          cx: 8.9,
          cy: 8.9,
          r: 1.9
        }), l.a.createElement("circle", {
          cx: 15.9,
          cy: 8.9,
          r: 1.9
        }), l.a.createElement("circle", {
          cx: 1.9,
          cy: 8.9,
          r: 1.9
        }), l.a.createElement("circle", {
          cx: 8.9,
          cy: 1.9,
          r: 1.9
        }), l.a.createElement("circle", {
          cx: 12.4,
          cy: 12.4,
          r: 1.9
        }), l.a.createElement("circle", {
          cx: 12.4,
          cy: 5.4,
          r: 1.9
        }), l.a.createElement("circle", {
          cx: 5.4,
          cy: 12.4,
          r: 1.9
        }), l.a.createElement("circle", {
          cx: 5.4,
          cy: 5.4,
          r: 1.9
        })));
      },
      "dev-platform": function devPlatform(_ref196) {
        var e = _ref196.className,
            _ref196$width = _ref196.width,
            t = _ref196$width === void 0 ? "18" : _ref196$width,
            _ref196$height = _ref196.height,
            a = _ref196$height === void 0 ? "16" : _ref196$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 18 16"
        }, l.a.createElement("path", {
          d: "M16.5 16h-15C.673 16 0 15.347 0 14.545V1.455C0 .653.673 0 1.5 0h15c.827 0 1.5.653 1.5 1.455v13.09c0 .802-.673 1.455-1.5 1.455zm-15-1.455h14.998l.001-10.182H1.5v10.182zm0-13.09v1.454h15V1.455h-15zm9.53 10.696a.76.76 0 0 1-.53.214.759.759 0 0 1-.53-.214.71.71 0 0 1 0-1.028l1.72-1.668-1.72-1.667a.71.71 0 0 1 0-1.029.768.768 0 0 1 1.06 0l2.251 2.182a.71.71 0 0 1 0 1.029l-2.25 2.182zm-3 0a.76.76 0 0 1-.53.213.759.759 0 0 1-.53-.213L4.72 9.969a.71.71 0 0 1 0-1.029l2.25-2.182a.766.766 0 0 1 1.06 0 .71.71 0 0 1 0 1.029L6.312 9.454l1.72 1.667a.71.71 0 0 1 0 1.029H8.03z"
        }));
      },
      star: function star(_ref197) {
        var e = _ref197.className,
            _ref197$width = _ref197.width,
            t = _ref197$width === void 0 ? "20" : _ref197$width,
            _ref197$height = _ref197.height,
            a = _ref197$height === void 0 ? "19" : _ref197$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 14 13"
        }, l.a.createElement("g", {
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          transform: "translate(-124.000000, -107.000000)",
          fill: "#353F45"
        }, l.a.createElement("path", {
          d: "M127.128699,119.68155 C126.746655,119.922451 126.266308,119.573459 126.377361,119.13567 L127.410415,115.063202 L124.18092,112.37572 C123.833751,112.086817 124.017227,111.522136 124.467906,111.492469 L128.660285,111.2165 L130.218263,107.31459 C130.385745,106.895137 130.979486,106.895137 131.146968,107.31459 L132.704946,111.2165 L136.897325,111.492469 C137.348004,111.522136 137.53148,112.086817 137.184311,112.37572 L133.954816,115.063202 L134.98787,119.13567 C135.098923,119.573459 134.618576,119.922451 134.236531,119.68155 L130.682615,117.440595 L127.128699,119.68155 Z",
          id: "Star"
        }))));
      },
      "lightbulb-2": function lightbulb2(_ref198) {
        var e = _ref198.className,
            _ref198$width = _ref198.width,
            t = _ref198$width === void 0 ? "16" : _ref198$width,
            _ref198$height = _ref198.height,
            a = _ref198$height === void 0 ? "16" : _ref198$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 30 30",
          version: "1.1"
        }, l.a.createElement("g", {
          id: "icon/insights",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          transform: "translate(6.000000, 2.000000)",
          fill: "#353F45"
        }, l.a.createElement("path", {
          d: "M6.02996594,17.0006278 L12.0299659,17.0006278 C12.5822507,17.0006278 13.0299659,17.448343 13.0299659,18.0006278 C13.0299659,18.5529125 12.5822507,19.0006278 12.0299659,19.0006278 L6.02996594,19.0006278 C5.47768119,19.0006278 5.02996594,18.5529125 5.02996594,18.0006278 C5.02996594,17.448343 5.47768119,17.0006278 6.02996594,17.0006278 Z M6.02996594,20.0006278 L12.0299659,20.0006278 C12.5822507,20.0006278 13.0299659,20.448343 13.0299659,21.0006278 C13.0299659,21.5529125 12.5822507,22.0006278 12.0299659,22.0006278 L6.02996594,22.0006278 C5.47768119,22.0006278 5.02996594,21.5529125 5.02996594,21.0006278 C5.02996594,20.448343 5.47768119,20.0006278 6.02996594,20.0006278 Z M7.02996594,23.0006278 L11.0299659,23.0006278 C11.5822507,23.0006278 12.0299659,23.448343 12.0299659,24.0006278 C12.0299659,24.5529125 11.5822507,25.0006278 11.0299659,25.0006278 L7.02996594,25.0006278 C6.47768119,25.0006278 6.02996594,24.5529125 6.02996594,24.0006278 C6.02996594,23.448343 6.47768119,23.0006278 7.02996594,23.0006278 Z M14.7061934,15.9601317 C14.2792169,16.3104309 13.6491105,16.2482716 13.2988113,15.8212951 C12.9485121,15.3943186 13.0106714,14.7642122 13.4376479,14.413913 C14.9837931,13.1454278 15.9246494,11.282054 15.9958058,9.2444024 C16.130727,5.38076421 13.1080047,2.13929135 9.2443665,2.00437013 C5.38072831,1.86944891 2.13925545,4.89217125 2.00433423,8.75580944 C1.92847797,10.9280485 2.85359934,12.969018 4.48171082,14.3469849 C4.90327476,14.7037794 4.9557808,15.3347635 4.59898633,15.7563275 C4.24219187,16.1778914 3.61120771,16.2303975 3.18964377,15.873603 C1.09874504,14.1039519 -0.0919164183,11.4771573 0.0055525792,8.68601045 C0.179022717,3.71847563 4.34663068,-0.167881663 9.31416549,0.0055884753 C14.2817003,0.179058614 18.1680576,4.34666657 17.9945875,9.31420139 C17.9031664,11.9321569 16.6919496,14.3309817 14.7061934,15.9601317 Z M8.75060956,14.1795466 C8.6975643,14.3398046 8.55198024,14.4532058 8.38084153,14.4532058 C8.36457948,14.4532058 8.34831743,14.4524183 8.33166819,14.4500558 C8.14813935,14.4280055 8.01649419,14.2819227 7.99481145,14.1078833 C7.9924883,14.097252 7.99364988,14.0862269 7.99210111,14.0755955 C7.99132673,14.0543328 7.98474447,14.0342513 7.98745481,14.0125948 L7.99093954,13.9814882 C7.99287549,13.9669193 7.99326269,13.9527442 7.99636022,13.9377815 L8.37000016,10.9165054 L6.54710187,10.9161116 C6.25980566,10.9161116 6.13358118,10.7593974 6.08363346,10.6660777 C5.94308289,10.4030499 6.11654475,10.1482909 6.17346192,10.0644212 L10.0322139,5.15194356 C10.1673438,4.98066047 10.416308,4.9503414 10.5878339,5.08382408 C10.6842447,5.15863738 10.7310949,5.26849481 10.7349668,5.38110852 C10.7411618,5.42835902 10.7411618,5.47718455 10.7287717,5.52640382 L9.9822662,8.55752382 L11.5647185,8.55752382 C11.8504659,8.55752382 11.9743672,8.70833169 12.0231534,8.79810765 C12.1555729,9.04420404 12.0065042,9.26588767 11.9267427,9.3851952 L8.75060956,14.1795466 Z"
        }))));
      },
      calendar: function CalendarSvg(_ref199) {
        var e = _ref199.className,
            _ref199$height = _ref199.height,
            t = _ref199$height === void 0 ? "104" : _ref199$height,
            _ref199$width = _ref199.width,
            a = _ref199$width === void 0 ? "102" : _ref199$width;
        return l.a.createElement("svg", {
          className: e,
          width: a,
          height: t,
          viewBox: "0 0 102 104",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("g", {
          filter: "url(#filter0_dd)"
        }, l.a.createElement("rect", {
          x: "19",
          y: "30.9056",
          width: "54.4151",
          height: "38.0377",
          rx: "1.0566",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2.11321",
          "stroke-linejoin": "round"
        }), l.a.createElement("rect", {
          x: "22.1698",
          y: "15.0565",
          width: "48.0755",
          height: "49.1321",
          rx: "1.58491",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2.11321"
        }), l.a.createElement("path", {
          d: "M19 33.0189V68.9434H73.4151L19 33.0189Z",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2.11321",
          "stroke-linejoin": "round"
        }), l.a.createElement("path", {
          d: "M73.4151 68.9434V33.0189L19 68.9434H73.4151Z",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2.11321",
          "stroke-linejoin": "round"
        }), l.a.createElement("line", {
          x1: "40.9434",
          y1: "13",
          x2: "40.9434",
          y2: "17",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linecap": "round"
        }), l.a.createElement("line", {
          x1: "45.9434",
          y1: "13",
          x2: "45.9434",
          y2: "17",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linecap": "round"
        }), l.a.createElement("line", {
          x1: "50.9434",
          y1: "13",
          x2: "50.9434",
          y2: "17",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linecap": "round"
        }), l.a.createElement("circle", {
          cx: "70",
          cy: "64",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          "stroke-width": "2"
        }), l.a.createElement("path", {
          d: "M64.9999 63.9997L68.7499 67.7497L75.2499 60.2497",
          stroke: "white",
          "stroke-width": "2.75",
          "stroke-linecap": "square"
        })), l.a.createElement("defs", null, l.a.createElement("filter", {
          id: "filter0_dd",
          x: "-11.2688",
          y: "-8.63441",
          width: "114.538",
          height: "114.538",
          filterUnits: "userSpaceOnUse",
          "color-interpolation-filters": "sRGB"
        }, l.a.createElement("feFlood", {
          "flood-opacity": "0",
          result: "BackgroundImageFix"
        }), l.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), l.a.createElement("feOffset", {
          dy: "2.59032"
        }), l.a.createElement("feGaussianBlur", {
          stdDeviation: "2.59032"
        }), l.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.1 0"
        }), l.a.createElement("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), l.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), l.a.createElement("feOffset", {
          dy: "8.63441"
        }), l.a.createElement("feGaussianBlur", {
          stdDeviation: "8.63441"
        }), l.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
        }), l.a.createElement("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow",
          result: "effect2_dropShadow"
        }), l.a.createElement("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect2_dropShadow",
          result: "shape"
        }))));
      },
      "notification-2": function NotificationSvg(_ref200) {
        var e = _ref200.className,
            _ref200$height = _ref200.height,
            t = _ref200$height === void 0 ? "106" : _ref200$height,
            _ref200$width = _ref200.width,
            a = _ref200$width === void 0 ? "105" : _ref200$width;
        return l.a.createElement("svg", {
          className: e,
          width: a,
          height: t,
          viewBox: "0 0 105 106",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("g", {
          filter: "url(#filter0_dd)"
        }, l.a.createElement("rect", {
          x: "20",
          y: "20",
          width: "56",
          height: "56",
          rx: "2.53807",
          fill: "#353F45"
        }), l.a.createElement("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M48.9981 33.1251C48.9981 32.7232 49.2091 32.3517 49.5523 32.1507C49.8941 31.9498 50.3162 31.9498 50.6587 32.1507L62.8135 39.2852C63.1034 39.4551 63.1085 39.8738 62.818 40.0438C61.1009 41.0465 56.4391 43.7783 54.7073 44.7934C54.4135 44.9659 54.0479 44.7501 54.0479 44.4077V41.1577C54.0479 41.1305 54.0338 41.1053 54.0101 41.0911L49.5523 38.4743C49.2091 38.2727 48.9981 37.9019 48.9981 37.4993V33.1251ZM46.8269 38.6023C47.3048 38.3218 47.5985 37.8062 47.5985 37.2493V33.1251C47.5985 32.7232 47.3875 32.3517 47.045 32.1507C46.7025 31.9498 46.2804 31.9498 45.9379 32.1507L33.7767 39.2891C33.49 39.4571 33.4842 39.8719 33.7716 40.0392C35.4874 41.042 40.1787 43.7906 41.9021 44.8012C42.1908 44.9704 42.5487 44.7579 42.5487 44.4219V41.1137L46.8269 38.6023ZM46.8057 55.7563C47.1482 55.5548 47.3592 55.1832 47.3592 54.7813V50.4039C47.3592 50.002 47.1482 49.6304 46.8057 49.4289L32.66 41.1268C32.3175 40.9259 31.8961 40.9259 31.5529 41.1268C31.2104 41.3278 31 41.6986 31 42.1012V46.4754C31 46.8773 31.2104 47.2488 31.5529 47.4504L36.0492 50.0892V61.5385C36.0492 61.9397 36.2602 62.3113 36.6027 62.5122L39.3845 64.1456C39.5564 64.2458 39.7476 64.2962 39.9381 64.2962C40.1292 64.2962 40.3204 64.2458 40.4916 64.1456C40.8341 63.9447 41.0445 63.5731 41.0445 63.1706V53.0226L45.6986 55.7557C45.7007 55.757 45.7031 55.758 45.7054 55.7588L45.7089 55.7602C46.0495 55.956 46.4657 55.9547 46.8057 55.7563ZM64.8044 47.4504C65.1476 47.2488 65.3579 46.8773 65.3579 46.4754V42.1012C65.3579 41.6986 65.1476 41.3278 64.8044 41.1268C64.4619 40.9259 64.0398 40.9259 63.6973 41.1268L49.5523 49.4289C49.2091 49.6304 48.9981 50.002 48.9981 50.4039V54.7813C48.9981 55.1832 49.2091 55.5548 49.5523 55.7563C49.8916 55.9547 50.3078 55.956 50.6491 55.7602C50.6508 55.7595 50.6525 55.7588 50.6542 55.7581C50.6557 55.7574 50.6572 55.7566 50.6587 55.7557L55.3128 53.0226V63.1706C55.3128 63.5731 55.5232 63.9447 55.8663 64.1456C56.0376 64.2458 56.2281 64.2962 56.4192 64.2962C56.6104 64.2962 56.8015 64.2458 56.9728 64.1456L59.7552 62.5122C60.0977 62.3113 60.3081 61.9397 60.3081 61.5385V50.0892L64.8044 47.4504Z",
          fill: "white"
        }), l.a.createElement("circle", {
          cx: "72.1523",
          cy: "23.1523",
          r: "11.376",
          fill: "#353F45",
          stroke: "white",
          "stroke-width": "2.44743"
        }), l.a.createElement("path", {
          d: "M72.1494 27.7703C74.0445 27.7703 75.7771 26.9446 75.7771 25.2661C75.7771 24.1697 74.9108 23.3304 73.8414 22.9514C74.8296 22.5995 75.6282 21.9497 75.6282 20.8262C75.6282 19.1206 73.8144 18.4438 72.1494 18.4438C70.4709 18.4438 68.6705 19.1206 68.6705 20.8262C68.6705 21.9497 69.4556 22.5995 70.4573 22.9514C69.3744 23.3304 68.5216 24.1697 68.5216 25.2661C68.5216 26.9446 70.2543 27.7703 72.1494 27.7703ZM72.1494 22.1934C71.5944 22.0986 70.6198 21.8143 70.6198 21.1511C70.6198 20.5148 71.256 20.1494 72.1494 20.1494C73.0293 20.1494 73.6655 20.5148 73.6655 21.1511C73.6655 21.8143 72.7044 22.0986 72.1494 22.1934ZM72.1494 26.0648C71.2018 26.0648 70.4709 25.6451 70.4709 24.9954C70.4709 24.2509 71.5809 23.8989 72.1494 23.8177C72.7044 23.8989 73.8279 24.2509 73.8279 24.9954C73.8279 25.6451 73.0699 26.0648 72.1494 26.0648Z",
          fill: "white"
        })), l.a.createElement("defs", null, l.a.createElement("filter", {
          id: "filter0_dd",
          x: "-12",
          y: "-2",
          width: "120",
          height: "120",
          filterUnits: "userSpaceOnUse",
          "color-interpolation-filters": "sRGB"
        }, l.a.createElement("feFlood", {
          "flood-opacity": "0",
          result: "BackgroundImageFix"
        }), l.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), l.a.createElement("feOffset", {
          dy: "3"
        }), l.a.createElement("feGaussianBlur", {
          stdDeviation: "3"
        }), l.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.1 0"
        }), l.a.createElement("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), l.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), l.a.createElement("feOffset", {
          dy: "10"
        }), l.a.createElement("feGaussianBlur", {
          stdDeviation: "10"
        }), l.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
        }), l.a.createElement("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow",
          result: "effect2_dropShadow"
        }), l.a.createElement("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect2_dropShadow",
          result: "shape"
        }))));
      },
      "routing-circle": function RoutingCircleSvg(_ref201) {
        var e = _ref201.className,
            _ref201$height = _ref201.height,
            t = _ref201$height === void 0 ? "94" : _ref201$height,
            _ref201$width = _ref201.width,
            a = _ref201$width === void 0 ? "88" : _ref201$width;
        return l.a.createElement("svg", {
          className: e,
          width: a,
          height: t,
          viewBox: "0 0 88 89",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("g", {
          filter: "url(#filter0_dd)"
        }, l.a.createElement("path", {
          d: "M24.2525 51.8463C20.6581 51.8463 17.7443 54.0056 17.7443 57.6036H30.7607C30.7607 54.0056 27.8469 51.8463 24.2525 51.8463Z",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), l.a.createElement("circle", {
          cx: "24.3777",
          cy: "47.9663",
          r: "3.8799",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), l.a.createElement("path", {
          d: "M44.746 37.8931C41.1516 37.8931 38.2378 40.0524 38.2378 43.6504H51.2542C51.2542 40.0524 48.3404 37.8931 44.746 37.8931Z",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), l.a.createElement("circle", {
          cx: "44.8712",
          cy: "34.0131",
          r: "3.8799",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), l.a.createElement("path", {
          d: "M65.6757 23.9401C62.0813 23.9401 59.1674 26.0994 59.1674 29.6974H72.1839C72.1839 26.0994 69.27 23.9401 65.6757 23.9401Z",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), l.a.createElement("circle", {
          cx: "65.8009",
          cy: "20.0602",
          r: "3.8799",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), l.a.createElement("path", {
          d: "M53.4989 14.984C33.4414 10.6237 20.4382 21.2405 19.2703 37.2218M19.2703 37.2218L23.6306 34.3875M19.2703 37.2218L16 33.2975",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }), l.a.createElement("path", {
          d: "M34.7495 65.016C54.807 69.3764 67.8102 58.7596 68.9781 42.7783M68.9781 42.7783L64.6178 45.6125M68.9781 42.7783L72.2484 46.7026",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })), l.a.createElement("defs", null, l.a.createElement("filter", {
          id: "filter0_dd",
          x: "-10.2528",
          y: "-7.12641",
          width: "108.506",
          height: "108.506",
          filterUnits: "userSpaceOnUse",
          "color-interpolation-filters": "sRGB"
        }, l.a.createElement("feFlood", {
          "flood-opacity": "0",
          result: "BackgroundImageFix"
        }), l.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), l.a.createElement("feOffset", {
          dy: "2.13792"
        }), l.a.createElement("feGaussianBlur", {
          stdDeviation: "2.13792"
        }), l.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.1 0"
        }), l.a.createElement("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), l.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), l.a.createElement("feOffset", {
          dy: "7.12641"
        }), l.a.createElement("feGaussianBlur", {
          stdDeviation: "7.12641"
        }), l.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
        }), l.a.createElement("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow",
          result: "effect2_dropShadow"
        }), l.a.createElement("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect2_dropShadow",
          result: "shape"
        }))));
      },
      "sequence-envelope": function SequenceEnvelopeSvg(_ref202) {
        var e = _ref202.className,
            _ref202$height = _ref202.height,
            t = _ref202$height === void 0 ? "94" : _ref202$height,
            _ref202$width = _ref202.width,
            a = _ref202$width === void 0 ? "92" : _ref202$width;
        return l.a.createElement("svg", {
          className: e,
          width: a,
          height: t,
          viewBox: "0 0 92 94",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("g", {
          filter: "url(#filter0_dd)"
        }, l.a.createElement("rect", {
          x: "19",
          y: "28.8491",
          width: "54.4151",
          height: "38.0377",
          rx: "1.0566",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), l.a.createElement("rect", {
          x: "22.1698",
          y: "13",
          width: "48.0755",
          height: "49.1321",
          rx: "1.58491",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2"
        }), l.a.createElement("path", {
          d: "M19 30.9624V66.8869H73.4151L19 30.9624Z",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), l.a.createElement("path", {
          d: "M73.4151 66.8869V30.9624L19 66.8869H73.4151Z",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), l.a.createElement("path", {
          d: "M54.9873 30.4913C53.9379 31.5362 52.5278 32.0594 51.1229 32.0594C49.7319 32.0594 48.3466 31.5487 47.3171 30.5223C46.9746 30.1816 46.9657 29.6216 47.298 29.2702C47.6304 28.9187 48.1766 28.9103 48.5183 29.2511C49.9138 30.6413 52.3742 30.6248 53.7853 29.22C54.4531 28.554 54.8209 27.671 54.8209 26.7329C54.82 25.7967 54.4526 24.9155 53.7853 24.2525C52.3933 22.8632 50.1303 22.8623 48.7326 24.2432C48.0231 25.0104 47.5607 25.964 47.0722 26.9739C46.5042 28.1475 45.9185 29.3611 44.8855 30.4691C44.8811 30.4735 44.8753 30.4744 44.8709 30.4784C44.8673 30.4828 44.8664 30.4877 44.8625 30.4913C43.8339 31.5167 42.4823 32.0292 41.129 32.0292C39.7774 32.0292 38.4263 31.5167 37.3964 30.4913C36.3909 29.4885 35.8362 28.1533 35.8371 26.7321C35.838 25.3135 36.3922 23.981 37.3964 22.9808C39.4832 20.9011 42.9953 20.8856 45.0666 22.948C45.4091 23.2888 45.418 23.8487 45.0856 24.2002C44.7524 24.5525 44.2062 24.5591 43.8654 24.2193C42.4699 22.83 40.0095 22.8446 38.5993 24.2521C37.9306 24.9159 37.5637 25.7967 37.5628 26.7334C37.5628 27.6714 37.9297 28.5544 38.5984 29.2213C39.9913 30.6066 42.2534 30.608 43.6489 29.2298C44.4937 28.321 44.996 27.2845 45.5267 26.1867C46.0538 25.0961 46.5996 23.969 47.4977 23.0039C47.5013 22.9995 47.507 22.9986 47.5115 22.9946C47.515 22.9901 47.5168 22.9853 47.5199 22.9817C49.5783 20.9286 52.9293 20.9286 54.9873 22.9817C55.9928 23.981 56.5457 25.3135 56.5466 26.7325C56.5474 28.1537 55.9932 29.4889 54.9873 30.4917V30.4913Z",
          fill: "#353F45"
        })), l.a.createElement("defs", null, l.a.createElement("filter", {
          id: "filter0_dd",
          x: "-11.2688",
          y: "-8.63441",
          width: "114.538",
          height: "114.538",
          filterUnits: "userSpaceOnUse",
          "color-interpolation-filters": "sRGB"
        }, l.a.createElement("feFlood", {
          "flood-opacity": "0",
          result: "BackgroundImageFix"
        }), l.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), l.a.createElement("feOffset", {
          dy: "2.59032"
        }), l.a.createElement("feGaussianBlur", {
          stdDeviation: "2.59032"
        }), l.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.1 0"
        }), l.a.createElement("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), l.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), l.a.createElement("feOffset", {
          dy: "8.63441"
        }), l.a.createElement("feGaussianBlur", {
          stdDeviation: "8.63441"
        }), l.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
        }), l.a.createElement("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow",
          result: "effect2_dropShadow"
        }), l.a.createElement("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect2_dropShadow",
          result: "shape"
        }))));
      },
      "cw-abandoned-scheduling": function CWAbandonedSchedulingSVG(_ref203) {
        var _ref203$height = _ref203.height,
            e = _ref203$height === void 0 ? 80 : _ref203$height,
            _ref203$width = _ref203.width,
            t = _ref203$width === void 0 ? 80 : _ref203$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("g", null, l.a.createElement("rect", {
          x: "13",
          y: "30.9056",
          width: "54.4151",
          height: "38.0377",
          rx: "1.0566",
          fill: "#353F45",
          stroke: "#353F45",
          strokeWidth: "2.11321",
          strokeLinejoin: "round"
        }), l.a.createElement("rect", {
          x: "16.1698",
          y: "15.0565",
          width: "48.0755",
          height: "49.1321",
          rx: "1.58491",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2.11321"
        }), l.a.createElement("rect", {
          x: "20",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "31",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "42",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "53",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "20",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "31",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "42",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "53",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("path", {
          d: "M13 33.0189V68.9434H67.4151L13 33.0189Z",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2.11321",
          strokeLinejoin: "round"
        }), l.a.createElement("path", {
          d: "M67.4151 68.9434V33.0189L13 68.9434H67.4151Z",
          fill: "#353F45",
          stroke: "#353F45",
          strokeWidth: "2.11321",
          strokeLinejoin: "round"
        }), l.a.createElement("line", {
          x1: "23",
          y1: "12",
          x2: "23",
          y2: "18",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), l.a.createElement("line", {
          x1: "40",
          y1: "12",
          x2: "40",
          y2: "18",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), l.a.createElement("line", {
          x1: "57",
          y1: "12",
          x2: "57",
          y2: "18",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        })), l.a.createElement("circle", {
          cx: "64",
          cy: "64",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M58.9999 63.9997L62.7499 67.7497L69.2499 60.2497",
          stroke: "white",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }));
      },
      "cw-clp": function CWClpSvg(_ref204) {
        var _ref204$height = _ref204.height,
            e = _ref204$height === void 0 ? 80 : _ref204$height,
            _ref204$width = _ref204.width,
            t = _ref204$width === void 0 ? 80 : _ref204$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("g", null, l.a.createElement("rect", {
          x: "10",
          y: "15",
          width: "60",
          height: "50",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("rect", {
          x: "15",
          y: "54",
          width: "50",
          height: "5",
          rx: "2.5",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "30",
          y: "28",
          width: "35",
          height: "7",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "44",
          y: "38",
          width: "21",
          height: "7",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "15",
          y: "20",
          width: "17",
          height: "3",
          rx: "1.5",
          fill: "#353F45"
        })));
      },
      "cw-help-article-lookup": function CWHelpArticleLookupSvg(_ref205) {
        var _ref205$height = _ref205.height,
            e = _ref205$height === void 0 ? 80 : _ref205$height,
            _ref205$width = _ref205.width,
            t = _ref205$width === void 0 ? 80 : _ref205$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("g", {
          clipPath: "url(#clip0)"
        }, l.a.createElement("g", null, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M34.3514 20.7326C35.926 20.1692 37.0542 18.6488 37.0542 16.8615C37.0542 14.5946 35.2391 12.757 33.0001 12.757C30.7612 12.757 28.9461 14.5946 28.9461 16.8615C28.9461 18.6487 30.0741 20.169 31.6487 20.7325V27.109H27.5946V29.8433H10.0523C8.91884 29.8433 8 30.7622 8 31.8956V59.2595C8 60.393 8.91884 61.3118 10.0523 61.3118H31.0769V64.6923H34.9231V61.3118H55.9477C57.0812 61.3118 58 60.393 58 59.2595V31.8956C58 30.7622 57.0812 29.8433 55.9477 29.8433H38.4054V27.109H34.3514V20.7326ZM31.0769 64.6923C24.7044 64.6923 19.5385 69.8582 19.5385 76.2308V78.1538C19.5385 79.2159 20.3995 80.0769 21.4615 80.0769H44.5385C45.6005 80.0769 46.4615 79.2159 46.4615 78.1538V76.2308C46.4615 69.8582 41.2956 64.6923 34.9231 64.6923H31.0769Z",
          fill: "#353F45"
        }), l.a.createElement("rect", {
          x: "14.7568",
          y: "38.7273",
          width: "37.1622",
          height: "11.6185",
          rx: "5.80924",
          fill: "white"
        }), l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M46.5134 44.5387C46.5134 46.6167 44.8496 48.3012 42.7972 48.3012C40.7448 48.3012 39.081 46.6167 39.081 44.5387C39.081 42.4607 40.7448 40.7761 42.7972 40.7761C44.8496 40.7761 46.5134 42.4607 46.5134 44.5387ZM27.5945 44.5391C27.5945 46.6171 25.9307 48.3016 23.8783 48.3016C21.8259 48.3016 20.1621 46.6171 20.1621 44.5391C20.1621 42.4611 21.8259 40.7766 23.8783 40.7766C25.9307 40.7766 27.5945 42.4611 27.5945 44.5391Z",
          fill: "#353F45"
        })), l.a.createElement("g", null, l.a.createElement("path", {
          d: "M60.5 13C53.0564 13 47 17.5182 47 23.0721C47 26.5334 49.9576 29.5232 52.8794 30.689C53.393 30.8932 53.7283 31.3906 53.7283 31.9426C53.7283 33.7345 53.091 35.4856 52.4054 36.8493C53.9659 36.4211 55.7702 35.5895 56.5994 33.9795C56.832 33.5315 57.2948 33.2494 57.7998 33.2494H60.5C67.9436 33.2494 74 28.6842 74 23.0721C74 17.5182 67.9436 13 60.5 13Z",
          fill: "white"
        }), l.a.createElement("path", {
          d: "M52.5088 31.6178L52.51 31.6182C52.6406 31.6701 52.7283 31.7978 52.7283 31.9426C52.7283 33.5136 52.1641 35.103 51.512 36.4001C51.3345 36.7531 51.3815 37.1774 51.6319 37.483C51.8823 37.7886 52.2891 37.9182 52.6701 37.8137C54.2932 37.3683 56.4566 36.4385 57.4873 34.4395C57.5486 34.3221 57.6697 34.2494 57.7998 34.2494H60.5C64.4192 34.2494 68.0101 33.0488 70.6433 31.0638C73.2766 29.0787 75 26.2622 75 23.0721C75 19.9065 73.2721 17.116 70.6393 15.1518C68.0063 13.1874 64.4168 12 60.5 12C56.5832 12 52.9937 13.1874 50.3607 15.1518C47.7279 17.116 46 19.9065 46 23.0721C46 25.0938 46.8626 26.9254 48.0758 28.3815C49.2879 29.8364 50.8949 30.9738 52.5088 31.6178Z",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinejoin: "round"
        })), l.a.createElement("circle", {
          cx: "54.5",
          cy: "23.5",
          r: "1.5",
          fill: "#353F45"
        }), l.a.createElement("circle", {
          cx: "60.5",
          cy: "23.5",
          r: "1.5",
          fill: "#353F45"
        }), l.a.createElement("circle", {
          cx: "66.5",
          cy: "23.5",
          r: "1.5",
          fill: "#353F45"
        })), l.a.createElement("defs", null, l.a.createElement("clipPath", {
          id: "clip0"
        }, l.a.createElement("rect", {
          width: "80",
          height: "80",
          fill: "white"
        }))));
      },
      "cw-saved-keyword-group": function CWSavedKeywordGroupSvg(_ref206) {
        var _ref206$height = _ref206.height,
            e = _ref206$height === void 0 ? 80 : _ref206$height,
            _ref206$width = _ref206.width,
            t = _ref206$width === void 0 ? 80 : _ref206$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("g", {
          clipPath: "url(#clip0)"
        }, l.a.createElement("g", null, l.a.createElement("circle", {
          cx: "40",
          cy: "40",
          r: "32",
          fill: "white"
        }), l.a.createElement("circle", {
          cx: "40",
          cy: "40",
          r: "31",
          stroke: "#353F45",
          strokeWidth: "2"
        })), l.a.createElement("mask", {
          id: "path-3-inside-1",
          fill: "white"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M70.0775 29.0527L41.8653 39.3001C41.814 39.1671 41.7479 39.0344 41.6679 38.9082C41.5786 38.7673 41.4874 38.6587 41.4143 38.5857C41.3413 38.5126 41.2328 38.4214 41.0918 38.3321C40.9656 38.2522 40.833 38.186 40.6999 38.1348L50.9473 9.92252C55.2098 11.4708 59.2092 13.9541 62.6276 17.3725C66.0459 20.7909 68.5293 24.7902 70.0775 29.0527ZM29.053 9.92252L39.3004 38.1348C39.1673 38.186 39.0346 38.2522 38.9085 38.3321C38.7675 38.4214 38.659 38.5126 38.5859 38.5857C38.5129 38.6587 38.4216 38.7673 38.3323 38.9082C38.2524 39.0344 38.1863 39.1671 38.135 39.3001L9.92276 29.0527C11.471 24.7902 13.9543 20.7909 17.3727 17.3725C20.7911 13.9541 24.7905 11.4708 29.053 9.92252ZM9.92276 50.947L38.135 40.6997C38.1863 40.8327 38.2524 40.9654 38.3323 41.0915C38.4216 41.2325 38.5129 41.341 38.5859 41.4141C38.659 41.4872 38.7675 41.5784 38.9085 41.6677C39.0346 41.7476 39.1673 41.8137 39.3004 41.865L29.053 70.0773C24.7905 68.529 20.7911 66.0457 17.3727 62.6273C13.9543 59.2089 11.471 55.2096 9.92276 50.947ZM50.9473 70.0773L40.6999 41.865C40.833 41.8137 40.9656 41.7476 41.0918 41.6677C41.2328 41.5784 41.3413 41.4872 41.4143 41.4141C41.4874 41.341 41.5786 41.2325 41.6679 41.0915C41.7479 40.9654 41.814 40.8327 41.8653 40.6997L70.0775 50.947C68.5293 55.2095 66.0459 59.2089 62.6276 62.6273C59.2092 66.0457 55.2098 68.529 50.9473 70.0773ZM40.0352 40.0349L41.8653 40.6997C41.8703 40.6866 41.8752 40.6735 41.88 40.6604L40.0616 39.9999L41.88 39.3394C41.8752 39.3263 41.8703 39.3132 41.8653 39.3001L40.0352 39.9648L40.6999 38.1348C40.6868 38.1297 40.6737 38.1248 40.6606 38.1201L40.0001 39.9384L39.3397 38.1201C39.3266 38.1248 39.3135 38.1297 39.3004 38.1348L39.9651 39.9648L38.135 39.3001C38.13 39.3132 38.1251 39.3263 38.1203 39.3394L39.9387 39.9999L38.1203 40.6604C38.1251 40.6735 38.13 40.6866 38.135 40.6997L39.9651 40.0349L39.3004 41.865C39.3135 41.8701 39.3266 41.875 39.3397 41.8797L40.0001 40.0613L40.6606 41.8797C40.6737 41.875 40.6868 41.8701 40.6999 41.865L40.0352 40.0349Z"
        })), l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M70.0775 29.0527L41.8653 39.3001C41.814 39.1671 41.7479 39.0344 41.6679 38.9082C41.5786 38.7673 41.4874 38.6587 41.4143 38.5857C41.3413 38.5126 41.2328 38.4214 41.0918 38.3321C40.9656 38.2522 40.833 38.186 40.6999 38.1348L50.9473 9.92252C55.2098 11.4708 59.2092 13.9541 62.6276 17.3725C66.0459 20.7909 68.5293 24.7902 70.0775 29.0527ZM29.053 9.92252L39.3004 38.1348C39.1673 38.186 39.0346 38.2522 38.9085 38.3321C38.7675 38.4214 38.659 38.5126 38.5859 38.5857C38.5129 38.6587 38.4216 38.7673 38.3323 38.9082C38.2524 39.0344 38.1863 39.1671 38.135 39.3001L9.92276 29.0527C11.471 24.7902 13.9543 20.7909 17.3727 17.3725C20.7911 13.9541 24.7905 11.4708 29.053 9.92252ZM9.92276 50.947L38.135 40.6997C38.1863 40.8327 38.2524 40.9654 38.3323 41.0915C38.4216 41.2325 38.5129 41.341 38.5859 41.4141C38.659 41.4872 38.7675 41.5784 38.9085 41.6677C39.0346 41.7476 39.1673 41.8137 39.3004 41.865L29.053 70.0773C24.7905 68.529 20.7911 66.0457 17.3727 62.6273C13.9543 59.2089 11.471 55.2096 9.92276 50.947ZM50.9473 70.0773L40.6999 41.865C40.833 41.8137 40.9656 41.7476 41.0918 41.6677C41.2328 41.5784 41.3413 41.4872 41.4143 41.4141C41.4874 41.341 41.5786 41.2325 41.6679 41.0915C41.7479 40.9654 41.814 40.8327 41.8653 40.6997L70.0775 50.947C68.5293 55.2095 66.0459 59.2089 62.6276 62.6273C59.2092 66.0457 55.2098 68.529 50.9473 70.0773ZM40.0352 40.0349L41.8653 40.6997C41.8703 40.6866 41.8752 40.6735 41.88 40.6604L40.0616 39.9999L41.88 39.3394C41.8752 39.3263 41.8703 39.3132 41.8653 39.3001L40.0352 39.9648L40.6999 38.1348C40.6868 38.1297 40.6737 38.1248 40.6606 38.1201L40.0001 39.9384L39.3397 38.1201C39.3266 38.1248 39.3135 38.1297 39.3004 38.1348L39.9651 39.9648L38.135 39.3001C38.13 39.3132 38.1251 39.3263 38.1203 39.3394L39.9387 39.9999L38.1203 40.6604C38.1251 40.6735 38.13 40.6866 38.135 40.6997L39.9651 40.0349L39.3004 41.865C39.3135 41.8701 39.3266 41.875 39.3397 41.8797L40.0001 40.0613L40.6606 41.8797C40.6737 41.875 40.6868 41.8701 40.6999 41.865L40.0352 40.0349Z",
          fill: "white"
        }), l.a.createElement("path", {
          d: "M70.0775 29.0527L75.8813 45.0313L91.8599 39.2275L86.0561 23.2489L70.0775 29.0527ZM41.6679 38.9082L27.3072 48.006L27.3072 48.006L41.6679 38.9082ZM41.0918 38.3321L31.994 52.6928L31.9941 52.6929L41.0918 38.3321ZM50.9473 9.92252L56.7511 -6.05608L40.7725 -11.8599L34.9687 4.11871L50.9473 9.92252ZM29.053 9.92252L45.0316 4.11871L39.2278 -11.8599L23.2492 -6.05608L29.053 9.92252ZM38.9085 38.3321L48.0062 52.6929L48.0063 52.6928L38.9085 38.3321ZM38.3323 38.9082L52.693 48.0061L52.6931 48.0059L38.3323 38.9082ZM9.92276 29.0527L-6.05584 23.2489L-11.8597 39.2275L4.11895 45.0313L9.92276 29.0527ZM9.92276 50.947L4.11895 34.9684L-11.8597 40.7723L-6.05584 56.7509L9.92276 50.947ZM38.3323 41.0915L52.6931 31.9939L52.693 31.9937L38.3323 41.0915ZM38.9085 41.6677L48.0063 27.307L48.0062 27.3069L38.9085 41.6677ZM29.053 70.0773L23.2492 86.0559L39.2278 91.8597L45.0316 75.8811L29.053 70.0773ZM50.9473 70.0773L34.9687 75.8811L40.7725 91.8597L56.7511 86.0559L50.9473 70.0773ZM41.0918 41.6677L31.9941 27.3069L31.994 27.307L41.0918 41.6677ZM41.6679 41.0915L27.3072 31.9938L27.3072 31.9938L41.6679 41.0915ZM70.0775 50.947L86.0561 56.7509L91.8599 40.7723L75.8813 34.9684L70.0775 50.947ZM40.0352 40.0349L45.839 24.0563L11.6317 11.6314L24.0566 45.8388L40.0352 40.0349ZM41.88 40.6604L57.8584 46.4647L63.6629 30.4858L47.6838 24.6818L41.88 40.6604ZM40.0616 39.9999L34.2578 24.0213L-9.73327 39.9999L34.2578 55.9785L40.0616 39.9999ZM41.88 39.3394L47.6838 55.318L63.6629 49.514L57.8584 33.5351L41.88 39.3394ZM40.0352 39.9648L24.0566 34.161L11.6316 68.3684L45.839 55.9434L40.0352 39.9648ZM40.6606 38.1201L46.465 22.1417L30.486 16.3371L24.682 32.3162L40.6606 38.1201ZM40.0001 39.9384L24.0215 45.7423L40.0001 89.7333L55.9787 45.7423L40.0001 39.9384ZM39.3397 38.1201L55.3183 32.3162L49.5142 16.3371L33.5353 22.1416L39.3397 38.1201ZM39.9651 39.9648L34.1612 55.9434L68.3687 68.3684L55.9437 34.161L39.9651 39.9648ZM38.1203 39.3394L22.1412 33.537L16.3393 49.5147L32.3165 55.318L38.1203 39.3394ZM39.9387 39.9999L45.7425 55.9785L89.7335 39.9999L45.7425 24.0213L39.9387 39.9999ZM38.1203 40.6604L32.3165 24.6818L16.3374 30.4858L22.1419 46.4647L38.1203 40.6604ZM39.9651 40.0349L55.9437 45.8388L68.3686 11.6314L34.1613 24.0563L39.9651 40.0349ZM39.3397 41.8797L33.5353 57.8581L49.5142 63.6627L55.3183 47.6835L39.3397 41.8797ZM40.0001 40.0613L55.9787 34.2575L40.0001 -9.73348L24.0215 34.2575L40.0001 40.0613ZM40.6606 41.8797L24.682 47.6835L30.486 63.6627L46.465 57.8581L40.6606 41.8797ZM34.5871 53.9977C34.3315 53.8992 34.0801 53.7942 33.8332 53.683L47.7919 22.6806C47.4701 22.5357 47.1436 22.3993 46.8127 22.2718L34.5871 53.9977ZM32.6885 53.1066C32.4564 52.9768 32.2247 52.839 31.994 52.6928L50.1896 23.9714C49.8899 23.7815 49.5882 23.602 49.2854 23.4327L32.6885 53.1066ZM31.9941 52.6929C31.7695 52.5506 31.5521 52.4044 31.3415 52.2548L51.0317 24.5366C50.7617 24.3448 50.4809 24.156 50.1895 23.9713L31.9941 52.6929ZM30.2317 51.3851C29.9595 51.1504 29.6787 50.8917 29.3935 50.6065L53.4352 26.5649C53.1018 26.2315 52.7651 25.9206 52.4294 25.6312L30.2317 51.3851ZM29.3935 50.6065C29.1084 50.3213 28.8496 50.0406 28.6149 49.7683L54.3688 27.5706C54.0795 27.2349 53.7685 26.8982 53.4352 26.5649L29.3935 50.6065ZM27.7452 48.6585C27.5957 48.448 27.4494 48.2305 27.3072 48.006L56.0287 29.8105C55.8441 29.5191 55.6552 29.2383 55.4634 28.9683L27.7452 48.6585ZM27.3072 48.006C27.1611 47.7753 27.0232 47.5436 26.8934 47.3115L56.5674 30.7147C56.398 30.4119 56.2185 30.1102 56.0287 29.8105L27.3072 48.006ZM26.317 46.1669C26.2058 45.9199 26.1008 45.6686 26.0023 45.413L57.7282 33.1873C57.6007 32.8564 57.4643 32.5299 57.3195 32.2081L26.317 46.1669ZM57.7274 46.8146C57.74 46.7819 57.7525 46.7492 57.7648 46.7167L25.974 34.6608C25.9836 34.6356 25.9933 34.6102 26.0031 34.5848L57.7274 46.8146ZM57.823 46.5612C57.8349 46.529 57.8467 46.4968 57.8584 46.4647L25.9016 34.856C25.9106 34.8313 25.9197 34.8064 25.9289 34.7814L57.823 46.5612ZM47.6838 24.6818L47.1787 24.4983L35.5711 56.4555L36.0762 56.639L47.6838 24.6818ZM46.3705 24.2048L45.8654 24.0213L34.2578 55.9785L34.7629 56.162L46.3705 24.2048ZM45.8654 55.9785L46.3705 55.795L34.7629 23.8378L34.2578 24.0213L45.8654 55.9785ZM47.1787 55.5015L47.6838 55.318L36.0762 23.3608L35.5711 23.5443L47.1787 55.5015ZM57.8584 33.5351C57.8466 33.5027 57.8347 33.4703 57.8228 33.4379L25.9291 45.219C25.9199 45.1939 25.9107 45.1689 25.9016 45.1438L57.8584 33.5351ZM57.7649 33.2833C57.7527 33.2512 57.7405 33.219 57.7281 33.187L26.0024 45.4133C25.9929 45.3884 25.9834 45.3636 25.9739 45.3387L57.7649 33.2833ZM24.7213 32.3309L24.5367 32.8393L56.4939 44.4469L56.6785 43.9386L24.7213 32.3309ZM24.2412 33.6527L24.0566 34.161L56.0138 45.7687L56.1984 45.2603L24.2412 33.6527ZM45.839 55.9434L46.3473 55.7588L34.7397 23.8016L34.2314 23.9862L45.839 55.9434ZM47.1607 55.4634L47.6691 55.2787L36.0614 23.3215L35.5531 23.5062L47.1607 55.4634ZM56.6785 43.9386L59.525 36.1019L27.5678 24.4942L24.7213 32.331L56.6785 43.9386ZM64.0794 23.5631L66.9259 15.7263L34.9687 4.11871L32.1222 11.9554L64.0794 23.5631ZM45.1435 25.9011C45.707 26.1058 46.2594 26.3451 46.7978 26.6189L62.2096 -3.68748C60.4291 -4.59293 58.6057 -5.38243 56.7511 -6.05608L45.1435 25.9011ZM49.2315 28.1728C49.703 28.5429 50.1625 28.949 50.6067 29.3933L74.6484 5.35166C73.2402 3.94346 71.7619 2.63443 70.2229 1.4266L49.2315 28.1728ZM50.6067 29.3933C51.051 29.8376 51.4572 30.2971 51.8272 30.7685L78.5734 9.77714C77.3656 8.23817 76.0566 6.75986 74.6484 5.35166L50.6067 29.3933ZM53.3811 33.2022C53.6549 33.7407 53.8942 34.2931 54.0989 34.8566L86.0561 23.2489C85.3825 21.3943 84.593 19.5709 83.6875 17.7904L53.3811 33.2022ZM64.2737 13.0741L56.437 15.9206L68.0446 47.8778L75.8813 45.0313L64.2737 13.0741ZM43.8982 20.475L36.0614 23.3215L47.6691 55.2787L55.5058 52.4322L43.8982 20.475ZM45.4135 53.9976C45.3887 54.0072 45.3638 54.0167 45.339 54.0261L33.2835 22.2351C33.2514 22.2473 33.2193 22.2596 33.1872 22.2719L45.4135 53.9976ZM45.2192 54.0709C45.1942 54.0802 45.1691 54.0893 45.144 54.0985L33.5353 22.1416C33.5029 22.1534 33.4705 22.1653 33.4382 22.1772L45.2192 54.0709ZM23.3611 43.9239L23.5445 44.429L55.5017 32.8213L55.3183 32.3162L23.3611 43.9239ZM23.8381 45.2372L24.0215 45.7423L55.9787 34.1346L55.7953 33.6295L23.8381 45.2372ZM55.9787 45.7423L56.1622 45.2371L24.205 33.6295L24.0215 34.1346L55.9787 45.7423ZM56.4558 44.429L56.6392 43.9239L24.682 32.3162L24.4985 32.8214L56.4558 44.429ZM34.8563 54.0985C34.8312 54.0893 34.8061 54.0802 34.781 54.0709L46.5622 22.1773C46.5298 22.1653 46.4974 22.1534 46.465 22.1417L34.8563 54.0985ZM34.6608 54.0259C34.6358 54.0164 34.6109 54.0069 34.5859 53.9973L46.8139 22.2723C46.7817 22.2599 46.7495 22.2475 46.7172 22.2353L34.6608 54.0259ZM53.9981 45.4127C53.8995 45.6685 53.7944 45.92 53.6832 46.167L22.6809 32.208C22.5359 32.5299 22.3995 32.8565 22.272 33.1875L53.9981 45.4127ZM53.1067 47.3118C52.9769 47.5438 52.8391 47.7754 52.693 48.0061L23.9716 29.8104C23.7818 30.1101 23.6024 30.4117 23.433 30.7144L53.1067 47.3118ZM52.6931 48.0059C52.5509 48.2305 52.4046 48.4479 52.2551 48.6584L24.5368 28.9684C24.345 29.2384 24.1562 29.5191 23.9715 29.8106L52.6931 48.0059ZM51.3854 49.7682C51.1507 50.0405 50.8919 50.3213 50.6067 50.6065L26.5651 26.5649C26.2317 26.8983 25.9207 27.235 25.6314 27.5707L51.3854 49.7682ZM50.6067 50.6065C50.3215 50.8917 50.0407 51.1505 49.7684 51.3852L27.571 25.6311C27.2353 25.9205 26.8985 26.2314 26.5651 26.5649L50.6067 50.6065ZM48.6587 52.2548C48.4482 52.4044 48.2307 52.5506 48.0062 52.6929L29.8108 23.9713C29.5193 24.156 29.2386 24.3448 28.9686 24.5366L48.6587 52.2548ZM48.0063 52.6928C47.7756 52.8389 47.544 52.9767 47.3119 53.1065L30.7148 23.4327C30.412 23.6021 30.1104 23.7815 29.8107 23.9714L48.0063 52.6928ZM46.1673 53.683C45.9203 53.7942 45.6689 53.8992 45.4132 53.9977L33.1875 22.2718C32.8566 22.3994 32.53 22.5357 32.2082 22.6806L46.1673 53.683ZM32.3312 55.2787L32.8395 55.4634L44.4472 23.5062L43.9388 23.3215L32.3312 55.2787ZM33.6529 55.7588L34.1612 55.9434L45.7689 23.9862L45.2606 23.8016L33.6529 55.7588ZM55.9437 34.161L55.759 33.6527L23.8018 45.2603L23.9865 45.7687L55.9437 34.161ZM55.4636 32.8393L55.279 32.3309L23.3218 43.9386L23.5064 44.4469L55.4636 32.8393ZM43.9388 23.3215L36.1021 20.475L24.4945 52.4322L32.3312 55.2787L43.9388 23.3215ZM23.5633 15.9206L15.7266 13.0741L4.11895 45.0313L11.9557 47.8778L23.5633 15.9206ZM25.9014 34.8566C26.106 34.2931 26.3453 33.7407 26.6191 33.2022L-3.68724 17.7904C-4.59269 19.5709 -5.38219 21.3943 -6.05584 23.2489L25.9014 34.8566ZM28.1731 30.7685C28.5431 30.2971 28.9493 29.8376 29.3935 29.3933L5.3519 5.35166C3.9437 6.75986 2.63467 8.23816 1.42683 9.77714L28.1731 30.7685ZM29.3935 29.3933C29.8378 28.949 30.2973 28.5429 30.7688 28.1728L9.77738 1.42659C8.23841 2.63443 6.7601 3.94346 5.3519 5.35166L29.3935 29.3933ZM33.2025 26.6189C33.7409 26.3451 34.2933 26.1058 34.8568 25.9011L23.2492 -6.05608C21.3945 -5.38243 19.5712 -4.59293 17.7907 -3.68748L33.2025 26.6189ZM13.0744 15.7263L15.9209 23.5631L47.8781 11.9554L45.0316 4.11871L13.0744 15.7263ZM20.4753 36.1018L23.3218 43.9386L55.279 32.3309L52.4325 24.4942L20.4753 36.1018ZM53.9983 34.5876C54.0077 34.6122 54.0171 34.6368 54.0265 34.6615L22.2352 46.716C22.2473 46.748 22.2595 46.7799 22.2718 46.8117L53.9983 34.5876ZM54.0712 34.7808C54.0804 34.8058 54.0896 34.8309 54.0987 34.856L22.1419 46.4647C22.1537 46.4971 22.1655 46.5295 22.1775 46.5618L54.0712 34.7808ZM43.9241 56.639L44.4292 56.4555L32.8216 24.4983L32.3165 24.6818L43.9241 56.639ZM45.2374 56.162L45.7425 55.9785L34.1349 24.0213L33.6298 24.2048L45.2374 56.162ZM45.7425 24.0213L45.2374 23.8378L33.6298 55.795L34.1349 55.9785L45.7425 24.0213ZM44.4292 23.5443L43.9241 23.3608L32.3165 55.318L32.8216 55.5015L44.4292 23.5443ZM54.0994 45.1418C54.09 45.1676 54.0807 45.1933 54.0713 45.2187L22.1774 33.4383C22.1653 33.471 22.1532 33.5039 22.1412 33.537L54.0994 45.1418ZM54.0263 45.3388C54.017 45.3635 54.0076 45.3879 53.9983 45.4122L22.2718 33.1881C22.2596 33.2196 22.2475 33.2513 22.2354 33.2832L54.0263 45.3388ZM22.272 46.8124C22.3996 47.1434 22.536 47.47 22.6809 47.7919L53.6832 33.8328C53.7944 34.0798 53.8995 34.3312 53.998 34.587L22.272 46.8124ZM23.433 49.2853C23.6024 49.5881 23.7818 49.8897 23.9716 50.1894L52.693 31.9937C52.8391 32.2244 52.9769 32.456 53.1067 32.688L23.433 49.2853ZM23.9715 50.1892C24.1562 50.4807 24.345 50.7614 24.5368 51.0314L52.2551 31.3413C52.4046 31.5519 52.5509 31.7693 52.6931 31.9939L23.9715 50.1892ZM25.6314 52.4291C25.9207 52.7648 26.2317 53.1015 26.5651 53.4349L50.6067 29.3933C50.8919 29.6785 51.1507 29.9593 51.3854 30.2316L25.6314 52.4291ZM26.5651 53.4349C26.8985 53.7683 27.2353 54.0793 27.571 54.3687L49.7684 28.6146C50.0407 28.8493 50.3215 29.1081 50.6067 29.3933L26.5651 53.4349ZM28.9686 55.4632C29.2386 55.655 29.5193 55.8438 29.8108 56.0285L48.0062 27.3069C48.2307 27.4492 48.4482 27.5954 48.6587 27.745L28.9686 55.4632ZM29.8107 56.0284C30.1103 56.2182 30.4119 56.3977 30.7147 56.567L47.312 26.8933C47.544 27.0231 47.7756 27.1609 48.0063 27.307L29.8107 56.0284ZM32.2082 57.3192C32.5301 57.4641 32.8567 57.6005 33.1877 57.728L45.413 26.002C45.6688 26.1006 45.9202 26.2056 46.1672 26.3168L32.2082 57.3192ZM43.9388 56.6783L44.4472 56.4936L32.8396 24.5364L32.3312 24.7211L43.9388 56.6783ZM45.2605 56.1982L45.7689 56.0136L34.1613 24.0563L33.6529 24.241L45.2605 56.1982ZM23.9865 34.2311L23.8018 34.7395L55.759 46.3471L55.9437 45.8388L23.9865 34.2311ZM23.5064 35.5529L23.3217 36.0612L55.279 47.6688L55.4636 47.1605L23.5064 35.5529ZM32.3312 24.7211L24.4945 27.5676L36.1021 59.5248L43.9388 56.6783L32.3312 24.7211ZM11.9557 32.122L4.11895 34.9684L15.7266 66.9256L23.5633 64.0792L11.9557 32.122ZM-6.05584 56.7509C-5.38219 58.6055 -4.59269 60.4288 -3.68724 62.2094L26.6191 46.7975C26.3453 46.2591 26.106 45.7067 25.9014 45.1432L-6.05584 56.7509ZM1.42683 70.2226C2.63467 71.7616 3.9437 73.2399 5.3519 74.6481L29.3935 50.6065C28.9493 50.1622 28.5431 49.7027 28.1731 49.2312L1.42683 70.2226ZM5.3519 74.6481C6.7601 76.0563 8.23841 77.3654 9.77738 78.5732L30.7688 51.827C30.2973 51.4569 29.8378 51.0508 29.3935 50.6065L5.3519 74.6481ZM17.7907 83.6873C19.5712 84.5927 21.3945 85.3822 23.2492 86.0559L34.8568 54.0987C34.2933 53.894 33.7409 53.6547 33.2025 53.3809L17.7907 83.6873ZM45.0316 75.8811L47.8781 68.0443L15.9209 56.4367L13.0744 64.2734L45.0316 75.8811ZM52.4325 55.5056L55.279 47.6688L23.3218 36.0612L20.4753 43.8979L52.4325 55.5056ZM33.1874 57.7279C33.2198 57.7404 33.2521 57.7527 33.2843 57.765L45.3382 25.9734C45.3631 25.9829 45.3882 25.9924 45.4133 26.0021L33.1874 57.7279ZM33.4389 57.8228C33.4711 57.8347 33.5032 57.8465 33.5353 57.8581L45.144 25.9013C45.1688 25.9103 45.1936 25.9194 45.2185 25.9286L33.4389 57.8228ZM55.3183 47.6835L55.5017 47.1784L23.5445 35.5708L23.3611 36.0759L55.3183 47.6835ZM55.7953 46.3703L55.9787 45.8652L24.0215 34.2575L23.8381 34.7626L55.7953 46.3703ZM24.0215 45.8652L24.205 46.3703L56.1622 34.7626L55.9787 34.2575L24.0215 45.8652ZM24.4985 47.1784L24.682 47.6835L56.6392 36.0759L56.4558 35.5708L24.4985 47.1784ZM46.465 57.8581C46.497 57.8465 46.5292 57.8347 46.5614 57.8228L34.7817 25.9286C34.8066 25.9194 34.8315 25.9103 34.8563 25.9013L46.465 57.8581ZM46.7165 57.7648C46.7489 57.7525 46.7814 57.7401 46.8139 57.7275L34.5859 26.0025C34.6112 25.9928 34.6364 25.9831 34.6615 25.9736L46.7165 57.7648ZM46.8126 57.728C47.1435 57.6005 47.4701 57.4641 47.7919 57.3192L33.8331 26.3168C34.0801 26.2056 34.3315 26.1005 34.5872 26.002L46.8126 57.728ZM49.2854 56.5671C49.5882 56.3977 49.8899 56.2183 50.1896 56.0284L31.994 27.307C32.2247 27.1608 32.4563 27.023 32.6884 26.8932L49.2854 56.5671ZM50.1895 56.0285C50.4809 55.8438 50.7617 55.655 51.0317 55.4631L31.3415 27.745C31.5521 27.5954 31.7695 27.4492 31.9941 27.3069L50.1895 56.0285ZM52.4294 54.3686C52.7651 54.0792 53.1018 53.7683 53.4352 53.4349L29.3935 29.3933C29.6787 29.1081 29.9595 28.8494 30.2317 28.6147L52.4294 54.3686ZM53.4352 53.4349C53.7685 53.1015 54.0795 52.7649 54.3688 52.4291L28.6149 30.2315C28.8496 29.9592 29.1084 29.6785 29.3935 29.3933L53.4352 53.4349ZM55.4634 51.0315C55.6552 50.7615 55.8441 50.4807 56.0287 50.1893L27.3072 31.9938C27.4494 31.7693 27.5957 31.5518 27.7452 31.3413L55.4634 51.0315ZM56.0287 50.1893C56.2185 49.8896 56.398 49.5879 56.5674 49.2851L26.8934 32.6882C27.0232 32.4562 27.1611 32.2245 27.3072 31.9938L56.0287 50.1893ZM57.3195 47.7917C57.4643 47.4699 57.6007 47.1434 57.7282 46.8125L26.0023 34.5868C26.1008 34.3312 26.2058 34.0799 26.317 33.8329L57.3195 47.7917ZM56.6785 36.0612L56.4939 35.5529L24.5367 47.1605L24.7213 47.6688L56.6785 36.0612ZM56.1984 34.7395L56.0138 34.2311L24.0566 45.8388L24.2412 46.3471L56.1984 34.7395ZM34.2314 56.0136L34.7397 56.1982L46.3473 24.241L45.839 24.0563L34.2314 56.0136ZM35.5531 56.4936L36.0614 56.6783L47.6691 24.7211L47.1607 24.5364L35.5531 56.4936ZM24.7213 47.6688L27.5678 55.5056L59.525 43.8979L56.6785 36.0612L24.7213 47.6688ZM32.1222 68.0443L34.9687 75.8811L66.9259 64.2734L64.0794 56.4367L32.1222 68.0443ZM56.7511 86.0559C58.6057 85.3822 60.4291 84.5927 62.2096 83.6873L46.7978 53.3809C46.2594 53.6547 45.707 53.894 45.1435 54.0987L56.7511 86.0559ZM70.2229 78.5732C71.7619 77.3654 73.2402 76.0563 74.6484 74.6481L50.6067 50.6065C50.1625 51.0508 49.703 51.4569 49.2315 51.827L70.2229 78.5732ZM74.6484 74.6481C76.0566 73.2399 77.3656 71.7616 78.5734 70.2226L51.8272 49.2312C51.4572 49.7027 51.051 50.1622 50.6067 50.6065L74.6484 74.6481ZM83.6875 62.2094C84.593 60.4288 85.3825 58.6055 86.0561 56.7509L54.0989 45.1432C53.8942 45.7067 53.6549 46.2591 53.3811 46.7975L83.6875 62.2094ZM75.8813 34.9684L68.0446 32.1219L56.437 64.0792L64.2737 66.9256L75.8813 34.9684ZM55.5058 27.5676L47.6691 24.7211L36.0614 56.6783L43.8982 59.5248L55.5058 27.5676ZM70.0775 29.0527L81.6851 61.0099L113.642 49.4023L102.035 17.4451L70.0775 29.0527ZM41.6679 38.9082L12.9464 57.1037L12.9465 57.1038L41.6679 38.9082ZM41.0918 38.3321L22.8961 67.0535L22.8964 67.0537L41.0918 38.3321ZM50.9473 9.92252L62.5549 -22.0347L30.5977 -33.6423L18.9901 -1.68511L50.9473 9.92252ZM29.053 9.92252L61.0102 -1.68511L49.4026 -33.6423L17.4453 -22.0347L29.053 9.92252ZM38.9085 38.3321L57.1039 67.0536L57.104 67.0535L38.9085 38.3321ZM38.3323 38.9082L67.0537 57.1039L67.0539 57.1036L38.3323 38.9082ZM9.92276 29.0527L-22.0344 17.4451L-33.6421 49.4023L-1.68487 61.0099L9.92276 29.0527ZM9.92276 50.947L-1.68487 18.9898L-33.6421 30.5975L-22.0344 62.5547L9.92276 50.947ZM38.3323 41.0915L67.0539 22.8962L67.0537 22.8959L38.3323 41.0915ZM38.9085 41.6677L57.104 12.9462L57.1039 12.9462L38.9085 41.6677ZM29.053 70.0773L17.4454 102.034L49.4026 113.642L61.0102 81.6849L29.053 70.0773ZM50.9473 70.0773L18.9901 81.6849L30.5977 113.642L62.5549 102.034L50.9473 70.0773ZM41.0918 41.6677L22.8964 12.9461L22.8961 12.9463L41.0918 41.6677ZM41.6679 41.0915L12.9465 22.896L12.9464 22.8961L41.6679 41.0915ZM70.0775 50.947L102.035 62.5547L113.642 30.5975L81.6851 18.9898L70.0775 50.947ZM40.0352 40.0349L51.6428 8.07773L-16.7718 -16.7721L8.07798 51.6426L40.0352 40.0349ZM41.88 40.6604L73.8368 52.2691L85.4459 20.3112L53.4876 8.70317L41.88 40.6604ZM40.0616 39.9999L28.454 8.04269L-59.5281 39.9999L28.454 71.9571L40.0616 39.9999ZM41.88 39.3394L53.4876 71.2966L85.4459 59.6886L73.8368 27.7307L41.88 39.3394ZM40.0352 39.9648L8.07799 28.3572L-16.7719 96.7719L51.6428 71.9221L40.0352 39.9648ZM40.6606 38.1201L52.2693 6.16324L20.3114 -5.44584L8.70341 26.5124L40.6606 38.1201ZM40.0001 39.9384L8.04293 51.5461L40.0002 139.528L71.9573 51.5461L40.0001 39.9384ZM39.3397 38.1201L71.2969 26.5124L59.6888 -5.44584L27.731 6.16324L39.3397 38.1201ZM39.9651 39.9648L28.3574 71.922L96.7722 96.772L71.9223 28.3572L39.9651 39.9648ZM38.1203 39.3394L6.16204 27.7347L-5.44163 59.69L26.5127 71.2966L38.1203 39.3394ZM39.9387 39.9999L51.5463 71.9571L139.528 39.9999L51.5463 8.04269L39.9387 39.9999ZM38.1203 40.6604L26.5127 8.70317L-5.4456 20.3112L6.16348 52.2691L38.1203 40.6604ZM39.9651 40.0349L71.9223 51.6426L96.7721 -16.7721L28.3575 8.07774L39.9651 40.0349ZM39.3397 41.8797L27.731 73.8365L59.6888 85.4456L71.2969 53.4874L39.3397 41.8797ZM40.0001 40.0613L71.9573 28.4537L40.0002 -59.5283L8.04293 28.4537L40.0001 40.0613ZM40.6606 41.8797L8.70341 53.4873L20.3114 85.4456L52.2693 73.8365L40.6606 41.8797ZM28.4744 69.8607C27.9255 69.6492 27.3852 69.4235 26.8538 69.1843L54.7713 7.17932C54.1651 6.90639 53.5496 6.64933 52.9255 6.40882L28.4744 69.8607ZM24.39 67.9435C23.8904 67.6641 23.3921 67.3677 22.8961 67.0535L59.2874 9.61069C58.7225 9.25278 58.1541 8.91465 57.5839 8.5957L24.39 67.9435ZM22.8964 67.0537C22.4138 66.7479 21.9472 66.4341 21.4964 66.1139L60.8768 10.6776C60.3665 10.315 59.8366 9.95862 59.2871 9.61051L22.8964 67.0537ZM19.1329 64.2621C18.5566 63.7654 17.9671 63.2217 17.3727 62.6273L65.456 14.544C64.8133 13.9014 64.1679 13.3056 63.5282 12.7543L19.1329 64.2621ZM17.3727 62.6273C16.7783 62.0329 16.2346 61.4434 15.738 60.8671L67.2458 16.4718C66.6944 15.8321 66.0986 15.1867 65.456 14.544L17.3727 62.6273ZM13.8862 58.5036C13.5659 58.0528 13.2521 57.5862 12.9464 57.1037L70.3895 20.7128C70.0414 20.1633 69.685 19.6335 69.3224 19.1232L13.8862 58.5036ZM12.9465 57.1038C12.6323 56.6079 12.3358 56.1095 12.0564 55.61L71.4044 22.4162C71.0854 21.846 70.7473 21.2776 70.3894 20.7127L12.9465 57.1038ZM10.8158 53.1463C10.5766 52.615 10.3509 52.0747 10.1394 51.5258L73.5911 27.0744C73.3506 26.4503 73.0936 25.8348 72.8207 25.2287L10.8158 53.1463ZM73.5896 52.9295C73.6134 52.8677 73.6369 52.8061 73.6602 52.7447L10.0786 28.6329C10.0991 28.5788 10.1199 28.5244 10.1409 28.4699L73.5896 52.9295ZM73.7701 52.4512C73.7926 52.3902 73.8148 52.3295 73.8368 52.2691L9.92315 29.0517C9.94246 28.9985 9.96203 28.9451 9.98184 28.8915L73.7701 52.4512ZM53.4876 8.70317L52.9825 8.5197L29.7672 72.4341L30.2723 72.6176L53.4876 8.70317ZM52.1743 8.22615L51.6692 8.04269L28.454 71.9571L28.9591 72.1406L52.1743 8.22615ZM51.6692 71.9571L52.1743 71.7736L28.9591 7.85922L28.454 8.04269L51.6692 71.9571ZM52.9825 71.4801L53.4876 71.2966L30.2723 7.38221L29.7672 7.56567L52.9825 71.4801ZM73.8368 27.7307C73.8146 27.6696 73.7922 27.6085 73.7696 27.5474L9.98227 51.1095C9.96242 51.0558 9.94271 51.002 9.92315 50.9481L73.8368 27.7307ZM73.6604 27.2555C73.6374 27.1949 73.6143 27.1344 73.5909 27.0738L10.1396 51.5264C10.1191 51.4731 10.0987 51.4198 10.0785 51.3665L73.6604 27.2555ZM8.74271 26.5271L8.55807 27.0355L72.4725 50.2508L72.6571 49.7424L8.74271 26.5271ZM8.26263 27.8488L8.07799 28.3572L71.9924 51.5725L72.177 51.0641L8.26263 27.8488ZM51.6428 71.9221L52.1512 71.7374L28.9359 7.82299L28.4276 8.00763L51.6428 71.9221ZM52.9645 71.442L53.4729 71.2573L30.2576 7.34291L29.7493 7.52755L52.9645 71.442ZM72.6571 49.7424L75.5036 41.9057L11.5892 18.6904L8.74271 26.5271L72.6571 49.7424ZM80.058 29.3669L82.9045 21.5302L18.9901 -1.68511L16.1436 6.15163L80.058 29.3669ZM39.3397 41.8797C39.2576 41.8499 39.1745 41.8141 39.0919 41.7721L69.9155 -18.8407C67.5139 -20.0619 65.0551 -21.1265 62.5549 -22.0347L39.3397 41.8797ZM38.7358 41.5459C38.6735 41.4971 38.6236 41.4518 38.5859 41.4141L86.6692 -6.66915C84.779 -8.55931 82.7913 -10.3198 80.7186 -11.9465L38.7358 41.5459ZM38.5859 41.4141C38.5482 41.3764 38.5029 41.3265 38.4541 41.2642L91.9466 -0.718553C90.3198 -2.79127 88.5593 -4.77899 86.6692 -6.66915L38.5859 41.4141ZM38.228 40.9081C38.1859 40.8255 38.1501 40.7425 38.1203 40.6604L102.035 17.4451C101.127 14.9449 100.062 12.4861 98.8407 10.0845L38.228 40.9081ZM58.4699 -2.90446L50.6331 -0.0579707L73.8484 63.8564L81.6851 61.0099L58.4699 -2.90446ZM38.0944 4.49642L30.2576 7.34291L53.4729 71.2573L61.3096 68.4108L38.0944 4.49642ZM51.5267 69.8604C51.4734 69.881 51.4201 69.9013 51.3667 69.9216L27.2558 6.33964C27.1952 6.36262 27.1346 6.38578 27.0741 6.40911L51.5267 69.8604ZM51.1097 70.0178C51.056 70.0376 51.0022 70.0573 50.9483 70.0769L27.731 6.16324C27.6698 6.18545 27.6087 6.20784 27.5477 6.23038L51.1097 70.0178ZM7.38245 49.7277L7.56592 50.2328L71.4803 27.0175L71.2969 26.5124L7.38245 49.7277ZM7.85947 51.041L8.04293 51.5461L71.9573 28.3308L71.7739 27.8257L7.85947 51.041ZM71.9573 51.5461L72.1408 51.041L8.22639 27.8257L8.04293 28.3308L71.9573 51.5461ZM72.4344 50.2328L72.6178 49.7277L8.70341 26.5124L8.51994 27.0175L72.4344 50.2328ZM29.0519 70.0769C28.9981 70.0573 28.9442 70.0376 28.8904 70.0177L52.4527 6.23044C52.3916 6.20785 52.3305 6.18546 52.2693 6.16324L29.0519 70.0769ZM28.6326 69.9212C28.579 69.9009 28.5255 69.8804 28.4719 69.8598L52.928 6.40979C52.8671 6.38633 52.8063 6.36306 52.7454 6.34L28.6326 69.9212ZM69.8611 51.5253C69.6495 52.0745 69.4237 52.615 69.1844 53.1465L7.17968 25.2285C6.90668 25.8348 6.64953 26.4505 6.40891 27.075L69.8611 51.5253ZM67.9436 55.6104C67.6642 56.1099 67.3678 56.6081 67.0537 57.1039L9.61093 20.7126C9.25315 21.2774 8.91509 21.8456 8.59617 22.4158L67.9436 55.6104ZM67.0539 57.1036C66.7482 57.5861 66.4344 58.0527 66.1142 58.5035L10.6777 19.1233C10.3152 19.6336 9.95883 20.1634 9.61075 20.7129L67.0539 57.1036ZM64.2624 60.867C63.7657 61.4432 63.2221 62.0328 62.6276 62.6273L14.5443 14.544C13.9016 15.1868 13.3057 15.8323 12.7543 16.472L64.2624 60.867ZM62.6276 62.6273C62.033 63.2218 61.4435 63.7655 60.8672 64.2622L16.4722 12.7541C15.8325 13.3055 15.187 13.9013 14.5443 14.544L62.6276 62.6273ZM58.5038 66.1139C58.053 66.4342 57.5864 66.7479 57.1039 67.0536L20.7131 9.61055C20.1636 9.95863 19.6338 10.315 19.1235 10.6775L58.5038 66.1139ZM57.104 67.0535C56.6082 67.3676 56.11 67.6641 55.6105 67.9434L22.4162 8.59583C21.846 8.91475 21.2777 9.25282 20.7129 9.61064L57.104 67.0535ZM53.1468 69.1841C52.6154 69.4234 52.0751 69.6491 51.5261 69.8607L27.0746 6.40888C26.4504 6.64944 25.8348 6.90653 25.2286 7.17948L53.1468 69.1841ZM26.5273 71.2573L27.0357 71.4419L50.251 7.52757L49.7427 7.34292L26.5273 71.2573ZM27.8491 71.7374L28.3574 71.922L51.5728 8.00765L51.0644 7.823L27.8491 71.7374ZM71.9223 28.3572L71.7376 27.8488L7.82324 51.0641L8.00788 51.5725L71.9223 28.3572ZM71.4422 27.0355L71.2576 26.5271L7.34315 49.7424L7.5278 50.2508L71.4422 27.0355ZM49.7426 7.34291L41.9059 4.49642L18.6906 68.4108L26.5274 71.2573L49.7426 7.34291ZM29.3671 -0.057969L21.5304 -2.90446L-1.68487 61.0099L6.15187 63.8564L29.3671 -0.057969ZM41.88 40.6604C41.8502 40.7425 41.8143 40.8255 41.7723 40.9081L-18.8404 10.0845C-20.0617 12.4861 -21.1263 14.9449 -22.0344 17.4451L41.88 40.6604ZM41.5462 41.2642C41.4973 41.3265 41.452 41.3764 41.4143 41.4141L-6.66891 -6.66915C-8.55907 -4.779 -10.3195 -2.79128 -11.9463 -0.718564L41.5462 41.2642ZM41.4143 41.4141C41.3767 41.4518 41.3267 41.4971 41.2645 41.5459L-0.718321 -11.9465C-2.79104 -10.3198 -4.77876 -8.55931 -6.66891 -6.66915L41.4143 41.4141ZM40.9084 41.7721C40.8257 41.8141 40.7427 41.8499 40.6606 41.8797L17.4453 -22.0347C14.9451 -21.1265 12.4863 -20.0619 10.0848 -18.8407L40.9084 41.7721ZM-2.90422 21.5302L-0.0577289 29.3669L63.8567 6.15162L61.0102 -1.68511L-2.90422 21.5302ZM4.49666 41.9057L7.34315 49.7424L71.2576 26.5271L68.4111 18.6904L4.49666 41.9057ZM69.8615 28.4756C69.8819 28.5283 69.9021 28.5813 69.9222 28.6343L6.33952 52.7433C6.36237 52.8036 6.38537 52.8637 6.4085 52.9238L69.8615 28.4756ZM70.018 28.8903C70.0378 28.944 70.0575 28.9978 70.0771 29.0517L6.16348 52.2691C6.18572 52.3303 6.20809 52.3914 6.23061 52.4523L70.018 28.8903ZM49.7279 72.6176L50.233 72.4341L27.0178 8.51971L26.5127 8.70317L49.7279 72.6176ZM51.0412 72.1406L51.5463 71.9571L28.331 8.04269L27.8259 8.22616L51.0412 72.1406ZM51.5463 8.04269L51.0412 7.85923L27.8259 71.7736L28.331 71.9571L51.5463 8.04269ZM50.233 7.56568L49.7279 7.38221L26.5127 71.2966L27.0178 71.4801L50.233 7.56568ZM70.0786 50.9441C70.0585 50.9995 70.0384 51.0544 70.0182 51.1089L6.23039 27.5481C6.20757 27.6098 6.18478 27.6721 6.16204 27.7347L70.0786 50.9441ZM69.9218 51.3666C69.9017 51.4195 69.8816 51.4721 69.8615 51.5242L6.40851 27.076C6.38562 27.1354 6.36276 27.1952 6.33994 27.2554L69.9218 51.3666ZM6.40899 52.925C6.6496 53.5494 6.90674 54.1651 7.17972 54.7714L69.1844 26.8532C69.4236 27.3846 69.6494 27.9251 69.861 28.4743L6.40899 52.925ZM8.59615 57.584C8.91506 58.1542 9.25312 58.7224 9.61093 59.2872L67.0537 22.8959C67.3678 23.3917 67.6642 23.8899 67.9436 24.3894L8.59615 57.584ZM9.61075 59.2869C9.95883 59.8363 10.3152 60.3661 10.6777 60.8765L66.1142 21.4963C66.4344 21.9471 66.7482 22.4137 67.0539 22.8962L9.61075 59.2869ZM12.7543 63.5278C13.3057 64.1675 13.9016 64.813 14.5443 65.4557L62.6276 17.3725C63.2221 17.967 63.7657 18.5565 64.2624 19.1328L12.7543 63.5278ZM14.5443 65.4557C15.187 66.0985 15.8325 66.6943 16.4722 67.2457L60.8672 15.7376C61.4435 16.2343 62.033 16.7779 62.6276 17.3725L14.5443 65.4557ZM19.1235 69.3223C19.6338 69.6848 20.1636 70.0412 20.7131 70.3892L57.1039 12.9462C57.5864 13.2519 58.053 13.5656 58.5038 13.8859L19.1235 69.3223ZM20.7129 70.3891C21.2777 70.7469 21.8459 71.085 22.4161 71.4039L55.6106 12.0564C56.1101 12.3358 56.6083 12.6322 57.104 12.9462L20.7129 70.3891ZM25.2287 72.8203C25.835 73.0933 26.4506 73.3505 27.075 73.5911L51.5257 10.139C52.0748 10.3506 52.6153 10.5764 53.1468 10.8157L25.2287 72.8203ZM49.7426 72.6569L50.251 72.4722L27.0357 8.55782L26.5274 8.74246L49.7426 72.6569ZM51.0643 72.1768L51.5727 71.9922L28.3575 8.07774L27.8491 8.26238L51.0643 72.1768ZM8.00787 28.4273L7.82322 28.9357L71.7376 52.1509L71.9223 51.6426L8.00787 28.4273ZM7.52779 29.7491L7.34314 30.2574L71.2576 53.4726L71.4422 52.9643L7.52779 29.7491ZM26.5274 8.74247L18.6906 11.589L41.9059 75.5034L49.7426 72.6569L26.5274 8.74247ZM6.15187 16.1433L-1.68487 18.9898L21.5304 82.9042L29.3671 80.0578L6.15187 16.1433ZM-22.0344 62.5547C-21.1263 65.0549 -20.0617 67.5137 -18.8404 69.9153L41.7723 39.0916C41.8143 39.1743 41.8501 39.2573 41.88 39.3394L-22.0344 62.5547ZM-11.9463 80.7183C-10.3195 82.7911 -8.55907 84.7788 -6.66891 86.6689L41.4143 38.5857C41.452 38.6234 41.4973 38.6733 41.5462 38.7355L-11.9463 80.7183ZM-6.66891 86.6689C-4.77876 88.5591 -2.79104 90.3196 -0.718321 91.9463L41.2645 38.4538C41.3267 38.5027 41.3767 38.548 41.4143 38.5857L-6.66891 86.6689ZM10.0848 98.8405C12.4863 100.062 14.9451 101.126 17.4454 102.034L40.6606 38.1201C40.7427 38.1499 40.8257 38.1857 40.9084 38.2277L10.0848 98.8405ZM61.0102 81.6849L63.8567 73.8482L-0.0577289 50.6329L-2.90422 58.4696L61.0102 81.6849ZM68.4111 61.3094L71.2576 53.4727L7.34315 30.2574L4.49666 38.0941L68.4111 61.3094ZM27.0745 73.5908C27.1356 73.6144 27.1965 73.6377 27.2574 73.6608L51.3651 10.0776C51.4187 10.0979 51.4724 10.1184 51.5262 10.1392L27.0745 73.5908ZM27.5491 73.7699C27.6099 73.7924 27.6705 73.8146 27.731 73.8365L50.9483 9.92291C51.0015 9.94222 51.0548 9.96175 51.1083 9.98149L27.5491 73.7699ZM71.2969 53.4874L71.4803 52.9823L7.56592 29.767L7.38245 30.2721L71.2969 53.4874ZM71.7739 52.1741L71.9573 51.669L8.04293 28.4537L7.85947 28.9588L71.7739 52.1741ZM8.04293 51.669L8.2264 52.1741L72.1408 28.9588L71.9573 28.4537L8.04293 51.669ZM8.51994 52.9822L8.70341 53.4873L72.6178 30.2721L72.4344 29.767L8.51994 52.9822ZM52.2693 73.8365C52.3298 73.8146 52.3904 73.7924 52.4513 73.7699L28.8918 9.98154C28.9454 9.96177 28.9988 9.94222 29.0519 9.92291L52.2693 73.8365ZM52.744 73.6603C52.8051 73.6372 52.8665 73.6137 52.928 73.59L28.4719 10.14C28.5261 10.1191 28.5802 10.0985 28.634 10.078L52.744 73.6603ZM52.9253 73.591C53.5495 73.3505 54.1651 73.0934 54.7713 72.8204L26.8537 10.8155C27.3851 10.5763 27.9255 10.3506 28.4745 10.139L52.9253 73.591ZM57.5839 71.404C58.1542 71.0851 58.7225 70.747 59.2874 70.3891L22.8961 12.9463C23.3921 12.6321 23.8904 12.3357 24.3899 12.0563L57.5839 71.404ZM59.2871 70.3893C59.8366 70.0412 60.3665 69.6847 60.8768 69.3222L21.4964 13.8859C21.9472 13.5657 22.4138 13.2518 22.8964 12.9461L59.2871 70.3893ZM63.5282 67.2455C64.1679 66.6942 64.8133 66.0984 65.456 65.4557L17.3727 17.3725C17.9671 16.7781 18.5566 16.2344 19.1329 15.7377L63.5282 67.2455ZM65.456 65.4557C66.0986 64.8131 66.6944 64.1677 67.2458 63.528L15.738 19.1327C16.2346 18.5564 16.7783 17.9669 17.3727 17.3725L65.456 65.4557ZM69.3224 60.8766C69.685 60.3663 70.0414 59.8365 70.3895 59.287L12.9464 22.8961C13.2521 22.4135 13.5659 21.9469 13.8862 21.4961L69.3224 60.8766ZM70.3894 59.2871C70.7473 58.7221 71.0854 58.1538 71.4044 57.5836L12.0564 24.3898C12.3358 23.8903 12.6323 23.3919 12.9465 22.896L70.3894 59.2871ZM72.8207 54.7711C73.0936 54.1649 73.3506 53.5495 73.5911 52.9254L10.1394 28.474C10.3509 27.9251 10.5766 27.3848 10.8158 26.8535L72.8207 54.7711ZM72.6571 30.2574L72.4725 29.749L8.55806 52.9643L8.7427 53.4726L72.6571 30.2574ZM72.177 28.9357L71.9924 28.4273L8.07798 51.6426L8.26262 52.1509L72.177 28.9357ZM28.4276 71.9922L28.9359 72.1768L52.1512 8.26238L51.6428 8.07773L28.4276 71.9922ZM29.7493 72.4722L30.2576 72.6569L53.4729 8.74246L52.9645 8.55782L29.7493 72.4722ZM8.74271 53.4727L11.5892 61.3094L75.5036 38.0941L72.6571 30.2574L8.74271 53.4727ZM16.1436 73.8482L18.9901 81.6849L82.9045 58.4696L80.058 50.6329L16.1436 73.8482ZM62.5549 102.034C65.0551 101.126 67.5139 100.062 69.9155 98.8405L39.0919 38.2277C39.1745 38.1857 39.2576 38.1499 39.3396 38.1201L62.5549 102.034ZM80.7186 91.9463C82.7913 90.3196 84.779 88.5591 86.6692 86.6689L38.5859 38.5857C38.6236 38.548 38.6735 38.5027 38.7358 38.4538L80.7186 91.9463ZM86.6692 86.6689C88.5593 84.7788 90.3198 82.7911 91.9466 80.7183L38.4541 38.7355C38.503 38.6733 38.5482 38.6234 38.5859 38.5857L86.6692 86.6689ZM98.8407 69.9153C100.062 67.5137 101.127 65.0549 102.035 62.5547L38.1203 39.3394C38.1501 39.2573 38.1859 39.1743 38.228 39.0916L98.8407 69.9153ZM81.6851 18.9898L73.8484 16.1433L50.6331 80.0578L58.4699 82.9042L81.6851 18.9898ZM61.3096 11.589L53.4729 8.74247L30.2576 72.6569L38.0944 75.5034L61.3096 11.589Z",
          fill: "#353F45",
          mask: "url(#path-3-inside-1)"
        }), l.a.createElement("g", null, l.a.createElement("path", {
          d: "M40.5 29C33.0564 29 27 33.5182 27 39.0721C27 42.5334 29.9576 45.5233 32.8794 46.689C33.393 46.8932 33.7283 47.3907 33.7283 47.9426C33.7283 49.7345 33.091 51.4856 32.4054 52.8493C33.9659 52.4211 35.7702 51.5895 36.5994 49.9795C36.832 49.5315 37.2948 49.2494 37.7998 49.2494H40.5C47.9436 49.2494 54 44.6842 54 39.0721C54 33.5182 47.9436 29 40.5 29Z",
          fill: "white"
        }), l.a.createElement("path", {
          d: "M32.5088 47.6178L32.51 47.6182C32.6406 47.6702 32.7283 47.7979 32.7283 47.9426C32.7283 49.5136 32.1641 51.103 31.512 52.4002C31.3345 52.7531 31.3815 53.1775 31.6319 53.4831C31.8823 53.7886 32.2891 53.9182 32.6701 53.8137C34.2932 53.3683 36.4566 52.4385 37.4873 50.4396C37.5486 50.3222 37.6697 50.2494 37.7998 50.2494H40.5C44.4192 50.2494 48.0101 49.0488 50.6433 47.0638C53.2766 45.0787 55 42.2623 55 39.0721C55 35.9066 53.2721 33.116 50.6393 31.1518C48.0063 29.1874 44.4168 28 40.5 28C36.5832 28 32.9937 29.1874 30.3607 31.1518C27.7279 33.116 26 35.9066 26 39.0721C26 41.0938 26.8626 42.9254 28.0758 44.3815C29.2879 45.8364 30.8949 46.9739 32.5088 47.6178Z",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinejoin: "round"
        })), l.a.createElement("circle", {
          cx: "34.5",
          cy: "39.5",
          r: "1.5",
          fill: "#353F45"
        }), l.a.createElement("circle", {
          cx: "40.5",
          cy: "39.5",
          r: "1.5",
          fill: "#353F45"
        }), l.a.createElement("circle", {
          cx: "46.5",
          cy: "39.5",
          r: "1.5",
          fill: "#353F45"
        })), l.a.createElement("defs", null, l.a.createElement("clipPath", {
          id: "clip0"
        }, l.a.createElement("rect", {
          width: "80",
          height: "80",
          fill: "white"
        }))));
      },
      "cw-team-availability": function CWTeamAvailabilitySvg(_ref207) {
        var _ref207$height = _ref207.height,
            e = _ref207$height === void 0 ? 80 : _ref207$height,
            _ref207$width = _ref207.width,
            t = _ref207$width === void 0 ? 80 : _ref207$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("g", null, l.a.createElement("rect", {
          x: "10",
          y: "16",
          width: "60",
          height: "52",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("line", {
          x1: "20",
          y1: "13",
          x2: "20",
          y2: "19",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), l.a.createElement("line", {
          x1: "41",
          y1: "13",
          x2: "41",
          y2: "19",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), l.a.createElement("line", {
          x1: "62",
          y1: "13",
          x2: "62",
          y2: "19",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), l.a.createElement("rect", {
          x: "14",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "25",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "36",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "47",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "58",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "14",
          y: "44",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "25",
          y: "44",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "36",
          y: "44",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "47",
          y: "44",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "58",
          y: "44",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "14",
          y: "55",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "25",
          y: "55",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "36",
          y: "55",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "47",
          y: "55",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "58",
          y: "55",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "14",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "25",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "36",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "47",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "58",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        })), l.a.createElement("circle", {
          cx: "65",
          cy: "61",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M59.9999 60.9997L63.7499 64.7497L70.2499 57.2497",
          stroke: "white",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }));
      },
      "cw-conversation-ratings": function CWConversationRatingsSVG(_ref208) {
        var _ref208$height = _ref208.height,
            e = _ref208$height === void 0 ? 80 : _ref208$height,
            _ref208$width = _ref208.width,
            t = _ref208$width === void 0 ? 80 : _ref208$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("g", {
          clipPath: "url(#clip0)"
        }, l.a.createElement("g", null, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M34.3514 20.725C35.926 20.1621 37.0542 18.6431 37.0542 16.8576C37.0542 14.5929 35.2391 12.757 33.0001 12.757C30.7612 12.757 28.9461 14.5929 28.9461 16.8576C28.9461 18.643 30.0741 20.1619 31.6487 20.7249V27.109H27.5946V29.8433H10.0523C8.91884 29.8433 8 30.7622 8 31.8956V59.2293C8 60.3627 8.91884 61.2816 10.0523 61.2816H31.0769V64.6923H34.9231V61.2816H55.9477C57.0812 61.2816 58 60.3627 58 59.2293V31.8956C58 30.7622 57.0812 29.8433 55.9477 29.8433H38.4054V27.109H34.3514V20.725ZM31.0769 64.6923C24.7044 64.6923 19.5385 69.8582 19.5385 76.2308V78.1538C19.5385 79.2159 20.3995 80.0769 21.4615 80.0769H44.5385C45.6005 80.0769 46.4615 79.2159 46.4615 78.1538V76.2308C46.4615 69.8582 41.2956 64.6923 34.9231 64.6923H31.0769Z",
          fill: "#353F45"
        }), l.a.createElement("rect", {
          x: "14.7568",
          y: "38.7273",
          width: "37.1622",
          height: "11.6185",
          rx: "5.80924",
          fill: "white"
        }), l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M46.5134 44.5351C46.5134 46.6111 44.8496 48.294 42.7972 48.294C40.7448 48.294 39.081 46.6111 39.081 44.5351C39.081 42.4591 40.7448 40.7761 42.7972 40.7761C44.8496 40.7761 46.5134 42.4591 46.5134 44.5351ZM27.5945 44.5355C27.5945 46.6115 25.9307 48.2944 23.8783 48.2944C21.8259 48.2944 20.1621 46.6115 20.1621 44.5355C20.1621 42.4595 21.8259 40.7766 23.8783 40.7766C25.9307 40.7766 27.5945 42.4595 27.5945 44.5355Z",
          fill: "#353F45"
        })), l.a.createElement("g", null, l.a.createElement("path", {
          d: "M60.5 13C53.0564 13 47 17.5182 47 23.0721C47 26.5334 49.9576 29.5232 52.8794 30.689C53.393 30.8932 53.7283 31.3906 53.7283 31.9426C53.7283 33.7345 53.091 35.4856 52.4054 36.8493C53.9659 36.4211 55.7702 35.5895 56.5994 33.9795C56.832 33.5315 57.2948 33.2494 57.7998 33.2494H60.5C67.9436 33.2494 74 28.6842 74 23.0721C74 17.5182 67.9436 13 60.5 13Z",
          fill: "white"
        }), l.a.createElement("path", {
          d: "M52.5088 31.6178L52.51 31.6182C52.6406 31.6701 52.7283 31.7978 52.7283 31.9426C52.7283 33.5136 52.1641 35.103 51.512 36.4001C51.3345 36.7531 51.3815 37.1774 51.6319 37.483C51.8823 37.7886 52.2891 37.9182 52.6701 37.8137C54.2932 37.3683 56.4566 36.4385 57.4873 34.4395C57.5486 34.3221 57.6697 34.2494 57.7998 34.2494H60.5C64.4192 34.2494 68.0101 33.0488 70.6433 31.0638C73.2766 29.0787 75 26.2622 75 23.0721C75 19.9065 73.2721 17.116 70.6393 15.1518C68.0063 13.1874 64.4168 12 60.5 12C56.5832 12 52.9937 13.1874 50.3607 15.1518C47.7279 17.116 46 19.9065 46 23.0721C46 25.0938 46.8626 26.9254 48.0758 28.3815C49.2879 29.8364 50.8949 30.9738 52.5088 31.6178Z",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinejoin: "round"
        })), l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M64.8401 21.9647L63.0699 23.777L63.4885 26.3468C63.5235 26.56 63.4333 26.7733 63.2576 26.8973C63.1607 26.9656 63.0474 27 62.9336 27C62.8401 27 62.7466 26.9769 62.6609 26.9301L60.5003 25.7337L58.3396 26.9301C58.1515 27.0338 57.9199 27.0214 57.7436 26.8973C57.5672 26.7733 57.4776 26.56 57.512 26.3468L57.9306 23.777L56.1604 21.9647C56.0128 21.8141 55.9621 21.593 56.0291 21.3933C56.0962 21.1931 56.2691 21.0476 56.4776 21.016L58.9013 20.6454L59.991 18.3232C60.0834 18.1263 60.2822 18 60.5003 18C60.7183 18 60.9166 18.1263 61.0096 18.3232L62.0986 20.6454L64.5224 21.016C64.7308 21.0476 64.9044 21.1931 64.9709 21.3933C65.0379 21.593 64.9872 21.8141 64.8401 21.9647Z",
          fill: "#353F45"
        })), l.a.createElement("defs", null, l.a.createElement("clipPath", {
          id: "clip0"
        }, l.a.createElement("rect", {
          width: "80",
          height: "80",
          fill: "white"
        }))));
      },
      "cw-document-success": function CWDocumentSuccessSVG(_ref209) {
        var _ref209$height = _ref209.height,
            e = _ref209$height === void 0 ? 80 : _ref209$height,
            _ref209$width = _ref209.width,
            t = _ref209$width === void 0 ? 80 : _ref209$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "16",
          y: "11",
          width: "48",
          height: "58",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("rect", {
          x: "20",
          y: "19",
          width: "31",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "20",
          y: "25",
          width: "39",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "20",
          y: "31",
          width: "23",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("circle", {
          cx: "59",
          cy: "65",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M53.9999 64.9997L57.7499 68.7497L64.2499 61.2497",
          stroke: "white",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }));
      },
      "cw-document": function CWDocumentSVG(_ref210) {
        var _ref210$height = _ref210.height,
            e = _ref210$height === void 0 ? 80 : _ref210$height,
            _ref210$width = _ref210.width,
            t = _ref210$width === void 0 ? 80 : _ref210$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "16",
          y: "11",
          width: "48",
          height: "58",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("rect", {
          x: "20",
          y: "19",
          width: "31",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "20",
          y: "25",
          width: "39",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "20",
          y: "31",
          width: "23",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }));
      },
      "cw-empty-search": function CWEmptySearchSVG(_ref211) {
        var _ref211$height = _ref211.height,
            e = _ref211$height === void 0 ? 80 : _ref211$height,
            _ref211$width = _ref211.width,
            t = _ref211$width === void 0 ? 80 : _ref211$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "6",
          y: "24.3211",
          width: "46.4211",
          height: "5.52632",
          rx: "1",
          fill: "#353F45"
        }), l.a.createElement("rect", {
          x: "6",
          y: "35.3737",
          width: "37.5789",
          height: "5.52632",
          rx: "1",
          fill: "#353F45"
        }), l.a.createElement("rect", {
          x: "6",
          y: "46.4263",
          width: "42",
          height: "5.52632",
          rx: "1",
          fill: "#353F45"
        }), l.a.createElement("circle", {
          cx: "45.7894",
          cy: "32.0579",
          r: "22",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("mask", {
          id: "mask0",
          "mask-type": "alpha",
          maskUnits: "userSpaceOnUse",
          x: "24",
          y: "11",
          width: "43",
          height: "43"
        }, l.a.createElement("circle", {
          cx: "45.7894",
          cy: "32.0579",
          r: "21",
          fill: "white"
        })), l.a.createElement("g", {
          mask: "url(#mask0)"
        }, l.a.createElement("rect", {
          x: "-1.73694",
          y: "17.6895",
          width: "55.7053",
          height: "6.63158",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "-1.73694",
          y: "28.7421",
          width: "45.0947",
          height: "6.63158",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "-1.73694",
          y: "39.7948",
          width: "50.4",
          height: "6.63158",
          rx: "1",
          fill: "#EFF3F5"
        })), l.a.createElement("path", {
          d: "M51.3157 54.0834L58.4291 50.8474L65.0674 65.4399C65.7535 66.948 65.087 68.7268 63.5789 69.4128L61.927 70.1643C60.4188 70.8504 58.6401 70.184 57.954 68.6759L51.3157 54.0834Z",
          fill: "#353F45",
          stroke: "#353F45",
          strokeWidth: "2"
        }));
      },
      "cw-image-success": function CWImageSuccessSVG(_ref212) {
        var _ref212$height = _ref212.height,
            e = _ref212$height === void 0 ? 80 : _ref212$height,
            _ref212$width = _ref212.width,
            t = _ref212$width === void 0 ? 80 : _ref212$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "8",
          y: "18",
          width: "64",
          height: "44",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M35.1415 36.4374C35.5295 35.7878 36.4705 35.7878 36.8585 36.4374L48.0869 55.2372C48.485 55.9038 48.0047 56.75 47.2283 56.75H24.7717C23.9953 56.75 23.515 55.9038 23.9131 55.2372L35.1415 36.4374Z",
          fill: "#EFF3F5"
        }), l.a.createElement("path", {
          d: "M33.5719 56.7417L33.1143 57.5H34H67.2286C68.3962 57.5 69.1161 56.2247 68.5129 55.225L52.7843 29.1605C52.2009 28.1938 50.7991 28.1938 50.2157 29.1605L33.5719 56.7417Z",
          fill: "#EFF3F5",
          stroke: "white"
        }), l.a.createElement("circle", {
          cx: "21",
          cy: "31",
          r: "7",
          fill: "#EFF3F5"
        }), l.a.createElement("circle", {
          cx: "66",
          cy: "58",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M60.9999 57.9997L64.7499 61.7497L71.2499 54.2497",
          stroke: "white",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }));
      },
      "cw-image": function CWImageSVG(_ref213) {
        var _ref213$height = _ref213.height,
            e = _ref213$height === void 0 ? 80 : _ref213$height,
            _ref213$width = _ref213.width,
            t = _ref213$width === void 0 ? 80 : _ref213$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "8",
          y: "18",
          width: "64",
          height: "44",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M35.1415 36.4374C35.5295 35.7878 36.4705 35.7878 36.8585 36.4374L48.0869 55.2372C48.485 55.9038 48.0047 56.75 47.2283 56.75H24.7717C23.9953 56.75 23.515 55.9038 23.9131 55.2372L35.1415 36.4374Z",
          fill: "#EFF3F5"
        }), l.a.createElement("path", {
          d: "M33.5719 56.7417L33.1143 57.5H34H67.2286C68.3962 57.5 69.1161 56.2247 68.5129 55.225L52.7843 29.1605C52.2009 28.1938 50.7991 28.1938 50.2157 29.1605L33.5719 56.7417Z",
          fill: "#EFF3F5",
          stroke: "white"
        }), l.a.createElement("circle", {
          cx: "21",
          cy: "31",
          r: "7",
          fill: "#EFF3F5"
        }));
      },
      "cw-video-success": function CWVideoSuccessSVG(_ref214) {
        var _ref214$height = _ref214.height,
            e = _ref214$height === void 0 ? 80 : _ref214$height,
            _ref214$width = _ref214.width,
            t = _ref214$width === void 0 ? 80 : _ref214$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "8",
          y: "18",
          width: "64",
          height: "44",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M50.5 39.134C51.1667 39.5189 51.1667 40.4811 50.5 40.866L34 50.3923C33.3333 50.7772 32.5 50.2961 32.5 49.5263L32.5 30.4737C32.5 29.7039 33.3333 29.2228 34 29.6077L50.5 39.134Z",
          fill: "#EFF3F5"
        }), l.a.createElement("circle", {
          cx: "66",
          cy: "58",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M60.9999 57.9997L64.7499 61.7497L71.2499 54.2497",
          stroke: "white",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }));
      },
      "cw-video": function CWVideoSVG(_ref215) {
        var _ref215$height = _ref215.height,
            e = _ref215$height === void 0 ? 80 : _ref215$height,
            _ref215$width = _ref215.width,
            t = _ref215$width === void 0 ? 80 : _ref215$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "8",
          y: "18",
          width: "64",
          height: "44",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M50.5 39.134C51.1667 39.5189 51.1667 40.4811 50.5 40.866L34 50.3923C33.3333 50.7772 32.5 50.2961 32.5 49.5263L32.5 30.4737C32.5 29.7039 33.3333 29.2228 34 29.6077L50.5 39.134Z",
          fill: "#EFF3F5"
        }));
      },
      "cw-announcement": function CWAnnouncementSVG(_ref216) {
        var _ref216$height = _ref216.height,
            e = _ref216$height === void 0 ? 40 : _ref216$height,
            _ref216$width = _ref216.width,
            t = _ref216$width === void 0 ? 40 : _ref216$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("circle", {
          cx: "31.5",
          cy: "16.5",
          r: "4.5",
          fill: "#353F45"
        }), l.a.createElement("path", {
          d: "M26.9218 27.1368C27.3054 29.3124 25.8527 31.387 23.6772 31.7706C21.5016 32.1542 19.4269 30.7015 19.0433 28.526",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M25.8648 8.4744L5.75626 24.1683C5.39419 24.4509 5.27116 24.9438 5.45797 25.3634L7.4395 29.814C7.62878 30.2391 8.08628 30.4774 8.54315 30.389L33.4252 25.5709C33.828 25.493 34.1397 25.1783 34.1782 24.7699C34.3167 23.3008 34.4086 19.5969 32.5433 15.4075C30.6871 11.2383 28.034 9.1518 26.9056 8.40948C26.5823 8.19677 26.1699 8.23629 25.8648 8.4744Z",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M10 21.2018L6 24.7018L8.5 30.2018L13.5 29.2018L10 21.2018Z",
          fill: "#353F45"
        }));
      },
      "cw-bots": function CWBotsSVG(_ref217) {
        var _ref217$height = _ref217.height,
            e = _ref217$height === void 0 ? 40 : _ref217$height,
            _ref217$width = _ref217.width,
            t = _ref217$width === void 0 ? 40 : _ref217$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.8772 6.50283C21.7662 6.18473 22.4032 5.32634 22.4032 4.31733C22.4032 3.0375 21.3784 2 20.1144 2C18.8503 2 17.8256 3.0375 17.8256 4.31733C17.8256 5.32628 18.4624 6.18463 19.3514 6.50277V10.1105H17.0625V11.6558H7.15867C6.51875 11.6558 6 12.1745 6 12.8144V28.2633C6 28.9032 6.51875 29.4219 7.15866 29.4219H19.0286V31.3143C15.4308 31.3143 12.5143 34.2308 12.5143 37.8286V38.9143C12.5143 39.5139 13.0004 40 13.6 40H26.6286C27.2282 40 27.7143 39.5139 27.7143 38.9143V37.8286C27.7143 34.2308 24.7977 31.3143 21.2 31.3143V29.4219H33.0699C33.7098 29.4219 34.2286 28.9032 34.2286 28.2633V12.8144C34.2286 12.1745 33.7098 11.6558 33.0699 11.6558H23.166V10.1105H20.8772V6.50283Z",
          fill: "#353F45"
        }), l.a.createElement("rect", {
          x: "9.81476",
          y: "16.6762",
          width: "20.9807",
          height: "6.56577",
          rx: "3.28288",
          fill: "white"
        }), l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M27.7436 19.9583C27.7436 21.1314 26.8043 22.0825 25.6456 22.0825C24.4868 22.0825 23.5475 21.1314 23.5475 19.9583C23.5475 18.7851 24.4868 17.834 25.6456 17.834C26.8043 17.834 27.7436 18.7851 27.7436 19.9583ZM17.0626 19.9587C17.0626 21.1319 16.1233 22.0829 14.9645 22.0829C13.8058 22.0829 12.8665 21.1319 12.8665 19.9587C12.8665 18.7855 13.8058 17.8345 14.9645 17.8345C16.1233 17.8345 17.0626 18.7855 17.0626 19.9587Z",
          fill: "#353F45"
        }));
      },
      "cw-clp-marketplace": function CWCLPSVG(_ref218) {
        var _ref218$height = _ref218.height,
            e = _ref218$height === void 0 ? 40 : _ref218$height,
            _ref218$width = _ref218.width,
            t = _ref218$width === void 0 ? 40 : _ref218$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "5.5",
          y: "8",
          width: "29",
          height: "24",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("rect", {
          x: "7.5",
          y: "27",
          width: "25",
          height: "2",
          rx: "1",
          fill: "#D6DDE1"
        }), l.a.createElement("rect", {
          x: "14",
          y: "15",
          width: "17.5",
          height: "3.5",
          rx: "0.5",
          fill: "#D6DDE1"
        }), l.a.createElement("rect", {
          x: "21",
          y: "20",
          width: "10.5",
          height: "3.5",
          rx: "0.5",
          fill: "#D6DDE1"
        }), l.a.createElement("rect", {
          x: "8",
          y: "11",
          width: "9",
          height: "2",
          rx: "1",
          fill: "#353F45"
        }));
      },
      "cw-email": function CWEmailSVG(_ref219) {
        var _ref219$height = _ref219.height,
            e = _ref219$height === void 0 ? 40 : _ref219$height,
            _ref219$width = _ref219.width,
            t = _ref219$width === void 0 ? 40 : _ref219$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "7",
          y: "15.0333",
          width: "26",
          height: "18.1748",
          rx: "0.504854",
          fill: "#353F45",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }), l.a.createElement("rect", {
          x: "8.51459",
          y: "7.46045",
          width: "22.9709",
          height: "23.4757",
          rx: "0.757282",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("rect", {
          x: "11",
          y: "11",
          width: "10",
          height: "2",
          rx: "1",
          fill: "#D6DDE1"
        }), l.a.createElement("rect", {
          x: "11",
          y: "14",
          width: "17",
          height: "2",
          rx: "1",
          fill: "#D6DDE1"
        }), l.a.createElement("path", {
          d: "M7 16.043V33.208H33L7 16.043Z",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }), l.a.createElement("path", {
          d: "M33 33.208V16.043L7 33.208H33Z",
          fill: "#353F45",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }));
      },
      "cw-live-chat": function CWLiveChatSVG(_ref220) {
        var _ref220$height = _ref220.height,
            e = _ref220$height === void 0 ? 40 : _ref220$height,
            _ref220$width = _ref220.width,
            t = _ref220$width === void 0 ? 40 : _ref220$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("path", {
          d: "M11.5068 26.7287L11.5079 26.7292C11.6369 26.7808 11.7283 26.9103 11.7283 27.0623C11.7283 28.646 11.1632 30.2473 10.5109 31.5531C10.3344 31.9064 10.3823 32.3304 10.6332 32.6353C10.8841 32.9403 11.291 33.069 11.6716 32.9639C13.2964 32.5153 15.459 31.5791 16.4885 29.5698C16.5514 29.4487 16.673 29.3773 16.7998 29.3773H19.5C23.4207 29.3773 27.0125 28.1687 29.6457 26.1711C32.2793 24.1732 34 21.3409 34 18.1357C34 14.9554 32.2748 12.1491 29.6418 10.1723C27.0086 8.19538 23.4182 7 19.5 7C15.5818 7 11.9914 8.19538 9.35824 10.1723C6.72518 12.1491 5 14.9554 5 18.1357C5 20.1664 5.861 22.0074 7.07378 23.4723C8.28541 24.9357 9.89228 26.0805 11.5068 26.7287Z",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }), l.a.createElement("path", {
          d: "M22.0988 14.1216C21.2462 14.1216 20.3662 14.5135 19.7475 15.1622C19.6512 15.2567 19.5687 15.3378 19.5 15.4189C19.4313 15.3378 19.3487 15.2567 19.2525 15.1622C18.6337 14.5135 17.7537 14.1216 16.9013 14.1216C15.2513 14.1216 14 15.3378 14 16.973C14 18.5811 14.7425 19.3919 15.9662 20.5946C17.4787 22.0811 19.17 23.5946 19.1837 23.6081C19.356 23.762 19.6165 23.762 19.7887 23.6081C19.8025 23.5946 21.4937 22.0811 23.0062 20.5946C24.2575 19.3919 25 18.5811 25 16.973C25 15.3378 23.7487 14.1216 22.0988 14.1216Z",
          fill: "#D6DDE1"
        }));
      },
      "dizzybot-error": function DizzybotErrorSVG(_ref221) {
        var _ref221$height = _ref221.height,
            e = _ref221$height === void 0 ? "80" : _ref221$height,
            _ref221$width = _ref221.width,
            t = _ref221$width === void 0 ? "80" : _ref221$width;
        return l.a.createElement("svg", {
          fill: "none",
          height: e,
          width: t,
          viewBox: "0 0 80 80"
        }, l.a.createElement("g", null, l.a.createElement("path", {
          clipRule: "evenodd",
          d: "M38.459 13.411h3.024v7.647h4.536v3.059h19.627a2.296 2.296 0 012.296 2.296v30.582a2.296 2.296 0 01-2.296 2.296H42.123v3.816h-4.304v-3.816H14.296A2.296 2.296 0 0112 56.995V26.413a2.296 2.296 0 012.296-2.296h19.627v-3.06h4.536zm-.64 49.696c-7.13 0-12.91 5.78-12.91 12.91v2.151c0 1.189.964 2.152 2.152 2.152h25.82a2.152 2.152 0 002.151-2.152v-2.151c0-7.13-5.78-12.91-12.91-12.91z",
          fill: "#353f45",
          fillRule: "evenodd"
        }), l.a.createElement("rect", {
          fill: "#fff",
          height: 12.999,
          rx: 6.5,
          transform: "rotate(-5 19.073 35.893)",
          width: 41.578,
          x: 19.073,
          y: 35.893
        }), l.a.createElement("path", {
          clipRule: "evenodd",
          d: "M55.088 40.812c-.04 2.322-1.935 4.172-4.23 4.132-2.297-.04-4.125-1.955-4.085-4.277.041-2.323 1.935-4.173 4.231-4.133 2.296.04 4.125 1.955 4.084 4.278zm-21.164-.37c-.04 2.323-1.935 4.173-4.23 4.133-2.297-.04-4.125-1.955-4.084-4.278.04-2.322 1.934-4.172 4.23-4.132 2.296.04 4.125 1.955 4.084 4.278z",
          fill: "#353f45",
          fillRule: "evenodd"
        }), l.a.createElement("path", {
          d: "M39.234 17.94c5.99 1.084 11.489 1.738 15.544 1.912 2.02.088 3.724.058 4.963-.11.612-.082 1.173-.206 1.617-.4.393-.173.995-.534 1.119-1.257s-.32-1.273-.633-1.573c-.353-.339-.838-.652-1.386-.945-1.109-.592-2.7-1.218-4.627-1.846-3.869-1.26-9.254-2.577-15.244-3.661S29.098 8.322 25.043 8.148c-2.02-.088-3.724-.058-4.963.11-.612.082-1.173.206-1.617.4-.393.173-.995.534-1.119 1.257-.124.722.32 1.273.633 1.573.353.339.838.652 1.386.945 1.109.592 2.7 1.218 4.627 1.846 3.869 1.26 9.254 2.577 15.244 3.661z",
          stroke: "#eff3f5",
          strokeWidth: 2
        }), l.a.createElement("path", {
          d: "M40.587 17.94c5.99-1.084 11.375-2.402 15.244-3.661 1.927-.628 3.518-1.254 4.627-1.846.548-.293 1.033-.606 1.386-.945.312-.3.757-.85.633-1.573s-.726-1.084-1.12-1.257c-.443-.194-1.004-.318-1.616-.4-1.24-.168-2.943-.198-4.963-.11-4.055.174-9.554.828-15.544 1.912s-11.375 2.402-15.244 3.661c-1.928.628-3.518 1.254-4.627 1.846-.548.293-1.033.606-1.386.945-.312.3-.757.85-.633 1.573s.726 1.084 1.12 1.257c.443.194 1.004.318 1.616.4 1.24.168 2.943.197 4.963.11 4.055-.175 9.554-.828 15.544-1.912z",
          stroke: "#eff3f5",
          strokeWidth: 2
        }), l.a.createElement("path", {
          clipRule: "evenodd",
          d: "M39.971 14.176c2.505 0 4.536-2.054 4.536-4.588C44.507 7.054 42.477 5 39.97 5c-2.505 0-4.536 2.054-4.536 4.588 0 2.534 2.031 4.588 4.536 4.588z",
          fill: "#353f45",
          fillRule: "evenodd"
        })));
      },
      "cw-upgrade-announcement": function CWUpgradeAnnouncementSVG(_ref222) {
        var _ref222$height = _ref222.height,
            e = _ref222$height === void 0 ? 40 : _ref222$height,
            _ref222$width = _ref222.width,
            t = _ref222$width === void 0 ? 40 : _ref222$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("circle", {
          cx: "31.5",
          cy: "16.5",
          r: "4.5",
          fill: "#687882"
        }), l.a.createElement("path", {
          d: "M26.9218 27.1368C27.3054 29.3124 25.8527 31.387 23.6772 31.7706C21.5016 32.1542 19.4269 30.7015 19.0433 28.526",
          stroke: "#687882",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M25.8648 8.4744L5.75626 24.1683C5.39419 24.4509 5.27116 24.9438 5.45797 25.3634L7.4395 29.814C7.62878 30.2391 8.08628 30.4774 8.54315 30.389L33.4252 25.5709C33.828 25.493 34.1397 25.1783 34.1782 24.7699C34.3167 23.3008 34.4086 19.5969 32.5433 15.4075C30.6871 11.2383 28.034 9.1518 26.9056 8.40948C26.5823 8.19677 26.1699 8.23629 25.8648 8.4744Z",
          fill: "#F5F8FA",
          stroke: "#687882",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M10 21.2018L6 24.7018L8.5 30.2018L13.5 29.2018L10 21.2018Z",
          fill: "#687882"
        }));
      },
      "cw-upgrade-bots": function CWUpgradeBotsSVG(_ref223) {
        var _ref223$height = _ref223.height,
            e = _ref223$height === void 0 ? 40 : _ref223$height,
            _ref223$width = _ref223.width,
            t = _ref223$width === void 0 ? 40 : _ref223$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.8772 6.50283C21.7662 6.18473 22.4032 5.32634 22.4032 4.31733C22.4032 3.0375 21.3784 2 20.1144 2C18.8503 2 17.8256 3.0375 17.8256 4.31733C17.8256 5.32628 18.4624 6.18463 19.3514 6.50277V10.1105H17.0625V11.6558H7.15867C6.51875 11.6558 6 12.1745 6 12.8144V28.2633C6 28.9032 6.51875 29.4219 7.15866 29.4219H19.0286V31.3143C15.4308 31.3143 12.5143 34.2308 12.5143 37.8286V38.9143C12.5143 39.5139 13.0004 40 13.6 40H26.6286C27.2282 40 27.7143 39.5139 27.7143 38.9143V37.8286C27.7143 34.2308 24.7977 31.3143 21.2 31.3143V29.4219H33.0699C33.7098 29.4219 34.2286 28.9032 34.2286 28.2633V12.8144C34.2286 12.1745 33.7098 11.6558 33.0699 11.6558H23.166V10.1105H20.8772V6.50283Z",
          fill: "#687882"
        }), l.a.createElement("rect", {
          x: "9.81476",
          y: "16.6762",
          width: "20.9807",
          height: "6.56577",
          rx: "3.28288",
          fill: "white"
        }), l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M27.7436 19.9583C27.7436 21.1314 26.8043 22.0825 25.6456 22.0825C24.4868 22.0825 23.5475 21.1314 23.5475 19.9583C23.5475 18.7851 24.4868 17.834 25.6456 17.834C26.8043 17.834 27.7436 18.7851 27.7436 19.9583ZM17.0626 19.9587C17.0626 21.1319 16.1233 22.0829 14.9645 22.0829C13.8058 22.0829 12.8665 21.1319 12.8665 19.9587C12.8665 18.7855 13.8058 17.8345 14.9645 17.8345C16.1233 17.8345 17.0626 18.7855 17.0626 19.9587Z",
          fill: "#687882"
        }));
      },
      "cw-upgrade-clp": function CWUpgradeCLPSVG(_ref224) {
        var _ref224$height = _ref224.height,
            e = _ref224$height === void 0 ? 40 : _ref224$height,
            _ref224$width = _ref224.width,
            t = _ref224$width === void 0 ? 40 : _ref224$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "5.5",
          y: "8",
          width: "29",
          height: "24",
          rx: "2",
          fill: "#F5F8FA",
          stroke: "#687882",
          strokeWidth: "2"
        }), l.a.createElement("rect", {
          x: "7.5",
          y: "27",
          width: "25",
          height: "2",
          rx: "1",
          fill: "#D6DDE1"
        }), l.a.createElement("rect", {
          x: "14",
          y: "15",
          width: "17.5",
          height: "3.5",
          rx: "0.5",
          fill: "#D6DDE1"
        }), l.a.createElement("rect", {
          x: "21",
          y: "20",
          width: "10.5",
          height: "3.5",
          rx: "0.5",
          fill: "#D6DDE1"
        }), l.a.createElement("rect", {
          x: "8",
          y: "11",
          width: "9",
          height: "2",
          rx: "1",
          fill: "#687882"
        }));
      },
      "cw-upgrade-email": function CWUpgradeEmailSVG(_ref225) {
        var _ref225$height = _ref225.height,
            e = _ref225$height === void 0 ? 40 : _ref225$height,
            _ref225$width = _ref225.width,
            t = _ref225$width === void 0 ? 40 : _ref225$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "7",
          y: "15.0333",
          width: "26",
          height: "18.1748",
          rx: "0.504854",
          fill: "#687882",
          stroke: "#687882",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }), l.a.createElement("rect", {
          x: "8.51459",
          y: "7.46045",
          width: "22.9709",
          height: "23.4757",
          rx: "0.757282",
          fill: "#F5F8FA",
          stroke: "#687882",
          strokeWidth: "2"
        }), l.a.createElement("rect", {
          x: "11",
          y: "11",
          width: "10",
          height: "2",
          rx: "1",
          fill: "#D6DDE1"
        }), l.a.createElement("rect", {
          x: "11",
          y: "14",
          width: "17",
          height: "2",
          rx: "1",
          fill: "#D6DDE1"
        }), l.a.createElement("path", {
          d: "M7 16.043V33.208H33L7 16.043Z",
          fill: "#F5F8FA",
          stroke: "#687882",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }), l.a.createElement("path", {
          d: "M33 33.208V16.043L7 33.208H33Z",
          fill: "#687882",
          stroke: "#687882",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }));
      },
      "cw-upgrade-live-chat": function CWUpgradeLiveChatSVG(_ref226) {
        var _ref226$height = _ref226.height,
            e = _ref226$height === void 0 ? 40 : _ref226$height,
            _ref226$width = _ref226.width,
            t = _ref226$width === void 0 ? 40 : _ref226$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("path", {
          d: "M11.5068 26.7287L11.5079 26.7292C11.6369 26.7808 11.7283 26.9103 11.7283 27.0623C11.7283 28.646 11.1632 30.2473 10.5109 31.5531C10.3344 31.9064 10.3823 32.3304 10.6332 32.6353C10.8841 32.9403 11.291 33.069 11.6716 32.9639C13.2964 32.5153 15.459 31.5791 16.4885 29.5698C16.5514 29.4487 16.673 29.3773 16.7998 29.3773H19.5C23.4207 29.3773 27.0125 28.1687 29.6457 26.1711C32.2793 24.1732 34 21.3409 34 18.1357C34 14.9554 32.2748 12.1491 29.6418 10.1723C27.0086 8.19538 23.4182 7 19.5 7C15.5818 7 11.9914 8.19538 9.35824 10.1723C6.72518 12.1491 5 14.9554 5 18.1357C5 20.1664 5.861 22.0074 7.07378 23.4723C8.28541 24.9357 9.89228 26.0805 11.5068 26.7287Z",
          fill: "#F5F8FA",
          stroke: "#687882",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }), l.a.createElement("path", {
          d: "M22.0988 14.1216C21.2462 14.1216 20.3662 14.5135 19.7475 15.1622C19.6512 15.2567 19.5687 15.3378 19.5 15.4189C19.4313 15.3378 19.3487 15.2567 19.2525 15.1622C18.6337 14.5135 17.7537 14.1216 16.9013 14.1216C15.2513 14.1216 14 15.3378 14 16.973C14 18.5811 14.7425 19.3919 15.9662 20.5946C17.4787 22.0811 19.17 23.5946 19.1837 23.6081C19.356 23.762 19.6165 23.762 19.7887 23.6081C19.8025 23.5946 21.4937 22.0811 23.0062 20.5946C24.2575 19.3919 25 18.5811 25 16.973C25 15.3378 23.7487 14.1216 22.0988 14.1216Z",
          fill: "#D6DDE1"
        }));
      },
      "cw-invite-success": function CWInviteSuccessSvg(_ref227) {
        var _ref227$height = _ref227.height,
            e = _ref227$height === void 0 ? 80 : _ref227$height,
            _ref227$width = _ref227.width,
            t = _ref227$width === void 0 ? 80 : _ref227$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "12",
          y: "30.9056",
          width: "54.4151",
          height: "38.0377",
          rx: "1.0566",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2.11321",
          "stroke-linejoin": "round"
        }), l.a.createElement("rect", {
          x: "15.1698",
          y: "15.0565",
          width: "48.0755",
          height: "49.1321",
          rx: "1.58491",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2.11321"
        }), l.a.createElement("path", {
          d: "M12 33.0189V68.9434H66.4151L12 33.0189Z",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2.11321",
          "stroke-linejoin": "round"
        }), l.a.createElement("path", {
          d: "M66.4151 68.9434V33.0189L12 68.9434H66.4151Z",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2.11321",
          "stroke-linejoin": "round"
        }), l.a.createElement("path", {
          d: "M32.8636 29.7954L37.6136 34.5454L45.847 25.0454",
          stroke: "#353F45",
          "stroke-width": "3.48333",
          "stroke-linecap": "square"
        }));
      },
      "cw-image-failure": function CWImageFailureSvg(_ref228) {
        var _ref228$height = _ref228.height,
            e = _ref228$height === void 0 ? 80 : _ref228$height,
            _ref228$width = _ref228.width,
            t = _ref228$width === void 0 ? 80 : _ref228$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "8",
          y: "18",
          width: "64",
          height: "44",
          rx: "2",
          fill: "#F5F8FA",
          stroke: "#687882",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M33.1415 36.4374C33.5295 35.7878 34.4705 35.7878 34.8585 36.4374L46.0869 55.2372C46.485 55.9038 46.0047 56.75 45.2283 56.75H22.7717C21.9953 56.75 21.515 55.9038 21.9131 55.2372L33.1415 36.4374Z",
          fill: "#D6DDE1"
        }), l.a.createElement("path", {
          d: "M33.5719 56.7417L33.1143 57.5H34H67.2286C68.3962 57.5 69.1161 56.2247 68.5129 55.225L52.7843 29.1605C52.2009 28.1938 50.7991 28.1938 50.2157 29.1605L33.5719 56.7417Z",
          fill: "#D6DDE1",
          stroke: "#F5F8FA"
        }), l.a.createElement("circle", {
          cx: "21",
          cy: "31",
          r: "7",
          fill: "#D6DDE1"
        }), l.a.createElement("circle", {
          cx: "66",
          cy: "58",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M67.3065 60.7609L67.7413 51H64.4152L64.8717 60.7609H67.3065ZM66.0891 65.7174C67.0456 65.7174 67.85 64.913 67.85 63.9783C67.85 63.0217 67.0456 62.2174 66.0891 62.2174C65.1326 62.2174 64.35 63.0217 64.35 63.9783C64.35 64.913 65.1326 65.7174 66.0891 65.7174Z",
          fill: "white"
        }));
      },
      "cw-be-prepared": function CWBePreparedSvg(_ref229) {
        var _ref229$height = _ref229.height,
            e = _ref229$height === void 0 ? 80 : _ref229$height,
            _ref229$width = _ref229.width,
            t = _ref229$width === void 0 ? 80 : _ref229$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "16",
          y: "11",
          width: "48",
          height: "58",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M44.4999 24.4998L48.2499 28.2498L54.7499 20.7498",
          stroke: "#EFF3F5",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }), l.a.createElement("path", {
          d: "M44.4999 39.4998L48.2499 43.2498L54.7499 35.7498",
          stroke: "#353F45",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }), l.a.createElement("path", {
          d: "M44.4999 54.4998L48.2499 58.2498L54.7499 50.7498",
          stroke: "#EFF3F5",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }));
      },
      "cw-group": function CWGroup(_ref230) {
        var _ref230$height = _ref230.height,
            e = _ref230$height === void 0 ? 80 : _ref230$height,
            _ref230$width = _ref230.width,
            t = _ref230$width === void 0 ? 80 : _ref230$width;
        return l.a.createElement("svg", {
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "3",
          y: "11",
          width: "34",
          height: "26",
          rx: "2.22876",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("circle", {
          cx: "20",
          cy: "22.671",
          r: "6",
          fill: "#353F45"
        }), l.a.createElement("path", {
          d: "M20 30C15.7036 30 8 30 8 36H32C32 30 24.2964 30 20 30Z",
          fill: "#353F45"
        }), l.a.createElement("rect", {
          x: "43",
          y: "11",
          width: "34",
          height: "26",
          rx: "2.22876",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("circle", {
          cx: "60",
          cy: "22.671",
          r: "6",
          fill: "#D6DDE1"
        }), l.a.createElement("path", {
          d: "M60 30C55.7036 30 48 30 48 36H72C72 30 64.2964 30 60 30Z",
          fill: "#D6DDE1"
        }), l.a.createElement("rect", {
          x: "43",
          y: "43",
          width: "34",
          height: "26",
          rx: "2.22876",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("circle", {
          cx: "60",
          cy: "54.671",
          r: "6",
          fill: "#D6DDE1"
        }), l.a.createElement("path", {
          d: "M60 62C55.7036 62 48 62 48 68H72C72 62 64.2964 62 60 62Z",
          fill: "#D6DDE1"
        }), l.a.createElement("rect", {
          x: "3",
          y: "43",
          width: "34",
          height: "26",
          rx: "2.22876",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("circle", {
          cx: "20",
          cy: "54.671",
          r: "6",
          fill: "#D6DDE1"
        }), l.a.createElement("path", {
          d: "M20 62C15.7036 62 8 62 8 68H32C32 62 24.2964 62 20 62Z",
          fill: "#D6DDE1"
        }));
      },
      "cw-one-on-one": function CWOneOnOneSvg(_ref231) {
        var _ref231$height = _ref231.height,
            e = _ref231$height === void 0 ? 80 : _ref231$height,
            _ref231$width = _ref231.width,
            t = _ref231$width === void 0 ? 80 : _ref231$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "3",
          y: "11",
          width: "50",
          height: "36.2353",
          rx: "3.58824",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("circle", {
          cx: "27.3671",
          cy: "26.1907",
          r: "8.54357",
          fill: "#D6DDE1"
        }), l.a.createElement("path", {
          d: "M28 36C21.7343 36 10 37.2548 10 46.25H45C45 37.2548 34.2656 36 28 36Z",
          fill: "#D6DDE1"
        }), l.a.createElement("rect", {
          x: "27",
          y: "27.7058",
          width: "50",
          height: "36.2353",
          rx: "3.58824",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("circle", {
          cx: "51.3671",
          cy: "42.8965",
          r: "8.54357",
          fill: "#353F45"
        }), l.a.createElement("path", {
          d: "M52 53C45.7343 53 34 54.2242 34 63H69C69 54.2242 58.2656 53 52 53Z",
          fill: "#353F45"
        }));
      },
      "cw-reminder": function CWReminderSvg(_ref232) {
        var _ref232$height = _ref232.height,
            e = _ref232$height === void 0 ? 80 : _ref232$height,
            _ref232$width = _ref232.width,
            t = _ref232$width === void 0 ? 80 : _ref232$width;
        return l.a.createElement("svg", {
          className: "colorway-icon",
          width: t,
          height: e,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "10",
          y: "16",
          width: "60",
          height: "52",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("line", {
          x1: "20",
          y1: "13",
          x2: "20",
          y2: "19",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), l.a.createElement("line", {
          x1: "41",
          y1: "13",
          x2: "41",
          y2: "19",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), l.a.createElement("line", {
          x1: "62",
          y1: "13",
          x2: "62",
          y2: "19",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), l.a.createElement("path", {
          d: "M42.0654 30.1844C42.1574 29.8769 42.0085 29.5486 41.7165 29.4152C41.4246 29.2819 41.079 29.3844 40.9069 29.6553L32.6002 42.7332C32.4744 42.9311 32.4665 43.1819 32.5794 43.3874C32.6924 43.593 32.9083 43.7207 33.1428 43.7207H38.3385L34.9335 53.7941C34.831 54.0973 34.9672 54.4298 35.2529 54.5739C35.5387 54.7181 35.887 54.6301 36.07 54.3675L45.4842 40.8586C45.6211 40.6621 45.6375 40.4058 45.5267 40.1935C45.4159 39.9813 45.1962 39.8482 44.9568 39.8482H39.1724L42.0654 30.1844Z",
          fill: "#EFF3F5",
          stroke: "#EFF3F5",
          strokeWidth: "1.28571",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), l.a.createElement("circle", {
          cx: "65",
          cy: "61",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M59.9999 60.9998L63.7499 64.7498L70.2499 57.2498",
          stroke: "white",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }));
      },
      "open-new-tab": function openNewTab(_ref233) {
        var e = _ref233.className,
            _ref233$width = _ref233.width,
            t = _ref233$width === void 0 ? "24" : _ref233$width,
            _ref233$height = _ref233.height,
            a = _ref233$height === void 0 ? "24" : _ref233$height;
        return l.a.createElement("svg", {
          className: h()("tide--open-new-tab", e),
          width: t,
          height: a,
          viewBox: "0 0 16 16",
          fill: "none"
        }, l.a.createElement("path", {
          d: "M7.74359 3H5C3.89543 3 3 3.89543 3 5V11C3 12.1046 3.89543 13 5 13H11C12.1046 13 13 12.1046 13 11V8.41667M8.16026 8L13 3M13 3H10.0833M13 3V5.91667",
          stroke: "#687882",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      },
      "csv-error": function csvError(_ref234) {
        var e = _ref234.className,
            _ref234$width = _ref234.width,
            t = _ref234$width === void 0 ? 80 : _ref234$width,
            _ref234$height = _ref234.height,
            a = _ref234$height === void 0 ? 80 : _ref234$height;
        return l.a.createElement("svg", {
          classname: e,
          width: t,
          height: a,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "8",
          y: "18",
          width: "64",
          height: "44",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2"
        }), l.a.createElement("rect", {
          x: "13",
          y: "26",
          width: "18",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "13",
          y: "32",
          width: "18",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "13",
          y: "38",
          width: "18",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "13",
          y: "44",
          width: "18",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "13",
          y: "50",
          width: "18",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "33",
          y: "26",
          width: "14",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "33",
          y: "32",
          width: "12",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "33",
          y: "38",
          width: "18",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "33",
          y: "44",
          width: "14",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "33",
          y: "50",
          width: "18",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "53",
          y: "26",
          width: "8",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "53",
          y: "32",
          width: "12",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "53",
          y: "38",
          width: "10",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "53",
          y: "44",
          width: "12",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("rect", {
          x: "53",
          y: "50",
          width: "10",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), l.a.createElement("circle", {
          cx: "66",
          cy: "58",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          "stroke-width": "2"
        }), l.a.createElement("circle", {
          cx: "66",
          cy: "58",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          "stroke-width": "2"
        }), l.a.createElement("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M66 65C65.74 65 65.48 64.89 65.29 64.71C65.109 64.52 65 64.26 65 64C65 63.73 65.109 63.48 65.29 63.29C65.66 62.92 66.33 62.92 66.71 63.29C66.89 63.48 67 63.73 67 64C67 64.26 66.89 64.52 66.71 64.71C66.52 64.89 66.26 65 66 65ZM66 61C65.447 61 65 60.552 65 60V52C65 51.448 65.447 51 66 51C66.553 51 67 51.448 67 52V60C67 60.552 66.553 61 66 61Z",
          fill: "white",
          stroke: "white",
          "stroke-width": "0.5"
        }));
      },
      "email-reply-mgmt": function emailReplyMgmt(_ref235) {
        var e = _ref235.className,
            _ref235$width = _ref235.width,
            t = _ref235$width === void 0 ? 32 : _ref235$width,
            _ref235$height = _ref235.height,
            a = _ref235$height === void 0 ? 23 : _ref235$height;
        return l.a.createElement("svg", {
          className: e,
          width: t,
          height: a,
          viewBox: "0 0 33 25",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, l.a.createElement("rect", {
          x: "1",
          y: "1",
          width: "29",
          height: "20",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), l.a.createElement("rect", {
          x: "3",
          y: "4",
          width: "25",
          height: "2",
          rx: "1",
          fill: "#D6DDE1"
        }), l.a.createElement("rect", {
          x: "15.5",
          y: "8",
          width: "10",
          height: "2",
          rx: "0.5",
          fill: "#D6DDE1"
        }), l.a.createElement("rect", {
          x: "15.5",
          y: "11",
          width: "11",
          height: "2",
          rx: "0.5",
          fill: "#D6DDE1"
        }), l.a.createElement("rect", {
          x: "15.5",
          y: "14",
          width: "8",
          height: "2",
          rx: "0.5",
          fill: "#D6DDE1"
        }), l.a.createElement("circle", {
          cx: "9.46666",
          cy: "10.4833",
          r: "2.48332",
          fill: "#353F45"
        }), l.a.createElement("path", {
          d: "M9.46664 13.5167C7.6884 13.5167 4.5 13.5167 4.5 16H14.4333C14.4333 13.5167 11.2449 13.5167 9.46664 13.5167Z",
          fill: "#353F45"
        }), l.a.createElement("circle", {
          cx: "25.5",
          cy: "18",
          r: "6",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), l.a.createElement("path", {
          d: "M26.5 18.7071L28.2733 17.8897L29.397 19.4865",
          stroke: "white"
        }), l.a.createElement("path", {
          d: "M21.8261 16.5L22.9481 18.098L24.7222 17.2826",
          stroke: "white"
        }), l.a.createElement("path", {
          d: "M22.8173 18.1342C22.8173 16.6793 23.9966 15.5 25.4514 15.5C26.4264 15.5 27.2777 16.0297 27.7332 16.8171",
          stroke: "white"
        }), l.a.createElement("path", {
          d: "M28.0856 18.1342C28.0856 19.589 26.9062 20.7683 25.4514 20.7683C24.4764 20.7683 23.6251 20.2386 23.1697 19.4512",
          stroke: "white"
        }));
      },
      "phone-hangup": function phoneHangup(_ref236) {
        var e = _ref236.className,
            _ref236$width = _ref236.width,
            t = _ref236$width === void 0 ? "34" : _ref236$width,
            _ref236$height = _ref236.height,
            a = _ref236$height === void 0 ? "34" : _ref236$height;
        return l.a.createElement("svg", {
          width: t,
          height: a,
          className: e,
          viewBox: "0 0 34 34",
          fill: "none"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.1959 10.344C10.9896 10.2923 5.61419 11.4633 3.82026 13.2572C3.17325 13.9042 3.04173 14.5477 3.04739 15.0667L3.36134 19.4126C3.38114 19.6771 3.50418 19.9245 3.7057 20.0992C3.90723 20.2753 4.16815 20.3637 4.4319 20.346L10.9557 19.9146C11.3552 19.8885 11.6939 19.6247 11.8176 19.2464L12.9667 15.7272L21.3523 15.7929L22.5572 19.3313C22.6866 19.7124 23.0323 19.9818 23.4326 20.0129L29.9804 20.532C30.2448 20.5532 30.5051 20.4669 30.7037 20.2937C30.8996 20.1204 31.0198 19.8743 31.034 19.6099L31.2546 15.2018C31.2426 13.6751 29.7138 12.449 26.71 11.5595C24.1595 10.8036 20.7802 10.3715 17.1959 10.344ZM26.174 13.4602C28.6277 14.1871 29.2202 14.9451 29.2704 15.2258L29.1043 18.475L24.2189 18.0882L22.9977 14.501C22.8591 14.0952 22.478 13.8187 22.0516 13.8166L12.2362 13.7381C11.8099 13.7345 11.433 14.0039 11.3 14.4084L10.1347 17.9793L5.267 18.3017L5.02729 14.9904C5.02658 14.9387 5.08103 14.8235 5.23376 14.6707C6.40826 13.4962 11.0052 12.2751 17.21 12.3267C20.6147 12.3528 23.7981 12.7559 26.174 13.4602Z",
          fill: "#353F45"
        }));
      },
      "microphone-off": function microphoneOff(_ref237) {
        var e = _ref237.className,
            _ref237$width = _ref237.width,
            t = _ref237$width === void 0 ? "30" : _ref237$width,
            _ref237$height = _ref237.height,
            a = _ref237$height === void 0 ? "30" : _ref237$height;
        return l.a.createElement("svg", {
          width: t,
          height: a,
          className: e,
          viewBox: "0 0 30 30",
          fill: "none"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M26.707 4.7074L4.70674 26.7069C4.51128 26.9026 4.25537 27 3.99946 27C3.74355 27 3.48764 26.9026 3.29319 26.7069C2.90227 26.3164 2.90227 25.6841 3.29319 25.2936L8.71769 19.8683C7.64468 18.476 7.04218 16.7626 7.04218 15V12.8138C7.04218 12.2617 7.48952 11.8141 8.04164 11.8141C8.59377 11.8141 9.04211 12.2617 9.04211 12.8138V15C9.04211 16.2336 9.44512 17.4311 10.1514 18.4349L11.0088 17.5777C11.0078 17.5616 10.9997 17.5476 10.9997 17.5315V6.83438C10.9997 6.77415 11.0239 6.72296 11.034 6.66575C11.2083 4.61807 12.91 3 14.9996 3C17.0902 3 18.7919 4.61807 18.9662 6.66575C18.9763 6.72296 18.9995 6.77415 18.9995 6.83438V9.5867L25.2924 3.2931C25.6834 2.90263 26.3161 2.90263 26.707 3.2931C27.0979 3.68356 27.0979 4.31694 26.707 4.7074ZM17.0411 7.21497C17.025 7.14471 16.9978 7.07846 16.9978 7.00217C16.9978 5.89803 16.1011 5.00067 14.9978 5.00067C13.8946 5.00067 12.9979 5.89803 12.9979 7.00217V15.5864L17.0411 11.5432V7.21497ZM15.5413 19.9629C15.495 19.9699 15.4507 19.972 15.4053 19.972C14.9126 19.972 14.4844 19.6076 14.4159 19.1067C14.3414 18.5587 14.7252 18.0558 15.2723 17.9815C16.0854 17.8711 16.7584 17.2608 16.9458 16.4618C17.0728 15.9248 17.6128 15.5925 18.1488 15.718C18.6858 15.8435 19.0193 16.3825 18.8934 16.9205C18.5165 18.5205 17.1695 19.7431 15.5413 19.9629ZM9.9998 25.0003H14.0007V22.9296C13.5805 22.8774 13.1654 22.8001 12.7614 22.6816C12.2315 22.5271 11.9272 21.972 12.0823 21.441C12.2385 20.911 12.7927 20.6079 13.3236 20.7614C13.8636 20.92 14.4279 21.0003 15.0001 21.0003C18.3088 21.0003 20.9999 18.3092 20.9999 14.9998C20.9999 14.8713 21.0291 14.7509 21.0735 14.6385V13.0214C21.0735 12.4693 21.4483 11.8139 22.0004 11.8139C22.5525 11.8139 23.0009 12.2616 23.0009 12.8136V14.9998C23.0009 19.0721 19.94 22.4357 16.0006 22.9306V25.0003H20.0005C20.5526 25.0003 20.9999 25.448 20.9999 26.0001C20.9999 26.5521 20.5526 26.9998 20.0005 26.9998H9.9998C9.44768 26.9998 9.00034 26.5521 9.00034 26.0001C9.00034 25.448 9.44768 25.0003 9.9998 25.0003Z",
          fill: "#353F45"
        }));
      },
      "microphone-on": function microphoneOn(_ref238) {
        var e = _ref238.className,
            _ref238$width = _ref238.width,
            t = _ref238$width === void 0 ? "30" : _ref238$width,
            _ref238$height = _ref238.height,
            a = _ref238$height === void 0 ? "30" : _ref238$height;
        return l.a.createElement("svg", {
          width: t,
          height: a,
          className: e,
          viewBox: "0 0 30 30",
          fill: "none"
        }, l.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 22.93V25H20C20.552 25 21 25.448 21 26C21 26.552 20.552 27 20 27H10C9.448 27 9 26.552 9 26C9 25.448 9.448 25 10 25H14V22.93C10.06 22.436 7 19.072 7 15V13C7 12.448 7.448 12 8 12C8.552 12 9 12.448 9 13V15C9 18.309 11.691 21 15 21C18.309 21 21 18.309 21 15V13C21 12.448 21.448 12 22 12C22.552 12 23 12.448 23 13V15C23 19.072 19.94 22.436 16 22.93ZM15 20C12.794 20 11 18.205 11 16C11 15.97 11.014 15.946 11.017 15.917C11.014 15.888 11 15.863 11 15.834V6.834C11 6.774 11.024 6.723 11.034 6.666C11.208 4.619 12.909 3 15 3C17.091 3 18.792 4.619 18.966 6.666C18.976 6.723 19 6.774 19 6.834V15.834C19 15.863 18.986 15.888 18.983 15.917C18.986 15.946 19 15.97 19 16C19 18.205 17.206 20 15 20ZM17 15.834V7.002C17 5.898 16.103 5 15 5C13.897 5 13 5.898 13 7.002V15.834C13 15.863 12.986 15.888 12.983 15.917C12.986 15.946 13 15.97 13 16C13 17.103 13.897 18 15 18C16.103 18 17 17.103 17 16C17 15.97 17.014 15.946 17.017 15.917C17.014 15.888 17 15.863 17 15.834Z",
          fill: "#353F45"
        }));
      }
    };
    a(3);

    var n = function n(e) {
      return "tide-icon ".concat(e);
    };

    var s = function s(_ref239) {
      var e = _ref239.name,
          _ref239$className = _ref239.className,
          t = _ref239$className === void 0 ? "" : _ref239$className,
          a = _ref239.width,
          c = _ref239.height;
      var l = {
        className: n(t),
        width: a,
        height: c
      };
      return function (e) {
        var t = r[e];
        if (!t) throw new Error("the icon ".concat(e, " does not exist."));
        return t;
      }(e)(l);
    };

    a.d(t, "ICON_NAMES", function () {
      return o;
    }), a.d(t, "Icon", function () {
      return s;
    });
    var o = Object.keys(r);
  }]);
});